export default [
  {
    "title": "Blues",
    "items": [
      {
        "title": "All Your Love",
        "artist": "Otis Rush",
        "url": "https://www.quickchords.org/charts/blues/otis_rush/all_your_love?source=ireal"
      },
      {
        "title": "Baby Please Don't Go",
        "artist": "Muddy Waters (Joe Williams)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_joe_williams/baby_please_dont_go?source=ireal"
      },
      {
        "title": "Back Door Man",
        "artist": "Howlin' Wolf (Willie Dixon)",
        "url": "https://www.quickchords.org/charts/blues/howlin_wolf_willie_dixon/back_door_man?source=ireal"
      },
      {
        "title": "Blow, Wind, Blow",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/blow_wind_blow?source=ireal"
      },
      {
        "title": "Blues and Booze",
        "artist": "Ma Rainey",
        "url": "https://www.quickchords.org/charts/blues/ma_rainey/blues_and_booze?source=ireal"
      },
      {
        "title": "Boogie Chillen No.2",
        "artist": "Besman Hooker-Bernard Lee John",
        "url": "https://www.quickchords.org/charts/blues/besman_hookerbernard_lee_john/boogie_chillen_no2?source=ireal"
      },
      {
        "title": "Boom Boom (1992)",
        "artist": "Hooker Lee John",
        "url": "https://www.quickchords.org/charts/blues/hooker_lee_john/boom_boom_1992?source=ireal"
      },
      {
        "title": "Born Under A Bad Sign",
        "artist": "Albert KIng",
        "url": "https://www.quickchords.org/charts/blues/albert_king/born_under_a_bad_sign?source=ireal"
      },
      {
        "title": "Come Back Baby",
        "artist": "Ray Charles (Mance Lipscomb)",
        "url": "https://www.quickchords.org/charts/blues/ray_charles_mance_lipscomb/come_back_baby?source=ireal"
      },
      {
        "title": "Come On In My Kitchen",
        "artist": "Robert Johnson",
        "url": "https://www.quickchords.org/charts/blues/robert_johnson/come_on_in_my_kitchen?source=ireal"
      },
      {
        "title": "Confessin' The Blues",
        "artist": "B.B. King (McShann-Brown)",
        "url": "https://www.quickchords.org/charts/blues/bb_king_mcshannbrown/confessin_the_blues?source=ireal"
      },
      {
        "title": "Crazy Blues",
        "artist": "Mamie Smith (Perry Bradford)",
        "url": "https://www.quickchords.org/charts/blues/mamie_smith_perry_bradford/crazy_blues?source=ireal"
      },
      {
        "title": "Crossroads (a.k.a. Cross Road Blues)",
        "artist": "Eric Clapton (Robert Johnson)",
        "url": "https://www.quickchords.org/charts/blues/eric_clapton_robert_johnson/crossroads_aka_cross_road_blues?source=ireal"
      },
      {
        "title": "Easy Rider",
        "artist": "Leadbelly",
        "url": "https://www.quickchords.org/charts/blues/leadbelly/easy_rider?source=ireal"
      },
      {
        "title": "Everyday (I Have The Blues)",
        "artist": "B.B. King (Peter Chatman)",
        "url": "https://www.quickchords.org/charts/blues/bb_king_peter_chatman/everyday_i_have_the_blues?source=ireal"
      },
      {
        "title": "Evil (Is Going On)",
        "artist": "Howlin' Wolf (Willie Dixon)",
        "url": "https://www.quickchords.org/charts/blues/howlin_wolf_willie_dixon/evil_is_going_on?source=ireal"
      },
      {
        "title": "Feel Like Going Home",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/feel_like_going_home?source=ireal"
      },
      {
        "title": "Five Long Years",
        "artist": "Eddie Boyd",
        "url": "https://www.quickchords.org/charts/blues/eddie_boyd/five_long_years?source=ireal"
      },
      {
        "title": "Folsom Prison Blues",
        "artist": "Johnny Cash",
        "url": "https://www.quickchords.org/charts/blues/johnny_cash/folsom_prison_blues?source=ireal"
      },
      {
        "title": "Forty Days And Forty Nights",
        "artist": "Bernard Roth",
        "url": "https://www.quickchords.org/charts/blues/bernard_roth/forty_days_and_forty_nights?source=ireal"
      },
      {
        "title": "Further On Up The Road",
        "artist": "Robey Veasey-Don Joe",
        "url": "https://www.quickchords.org/charts/blues/robey_veaseydon_joe/further_on_up_the_road?source=ireal"
      },
      {
        "title": "Going Down Slow",
        "artist": "Eric Clapton (J.B. Oden)",
        "url": "https://www.quickchords.org/charts/blues/eric_clapton_jb_oden/going_down_slow?source=ireal"
      },
      {
        "title": "Good Morning Little Schoolgirl",
        "artist": "Williamson Boy Sonny",
        "url": "https://www.quickchords.org/charts/blues/williamson_boy_sonny/good_morning_little_schoolgirl?source=ireal"
      },
      {
        "title": "Hellhound On My Trail",
        "artist": "Eric Clapton (Robert Johnson)",
        "url": "https://www.quickchords.org/charts/blues/eric_clapton_robert_johnson/hellhound_on_my_trail?source=ireal"
      },
      {
        "title": "Honey Bee",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/honey_bee?source=ireal"
      },
      {
        "title": "I Ain't Superstitious",
        "artist": "Howlin' Wolf (Willie Dixon)",
        "url": "https://www.quickchords.org/charts/blues/howlin_wolf_willie_dixon/i_aint_superstitious?source=ireal"
      },
      {
        "title": "I Can't Be Satisfied (1948)",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/i_cant_be_satisfied_1948?source=ireal"
      },
      {
        "title": "I Can't Quit You Baby",
        "artist": "Willie Dixon",
        "url": "https://www.quickchords.org/charts/blues/willie_dixon/i_cant_quit_you_baby?source=ireal"
      },
      {
        "title": "I Just Want To Make Love To You",
        "artist": "Willie Dixon",
        "url": "https://www.quickchords.org/charts/blues/willie_dixon/i_just_want_to_make_love_to_you?source=ireal"
      },
      {
        "title": "I'm Ready",
        "artist": "Muddy Waters (Willie Dixon)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_willie_dixon/im_ready?source=ireal"
      },
      {
        "title": "I'm Tore Down",
        "artist": "Eric Clapton (Sonny Thompson)",
        "url": "https://www.quickchords.org/charts/blues/eric_clapton_sonny_thompson/im_tore_down?source=ireal"
      },
      {
        "title": "I'm Your Hoochie Coochie Man",
        "artist": "Willie Dixon",
        "url": "https://www.quickchords.org/charts/blues/willie_dixon/im_your_hoochie_coochie_man?source=ireal"
      },
      {
        "title": "It's My Own Fault (Newport)",
        "artist": "Hooker Lee John",
        "url": "https://www.quickchords.org/charts/blues/hooker_lee_john/its_my_own_fault_newport?source=ireal"
      },
      {
        "title": "Juke",
        "artist": "Little Walter",
        "url": "https://www.quickchords.org/charts/blues/little_walter/juke?source=ireal"
      },
      {
        "title": "Kindhearted Woman Blues",
        "artist": "Robert Johnson",
        "url": "https://www.quickchords.org/charts/blues/robert_johnson/kindhearted_woman_blues?source=ireal"
      },
      {
        "title": "Long Distance Call",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/long_distance_call?source=ireal"
      },
      {
        "title": "Love Struck Baby",
        "artist": "Vaughan Ray Stevie",
        "url": "https://www.quickchords.org/charts/blues/vaughan_ray_stevie/love_struck_baby?source=ireal"
      },
      {
        "title": "Nobody Knows You When You're Down and Out",
        "artist": "Bessie Smith (Jimmie Cox)",
        "url": "https://www.quickchords.org/charts/blues/bessie_smith_jimmie_cox/nobody_knows_you_when_youre_down_and_out?source=ireal"
      },
      {
        "title": "Pinetop's Blues",
        "artist": "Pinetop Smith",
        "url": "https://www.quickchords.org/charts/blues/pinetop_smith/pinetops_blues?source=ireal"
      },
      {
        "title": "Reconsider Baby",
        "artist": "Lowell Fulson",
        "url": "https://www.quickchords.org/charts/blues/lowell_fulson/reconsider_baby?source=ireal"
      },
      {
        "title": "Red House",
        "artist": "Jimi Hendrix",
        "url": "https://www.quickchords.org/charts/blues/jimi_hendrix/red_house?source=ireal"
      },
      {
        "title": "Rock Me Baby",
        "artist": "King Josea-B.B. Joe",
        "url": "https://www.quickchords.org/charts/blues/king_joseabb_joe/rock_me_baby?source=ireal"
      },
      {
        "title": "Rollin' And Tumblin' (1950)",
        "artist": "Muddy Waters",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters/rollin_and_tumblin_1950?source=ireal"
      },
      {
        "title": "Rollin' Stone (Catfish Blues)",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/rollin_stone_catfish_blues?source=ireal"
      },
      {
        "title": "Smokestack Lightning",
        "artist": "Chester Burnett",
        "url": "https://www.quickchords.org/charts/blues/chester_burnett/smokestack_lightning?source=ireal"
      },
      {
        "title": "Spoonful",
        "artist": "Howlin' Wolf (Willie Dixon)",
        "url": "https://www.quickchords.org/charts/blues/howlin_wolf_willie_dixon/spoonful?source=ireal"
      },
      {
        "title": "Standing Around Crying",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/standing_around_crying?source=ireal"
      },
      {
        "title": "Stateboro Blues",
        "artist": "The Allman Brothers (Blind Willie McTell)",
        "url": "https://www.quickchords.org/charts/blues/the_allman_brothers_blind_willie_mctell/stateboro_blues?source=ireal"
      },
      {
        "title": "Still A Fool",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/still_a_fool?source=ireal"
      },
      {
        "title": "Sweet Home Chicago",
        "artist": "Robert Johnson",
        "url": "https://www.quickchords.org/charts/blues/robert_johnson/sweet_home_chicago?source=ireal"
      },
      {
        "title": "Texas Flood",
        "artist": "Davis C. Larry/Scott W. Joseph",
        "url": "https://www.quickchords.org/charts/blues/davis_c_larryscott_w_joseph/texas_flood?source=ireal"
      },
      {
        "title": "Three O'Clock Blues",
        "artist": "B.B. King (B.B.King-Jules Bihari)",
        "url": "https://www.quickchords.org/charts/blues/bb_king_bbkingjules_bihari/three_oclock_blues?source=ireal"
      },
      {
        "title": "Worried Life Blues",
        "artist": "Big Maceo (Maceo Merriweather)",
        "url": "https://www.quickchords.org/charts/blues/big_maceo_maceo_merriweather/worried_life_blues?source=ireal"
      },
      {
        "title": "You Gonna Need My Help",
        "artist": "Muddy Waters (McKinley Morganfield)",
        "url": "https://www.quickchords.org/charts/blues/muddy_waters_mckinley_morganfield/you_gonna_need_my_help?source=ireal"
      }
    ]
  },
  {
    "title": "Brazilian",
    "items": [
      {
        "title": "A Felicidade",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/a_felicidade?source=ireal"
      },
      {
        "title": "Abre Alas",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/abre_alas?source=ireal"
      },
      {
        "title": "Agua De Beber",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/agua_de_beber?source=ireal"
      },
      {
        "title": "Agua Doçe",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/agua_doe?source=ireal"
      },
      {
        "title": "Ai,Ai,Ai,Ai,Ai,Ai",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/aiaiaiaiaiai?source=ireal"
      },
      {
        "title": "Algum Lugar",
        "artist": "Moraes De Medalha-Vinicius Marília",
        "url": "https://www.quickchords.org/charts/brazilian/moraes_de_medalhavinicius_marlia/algum_lugar?source=ireal"
      },
      {
        "title": "Aliás",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/alis?source=ireal"
      },
      {
        "title": "Amazonia",
        "artist": "Ana Caram",
        "url": "https://www.quickchords.org/charts/brazilian/ana_caram/amazonia?source=ireal"
      },
      {
        "title": "Amigos Meus",
        "artist": "Moraes De Medalha-Vinicius Marília",
        "url": "https://www.quickchords.org/charts/brazilian/moraes_de_medalhavinicius_marlia/amigos_meus?source=ireal"
      },
      {
        "title": "Amor",
        "artist": "Gabriel Ruiz",
        "url": "https://www.quickchords.org/charts/brazilian/gabriel_ruiz/amor?source=ireal"
      },
      {
        "title": "Amor Em Paz",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/amor_em_paz?source=ireal"
      },
      {
        "title": "Anjo De Mim",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/anjo_de_mim?source=ireal"
      },
      {
        "title": "Anos Dourados",
        "artist": "Buarque Jobim-Chico Antonio-Carlos",
        "url": "https://www.quickchords.org/charts/brazilian/buarque_jobimchico_antoniocarlos/anos_dourados?source=ireal"
      },
      {
        "title": "Aos Nossos Filhos",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/aos_nossos_filhos?source=ireal"
      },
      {
        "title": "Apareçida",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/apareida?source=ireal"
      },
      {
        "title": "Aquarela Do Brasil (a.k.a. Brazil)",
        "artist": "Ary Barroso",
        "url": "https://www.quickchords.org/charts/brazilian/ary_barroso/aquarela_do_brasil_aka_brazil?source=ireal"
      },
      {
        "title": "Aquele Um",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/aquele_um?source=ireal"
      },
      {
        "title": "As Rosas Nao Falam",
        "artist": "Cartola",
        "url": "https://www.quickchords.org/charts/brazilian/cartola/as_rosas_nao_falam?source=ireal"
      },
      {
        "title": "Baila Comigo",
        "artist": "Rita Lee",
        "url": "https://www.quickchords.org/charts/brazilian/rita_lee/baila_comigo?source=ireal"
      },
      {
        "title": "Baía (a.k.a.Bahia)",
        "artist": "Ary Barroso",
        "url": "https://www.quickchords.org/charts/brazilian/ary_barroso/baa_akabahia?source=ireal"
      },
      {
        "title": "Bala Com Bala",
        "artist": "João Bosco",
        "url": "https://www.quickchords.org/charts/brazilian/joo_bosco/bala_com_bala?source=ireal"
      },
      {
        "title": "Batida Diferente",
        "artist": "Mauricio Einhorn",
        "url": "https://www.quickchords.org/charts/brazilian/mauricio_einhorn/batida_diferente?source=ireal"
      },
      {
        "title": "Beijo Partido",
        "artist": "Toninho Horta",
        "url": "https://www.quickchords.org/charts/brazilian/toninho_horta/beijo_partido?source=ireal"
      },
      {
        "title": "Brigas Nunca Mais",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/brigas_nunca_mais?source=ireal"
      },
      {
        "title": "Camaleão",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/camaleo?source=ireal"
      },
      {
        "title": "Caminhos Cruzados",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/caminhos_cruzados?source=ireal"
      },
      {
        "title": "Canto de Ossanha",
        "artist": "Powell Moraes-Baden de Vinicius",
        "url": "https://www.quickchords.org/charts/brazilian/powell_moraesbaden_de_vinicius/canto_de_ossanha?source=ireal"
      },
      {
        "title": "Capim",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/capim?source=ireal"
      },
      {
        "title": "Casa Forte",
        "artist": "Edu Lobo",
        "url": "https://www.quickchords.org/charts/brazilian/edu_lobo/casa_forte?source=ireal"
      },
      {
        "title": "Certain Sadness, A",
        "artist": "Astrud Gilberto (Lyra-Court)",
        "url": "https://www.quickchords.org/charts/brazilian/astrud_gilberto_lyracourt/certain_sadness_a?source=ireal"
      },
      {
        "title": "Chega De Saudade (No More Blues)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/chega_de_saudade_no_more_blues?source=ireal"
      },
      {
        "title": "Coisa Feita",
        "artist": "João Bosco",
        "url": "https://www.quickchords.org/charts/brazilian/joo_bosco/coisa_feita?source=ireal"
      },
      {
        "title": "Começar De Novo (The Island)",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/comear_de_novo_the_island?source=ireal"
      },
      {
        "title": "Coracao Vagabundo",
        "artist": "Caetano Veloso",
        "url": "https://www.quickchords.org/charts/brazilian/caetano_veloso/coracao_vagabundo?source=ireal"
      },
      {
        "title": "Corcovado",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/corcovado?source=ireal"
      },
      {
        "title": "Cravo e Canela",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/cravo_e_canela?source=ireal"
      },
      {
        "title": "Cucurrucucú paloma",
        "artist": "Caetano Veloso (Tomás Méndez)",
        "url": "https://www.quickchords.org/charts/brazilian/caetano_veloso_toms_mndez/cucurrucuc_paloma?source=ireal"
      },
      {
        "title": "Deirdre's Samba (Quem Te Viu, Quem Te Ve)",
        "artist": "Chico Buarque",
        "url": "https://www.quickchords.org/charts/brazilian/chico_buarque/deirdres_samba_quem_te_viu_quem_te_ve?source=ireal"
      },
      {
        "title": "Deixa",
        "artist": "Baden Powell",
        "url": "https://www.quickchords.org/charts/brazilian/baden_powell/deixa?source=ireal"
      },
      {
        "title": "Desafinado",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/desafinado?source=ireal"
      },
      {
        "title": "Desafinado (Original)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/desafinado_original?source=ireal"
      },
      {
        "title": "Desde que o samba é samba",
        "artist": "Gil Veloso-Gilberto Caetano",
        "url": "https://www.quickchords.org/charts/brazilian/gil_velosogilberto_caetano/desde_que_o_samba__samba?source=ireal"
      },
      {
        "title": "Dindi",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/dindi?source=ireal"
      },
      {
        "title": "Dinorah, Dinorah",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/dinorah_dinorah?source=ireal"
      },
      {
        "title": "Discussao",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/discussao?source=ireal"
      },
      {
        "title": "Doce Presença",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/doce_presena?source=ireal"
      },
      {
        "title": "Dolphin, The",
        "artist": "Luiz Eca",
        "url": "https://www.quickchords.org/charts/brazilian/luiz_eca/dolphin_the?source=ireal"
      },
      {
        "title": "Dom De Iludir",
        "artist": "Caetano Veloso",
        "url": "https://www.quickchords.org/charts/brazilian/caetano_veloso/dom_de_iludir?source=ireal"
      },
      {
        "title": "Don Quixote",
        "artist": "Milton Nascimento (Nascimento-Mariano)",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento_nascimentomariano/don_quixote?source=ireal"
      },
      {
        "title": "Doralice",
        "artist": "João Gilberto (Caymmi-Almeida)",
        "url": "https://www.quickchords.org/charts/brazilian/joo_gilberto_caymmialmeida/doralice?source=ireal"
      },
      {
        "title": "Ella Carioca",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/ella_carioca?source=ireal"
      },
      {
        "title": "Embola A Bola",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/embola_a_bola?source=ireal"
      },
      {
        "title": "Encontros E Despedidas",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/encontros_e_despedidas?source=ireal"
      },
      {
        "title": "Este Seu Olhar",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/este_seu_olhar?source=ireal"
      },
      {
        "title": "Eu Sei Que Vou Te Amar",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/eu_sei_que_vou_te_amar?source=ireal"
      },
      {
        "title": "Fato Consumado",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/fato_consumado?source=ireal"
      },
      {
        "title": "Favela",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/favela?source=ireal"
      },
      {
        "title": "Flor De Lis",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/flor_de_lis?source=ireal"
      },
      {
        "title": "Flor De Noite, A",
        "artist": "Moraes De Medalha-Vinicius Marília",
        "url": "https://www.quickchords.org/charts/brazilian/moraes_de_medalhavinicius_marlia/flor_de_noite_a?source=ireal"
      },
      {
        "title": "Fotografia",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/fotografia?source=ireal"
      },
      {
        "title": "Francisco",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/francisco?source=ireal"
      },
      {
        "title": "Gentle Rain, The",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/brazilian/luiz_bonfa/gentle_rain_the?source=ireal"
      },
      {
        "title": "Girl From Ipanema, The",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/girl_from_ipanema_the?source=ireal"
      },
      {
        "title": "Guarde Nos Olhos",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/guarde_nos_olhos?source=ireal"
      },
      {
        "title": "How Insensitive",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/how_insensitive?source=ireal"
      },
      {
        "title": "Hurry",
        "artist": "Hugo Fatorusso",
        "url": "https://www.quickchords.org/charts/brazilian/hugo_fatorusso/hurry?source=ireal"
      },
      {
        "title": "If You Never Come To Me",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/if_you_never_come_to_me?source=ireal"
      },
      {
        "title": "Incompatibilidade De Gênios",
        "artist": "João Bosco",
        "url": "https://www.quickchords.org/charts/brazilian/joo_bosco/incompatibilidade_de_gnios?source=ireal"
      },
      {
        "title": "Jogral",
        "artist": "Djavan-Neto-Filo",
        "url": "https://www.quickchords.org/charts/brazilian/djavannetofilo/jogral?source=ireal"
      },
      {
        "title": "Juntos",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/juntos?source=ireal"
      },
      {
        "title": "Lanterna Dos Afogados",
        "artist": "Matheus Lucas",
        "url": "https://www.quickchords.org/charts/brazilian/matheus_lucas/lanterna_dos_afogados?source=ireal"
      },
      {
        "title": "Lelé do coraçao",
        "artist": "Jr Mauro Haroldo",
        "url": "https://www.quickchords.org/charts/brazilian/jr_mauro_haroldo/lel_do_coraao?source=ireal"
      },
      {
        "title": "Leva E Traz (Elis)",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/leva_e_traz_elis?source=ireal"
      },
      {
        "title": "Ligia",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/ligia?source=ireal"
      },
      {
        "title": "Like A Lover",
        "artist": "Motta Caymmi-Nelson Dori",
        "url": "https://www.quickchords.org/charts/brazilian/motta_caymminelson_dori/like_a_lover?source=ireal"
      },
      {
        "title": "Limao",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/limao?source=ireal"
      },
      {
        "title": "Linha Do Equador",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/linha_do_equador?source=ireal"
      },
      {
        "title": "Little Boat (O Barquinho)",
        "artist": "Roberto Menescal",
        "url": "https://www.quickchords.org/charts/brazilian/roberto_menescal/little_boat_o_barquinho?source=ireal"
      },
      {
        "title": "Little Tear, A",
        "artist": "Deodato-Valle",
        "url": "https://www.quickchords.org/charts/brazilian/deodatovalle/little_tear_a?source=ireal"
      },
      {
        "title": "Lobo Bobo",
        "artist": "Bôscoli Lyra-Ronaldo Carlos",
        "url": "https://www.quickchords.org/charts/brazilian/bscoli_lyraronaldo_carlos/lobo_bobo?source=ireal"
      },
      {
        "title": "Look To The Sky",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/look_to_the_sky?source=ireal"
      },
      {
        "title": "Love Dance",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/love_dance?source=ireal"
      },
      {
        "title": "Lua Soberana",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/lua_soberana?source=ireal"
      },
      {
        "title": "Luiza",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/luiza?source=ireal"
      },
      {
        "title": "Luz De Sol",
        "artist": "Caetano Veloso",
        "url": "https://www.quickchords.org/charts/brazilian/caetano_veloso/luz_de_sol?source=ireal"
      },
      {
        "title": "Madalena",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/madalena?source=ireal"
      },
      {
        "title": "Malasia",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/malasia?source=ireal"
      },
      {
        "title": "Manha De Carnaval (Black Orpheus)",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/brazilian/luiz_bonfa/manha_de_carnaval_black_orpheus?source=ireal"
      },
      {
        "title": "Maria Das Mercedes",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/maria_das_mercedes?source=ireal"
      },
      {
        "title": "Mas que nada",
        "artist": "Jor Ben Jorge",
        "url": "https://www.quickchords.org/charts/brazilian/jor_ben_jorge/mas_que_nada?source=ireal"
      },
      {
        "title": "Me Deixa Em Paz",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/me_deixa_em_paz?source=ireal"
      },
      {
        "title": "Me Deixa Em Paz (Nascimento)",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/me_deixa_em_paz_nascimento?source=ireal"
      },
      {
        "title": "Meditation",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/meditation?source=ireal"
      },
      {
        "title": "Mimha Saudade",
        "artist": "João Donato",
        "url": "https://www.quickchords.org/charts/brazilian/joo_donato/mimha_saudade?source=ireal"
      },
      {
        "title": "Monster And The Flower, The",
        "artist": "Claudio Roditi",
        "url": "https://www.quickchords.org/charts/brazilian/claudio_roditi/monster_and_the_flower_the?source=ireal"
      },
      {
        "title": "Muito Obrigado",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/muito_obrigado?source=ireal"
      },
      {
        "title": "Nada Sera Como Antes",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/nada_sera_como_antes?source=ireal"
      },
      {
        "title": "Nightmood",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/nightmood?source=ireal"
      },
      {
        "title": "Noite, A",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/noite_a?source=ireal"
      },
      {
        "title": "Noturna",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/noturna?source=ireal"
      },
      {
        "title": "Novidade, A",
        "artist": "Gilberto Gil",
        "url": "https://www.quickchords.org/charts/brazilian/gilberto_gil/novidade_a?source=ireal"
      },
      {
        "title": "Novo Tempo",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/novo_tempo?source=ireal"
      },
      {
        "title": "O Grande Amor",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/o_grande_amor?source=ireal"
      },
      {
        "title": "O Pato",
        "artist": "Texeira Neuza - Silva Jayme",
        "url": "https://www.quickchords.org/charts/brazilian/texeira_neuza__silva_jayme/o_pato?source=ireal"
      },
      {
        "title": "O Sambinha",
        "artist": "Hugo Fatorusso",
        "url": "https://www.quickchords.org/charts/brazilian/hugo_fatorusso/o_sambinha?source=ireal"
      },
      {
        "title": "O Tempo Me Guardou você",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/o_tempo_me_guardou_voc?source=ireal"
      },
      {
        "title": "Obsessao",
        "artist": "Monsueto",
        "url": "https://www.quickchords.org/charts/brazilian/monsueto/obsessao?source=ireal"
      },
      {
        "title": "Oceano",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/oceano?source=ireal"
      },
      {
        "title": "Odara",
        "artist": "Caetano Veloso",
        "url": "https://www.quickchords.org/charts/brazilian/caetano_veloso/odara?source=ireal"
      },
      {
        "title": "Once I Loved",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/once_i_loved?source=ireal"
      },
      {
        "title": "One Note Samba",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/one_note_samba?source=ireal"
      },
      {
        "title": "Outra Vez",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/outra_vez?source=ireal"
      },
      {
        "title": "Pais Tropical",
        "artist": "Sergio Mendes (Jorge Ben Jor)",
        "url": "https://www.quickchords.org/charts/brazilian/sergio_mendes_jorge_ben_jor/pais_tropical?source=ireal"
      },
      {
        "title": "Palco",
        "artist": "Gilberto Gil",
        "url": "https://www.quickchords.org/charts/brazilian/gilberto_gil/palco?source=ireal"
      },
      {
        "title": "Papel Mache",
        "artist": "João Bosco",
        "url": "https://www.quickchords.org/charts/brazilian/joo_bosco/papel_mache?source=ireal"
      },
      {
        "title": "Pedacinhos Do Céu",
        "artist": "Waldir Azevedo",
        "url": "https://www.quickchords.org/charts/brazilian/waldir_azevedo/pedacinhos_do_cu?source=ireal"
      },
      {
        "title": "Ponta De Areia",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/ponta_de_areia?source=ireal"
      },
      {
        "title": "Ponteio",
        "artist": "Capinan Carlos Jose - Lobo Edu",
        "url": "https://www.quickchords.org/charts/brazilian/capinan_carlos_jose__lobo_edu/ponteio?source=ireal"
      },
      {
        "title": "Rã, A",
        "artist": "Veloso Donato-Caetano João",
        "url": "https://www.quickchords.org/charts/brazilian/veloso_donatocaetano_joo/r_a?source=ireal"
      },
      {
        "title": "Recado Bossa Nova",
        "artist": "Djalma Ferreira",
        "url": "https://www.quickchords.org/charts/brazilian/djalma_ferreira/recado_bossa_nova?source=ireal"
      },
      {
        "title": "Rio De Maio",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/rio_de_maio?source=ireal"
      },
      {
        "title": "Rosa Morena",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/rosa_morena?source=ireal"
      },
      {
        "title": "Saídas E Bandeiras",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/sadas_e_bandeiras?source=ireal"
      },
      {
        "title": "Samba De Orfeu",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/brazilian/luiz_bonfa/samba_de_orfeu?source=ireal"
      },
      {
        "title": "Samba De Rei",
        "artist": "Carlos Pingarilho",
        "url": "https://www.quickchords.org/charts/brazilian/carlos_pingarilho/samba_de_rei?source=ireal"
      },
      {
        "title": "Samba Dobrado",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/samba_dobrado?source=ireal"
      },
      {
        "title": "Samurai",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/samurai?source=ireal"
      },
      {
        "title": "Sem Fantasia",
        "artist": "Chico Buarque",
        "url": "https://www.quickchords.org/charts/brazilian/chico_buarque/sem_fantasia?source=ireal"
      },
      {
        "title": "Serrado",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/serrado?source=ireal"
      },
      {
        "title": "Setembro",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/setembro?source=ireal"
      },
      {
        "title": "Sina",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/sina?source=ireal"
      },
      {
        "title": "So Many Stars",
        "artist": "Sergio Mendez",
        "url": "https://www.quickchords.org/charts/brazilian/sergio_mendez/so_many_stars?source=ireal"
      },
      {
        "title": "So Nice (Summer Samba)",
        "artist": "Marco Valles",
        "url": "https://www.quickchords.org/charts/brazilian/marco_valles/so_nice_summer_samba?source=ireal"
      },
      {
        "title": "So Tinha De Ser Com Voçe",
        "artist": "Oliveira de Jobim-Aloysio Antonio-Carlos",
        "url": "https://www.quickchords.org/charts/brazilian/oliveira_de_jobimaloysio_antoniocarlos/so_tinha_de_ser_com_voe?source=ireal"
      },
      {
        "title": "Sozinho",
        "artist": "Caetano Veloso",
        "url": "https://www.quickchords.org/charts/brazilian/caetano_veloso/sozinho?source=ireal"
      },
      {
        "title": "Só Danço Samba",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/s_dano_samba?source=ireal"
      },
      {
        "title": "Tens (Calmaria)",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/tens_calmaria?source=ireal"
      },
      {
        "title": "Triste",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/triste?source=ireal"
      },
      {
        "title": "Tristeza",
        "artist": "Niltinho - Lobo Haroldo",
        "url": "https://www.quickchords.org/charts/brazilian/niltinho__lobo_haroldo/tristeza?source=ireal"
      },
      {
        "title": "Tudo Que Voce Podia Ser",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/tudo_que_voce_podia_ser?source=ireal"
      },
      {
        "title": "Valsa",
        "artist": "João Gilberto",
        "url": "https://www.quickchords.org/charts/brazilian/joo_gilberto/valsa?source=ireal"
      },
      {
        "title": "Velas (Velas Içadas)",
        "artist": "Martins Vitor - Lins Ivan",
        "url": "https://www.quickchords.org/charts/brazilian/martins_vitor__lins_ivan/velas_velas_iadas?source=ireal"
      },
      {
        "title": "Ventos Do Norte",
        "artist": "Djavan",
        "url": "https://www.quickchords.org/charts/brazilian/djavan/ventos_do_norte?source=ireal"
      },
      {
        "title": "Vera Cruz",
        "artist": "Milton Nascimento",
        "url": "https://www.quickchords.org/charts/brazilian/milton_nascimento/vera_cruz?source=ireal"
      },
      {
        "title": "Vitoriosa",
        "artist": "Ivan Lins",
        "url": "https://www.quickchords.org/charts/brazilian/ivan_lins/vitoriosa?source=ireal"
      },
      {
        "title": "Vivo Sonhando (Dreamer)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/vivo_sonhando_dreamer?source=ireal"
      },
      {
        "title": "Voce Vai Ver",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/voce_vai_ver?source=ireal"
      },
      {
        "title": "Você E Eu",
        "artist": "Carlos Lyra",
        "url": "https://www.quickchords.org/charts/brazilian/carlos_lyra/voc_e_eu?source=ireal"
      },
      {
        "title": "Wave",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/wave?source=ireal"
      },
      {
        "title": "Zingaro (Retrato Em Branco E Preto)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/brazilian/antoniocarlos_jobim/zingaro_retrato_em_branco_e_preto?source=ireal"
      }
    ]
  },
  {
    "title": "Country",
    "items": [
      {
        "title": "Blue Eyes Crying In The Rain",
        "artist": "Willie Nelson (Fred Rose)",
        "url": "https://www.quickchords.org/charts/country/willie_nelson_fred_rose/blue_eyes_crying_in_the_rain?source=ireal"
      },
      {
        "title": "Blue Moon of Kentucky",
        "artist": "Bill Monroe",
        "url": "https://www.quickchords.org/charts/country/bill_monroe/blue_moon_of_kentucky?source=ireal"
      },
      {
        "title": "Boy Named Sue, A",
        "artist": "Johnny Cash",
        "url": "https://www.quickchords.org/charts/country/johnny_cash/boy_named_sue_a?source=ireal"
      },
      {
        "title": "Can the Circle Be Unbroken (1935)",
        "artist": "Family Carter The",
        "url": "https://www.quickchords.org/charts/country/family_carter_the/can_the_circle_be_unbroken_1935?source=ireal"
      },
      {
        "title": "Coal Miner's Daughter",
        "artist": "Loretta Lynn",
        "url": "https://www.quickchords.org/charts/country/loretta_lynn/coal_miners_daughter?source=ireal"
      },
      {
        "title": "Cold Cold Heart",
        "artist": "Hank Williams",
        "url": "https://www.quickchords.org/charts/country/hank_williams/cold_cold_heart?source=ireal"
      },
      {
        "title": "Crazy",
        "artist": "Willie Nelson",
        "url": "https://www.quickchords.org/charts/country/willie_nelson/crazy?source=ireal"
      },
      {
        "title": "Crying",
        "artist": "Melson Orbison-Joe Roy",
        "url": "https://www.quickchords.org/charts/country/melson_orbisonjoe_roy/crying?source=ireal"
      },
      {
        "title": "Dance, The",
        "artist": "Garth Brooks",
        "url": "https://www.quickchords.org/charts/country/garth_brooks/dance_the?source=ireal"
      },
      {
        "title": "Don't Come Home Drinkin'",
        "artist": "Loretta Lynn",
        "url": "https://www.quickchords.org/charts/country/loretta_lynn/dont_come_home_drinkin?source=ireal"
      },
      {
        "title": "Forever And Ever Amen",
        "artist": "Randy Travis (Overstreet-Schlitz)",
        "url": "https://www.quickchords.org/charts/country/randy_travis_overstreetschlitz/forever_and_ever_amen?source=ireal"
      },
      {
        "title": "Friends In Low Places",
        "artist": "Garth Brooks (Blackwell-Lee)",
        "url": "https://www.quickchords.org/charts/country/garth_brooks_blackwelllee/friends_in_low_places?source=ireal"
      },
      {
        "title": "Galveston",
        "artist": "Glen Campbell (Jim Webb)",
        "url": "https://www.quickchords.org/charts/country/glen_campbell_jim_webb/galveston?source=ireal"
      },
      {
        "title": "Gambler, The",
        "artist": "Kenny Rogers (Don Schlitz)",
        "url": "https://www.quickchords.org/charts/country/kenny_rogers_don_schlitz/gambler_the?source=ireal"
      },
      {
        "title": "Gone Country",
        "artist": "Alan Jackson (Bob McDill)",
        "url": "https://www.quickchords.org/charts/country/alan_jackson_bob_mcdill/gone_country?source=ireal"
      },
      {
        "title": "Goodnight Irene",
        "artist": "Lomax A. Lebetter-John Huddie",
        "url": "https://www.quickchords.org/charts/country/lomax_a_lebetterjohn_huddie/goodnight_irene?source=ireal"
      },
      {
        "title": "He Stopped Loving Her Today",
        "artist": "George Jones (Braddock-Putman)",
        "url": "https://www.quickchords.org/charts/country/george_jones_braddockputman/he_stopped_loving_her_today?source=ireal"
      },
      {
        "title": "I Am A Man Of Constant Sorrow",
        "artist": "Carter Stanley",
        "url": "https://www.quickchords.org/charts/country/carter_stanley/i_am_a_man_of_constant_sorrow?source=ireal"
      },
      {
        "title": "I Fall To Pieces",
        "artist": "Patsy Cline (Cochran-Howard)",
        "url": "https://www.quickchords.org/charts/country/patsy_cline_cochranhoward/i_fall_to_pieces?source=ireal"
      },
      {
        "title": "I Walk The line",
        "artist": "Johnny Cash",
        "url": "https://www.quickchords.org/charts/country/johnny_cash/i_walk_the_line?source=ireal"
      },
      {
        "title": "I'm So Lonesome I Could Cry",
        "artist": "Hank Williams",
        "url": "https://www.quickchords.org/charts/country/hank_williams/im_so_lonesome_i_could_cry?source=ireal"
      },
      {
        "title": "It Wasn't God Who Made Honky Tonk Angels",
        "artist": "Kitty Wells (J.D. Miller)",
        "url": "https://www.quickchords.org/charts/country/kitty_wells_jd_miller/it_wasnt_god_who_made_honky_tonk_angels?source=ireal"
      },
      {
        "title": "Jackson",
        "artist": "Johnny Cash-June Carter (Leiber-Wheeler)",
        "url": "https://www.quickchords.org/charts/country/johnny_cashjune_carter_leiberwheeler/jackson?source=ireal"
      },
      {
        "title": "Jambalaya (On The Bayou)",
        "artist": "Hank Williams",
        "url": "https://www.quickchords.org/charts/country/hank_williams/jambalaya_on_the_bayou?source=ireal"
      },
      {
        "title": "Jolene",
        "artist": "Dolly Parton",
        "url": "https://www.quickchords.org/charts/country/dolly_parton/jolene?source=ireal"
      },
      {
        "title": "Keep On The Sunny Side",
        "artist": "The Carter Family (Blenkhorn-Entwisle)",
        "url": "https://www.quickchords.org/charts/country/the_carter_family_blenkhornentwisle/keep_on_the_sunny_side?source=ireal"
      },
      {
        "title": "King Of The Road",
        "artist": "Roger Miller",
        "url": "https://www.quickchords.org/charts/country/roger_miller/king_of_the_road?source=ireal"
      },
      {
        "title": "Legend Of Bonnie And Clyde, The",
        "artist": "Merle Haggard",
        "url": "https://www.quickchords.org/charts/country/merle_haggard/legend_of_bonnie_and_clyde_the?source=ireal"
      },
      {
        "title": "Long Black Veil, The",
        "artist": "Lefty Frizzell (Wilkin-Dill)",
        "url": "https://www.quickchords.org/charts/country/lefty_frizzell_wilkindill/long_black_veil_the?source=ireal"
      },
      {
        "title": "Lost Highway",
        "artist": "Hank Williams",
        "url": "https://www.quickchords.org/charts/country/hank_williams/lost_highway?source=ireal"
      },
      {
        "title": "Mama Tried",
        "artist": "Merle Haggard",
        "url": "https://www.quickchords.org/charts/country/merle_haggard/mama_tried?source=ireal"
      },
      {
        "title": "Mammas Don't Let Your Babies Grow Up to Be Cowboys",
        "artist": "Willie and Waylon (Bruce-Bruce)",
        "url": "https://www.quickchords.org/charts/country/willie_and_waylon_brucebruce/mammas_dont_let_your_babies_grow_up_to_be_cowboys?source=ireal"
      },
      {
        "title": "Mind Your Own Business",
        "artist": "Hank Williams",
        "url": "https://www.quickchords.org/charts/country/hank_williams/mind_your_own_business?source=ireal"
      },
      {
        "title": "Move It On Over",
        "artist": "Hank Williams",
        "url": "https://www.quickchords.org/charts/country/hank_williams/move_it_on_over?source=ireal"
      },
      {
        "title": "Okie From Muskogee",
        "artist": "Burris E. Haggard-Roy Merle",
        "url": "https://www.quickchords.org/charts/country/burris_e_haggardroy_merle/okie_from_muskogee?source=ireal"
      },
      {
        "title": "Ring of Fire",
        "artist": "Cash (Carter-Kilgore)",
        "url": "https://www.quickchords.org/charts/country/cash_carterkilgore/ring_of_fire?source=ireal"
      },
      {
        "title": "Save The Last Dance For Me 1",
        "artist": "Emmylou Harris (Pomus-Shuman)",
        "url": "https://www.quickchords.org/charts/country/emmylou_harris_pomusshuman/save_the_last_dance_for_me_1?source=ireal"
      },
      {
        "title": "She's Got You",
        "artist": "Patsy Cline (Hank Cochran)",
        "url": "https://www.quickchords.org/charts/country/patsy_cline_hank_cochran/shes_got_you?source=ireal"
      },
      {
        "title": "Sing Me Back Home",
        "artist": "Merle Haggard",
        "url": "https://www.quickchords.org/charts/country/merle_haggard/sing_me_back_home?source=ireal"
      },
      {
        "title": "Sixteen Tons (1947)",
        "artist": "Merle Travis",
        "url": "https://www.quickchords.org/charts/country/merle_travis/sixteen_tons_1947?source=ireal"
      },
      {
        "title": "Stand By Your Man",
        "artist": "Sherrill Billy Wynette- Tammy",
        "url": "https://www.quickchords.org/charts/country/sherrill_billy_wynette_tammy/stand_by_your_man?source=ireal"
      },
      {
        "title": "Sunday Morning Coming Down",
        "artist": "Kris Kristofferson",
        "url": "https://www.quickchords.org/charts/country/kris_kristofferson/sunday_morning_coming_down?source=ireal"
      },
      {
        "title": "Tennessee Flat Top Box",
        "artist": "Rosanne Cash (Johnny Cash)",
        "url": "https://www.quickchords.org/charts/country/rosanne_cash_johnny_cash/tennessee_flat_top_box?source=ireal"
      },
      {
        "title": "Tennessee Waltz",
        "artist": "Patti Page (Stewart-King)",
        "url": "https://www.quickchords.org/charts/country/patti_page_stewartking/tennessee_waltz?source=ireal"
      },
      {
        "title": "Wabash Cannoball",
        "artist": "Roy Scuff (J.A. Roff)",
        "url": "https://www.quickchords.org/charts/country/roy_scuff_ja_roff/wabash_cannoball?source=ireal"
      },
      {
        "title": "Walkin' After Midnight",
        "artist": "Patsy Cline (Block-Hecht)",
        "url": "https://www.quickchords.org/charts/country/patsy_cline_blockhecht/walkin_after_midnight?source=ireal"
      },
      {
        "title": "Year That Clayton Delaney Died, The",
        "artist": "Tom Hall",
        "url": "https://www.quickchords.org/charts/country/tom_hall/year_that_clayton_delaney_died_the?source=ireal"
      },
      {
        "title": "You Are My Sunshine",
        "artist": "Gene Autrey (Jimmie Davis)",
        "url": "https://www.quickchords.org/charts/country/gene_autrey_jimmie_davis/you_are_my_sunshine?source=ireal"
      },
      {
        "title": "You Don't Know Me",
        "artist": "Walker Arnold-Cindy Eddy",
        "url": "https://www.quickchords.org/charts/country/walker_arnoldcindy_eddy/you_dont_know_me?source=ireal"
      },
      {
        "title": "Your Cheatin' Heart",
        "artist": "Hank Williams",
        "url": "https://www.quickchords.org/charts/country/hank_williams/your_cheatin_heart?source=ireal"
      }
    ]
  },
  {
    "title": "Jazz",
    "items": [
      {
        "title": "26-2",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/262?source=ireal"
      },
      {
        "title": "500 Miles High",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/500_miles_high?source=ireal"
      },
      {
        "title": "502 Blues",
        "artist": "Jimmy Rowles",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_rowles/502_blues?source=ireal"
      },
      {
        "title": "52nd Street Theme",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/52nd_street_theme?source=ireal"
      },
      {
        "title": "9.20 Special",
        "artist": "Earl Warren",
        "url": "https://www.quickchords.org/charts/jazz/earl_warren/920_special?source=ireal"
      },
      {
        "title": "A Ballad",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/jazz/gerry_mulligan/a_ballad?source=ireal"
      },
      {
        "title": "A Beautiful Friendship",
        "artist": "Donald Kahn",
        "url": "https://www.quickchords.org/charts/jazz/donald_kahn/a_beautiful_friendship?source=ireal"
      },
      {
        "title": "A Blossom Fell",
        "artist": "Barnes-Cornelius",
        "url": "https://www.quickchords.org/charts/jazz/barnescornelius/a_blossom_fell?source=ireal"
      },
      {
        "title": "A Certain Smile",
        "artist": "Fain-Webster",
        "url": "https://www.quickchords.org/charts/jazz/fainwebster/a_certain_smile?source=ireal"
      },
      {
        "title": "A Child Is Born",
        "artist": "Thad Jones",
        "url": "https://www.quickchords.org/charts/jazz/thad_jones/a_child_is_born?source=ireal"
      },
      {
        "title": "A Felicidade",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/a_felicidade?source=ireal"
      },
      {
        "title": "A Fine Romance",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/a_fine_romance?source=ireal"
      },
      {
        "title": "A Flower Is A Lovesome Thing",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/a_flower_is_a_lovesome_thing?source=ireal"
      },
      {
        "title": "A Foggy Day",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/a_foggy_day?source=ireal"
      },
      {
        "title": "A Ghost Of A Chance",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/jazz/victor_young/a_ghost_of_a_chance?source=ireal"
      },
      {
        "title": "A Kiss To Build A Dream On",
        "artist": "Kalmar-Ruby-Hammerstein",
        "url": "https://www.quickchords.org/charts/jazz/kalmarrubyhammerstein/a_kiss_to_build_a_dream_on?source=ireal"
      },
      {
        "title": "A Little Tear",
        "artist": "Deodato-Valle",
        "url": "https://www.quickchords.org/charts/jazz/deodatovalle/a_little_tear?source=ireal"
      },
      {
        "title": "A Lovely Way To Spend An Evening",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/a_lovely_way_to_spend_an_evening?source=ireal"
      },
      {
        "title": "A Night In Tunisia",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/a_night_in_tunisia?source=ireal"
      },
      {
        "title": "A Nightingale Sang In Berkeley Square",
        "artist": "Manning Sherwin",
        "url": "https://www.quickchords.org/charts/jazz/manning_sherwin/a_nightingale_sang_in_berkeley_square?source=ireal"
      },
      {
        "title": "A Pretty Girl Is Like A Melody",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/a_pretty_girl_is_like_a_melody?source=ireal"
      },
      {
        "title": "A Sleepin' Bee",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/a_sleepin_bee?source=ireal"
      },
      {
        "title": "A Smooth One",
        "artist": "Benny Goodman",
        "url": "https://www.quickchords.org/charts/jazz/benny_goodman/a_smooth_one?source=ireal"
      },
      {
        "title": "A Sound For Sore Ears",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_heath/a_sound_for_sore_ears?source=ireal"
      },
      {
        "title": "A Sunday Kind Of Love",
        "artist": "Belle-Prima-Leonard-Rhodes",
        "url": "https://www.quickchords.org/charts/jazz/belleprimaleonardrhodes/a_sunday_kind_of_love?source=ireal"
      },
      {
        "title": "A Taste Of Honey",
        "artist": "Marlow-Scott",
        "url": "https://www.quickchords.org/charts/jazz/marlowscott/a_taste_of_honey?source=ireal"
      },
      {
        "title": "A Time For Love",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/jazz/johnny_mandel/a_time_for_love?source=ireal"
      },
      {
        "title": "A Tisket A Tasket",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/a_tisket_a_tasket?source=ireal"
      },
      {
        "title": "A Weaver Of Dreams",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/jazz/victor_young/a_weaver_of_dreams?source=ireal"
      },
      {
        "title": "A Wonderful Day Like Today",
        "artist": "Bricusse-Newley",
        "url": "https://www.quickchords.org/charts/jazz/bricussenewley/a_wonderful_day_like_today?source=ireal"
      },
      {
        "title": "Ablution",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/jazz/lennie_tristano/ablution?source=ireal"
      },
      {
        "title": "Ac-Cent-Tchu-Ate The Positive",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/accenttchuate_the_positive?source=ireal"
      },
      {
        "title": "Across The Alley From The Alamo",
        "artist": "Joe Greene",
        "url": "https://www.quickchords.org/charts/jazz/joe_greene/across_the_alley_from_the_alamo?source=ireal"
      },
      {
        "title": "Adam's Apple",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/adams_apple?source=ireal"
      },
      {
        "title": "Affirmation",
        "artist": "José Feliciano",
        "url": "https://www.quickchords.org/charts/jazz/jos_feliciano/affirmation?source=ireal"
      },
      {
        "title": "African Queen, The",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/african_queen_the?source=ireal"
      },
      {
        "title": "Afro Blue",
        "artist": "Mongo Santamaria",
        "url": "https://www.quickchords.org/charts/jazz/mongo_santamaria/afro_blue?source=ireal"
      },
      {
        "title": "Afro Centric",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/afro_centric?source=ireal"
      },
      {
        "title": "After You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/after_you?source=ireal"
      },
      {
        "title": "After You've Gone",
        "artist": "Henry Creamer",
        "url": "https://www.quickchords.org/charts/jazz/henry_creamer/after_youve_gone?source=ireal"
      },
      {
        "title": "Afternoon In Paris",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/jazz/john_lewis/afternoon_in_paris?source=ireal"
      },
      {
        "title": "Again",
        "artist": "Lionel Newman",
        "url": "https://www.quickchords.org/charts/jazz/lionel_newman/again?source=ireal"
      },
      {
        "title": "Agua De Beber",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/agua_de_beber?source=ireal"
      },
      {
        "title": "Ahmid-6",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/ahmid6?source=ireal"
      },
      {
        "title": "Ain't Misbehavin'",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/jazz/fats_waller/aint_misbehavin?source=ireal"
      },
      {
        "title": "Ain't She Sweet",
        "artist": "Milton Ager",
        "url": "https://www.quickchords.org/charts/jazz/milton_ager/aint_she_sweet?source=ireal"
      },
      {
        "title": "Airegin",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/airegin?source=ireal"
      },
      {
        "title": "Airmail Special",
        "artist": "Charlie Christian",
        "url": "https://www.quickchords.org/charts/jazz/charlie_christian/airmail_special?source=ireal"
      },
      {
        "title": "Aisha",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/jazz/mccoy_tyner/aisha?source=ireal"
      },
      {
        "title": "Alexander's Ragtime Band",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/alexanders_ragtime_band?source=ireal"
      },
      {
        "title": "Alfie",
        "artist": "Burt Bacharach",
        "url": "https://www.quickchords.org/charts/jazz/burt_bacharach/alfie?source=ireal"
      },
      {
        "title": "Alfie's Theme",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/alfies_theme?source=ireal"
      },
      {
        "title": "Alice In Wonderland",
        "artist": "Sammy Fain",
        "url": "https://www.quickchords.org/charts/jazz/sammy_fain/alice_in_wonderland?source=ireal"
      },
      {
        "title": "All About Ronnie",
        "artist": "Joe Greene",
        "url": "https://www.quickchords.org/charts/jazz/joe_greene/all_about_ronnie?source=ireal"
      },
      {
        "title": "All Alone",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/all_alone?source=ireal"
      },
      {
        "title": "All Blues",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/all_blues?source=ireal"
      },
      {
        "title": "All By Myself",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/all_by_myself?source=ireal"
      },
      {
        "title": "All God's Chillun Got Rhythm",
        "artist": "Kahn-Kaper",
        "url": "https://www.quickchords.org/charts/jazz/kahnkaper/all_gods_chillun_got_rhythm?source=ireal"
      },
      {
        "title": "All My Tomorrows",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/all_my_tomorrows?source=ireal"
      },
      {
        "title": "All Of A Sudden My Heart Sings",
        "artist": "Herpin-Jamblan-Rome",
        "url": "https://www.quickchords.org/charts/jazz/herpinjamblanrome/all_of_a_sudden_my_heart_sings?source=ireal"
      },
      {
        "title": "All Of Me",
        "artist": "Gerald Marks",
        "url": "https://www.quickchords.org/charts/jazz/gerald_marks/all_of_me?source=ireal"
      },
      {
        "title": "All Of You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/all_of_you?source=ireal"
      },
      {
        "title": "All Or Nothing At All",
        "artist": "Arthur Altman",
        "url": "https://www.quickchords.org/charts/jazz/arthur_altman/all_or_nothing_at_all?source=ireal"
      },
      {
        "title": "All The Things You Are",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/all_the_things_you_are?source=ireal"
      },
      {
        "title": "All The Way",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/all_the_way?source=ireal"
      },
      {
        "title": "All Through The Day",
        "artist": "Kern-Hammerstein",
        "url": "https://www.quickchords.org/charts/jazz/kernhammerstein/all_through_the_day?source=ireal"
      },
      {
        "title": "All Through The Night",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/all_through_the_night?source=ireal"
      },
      {
        "title": "All Too Soon",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/all_too_soon?source=ireal"
      },
      {
        "title": "Almost Like Being In Love",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/jazz/frederick_loewe/almost_like_being_in_love?source=ireal"
      },
      {
        "title": "Alone Together",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/alone_together?source=ireal"
      },
      {
        "title": "Alone Too Long",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/alone_too_long?source=ireal"
      },
      {
        "title": "Along Came Betty",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/along_came_betty?source=ireal"
      },
      {
        "title": "Always",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/always?source=ireal"
      },
      {
        "title": "Always And Forever",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/always_and_forever?source=ireal"
      },
      {
        "title": "Am I Blue?",
        "artist": "Harry Akst",
        "url": "https://www.quickchords.org/charts/jazz/harry_akst/am_i_blue?source=ireal"
      },
      {
        "title": "Among My Souvenirs",
        "artist": "Horatio Nicholls",
        "url": "https://www.quickchords.org/charts/jazz/horatio_nicholls/among_my_souvenirs?source=ireal"
      },
      {
        "title": "Ana Maria",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/ana_maria?source=ireal"
      },
      {
        "title": "And On The Third Day",
        "artist": "Michael Gibbs",
        "url": "https://www.quickchords.org/charts/jazz/michael_gibbs/and_on_the_third_day?source=ireal"
      },
      {
        "title": "And The Angels Sing",
        "artist": "Ziggy Elman",
        "url": "https://www.quickchords.org/charts/jazz/ziggy_elman/and_the_angels_sing?source=ireal"
      },
      {
        "title": "Angel Eyes",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/jazz/matt_dennis/angel_eyes?source=ireal"
      },
      {
        "title": "Anthropology",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/anthropology?source=ireal"
      },
      {
        "title": "Anything Goes",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/anything_goes?source=ireal"
      },
      {
        "title": "April",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/jazz/lennie_tristano/april?source=ireal"
      },
      {
        "title": "April In Paris",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/jazz/vernon_duke/april_in_paris?source=ireal"
      },
      {
        "title": "April Joy",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/april_joy?source=ireal"
      },
      {
        "title": "April Skies",
        "artist": "Buddy Collette",
        "url": "https://www.quickchords.org/charts/jazz/buddy_collette/april_skies?source=ireal"
      },
      {
        "title": "Aren't You Glad You're You",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/arent_you_glad_youre_you?source=ireal"
      },
      {
        "title": "Armando's Rhumba",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/armandos_rhumba?source=ireal"
      },
      {
        "title": "As Long As I Live",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/as_long_as_i_live?source=ireal"
      },
      {
        "title": "As Time Goes By",
        "artist": "Herman Hupfeld",
        "url": "https://www.quickchords.org/charts/jazz/herman_hupfeld/as_time_goes_by?source=ireal"
      },
      {
        "title": "Ask Me Now",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/ask_me_now?source=ireal"
      },
      {
        "title": "At Last",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/at_last?source=ireal"
      },
      {
        "title": "At Long Last Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/at_long_last_love?source=ireal"
      },
      {
        "title": "Au Privave",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/au_privave?source=ireal"
      },
      {
        "title": "Autumn In New York",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/jazz/vernon_duke/autumn_in_new_york?source=ireal"
      },
      {
        "title": "Autumn Leaves",
        "artist": "Joseph Kosma",
        "url": "https://www.quickchords.org/charts/jazz/joseph_kosma/autumn_leaves?source=ireal"
      },
      {
        "title": "Autumn Nocturne",
        "artist": "Gannon-Myrow",
        "url": "https://www.quickchords.org/charts/jazz/gannonmyrow/autumn_nocturne?source=ireal"
      },
      {
        "title": "Avalon",
        "artist": "Jolson-Sylva-Rose",
        "url": "https://www.quickchords.org/charts/jazz/jolsonsylvarose/avalon?source=ireal"
      },
      {
        "title": "Ba-lue Bolivar Ba-lues-are",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/balue_bolivar_baluesare?source=ireal"
      },
      {
        "title": "Backstage Sally",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/backstage_sally?source=ireal"
      },
      {
        "title": "Bags and Trane",
        "artist": "Milt Jackson",
        "url": "https://www.quickchords.org/charts/jazz/milt_jackson/bags_and_trane?source=ireal"
      },
      {
        "title": "Bags' Groove",
        "artist": "Milt Jackson",
        "url": "https://www.quickchords.org/charts/jazz/milt_jackson/bags_groove?source=ireal"
      },
      {
        "title": "Balance, The",
        "artist": "Dave Holland",
        "url": "https://www.quickchords.org/charts/jazz/dave_holland/balance_the?source=ireal"
      },
      {
        "title": "Ballade",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/ballade?source=ireal"
      },
      {
        "title": "Baltimore Oriole",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/baltimore_oriole?source=ireal"
      },
      {
        "title": "Barbados",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/barbados?source=ireal"
      },
      {
        "title": "Barbara",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/barbara?source=ireal"
      },
      {
        "title": "Bark For Barksdale",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/jazz/gerry_mulligan/bark_for_barksdale?source=ireal"
      },
      {
        "title": "Basin Street Blues",
        "artist": "Spencer Williams",
        "url": "https://www.quickchords.org/charts/jazz/spencer_williams/basin_street_blues?source=ireal"
      },
      {
        "title": "Bat, The",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/bat_the?source=ireal"
      },
      {
        "title": "Baubles, Bangles and Beads",
        "artist": "Borodin-Wright-Forrest",
        "url": "https://www.quickchords.org/charts/jazz/borodinwrightforrest/baubles_bangles_and_beads?source=ireal"
      },
      {
        "title": "Be Careful It's My Heart",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/be_careful_its_my_heart?source=ireal"
      },
      {
        "title": "Be My Love",
        "artist": "Nikolaus Brodszky",
        "url": "https://www.quickchords.org/charts/jazz/nikolaus_brodszky/be_my_love?source=ireal"
      },
      {
        "title": "Be-Bop",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/bebop?source=ireal"
      },
      {
        "title": "Beatrice",
        "artist": "Sam Rivers",
        "url": "https://www.quickchords.org/charts/jazz/sam_rivers/beatrice?source=ireal"
      },
      {
        "title": "Beautiful Love",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/jazz/victor_young/beautiful_love?source=ireal"
      },
      {
        "title": "Beauty And The Beast",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/beauty_and_the_beast?source=ireal"
      },
      {
        "title": "Begin The Beguine",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/begin_the_beguine?source=ireal"
      },
      {
        "title": "Bein' Green",
        "artist": "Joe Raposo",
        "url": "https://www.quickchords.org/charts/jazz/joe_raposo/bein_green?source=ireal"
      },
      {
        "title": "Bemsha Swing",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/bemsha_swing?source=ireal"
      },
      {
        "title": "Benny's Tune",
        "artist": "Lionel Loueke",
        "url": "https://www.quickchords.org/charts/jazz/lionel_loueke/bennys_tune?source=ireal"
      },
      {
        "title": "Bernie's Tune",
        "artist": "Bernie Miller",
        "url": "https://www.quickchords.org/charts/jazz/bernie_miller/bernies_tune?source=ireal"
      },
      {
        "title": "Besame Mucho",
        "artist": "Consuelo Velazques",
        "url": "https://www.quickchords.org/charts/jazz/consuelo_velazques/besame_mucho?source=ireal"
      },
      {
        "title": "Bess You Is My Woman",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/bess_you_is_my_woman?source=ireal"
      },
      {
        "title": "Bessie's Blues",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/bessies_blues?source=ireal"
      },
      {
        "title": "Best Is Yet To Come (Page 1), The",
        "artist": "Cy Coleman",
        "url": "https://www.quickchords.org/charts/jazz/cy_coleman/best_is_yet_to_come_page_1_the?source=ireal"
      },
      {
        "title": "Best Is Yet To Come (Page 2), The",
        "artist": "Cy Coleman",
        "url": "https://www.quickchords.org/charts/jazz/cy_coleman/best_is_yet_to_come_page_2_the?source=ireal"
      },
      {
        "title": "Best Thing For You Is Me, The",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/best_thing_for_you_is_me_the?source=ireal"
      },
      {
        "title": "Best Things In Life Are Free, The",
        "artist": "DeSylva-Brown-Henderson",
        "url": "https://www.quickchords.org/charts/jazz/desylvabrownhenderson/best_things_in_life_are_free_the?source=ireal"
      },
      {
        "title": "Better Days Ahead",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/better_days_ahead?source=ireal"
      },
      {
        "title": "Better Git It In Your Soul",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/jazz/charles_mingus/better_git_it_in_your_soul?source=ireal"
      },
      {
        "title": "Better Than Anything",
        "artist": "Loughborough-Wheat",
        "url": "https://www.quickchords.org/charts/jazz/loughboroughwheat/better_than_anything?source=ireal"
      },
      {
        "title": "Between The Devil And The Deep Blue Sea",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/between_the_devil_and_the_deep_blue_sea?source=ireal"
      },
      {
        "title": "Bewitched",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/bewitched?source=ireal"
      },
      {
        "title": "Beyond The Blue Horizon",
        "artist": "Whiting-Harding",
        "url": "https://www.quickchords.org/charts/jazz/whitingharding/beyond_the_blue_horizon?source=ireal"
      },
      {
        "title": "Beyond The Sea",
        "artist": "Charles Trenet",
        "url": "https://www.quickchords.org/charts/jazz/charles_trenet/beyond_the_sea?source=ireal"
      },
      {
        "title": "Bidin' My Time",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/bidin_my_time?source=ireal"
      },
      {
        "title": "Bill Bailey",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/bill_bailey?source=ireal"
      },
      {
        "title": "Bill's Hit Tune",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/bills_hit_tune?source=ireal"
      },
      {
        "title": "Billie's Bounce",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/billies_bounce?source=ireal"
      },
      {
        "title": "Billy Boy",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/billy_boy?source=ireal"
      },
      {
        "title": "Birk's Works",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/birks_works?source=ireal"
      },
      {
        "title": "Birth Of The Blues, The",
        "artist": "Ray Henderson",
        "url": "https://www.quickchords.org/charts/jazz/ray_henderson/birth_of_the_blues_the?source=ireal"
      },
      {
        "title": "Black And Blue",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/jazz/fats_waller/black_and_blue?source=ireal"
      },
      {
        "title": "Black And Tan Fantasy",
        "artist": "Ellington-Miley",
        "url": "https://www.quickchords.org/charts/jazz/ellingtonmiley/black_and_tan_fantasy?source=ireal"
      },
      {
        "title": "Black Coffee",
        "artist": "Burke-Webster",
        "url": "https://www.quickchords.org/charts/jazz/burkewebster/black_coffee?source=ireal"
      },
      {
        "title": "Black Narcissus",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/black_narcissus?source=ireal"
      },
      {
        "title": "Black Nile",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/black_nile?source=ireal"
      },
      {
        "title": "Blackberry Winter",
        "artist": "Alec Wilder",
        "url": "https://www.quickchords.org/charts/jazz/alec_wilder/blackberry_winter?source=ireal"
      },
      {
        "title": "Blame It On My Youth",
        "artist": "Oscar Levant",
        "url": "https://www.quickchords.org/charts/jazz/oscar_levant/blame_it_on_my_youth?source=ireal"
      },
      {
        "title": "Blood Count",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/blood_count?source=ireal"
      },
      {
        "title": "Bloomdido",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/bloomdido?source=ireal"
      },
      {
        "title": "Blue (And Broken Hearted)",
        "artist": "Leslie-Handman-Clarke",
        "url": "https://www.quickchords.org/charts/jazz/lesliehandmanclarke/blue_and_broken_hearted?source=ireal"
      },
      {
        "title": "Blue And Sentimental",
        "artist": "Livingstone-David-Basie",
        "url": "https://www.quickchords.org/charts/jazz/livingstonedavidbasie/blue_and_sentimental?source=ireal"
      },
      {
        "title": "Blue Bossa",
        "artist": "Kenny Dorham",
        "url": "https://www.quickchords.org/charts/jazz/kenny_dorham/blue_bossa?source=ireal"
      },
      {
        "title": "Blue Champagne",
        "artist": "Watts-Ryerson-Eaton",
        "url": "https://www.quickchords.org/charts/jazz/wattsryersoneaton/blue_champagne?source=ireal"
      },
      {
        "title": "Blue Daniel",
        "artist": "Frank Rosolino",
        "url": "https://www.quickchords.org/charts/jazz/frank_rosolino/blue_daniel?source=ireal"
      },
      {
        "title": "Blue In Green",
        "artist": "Davis Miles/Evans Bill",
        "url": "https://www.quickchords.org/charts/jazz/davis_milesevans_bill/blue_in_green?source=ireal"
      },
      {
        "title": "Blue Lou",
        "artist": "Irving Mills",
        "url": "https://www.quickchords.org/charts/jazz/irving_mills/blue_lou?source=ireal"
      },
      {
        "title": "Blue Monk",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/blue_monk?source=ireal"
      },
      {
        "title": "Blue Moon",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/blue_moon?source=ireal"
      },
      {
        "title": "Blue Room, The",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/blue_room_the?source=ireal"
      },
      {
        "title": "Blue Silver",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/blue_silver?source=ireal"
      },
      {
        "title": "Blue Skies",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/blue_skies?source=ireal"
      },
      {
        "title": "Blue Sphere",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/blue_sphere?source=ireal"
      },
      {
        "title": "Blue Turning Grey Over You",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/jazz/fats_waller/blue_turning_grey_over_you?source=ireal"
      },
      {
        "title": "Blueberry Hill",
        "artist": "Lewis-Stock-Rose",
        "url": "https://www.quickchords.org/charts/jazz/lewisstockrose/blueberry_hill?source=ireal"
      },
      {
        "title": "Bluehawk",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/bluehawk?source=ireal"
      },
      {
        "title": "Blues Five Spot",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/blues_five_spot?source=ireal"
      },
      {
        "title": "Blues For Alice",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/blues_for_alice?source=ireal"
      },
      {
        "title": "Blues For Wood",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/jazz/woody_shaw/blues_for_wood?source=ireal"
      },
      {
        "title": "Blues In The Closet",
        "artist": "Oscar Pettiford",
        "url": "https://www.quickchords.org/charts/jazz/oscar_pettiford/blues_in_the_closet?source=ireal"
      },
      {
        "title": "Blues In The Night",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/blues_in_the_night?source=ireal"
      },
      {
        "title": "Blues March",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/blues_march?source=ireal"
      },
      {
        "title": "Bluesette",
        "artist": "Toots Thielemans",
        "url": "https://www.quickchords.org/charts/jazz/toots_thielemans/bluesette?source=ireal"
      },
      {
        "title": "Body And Soul",
        "artist": "Johnny Green",
        "url": "https://www.quickchords.org/charts/jazz/johnny_green/body_and_soul?source=ireal"
      },
      {
        "title": "Bohemia After Dark",
        "artist": "Oscar Pettiford",
        "url": "https://www.quickchords.org/charts/jazz/oscar_pettiford/bohemia_after_dark?source=ireal"
      },
      {
        "title": "Bolivia",
        "artist": "Cedar Walton",
        "url": "https://www.quickchords.org/charts/jazz/cedar_walton/bolivia?source=ireal"
      },
      {
        "title": "Boo Boo's Birthday",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/boo_boos_birthday?source=ireal"
      },
      {
        "title": "Booker's Waltz",
        "artist": "Booker Little",
        "url": "https://www.quickchords.org/charts/jazz/booker_little/bookers_waltz?source=ireal"
      },
      {
        "title": "Boplicity",
        "artist": "Cleo Henry",
        "url": "https://www.quickchords.org/charts/jazz/cleo_henry/boplicity?source=ireal"
      },
      {
        "title": "Born To Be Blue",
        "artist": "Wells-Torme",
        "url": "https://www.quickchords.org/charts/jazz/wellstorme/born_to_be_blue?source=ireal"
      },
      {
        "title": "Bossa Antigua",
        "artist": "Paul Desmond",
        "url": "https://www.quickchords.org/charts/jazz/paul_desmond/bossa_antigua?source=ireal"
      },
      {
        "title": "Bouncin' With Bud",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/jazz/bud_powell/bouncin_with_bud?source=ireal"
      },
      {
        "title": "Bourbon Street Parade",
        "artist": "Paul Barbarin",
        "url": "https://www.quickchords.org/charts/jazz/paul_barbarin/bourbon_street_parade?source=ireal"
      },
      {
        "title": "Boy Next Door, The",
        "artist": "Martin-Blane",
        "url": "https://www.quickchords.org/charts/jazz/martinblane/boy_next_door_the?source=ireal"
      },
      {
        "title": "Brazil (Aquarela Do Brasil)",
        "artist": "Ary Barroso",
        "url": "https://www.quickchords.org/charts/jazz/ary_barroso/brazil_aquarela_do_brasil?source=ireal"
      },
      {
        "title": "Brazilian Like",
        "artist": "Michel Petrucciani",
        "url": "https://www.quickchords.org/charts/jazz/michel_petrucciani/brazilian_like?source=ireal"
      },
      {
        "title": "Brazilian Suite",
        "artist": "Michel Petrucciani",
        "url": "https://www.quickchords.org/charts/jazz/michel_petrucciani/brazilian_suite?source=ireal"
      },
      {
        "title": "Breeze And I, The",
        "artist": "Ernesto Lecuona",
        "url": "https://www.quickchords.org/charts/jazz/ernesto_lecuona/breeze_and_i_the?source=ireal"
      },
      {
        "title": "Bright Boy",
        "artist": "John Bright",
        "url": "https://www.quickchords.org/charts/jazz/john_bright/bright_boy?source=ireal"
      },
      {
        "title": "Bright Mississippi",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/bright_mississippi?source=ireal"
      },
      {
        "title": "Bright Size Life",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/bright_size_life?source=ireal"
      },
      {
        "title": "Brilliant Corners",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/brilliant_corners?source=ireal"
      },
      {
        "title": "Broadway",
        "artist": "William-Henri-Woode",
        "url": "https://www.quickchords.org/charts/jazz/williamhenriwoode/broadway?source=ireal"
      },
      {
        "title": "Brother Can You Spare A Dime",
        "artist": "Yarburg-Gorney",
        "url": "https://www.quickchords.org/charts/jazz/yarburggorney/brother_can_you_spare_a_dime?source=ireal"
      },
      {
        "title": "Brotherhood Of Man",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/brotherhood_of_man?source=ireal"
      },
      {
        "title": "Bud Powell",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/bud_powell?source=ireal"
      },
      {
        "title": "Budo",
        "artist": "Davis-Powell",
        "url": "https://www.quickchords.org/charts/jazz/davispowell/budo?source=ireal"
      },
      {
        "title": "Bunko",
        "artist": "Lennie Niehaus",
        "url": "https://www.quickchords.org/charts/jazz/lennie_niehaus/bunko?source=ireal"
      },
      {
        "title": "But Beautiful",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/but_beautiful?source=ireal"
      },
      {
        "title": "But Not For Me",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/but_not_for_me?source=ireal"
      },
      {
        "title": "Butch And Butch",
        "artist": "Oliver Nelson",
        "url": "https://www.quickchords.org/charts/jazz/oliver_nelson/butch_and_butch?source=ireal"
      },
      {
        "title": "Butterfly",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/butterfly?source=ireal"
      },
      {
        "title": "Butterfly Dreams",
        "artist": "Stanley Clarke",
        "url": "https://www.quickchords.org/charts/jazz/stanley_clarke/butterfly_dreams?source=ireal"
      },
      {
        "title": "By Myself",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/by_myself?source=ireal"
      },
      {
        "title": "Bye Bye Baby",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/bye_bye_baby?source=ireal"
      },
      {
        "title": "Bye Bye Blackbird",
        "artist": "Ray Henderson",
        "url": "https://www.quickchords.org/charts/jazz/ray_henderson/bye_bye_blackbird?source=ireal"
      },
      {
        "title": "Bye Bye Blues",
        "artist": "Hamm-Bennett-Lown-Gray",
        "url": "https://www.quickchords.org/charts/jazz/hammbennettlowngray/bye_bye_blues?source=ireal"
      },
      {
        "title": "Bye-Ya",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/byeya?source=ireal"
      },
      {
        "title": "C-Jam Blues",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/cjam_blues?source=ireal"
      },
      {
        "title": "C.T.A.",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_heath/cta?source=ireal"
      },
      {
        "title": "C'est Si Bon",
        "artist": "Henri Betti",
        "url": "https://www.quickchords.org/charts/jazz/henri_betti/cest_si_bon?source=ireal"
      },
      {
        "title": "Cabin in the Sky",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/jazz/vernon_duke/cabin_in_the_sky?source=ireal"
      },
      {
        "title": "Call Me",
        "artist": "Tony Hatch",
        "url": "https://www.quickchords.org/charts/jazz/tony_hatch/call_me?source=ireal"
      },
      {
        "title": "Call Me Irresponsible",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/call_me_irresponsible?source=ireal"
      },
      {
        "title": "Can't Help Lovin' Dat Man",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/cant_help_lovin_dat_man?source=ireal"
      },
      {
        "title": "Can't We Be Friends",
        "artist": "Swift-James",
        "url": "https://www.quickchords.org/charts/jazz/swiftjames/cant_we_be_friends?source=ireal"
      },
      {
        "title": "Candy",
        "artist": "David-Whitney-Kramer",
        "url": "https://www.quickchords.org/charts/jazz/davidwhitneykramer/candy?source=ireal"
      },
      {
        "title": "Cantaloupe Island",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/cantaloupe_island?source=ireal"
      },
      {
        "title": "Captain Marvel",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/captain_marvel?source=ireal"
      },
      {
        "title": "Caravan",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/caravan?source=ireal"
      },
      {
        "title": "Catch Me",
        "artist": "Joe Pass",
        "url": "https://www.quickchords.org/charts/jazz/joe_pass/catch_me?source=ireal"
      },
      {
        "title": "Celia",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/jazz/bud_powell/celia?source=ireal"
      },
      {
        "title": "Central Park West",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/central_park_west?source=ireal"
      },
      {
        "title": "Ceora",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/jazz/lee_morgan/ceora?source=ireal"
      },
      {
        "title": "Chameleon",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/chameleon?source=ireal"
      },
      {
        "title": "Change Partners",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/change_partners?source=ireal"
      },
      {
        "title": "Charleston, The",
        "artist": "James Johnson",
        "url": "https://www.quickchords.org/charts/jazz/james_johnson/charleston_the?source=ireal"
      },
      {
        "title": "Chase, The",
        "artist": "Dexter Gordon",
        "url": "https://www.quickchords.org/charts/jazz/dexter_gordon/chase_the?source=ireal"
      },
      {
        "title": "Chasin' The Trane",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/chasin_the_trane?source=ireal"
      },
      {
        "title": "Cheek To Cheek",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/cheek_to_cheek?source=ireal"
      },
      {
        "title": "Cheers",
        "artist": "Howard McGhee",
        "url": "https://www.quickchords.org/charts/jazz/howard_mcghee/cheers?source=ireal"
      },
      {
        "title": "Cheese Cake",
        "artist": "Dexter Gordon",
        "url": "https://www.quickchords.org/charts/jazz/dexter_gordon/cheese_cake?source=ireal"
      },
      {
        "title": "Cheetah",
        "artist": "Kenny Burrell",
        "url": "https://www.quickchords.org/charts/jazz/kenny_burrell/cheetah?source=ireal"
      },
      {
        "title": "Chega De Saudade (No More Blues)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/chega_de_saudade_no_more_blues?source=ireal"
      },
      {
        "title": "Chelsea Bridge",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/chelsea_bridge?source=ireal"
      },
      {
        "title": "Cherokee",
        "artist": "Ray Noble",
        "url": "https://www.quickchords.org/charts/jazz/ray_noble/cherokee?source=ireal"
      },
      {
        "title": "Cheryl",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/cheryl?source=ireal"
      },
      {
        "title": "Chicago",
        "artist": "Fred Fisher",
        "url": "https://www.quickchords.org/charts/jazz/fred_fisher/chicago?source=ireal"
      },
      {
        "title": "Chicken, The",
        "artist": "Pee-Wee Ellis",
        "url": "https://www.quickchords.org/charts/jazz/peewee_ellis/chicken_the?source=ireal"
      },
      {
        "title": "Chucho",
        "artist": "Paquito D'Rivera",
        "url": "https://www.quickchords.org/charts/jazz/paquito_drivera/chucho?source=ireal"
      },
      {
        "title": "Close Enough For Love",
        "artist": "Mandel-Williams",
        "url": "https://www.quickchords.org/charts/jazz/mandelwilliams/close_enough_for_love?source=ireal"
      },
      {
        "title": "Close Your Eyes",
        "artist": "Bernice Petkere",
        "url": "https://www.quickchords.org/charts/jazz/bernice_petkere/close_your_eyes?source=ireal"
      },
      {
        "title": "Come Back To Me",
        "artist": "Lerner Alan/Lane Burton",
        "url": "https://www.quickchords.org/charts/jazz/lerner_alanlane_burton/come_back_to_me?source=ireal"
      },
      {
        "title": "Come Fly With Me",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/come_fly_with_me?source=ireal"
      },
      {
        "title": "Come Rain Or Come Shine",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/come_rain_or_come_shine?source=ireal"
      },
      {
        "title": "Come Sunday",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/come_sunday?source=ireal"
      },
      {
        "title": "Comes Love",
        "artist": "Brown-Stept-Tobias",
        "url": "https://www.quickchords.org/charts/jazz/brownstepttobias/comes_love?source=ireal"
      },
      {
        "title": "Comrade Conrad",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/comrade_conrad?source=ireal"
      },
      {
        "title": "Con Alma",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/con_alma?source=ireal"
      },
      {
        "title": "Conception",
        "artist": "George Shearing",
        "url": "https://www.quickchords.org/charts/jazz/george_shearing/conception?source=ireal"
      },
      {
        "title": "Conference Of The Birds",
        "artist": "Dave Holland",
        "url": "https://www.quickchords.org/charts/jazz/dave_holland/conference_of_the_birds?source=ireal"
      },
      {
        "title": "Confessin' (That I Love You)",
        "artist": "Daugherty-Neiberg-Reynolds",
        "url": "https://www.quickchords.org/charts/jazz/daughertyneibergreynolds/confessin_that_i_love_you?source=ireal"
      },
      {
        "title": "Confirmation",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/confirmation?source=ireal"
      },
      {
        "title": "Contemplation",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/jazz/mccoy_tyner/contemplation?source=ireal"
      },
      {
        "title": "Continuum",
        "artist": "Jaco Pastorius",
        "url": "https://www.quickchords.org/charts/jazz/jaco_pastorius/continuum?source=ireal"
      },
      {
        "title": "Cool One, The",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/cool_one_the?source=ireal"
      },
      {
        "title": "Copenhagen",
        "artist": "Davis-Melrose",
        "url": "https://www.quickchords.org/charts/jazz/davismelrose/copenhagen?source=ireal"
      },
      {
        "title": "Coral",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/coral?source=ireal"
      },
      {
        "title": "Corcovado",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/corcovado?source=ireal"
      },
      {
        "title": "Core, The",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/jazz/freddie_hubbard/core_the?source=ireal"
      },
      {
        "title": "Cottage For Sale",
        "artist": "Willard Robison",
        "url": "https://www.quickchords.org/charts/jazz/willard_robison/cottage_for_sale?source=ireal"
      },
      {
        "title": "Cottontail",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/cottontail?source=ireal"
      },
      {
        "title": "Could It Be You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/could_it_be_you?source=ireal"
      },
      {
        "title": "Countdown",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/countdown?source=ireal"
      },
      {
        "title": "Country",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/country?source=ireal"
      },
      {
        "title": "Cousin Mary",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/cousin_mary?source=ireal"
      },
      {
        "title": "Crazy He Calls Me",
        "artist": "Carl Sigman",
        "url": "https://www.quickchords.org/charts/jazz/carl_sigman/crazy_he_calls_me?source=ireal"
      },
      {
        "title": "Crazy Rhythm",
        "artist": "Wolfe-Kahn-Meyer",
        "url": "https://www.quickchords.org/charts/jazz/wolfekahnmeyer/crazy_rhythm?source=ireal"
      },
      {
        "title": "Creole Love Call",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/creole_love_call?source=ireal"
      },
      {
        "title": "Crepuscule With Nellie",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/crepuscule_with_nellie?source=ireal"
      },
      {
        "title": "Crisis",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/jazz/freddie_hubbard/crisis?source=ireal"
      },
      {
        "title": "Criss Cross",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/criss_cross?source=ireal"
      },
      {
        "title": "Crosscurrent",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/jazz/lennie_tristano/crosscurrent?source=ireal"
      },
      {
        "title": "Cry Me A River",
        "artist": "Arthur Hamilton",
        "url": "https://www.quickchords.org/charts/jazz/arthur_hamilton/cry_me_a_river?source=ireal"
      },
      {
        "title": "Crystal Silence",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/crystal_silence?source=ireal"
      },
      {
        "title": "Cute",
        "artist": "Neal Hefti",
        "url": "https://www.quickchords.org/charts/jazz/neal_hefti/cute?source=ireal"
      },
      {
        "title": "Cyclic Episode",
        "artist": "Sam Rivers",
        "url": "https://www.quickchords.org/charts/jazz/sam_rivers/cyclic_episode?source=ireal"
      },
      {
        "title": "Cynthia's In Love",
        "artist": "Owens-White-Gish",
        "url": "https://www.quickchords.org/charts/jazz/owenswhitegish/cynthias_in_love?source=ireal"
      },
      {
        "title": "Daahoud",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/jazz/clifford_brown/daahoud?source=ireal"
      },
      {
        "title": "Dance Of The Infidels",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/jazz/bud_powell/dance_of_the_infidels?source=ireal"
      },
      {
        "title": "Dancing In The Dark",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/dancing_in_the_dark?source=ireal"
      },
      {
        "title": "Dancing On The Ceiling",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/dancing_on_the_ceiling?source=ireal"
      },
      {
        "title": "Danny Boy",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/danny_boy?source=ireal"
      },
      {
        "title": "Darn That Dream",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/darn_that_dream?source=ireal"
      },
      {
        "title": "Dat Dere",
        "artist": "Bobby Timmons",
        "url": "https://www.quickchords.org/charts/jazz/bobby_timmons/dat_dere?source=ireal"
      },
      {
        "title": "Day By Day",
        "artist": "Cahn-Stordahl-Weston",
        "url": "https://www.quickchords.org/charts/jazz/cahnstordahlweston/day_by_day?source=ireal"
      },
      {
        "title": "Day Dream",
        "artist": "Strayhorn-Ellington",
        "url": "https://www.quickchords.org/charts/jazz/strayhornellington/day_dream?source=ireal"
      },
      {
        "title": "Day Dreaming",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/day_dreaming?source=ireal"
      },
      {
        "title": "Day In, Day Out",
        "artist": "Rube Bloom",
        "url": "https://www.quickchords.org/charts/jazz/rube_bloom/day_in_day_out?source=ireal"
      },
      {
        "title": "Daybreak",
        "artist": "Adamson-Grofe",
        "url": "https://www.quickchords.org/charts/jazz/adamsongrofe/daybreak?source=ireal"
      },
      {
        "title": "Days And Nights Waiting",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/days_and_nights_waiting?source=ireal"
      },
      {
        "title": "Days Of Wine And Roses",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/jazz/henry_mancini/days_of_wine_and_roses?source=ireal"
      },
      {
        "title": "Dear Lord",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/dear_lord?source=ireal"
      },
      {
        "title": "Dear Old Stockholm",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/dear_old_stockholm?source=ireal"
      },
      {
        "title": "Dearly Beloved",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/dearly_beloved?source=ireal"
      },
      {
        "title": "Decision",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/decision?source=ireal"
      },
      {
        "title": "Dedicated To You",
        "artist": "Cahn-Chaplin-Zaret",
        "url": "https://www.quickchords.org/charts/jazz/cahnchaplinzaret/dedicated_to_you?source=ireal"
      },
      {
        "title": "Deed I Do",
        "artist": "Hirsch-Rose",
        "url": "https://www.quickchords.org/charts/jazz/hirschrose/deed_i_do?source=ireal"
      },
      {
        "title": "Deep Purple",
        "artist": "Peter De-Rose",
        "url": "https://www.quickchords.org/charts/jazz/peter_derose/deep_purple?source=ireal"
      },
      {
        "title": "Del Sasser",
        "artist": "Sam Jones",
        "url": "https://www.quickchords.org/charts/jazz/sam_jones/del_sasser?source=ireal"
      },
      {
        "title": "Deluge",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/deluge?source=ireal"
      },
      {
        "title": "Desafinado",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/desafinado?source=ireal"
      },
      {
        "title": "Desafinado (Original)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/desafinado_original?source=ireal"
      },
      {
        "title": "Detour Ahead",
        "artist": "Herb Ellis",
        "url": "https://www.quickchords.org/charts/jazz/herb_ellis/detour_ahead?source=ireal"
      },
      {
        "title": "Devil May Care",
        "artist": "Dorough-Kirk",
        "url": "https://www.quickchords.org/charts/jazz/doroughkirk/devil_may_care?source=ireal"
      },
      {
        "title": "Dewey Square",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/dewey_square?source=ireal"
      },
      {
        "title": "Dexterity",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/dexterity?source=ireal"
      },
      {
        "title": "Diane",
        "artist": "Rapee-pollack",
        "url": "https://www.quickchords.org/charts/jazz/rapeepollack/diane?source=ireal"
      },
      {
        "title": "Dienda",
        "artist": "Kenny Kirkland",
        "url": "https://www.quickchords.org/charts/jazz/kenny_kirkland/dienda?source=ireal"
      },
      {
        "title": "Dig",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/dig?source=ireal"
      },
      {
        "title": "Dinah",
        "artist": "Harry Akst",
        "url": "https://www.quickchords.org/charts/jazz/harry_akst/dinah?source=ireal"
      },
      {
        "title": "Dindi",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/dindi?source=ireal"
      },
      {
        "title": "Diverse",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/diverse?source=ireal"
      },
      {
        "title": "Django",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/jazz/john_lewis/django?source=ireal"
      },
      {
        "title": "Do Nothin' Til You Hear From Me",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/do_nothin_til_you_hear_from_me?source=ireal"
      },
      {
        "title": "Do You Know What It Means?",
        "artist": "Louis Alter",
        "url": "https://www.quickchords.org/charts/jazz/louis_alter/do_you_know_what_it_means?source=ireal"
      },
      {
        "title": "Dolores",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/dolores?source=ireal"
      },
      {
        "title": "Dolphin Dance",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/dolphin_dance?source=ireal"
      },
      {
        "title": "Dolphin, The",
        "artist": "Luiz Eca",
        "url": "https://www.quickchords.org/charts/jazz/luiz_eca/dolphin_the?source=ireal"
      },
      {
        "title": "Domingo",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/domingo?source=ireal"
      },
      {
        "title": "Don't Be That Way",
        "artist": "Edgar Sampson",
        "url": "https://www.quickchords.org/charts/jazz/edgar_sampson/dont_be_that_way?source=ireal"
      },
      {
        "title": "Don't Blame Me",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/dont_blame_me?source=ireal"
      },
      {
        "title": "Don't Explain",
        "artist": "Billie Holiday",
        "url": "https://www.quickchords.org/charts/jazz/billie_holiday/dont_explain?source=ireal"
      },
      {
        "title": "Don't Fence Me In",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/dont_fence_me_in?source=ireal"
      },
      {
        "title": "Don't Get Around Much Anymore",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/dont_get_around_much_anymore?source=ireal"
      },
      {
        "title": "Don't Go To Strangers",
        "artist": "Kent-Mason-Evans",
        "url": "https://www.quickchords.org/charts/jazz/kentmasonevans/dont_go_to_strangers?source=ireal"
      },
      {
        "title": "Don't Know Why",
        "artist": "Jesse Harris",
        "url": "https://www.quickchords.org/charts/jazz/jesse_harris/dont_know_why?source=ireal"
      },
      {
        "title": "Don't Misunderstand",
        "artist": "Gordon Parks",
        "url": "https://www.quickchords.org/charts/jazz/gordon_parks/dont_misunderstand?source=ireal"
      },
      {
        "title": "Don't Take Your Love From Me",
        "artist": "Henry Nemo",
        "url": "https://www.quickchords.org/charts/jazz/henry_nemo/dont_take_your_love_from_me?source=ireal"
      },
      {
        "title": "Don't Worry 'Bout Me",
        "artist": "Rube Bloom",
        "url": "https://www.quickchords.org/charts/jazz/rube_bloom/dont_worry_bout_me?source=ireal"
      },
      {
        "title": "Donna Lee",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/donna_lee?source=ireal"
      },
      {
        "title": "Down By The Riverside",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/down_by_the_riverside?source=ireal"
      },
      {
        "title": "Down For Double",
        "artist": "Freddie Green",
        "url": "https://www.quickchords.org/charts/jazz/freddie_green/down_for_double?source=ireal"
      },
      {
        "title": "Down In The Depths",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/down_in_the_depths?source=ireal"
      },
      {
        "title": "Doxy",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/doxy?source=ireal"
      },
      {
        "title": "Dream",
        "artist": "Johnny Mercer",
        "url": "https://www.quickchords.org/charts/jazz/johnny_mercer/dream?source=ireal"
      },
      {
        "title": "Dream A Little Dream Of Me",
        "artist": "Schwendt-Andre-Kahn",
        "url": "https://www.quickchords.org/charts/jazz/schwendtandrekahn/dream_a_little_dream_of_me?source=ireal"
      },
      {
        "title": "Dream Dancing",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/dream_dancing?source=ireal"
      },
      {
        "title": "Dreamsville",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/jazz/henry_mancini/dreamsville?source=ireal"
      },
      {
        "title": "Driftin'",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/driftin?source=ireal"
      },
      {
        "title": "Duke, The",
        "artist": "Dave Brubeck",
        "url": "https://www.quickchords.org/charts/jazz/dave_brubeck/duke_the?source=ireal"
      },
      {
        "title": "E.S.P.",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/esp?source=ireal"
      },
      {
        "title": "Early Autumn",
        "artist": "Burns-Herman",
        "url": "https://www.quickchords.org/charts/jazz/burnsherman/early_autumn?source=ireal"
      },
      {
        "title": "East Of The Sun",
        "artist": "Brooks Bowman",
        "url": "https://www.quickchords.org/charts/jazz/brooks_bowman/east_of_the_sun?source=ireal"
      },
      {
        "title": "Easy Living",
        "artist": "Ralph Rainger",
        "url": "https://www.quickchords.org/charts/jazz/ralph_rainger/easy_living?source=ireal"
      },
      {
        "title": "Easy Street",
        "artist": "Alan Jones",
        "url": "https://www.quickchords.org/charts/jazz/alan_jones/easy_street?source=ireal"
      },
      {
        "title": "Easy To Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/easy_to_love?source=ireal"
      },
      {
        "title": "Ecaroh",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/ecaroh?source=ireal"
      },
      {
        "title": "Eclypso",
        "artist": "Tommy Flanagan",
        "url": "https://www.quickchords.org/charts/jazz/tommy_flanagan/eclypso?source=ireal"
      },
      {
        "title": "Eiderdown",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/jazz/steve_swallow/eiderdown?source=ireal"
      },
      {
        "title": "Eighty One",
        "artist": "Ron Carter",
        "url": "https://www.quickchords.org/charts/jazz/ron_carter/eighty_one?source=ireal"
      },
      {
        "title": "El Cajon",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/jazz/johnny_mandel/el_cajon?source=ireal"
      },
      {
        "title": "El Gaucho",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/el_gaucho?source=ireal"
      },
      {
        "title": "Elora",
        "artist": "J.J. Johnson",
        "url": "https://www.quickchords.org/charts/jazz/jj_johnson/elora?source=ireal"
      },
      {
        "title": "Embraceable You",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/embraceable_you?source=ireal"
      },
      {
        "title": "Emily",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/jazz/johnny_mandel/emily?source=ireal"
      },
      {
        "title": "End Of A Love Affair, The",
        "artist": "Edward Redding",
        "url": "https://www.quickchords.org/charts/jazz/edward_redding/end_of_a_love_affair_the?source=ireal"
      },
      {
        "title": "Epilogue",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/epilogue?source=ireal"
      },
      {
        "title": "Epistrophy",
        "artist": "Monk Thelonious/Clarke Kenny",
        "url": "https://www.quickchords.org/charts/jazz/monk_theloniousclarke_kenny/epistrophy?source=ireal"
      },
      {
        "title": "Equinox",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/equinox?source=ireal"
      },
      {
        "title": "Eronel",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/eronel?source=ireal"
      },
      {
        "title": "Estate",
        "artist": "Bruno Martino",
        "url": "https://www.quickchords.org/charts/jazz/bruno_martino/estate?source=ireal"
      },
      {
        "title": "Eternal Triangle",
        "artist": "Sonny Stitt",
        "url": "https://www.quickchords.org/charts/jazz/sonny_stitt/eternal_triangle?source=ireal"
      },
      {
        "title": "Ev'ry Time We Say Goodbye",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/evry_time_we_say_goodbye?source=ireal"
      },
      {
        "title": "Everybody's Song But My Own",
        "artist": "Kenny Wheeler",
        "url": "https://www.quickchords.org/charts/jazz/kenny_wheeler/everybodys_song_but_my_own?source=ireal"
      },
      {
        "title": "Everything Happens To Me",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/jazz/matt_dennis/everything_happens_to_me?source=ireal"
      },
      {
        "title": "Everything I Have Is Yours",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/everything_i_have_is_yours?source=ireal"
      },
      {
        "title": "Everything I Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/everything_i_love?source=ireal"
      },
      {
        "title": "Everything I've Got Belongs To You",
        "artist": "Rodgers-Hart",
        "url": "https://www.quickchords.org/charts/jazz/rodgershart/everything_ive_got_belongs_to_you?source=ireal"
      },
      {
        "title": "Evidence",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/evidence?source=ireal"
      },
      {
        "title": "Exactly Like You",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/exactly_like_you?source=ireal"
      },
      {
        "title": "Eye of the Hurricane",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/eye_of_the_hurricane?source=ireal"
      },
      {
        "title": "Fall",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/fall?source=ireal"
      },
      {
        "title": "Falling Grace",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/jazz/steve_swallow/falling_grace?source=ireal"
      },
      {
        "title": "Falling In Love Again",
        "artist": "Frederick Hollander",
        "url": "https://www.quickchords.org/charts/jazz/frederick_hollander/falling_in_love_again?source=ireal"
      },
      {
        "title": "Falling In Love With Love",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/falling_in_love_with_love?source=ireal"
      },
      {
        "title": "Fantasy in D (or Ugetsu)",
        "artist": "Cedar Walton",
        "url": "https://www.quickchords.org/charts/jazz/cedar_walton/fantasy_in_d_or_ugetsu?source=ireal"
      },
      {
        "title": "Farmer's Trust",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/farmers_trust?source=ireal"
      },
      {
        "title": "Fascinating Rhythm",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/fascinating_rhythm?source=ireal"
      },
      {
        "title": "Fascination",
        "artist": "Fernando-Dante Marchetti",
        "url": "https://www.quickchords.org/charts/jazz/fernandodante_marchetti/fascination?source=ireal"
      },
      {
        "title": "Favela",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/favela?source=ireal"
      },
      {
        "title": "Fee-Fi-Fo-Fum",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/feefifofum?source=ireal"
      },
      {
        "title": "Feel Like Makin' Love",
        "artist": "Eugene McDaniels",
        "url": "https://www.quickchords.org/charts/jazz/eugene_mcdaniels/feel_like_makin_love?source=ireal"
      },
      {
        "title": "Feels So Good",
        "artist": "Chuck Mangione",
        "url": "https://www.quickchords.org/charts/jazz/chuck_mangione/feels_so_good?source=ireal"
      },
      {
        "title": "Fever",
        "artist": "Davenport-Cooley",
        "url": "https://www.quickchords.org/charts/jazz/davenportcooley/fever?source=ireal"
      },
      {
        "title": "Fine And Dandy",
        "artist": "Kay Swift",
        "url": "https://www.quickchords.org/charts/jazz/kay_swift/fine_and_dandy?source=ireal"
      },
      {
        "title": "Fine And Mellow",
        "artist": "Billie Holiday",
        "url": "https://www.quickchords.org/charts/jazz/billie_holiday/fine_and_mellow?source=ireal"
      },
      {
        "title": "Five Brothers",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/jazz/gerry_mulligan/five_brothers?source=ireal"
      },
      {
        "title": "Flamingo",
        "artist": "Ted Grouya",
        "url": "https://www.quickchords.org/charts/jazz/ted_grouya/flamingo?source=ireal"
      },
      {
        "title": "Flintstones",
        "artist": "Hoyt Curtain",
        "url": "https://www.quickchords.org/charts/jazz/hoyt_curtain/flintstones?source=ireal"
      },
      {
        "title": "Fly Me To The Moon",
        "artist": "Bart Howard",
        "url": "https://www.quickchords.org/charts/jazz/bart_howard/fly_me_to_the_moon?source=ireal"
      },
      {
        "title": "Flying Home",
        "artist": "Goodman-Hampton",
        "url": "https://www.quickchords.org/charts/jazz/goodmanhampton/flying_home?source=ireal"
      },
      {
        "title": "Folks Who Live On The Hill, The",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/folks_who_live_on_the_hill_the?source=ireal"
      },
      {
        "title": "Fools Rush In",
        "artist": "Rube Bloom",
        "url": "https://www.quickchords.org/charts/jazz/rube_bloom/fools_rush_in?source=ireal"
      },
      {
        "title": "Footprints",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/footprints?source=ireal"
      },
      {
        "title": "For All We Know",
        "artist": "Fred Coots",
        "url": "https://www.quickchords.org/charts/jazz/fred_coots/for_all_we_know?source=ireal"
      },
      {
        "title": "For Heaven's Sake",
        "artist": "Edwards-Meyer-Bretton",
        "url": "https://www.quickchords.org/charts/jazz/edwardsmeyerbretton/for_heavens_sake?source=ireal"
      },
      {
        "title": "For Jan",
        "artist": "Kenny Wheeler",
        "url": "https://www.quickchords.org/charts/jazz/kenny_wheeler/for_jan?source=ireal"
      },
      {
        "title": "For Minors Only",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_heath/for_minors_only?source=ireal"
      },
      {
        "title": "For Once In My Life",
        "artist": "Orlando Murden",
        "url": "https://www.quickchords.org/charts/jazz/orlando_murden/for_once_in_my_life?source=ireal"
      },
      {
        "title": "For Sentimental Reasons",
        "artist": "William Best",
        "url": "https://www.quickchords.org/charts/jazz/william_best/for_sentimental_reasons?source=ireal"
      },
      {
        "title": "For You, For Me, For Evermore",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/for_you_for_me_for_evermore?source=ireal"
      },
      {
        "title": "Forest Flower",
        "artist": "Charles Lloyd",
        "url": "https://www.quickchords.org/charts/jazz/charles_lloyd/forest_flower?source=ireal"
      },
      {
        "title": "Forever Sonny",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_heath/forever_sonny?source=ireal"
      },
      {
        "title": "Four",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/four?source=ireal"
      },
      {
        "title": "Four Brothers",
        "artist": "Jimmy Giuffre",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_giuffre/four_brothers?source=ireal"
      },
      {
        "title": "Four In One",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/four_in_one?source=ireal"
      },
      {
        "title": "Four On Six",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/four_on_six?source=ireal"
      },
      {
        "title": "Freckle Face",
        "artist": "Sammy Nestico",
        "url": "https://www.quickchords.org/charts/jazz/sammy_nestico/freckle_face?source=ireal"
      },
      {
        "title": "Freddie Freeloader",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/freddie_freeloader?source=ireal"
      },
      {
        "title": "Freight Train",
        "artist": "Tommy Flanagan",
        "url": "https://www.quickchords.org/charts/jazz/tommy_flanagan/freight_train?source=ireal"
      },
      {
        "title": "Frenesi",
        "artist": "Alberto Dominguez",
        "url": "https://www.quickchords.org/charts/jazz/alberto_dominguez/frenesi?source=ireal"
      },
      {
        "title": "Friday The 13th",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/friday_the_13th?source=ireal"
      },
      {
        "title": "Frim Fram Sauce, The",
        "artist": "Joe Richardel",
        "url": "https://www.quickchords.org/charts/jazz/joe_richardel/frim_fram_sauce_the?source=ireal"
      },
      {
        "title": "From This Moment On",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/from_this_moment_on?source=ireal"
      },
      {
        "title": "Full House",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/full_house?source=ireal"
      },
      {
        "title": "Funk In Deep Freeze",
        "artist": "Hank Mobley",
        "url": "https://www.quickchords.org/charts/jazz/hank_mobley/funk_in_deep_freeze?source=ireal"
      },
      {
        "title": "Funkallero",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/funkallero?source=ireal"
      },
      {
        "title": "Gallop's Gallop",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/gallops_gallop?source=ireal"
      },
      {
        "title": "Gary's Notebook",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/jazz/lee_morgan/garys_notebook?source=ireal"
      },
      {
        "title": "Gee Baby, Ain't I Good To You",
        "artist": "Don Redman",
        "url": "https://www.quickchords.org/charts/jazz/don_redman/gee_baby_aint_i_good_to_you?source=ireal"
      },
      {
        "title": "Gentle Rain, The",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/jazz/luiz_bonfa/gentle_rain_the?source=ireal"
      },
      {
        "title": "Gentle Wind And Falling Tear",
        "artist": "Gary Burton",
        "url": "https://www.quickchords.org/charts/jazz/gary_burton/gentle_wind_and_falling_tear?source=ireal"
      },
      {
        "title": "Georgia On My Mind",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/georgia_on_my_mind?source=ireal"
      },
      {
        "title": "Get Happy",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/get_happy?source=ireal"
      },
      {
        "title": "Get Me To The Church On Time",
        "artist": "Alan Lerner",
        "url": "https://www.quickchords.org/charts/jazz/alan_lerner/get_me_to_the_church_on_time?source=ireal"
      },
      {
        "title": "Get Out Of Town",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/get_out_of_town?source=ireal"
      },
      {
        "title": "Giant Steps",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/giant_steps?source=ireal"
      },
      {
        "title": "Girl From Ipanema, The",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/girl_from_ipanema_the?source=ireal"
      },
      {
        "title": "Girl Talk",
        "artist": "Neal Hefti",
        "url": "https://www.quickchords.org/charts/jazz/neal_hefti/girl_talk?source=ireal"
      },
      {
        "title": "Give Me The Simple Life",
        "artist": "Rube Bloom",
        "url": "https://www.quickchords.org/charts/jazz/rube_bloom/give_me_the_simple_life?source=ireal"
      },
      {
        "title": "Glad To Be Unhappy",
        "artist": "Rodgers-Hart",
        "url": "https://www.quickchords.org/charts/jazz/rodgershart/glad_to_be_unhappy?source=ireal"
      },
      {
        "title": "Gloria's Step",
        "artist": "Scott LaFaro",
        "url": "https://www.quickchords.org/charts/jazz/scott_lafaro/glorias_step?source=ireal"
      },
      {
        "title": "Glory Of Love, The",
        "artist": "Billy Hill",
        "url": "https://www.quickchords.org/charts/jazz/billy_hill/glory_of_love_the?source=ireal"
      },
      {
        "title": "God Bless The Child",
        "artist": "Herzog-Holiday",
        "url": "https://www.quickchords.org/charts/jazz/herzogholiday/god_bless_the_child?source=ireal"
      },
      {
        "title": "Godchild",
        "artist": "George Wallington",
        "url": "https://www.quickchords.org/charts/jazz/george_wallington/godchild?source=ireal"
      },
      {
        "title": "Golden Earring",
        "artist": "Jay Livingston",
        "url": "https://www.quickchords.org/charts/jazz/jay_livingston/golden_earring?source=ireal"
      },
      {
        "title": "Gone With The Wind",
        "artist": "Allie Wrubel",
        "url": "https://www.quickchords.org/charts/jazz/allie_wrubel/gone_with_the_wind?source=ireal"
      },
      {
        "title": "Good Bait",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tadd_dameron/good_bait?source=ireal"
      },
      {
        "title": "Good Life, The",
        "artist": "Sacha Distel",
        "url": "https://www.quickchords.org/charts/jazz/sacha_distel/good_life_the?source=ireal"
      },
      {
        "title": "Good Morning Heartache",
        "artist": "Drake-Fisher-Higginbotham",
        "url": "https://www.quickchords.org/charts/jazz/drakefisherhigginbotham/good_morning_heartache?source=ireal"
      },
      {
        "title": "Goodbye",
        "artist": "Gordon Jenkins",
        "url": "https://www.quickchords.org/charts/jazz/gordon_jenkins/goodbye?source=ireal"
      },
      {
        "title": "Goodbye Pork Pie Hat",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/jazz/charles_mingus/goodbye_pork_pie_hat?source=ireal"
      },
      {
        "title": "Got A Match?",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/got_a_match?source=ireal"
      },
      {
        "title": "Grand Central",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/grand_central?source=ireal"
      },
      {
        "title": "Gravy Waltz, The",
        "artist": "Ray Brown",
        "url": "https://www.quickchords.org/charts/jazz/ray_brown/gravy_waltz_the?source=ireal"
      },
      {
        "title": "Green Chimneys",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/green_chimneys?source=ireal"
      },
      {
        "title": "Gregory Is Here",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/gregory_is_here?source=ireal"
      },
      {
        "title": "Groovin' High",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/groovin_high?source=ireal"
      },
      {
        "title": "Hackensack",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/hackensack?source=ireal"
      },
      {
        "title": "Half Nelson",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/half_nelson?source=ireal"
      },
      {
        "title": "Hallelujah I Just Love Him So",
        "artist": "Ray Charles",
        "url": "https://www.quickchords.org/charts/jazz/ray_charles/hallelujah_i_just_love_him_so?source=ireal"
      },
      {
        "title": "Hallucinations",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/jazz/bud_powell/hallucinations?source=ireal"
      },
      {
        "title": "Happiness Is A Thing Called Joe",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/happiness_is_a_thing_called_joe?source=ireal"
      },
      {
        "title": "Happy Little Sunbeam",
        "artist": "Russ Freeman",
        "url": "https://www.quickchords.org/charts/jazz/russ_freeman/happy_little_sunbeam?source=ireal"
      },
      {
        "title": "Harlequin",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/harlequin?source=ireal"
      },
      {
        "title": "Haunted Heart",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/haunted_heart?source=ireal"
      },
      {
        "title": "Have You Met Miss Jones?",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/have_you_met_miss_jones?source=ireal"
      },
      {
        "title": "He's A Tramp",
        "artist": "Lee-Burke",
        "url": "https://www.quickchords.org/charts/jazz/leeburke/hes_a_tramp?source=ireal"
      },
      {
        "title": "Heart And Soul",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/heart_and_soul?source=ireal"
      },
      {
        "title": "Heatwave",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/heatwave?source=ireal"
      },
      {
        "title": "Hello",
        "artist": "Milt Jackson",
        "url": "https://www.quickchords.org/charts/jazz/milt_jackson/hello?source=ireal"
      },
      {
        "title": "Hello Dolly",
        "artist": "Jerry Herman",
        "url": "https://www.quickchords.org/charts/jazz/jerry_herman/hello_dolly?source=ireal"
      },
      {
        "title": "Hello Young Lovers",
        "artist": "Richard Rogers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rogers/hello_young_lovers?source=ireal"
      },
      {
        "title": "Here's That Rainy Day",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/heres_that_rainy_day?source=ireal"
      },
      {
        "title": "Here's That Sunny Day",
        "artist": "Barney Kessel",
        "url": "https://www.quickchords.org/charts/jazz/barney_kessel/heres_that_sunny_day?source=ireal"
      },
      {
        "title": "Here's To Life",
        "artist": "Artie Butler",
        "url": "https://www.quickchords.org/charts/jazz/artie_butler/heres_to_life?source=ireal"
      },
      {
        "title": "Heyoke",
        "artist": "Kenny Wheeler",
        "url": "https://www.quickchords.org/charts/jazz/kenny_wheeler/heyoke?source=ireal"
      },
      {
        "title": "High Fly",
        "artist": "Randy Weston",
        "url": "https://www.quickchords.org/charts/jazz/randy_weston/high_fly?source=ireal"
      },
      {
        "title": "High Hopes",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/high_hopes?source=ireal"
      },
      {
        "title": "Hocus-Pocus",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/jazz/lee_morgan/hocuspocus?source=ireal"
      },
      {
        "title": "Home At Last",
        "artist": "Hank Mobley",
        "url": "https://www.quickchords.org/charts/jazz/hank_mobley/home_at_last?source=ireal"
      },
      {
        "title": "Home Cookin'",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/home_cookin?source=ireal"
      },
      {
        "title": "Homecoming",
        "artist": "Dave Holland",
        "url": "https://www.quickchords.org/charts/jazz/dave_holland/homecoming?source=ireal"
      },
      {
        "title": "Honeysuckle Rose",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/jazz/fats_waller/honeysuckle_rose?source=ireal"
      },
      {
        "title": "Horace-Scope",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/horacescope?source=ireal"
      },
      {
        "title": "Hot House",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tadd_dameron/hot_house?source=ireal"
      },
      {
        "title": "House Of Jade",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/house_of_jade?source=ireal"
      },
      {
        "title": "How About You",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/how_about_you?source=ireal"
      },
      {
        "title": "How Are Things In Glocca Morra",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/how_are_things_in_glocca_morra?source=ireal"
      },
      {
        "title": "How Deep Is The Ocean",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/how_deep_is_the_ocean?source=ireal"
      },
      {
        "title": "How High The Moon",
        "artist": "Morgan Lewis",
        "url": "https://www.quickchords.org/charts/jazz/morgan_lewis/how_high_the_moon?source=ireal"
      },
      {
        "title": "How Insensitive",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/how_insensitive?source=ireal"
      },
      {
        "title": "How Little We Know",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/how_little_we_know?source=ireal"
      },
      {
        "title": "How Long Has This Been Going On?",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/how_long_has_this_been_going_on?source=ireal"
      },
      {
        "title": "How My Heart Sings",
        "artist": "Earl Zindars",
        "url": "https://www.quickchords.org/charts/jazz/earl_zindars/how_my_heart_sings?source=ireal"
      },
      {
        "title": "Humpty Dumpty",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/humpty_dumpty?source=ireal"
      },
      {
        "title": "Hungaria",
        "artist": "Django Reinhardt",
        "url": "https://www.quickchords.org/charts/jazz/django_reinhardt/hungaria?source=ireal"
      },
      {
        "title": "I Ain't Got Nobody",
        "artist": "Graham-Williams",
        "url": "https://www.quickchords.org/charts/jazz/grahamwilliams/i_aint_got_nobody?source=ireal"
      },
      {
        "title": "I Believe In You",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/i_believe_in_you?source=ireal"
      },
      {
        "title": "I Can't Believe...You're In Love...",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/i_cant_believeyoure_in_love?source=ireal"
      },
      {
        "title": "I Can't Get Started",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/jazz/vernon_duke/i_cant_get_started?source=ireal"
      },
      {
        "title": "I Can't Give You Anything But Love",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/i_cant_give_you_anything_but_love?source=ireal"
      },
      {
        "title": "I Concentrate On You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/i_concentrate_on_you?source=ireal"
      },
      {
        "title": "I Could Have Danced All Night",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/jazz/frederick_loewe/i_could_have_danced_all_night?source=ireal"
      },
      {
        "title": "I Could Write A Book",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/i_could_write_a_book?source=ireal"
      },
      {
        "title": "I Cover The Waterfront",
        "artist": "Johnny Green",
        "url": "https://www.quickchords.org/charts/jazz/johnny_green/i_cover_the_waterfront?source=ireal"
      },
      {
        "title": "I Cried For You",
        "artist": "Freed-Arnheim-Lyman",
        "url": "https://www.quickchords.org/charts/jazz/freedarnheimlyman/i_cried_for_you?source=ireal"
      },
      {
        "title": "I Didn't Know About You",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/i_didnt_know_about_you?source=ireal"
      },
      {
        "title": "I Didn't Know What Time It Was",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/i_didnt_know_what_time_it_was?source=ireal"
      },
      {
        "title": "I Don't Know Enough About You",
        "artist": "Peggy Lee",
        "url": "https://www.quickchords.org/charts/jazz/peggy_lee/i_dont_know_enough_about_you?source=ireal"
      },
      {
        "title": "I Don't Want To Miss Mississippi",
        "artist": "Serger Ellis",
        "url": "https://www.quickchords.org/charts/jazz/serger_ellis/i_dont_want_to_miss_mississippi?source=ireal"
      },
      {
        "title": "I Fall In Love Too Easily",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/i_fall_in_love_too_easily?source=ireal"
      },
      {
        "title": "I Found A New Baby",
        "artist": "Palmer-Williams",
        "url": "https://www.quickchords.org/charts/jazz/palmerwilliams/i_found_a_new_baby?source=ireal"
      },
      {
        "title": "I Get A Kick Out Of You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/i_get_a_kick_out_of_you?source=ireal"
      },
      {
        "title": "I Get Along Without You",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/i_get_along_without_you?source=ireal"
      },
      {
        "title": "I Got It Bad",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/i_got_it_bad?source=ireal"
      },
      {
        "title": "I Got Rhythm",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/i_got_rhythm?source=ireal"
      },
      {
        "title": "I Got The Sun In The Morning",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/i_got_the_sun_in_the_morning?source=ireal"
      },
      {
        "title": "I Gotta Right To Sing The Blues",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/i_gotta_right_to_sing_the_blues?source=ireal"
      },
      {
        "title": "I Guess I'll Hang My Tears Out To Dry",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/i_guess_ill_hang_my_tears_out_to_dry?source=ireal"
      },
      {
        "title": "I Guess I'll Have To Change My Plan",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/i_guess_ill_have_to_change_my_plan?source=ireal"
      },
      {
        "title": "I Hadn't Anyone Till You",
        "artist": "Ray Noble",
        "url": "https://www.quickchords.org/charts/jazz/ray_noble/i_hadnt_anyone_till_you?source=ireal"
      },
      {
        "title": "I Have Dreamed",
        "artist": "Rodgers-Hammerstein",
        "url": "https://www.quickchords.org/charts/jazz/rodgershammerstein/i_have_dreamed?source=ireal"
      },
      {
        "title": "I Hear A Rhapsody",
        "artist": "Fragos-Baker-Gasparre",
        "url": "https://www.quickchords.org/charts/jazz/fragosbakergasparre/i_hear_a_rhapsody?source=ireal"
      },
      {
        "title": "I Hear Music",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/i_hear_music?source=ireal"
      },
      {
        "title": "I Left My Heart In San Francisco",
        "artist": "George Cory",
        "url": "https://www.quickchords.org/charts/jazz/george_cory/i_left_my_heart_in_san_francisco?source=ireal"
      },
      {
        "title": "I Let A Song Go Out Of My Heart",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/i_let_a_song_go_out_of_my_heart?source=ireal"
      },
      {
        "title": "I Like The Likes Of You",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/jazz/vernon_duke/i_like_the_likes_of_you?source=ireal"
      },
      {
        "title": "I Love Being Here With You",
        "artist": "Schluger Bill/Lee Peggy",
        "url": "https://www.quickchords.org/charts/jazz/schluger_billlee_peggy/i_love_being_here_with_you?source=ireal"
      },
      {
        "title": "I Love Paris",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/i_love_paris?source=ireal"
      },
      {
        "title": "I Love You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/i_love_you?source=ireal"
      },
      {
        "title": "I Loves You Porgy",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/i_loves_you_porgy?source=ireal"
      },
      {
        "title": "I May Be Wrong",
        "artist": "Henry Sullivan",
        "url": "https://www.quickchords.org/charts/jazz/henry_sullivan/i_may_be_wrong?source=ireal"
      },
      {
        "title": "I Mean You",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/i_mean_you?source=ireal"
      },
      {
        "title": "I Only Have Eyes For You",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/i_only_have_eyes_for_you?source=ireal"
      },
      {
        "title": "I Remember Clifford",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/i_remember_clifford?source=ireal"
      },
      {
        "title": "I Remember You",
        "artist": "Victor Schertzinger",
        "url": "https://www.quickchords.org/charts/jazz/victor_schertzinger/i_remember_you?source=ireal"
      },
      {
        "title": "I See Your Face Before Me",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/i_see_your_face_before_me?source=ireal"
      },
      {
        "title": "I Should Care",
        "artist": "Cahn-Stordahl-Weston",
        "url": "https://www.quickchords.org/charts/jazz/cahnstordahlweston/i_should_care?source=ireal"
      },
      {
        "title": "I Surrender Dear",
        "artist": "Harry Barris",
        "url": "https://www.quickchords.org/charts/jazz/harry_barris/i_surrender_dear?source=ireal"
      },
      {
        "title": "I Think Of You",
        "artist": "Elliot-Marcotte",
        "url": "https://www.quickchords.org/charts/jazz/elliotmarcotte/i_think_of_you?source=ireal"
      },
      {
        "title": "I Thought About You",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/i_thought_about_you?source=ireal"
      },
      {
        "title": "I Used To Be Color Blind",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/i_used_to_be_color_blind?source=ireal"
      },
      {
        "title": "I Want To Be Happy",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/jazz/vincent_youmans/i_want_to_be_happy?source=ireal"
      },
      {
        "title": "I Want To Talk About You",
        "artist": "Billy Eckstine",
        "url": "https://www.quickchords.org/charts/jazz/billy_eckstine/i_want_to_talk_about_you?source=ireal"
      },
      {
        "title": "I Was Doing All Right",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/i_was_doing_all_right?source=ireal"
      },
      {
        "title": "I Will Wait For You",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/jazz/michel_legrand/i_will_wait_for_you?source=ireal"
      },
      {
        "title": "I Wish I Knew",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/i_wish_i_knew?source=ireal"
      },
      {
        "title": "I Wish I Knew How It Would Feel To Be Free",
        "artist": "Billy Taylor",
        "url": "https://www.quickchords.org/charts/jazz/billy_taylor/i_wish_i_knew_how_it_would_feel_to_be_free?source=ireal"
      },
      {
        "title": "I Wish I Were In Love Again",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/i_wish_i_were_in_love_again?source=ireal"
      },
      {
        "title": "I Wish You Love",
        "artist": "Charles Trenet",
        "url": "https://www.quickchords.org/charts/jazz/charles_trenet/i_wish_you_love?source=ireal"
      },
      {
        "title": "I Won't Dance",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/i_wont_dance?source=ireal"
      },
      {
        "title": "I'll Be Around",
        "artist": "Alec Wilder",
        "url": "https://www.quickchords.org/charts/jazz/alec_wilder/ill_be_around?source=ireal"
      },
      {
        "title": "I'll Be Seeing You",
        "artist": "Sammy Fain",
        "url": "https://www.quickchords.org/charts/jazz/sammy_fain/ill_be_seeing_you?source=ireal"
      },
      {
        "title": "I'll Close My Eyes",
        "artist": "Reid-Kaye",
        "url": "https://www.quickchords.org/charts/jazz/reidkaye/ill_close_my_eyes?source=ireal"
      },
      {
        "title": "I'll Get By (As Long As I Have You)",
        "artist": "Ahlert-Turk",
        "url": "https://www.quickchords.org/charts/jazz/ahlertturk/ill_get_by_as_long_as_i_have_you?source=ireal"
      },
      {
        "title": "I'll Never Be The Same",
        "artist": "Khan-Malneck-Signorelli",
        "url": "https://www.quickchords.org/charts/jazz/khanmalnecksignorelli/ill_never_be_the_same?source=ireal"
      },
      {
        "title": "I'll Only Miss Her When I Think Of Her",
        "artist": "Cahn-VanHeusen",
        "url": "https://www.quickchords.org/charts/jazz/cahnvanheusen/ill_only_miss_her_when_i_think_of_her?source=ireal"
      },
      {
        "title": "I'll Remember April",
        "artist": "Raye-DePaul",
        "url": "https://www.quickchords.org/charts/jazz/rayedepaul/ill_remember_april?source=ireal"
      },
      {
        "title": "I'll See You In My Dreams",
        "artist": "Jones-Kahn",
        "url": "https://www.quickchords.org/charts/jazz/joneskahn/ill_see_you_in_my_dreams?source=ireal"
      },
      {
        "title": "I'll Take Romance",
        "artist": "Ben Oakland",
        "url": "https://www.quickchords.org/charts/jazz/ben_oakland/ill_take_romance?source=ireal"
      },
      {
        "title": "I'm A Fool To Want You",
        "artist": "Herron-Sinatra-Wolf",
        "url": "https://www.quickchords.org/charts/jazz/herronsinatrawolf/im_a_fool_to_want_you?source=ireal"
      },
      {
        "title": "I'm All Smiles",
        "artist": "Leonard-Martin",
        "url": "https://www.quickchords.org/charts/jazz/leonardmartin/im_all_smiles?source=ireal"
      },
      {
        "title": "I'm Always Chasing Rainbows",
        "artist": "Harry Carroll",
        "url": "https://www.quickchords.org/charts/jazz/harry_carroll/im_always_chasing_rainbows?source=ireal"
      },
      {
        "title": "I'm Beginning To See The Light",
        "artist": "Hodges-James-Ellington",
        "url": "https://www.quickchords.org/charts/jazz/hodgesjamesellington/im_beginning_to_see_the_light?source=ireal"
      },
      {
        "title": "I'm Confessin' That I Love You",
        "artist": "Reynolds-Daugherty",
        "url": "https://www.quickchords.org/charts/jazz/reynoldsdaugherty/im_confessin_that_i_love_you?source=ireal"
      },
      {
        "title": "I'm Getting Sentimental Over You",
        "artist": "George Bassman",
        "url": "https://www.quickchords.org/charts/jazz/george_bassman/im_getting_sentimental_over_you?source=ireal"
      },
      {
        "title": "I'm Glad There Is You",
        "artist": "Jimmy Dorsey",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_dorsey/im_glad_there_is_you?source=ireal"
      },
      {
        "title": "I'm Gonna Sit Right Down and Write Myself A Letter",
        "artist": "Fred Ahlert",
        "url": "https://www.quickchords.org/charts/jazz/fred_ahlert/im_gonna_sit_right_down_and_write_myself_a_letter?source=ireal"
      },
      {
        "title": "I'm In The Mood For Love",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/im_in_the_mood_for_love?source=ireal"
      },
      {
        "title": "I'm Just A Lucky So-And-So",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/im_just_a_lucky_soandso?source=ireal"
      },
      {
        "title": "I'm Old Fashioned",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/im_old_fashioned?source=ireal"
      },
      {
        "title": "I'm Putting All My Eggs In One Basket",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/im_putting_all_my_eggs_in_one_basket?source=ireal"
      },
      {
        "title": "I'm Sitting On Top Of The World",
        "artist": "Louis-Henderson-Young",
        "url": "https://www.quickchords.org/charts/jazz/louishendersonyoung/im_sitting_on_top_of_the_world?source=ireal"
      },
      {
        "title": "I'm Through With Love",
        "artist": "Kahn-Malneck-Livingston",
        "url": "https://www.quickchords.org/charts/jazz/kahnmalnecklivingston/im_through_with_love?source=ireal"
      },
      {
        "title": "I've Found A New Baby",
        "artist": "Palmer-Williams",
        "url": "https://www.quickchords.org/charts/jazz/palmerwilliams/ive_found_a_new_baby?source=ireal"
      },
      {
        "title": "I've Got A Crush On You",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/ive_got_a_crush_on_you?source=ireal"
      },
      {
        "title": "I've Got My Love To Keep Me Warm",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/ive_got_my_love_to_keep_me_warm?source=ireal"
      },
      {
        "title": "I've Got The World On A String",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/ive_got_the_world_on_a_string?source=ireal"
      },
      {
        "title": "I've Got You Under My Skin",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/ive_got_you_under_my_skin?source=ireal"
      },
      {
        "title": "I've Grown Accustomed To Her Face",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/jazz/frederick_loewe/ive_grown_accustomed_to_her_face?source=ireal"
      },
      {
        "title": "I've Heard That Song Before",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/ive_heard_that_song_before?source=ireal"
      },
      {
        "title": "I've Never Been In Love Before",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/ive_never_been_in_love_before?source=ireal"
      },
      {
        "title": "I've Told Eve'ry Little Star",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/ive_told_every_little_star?source=ireal"
      },
      {
        "title": "Idle Moments",
        "artist": "Grant Green",
        "url": "https://www.quickchords.org/charts/jazz/grant_green/idle_moments?source=ireal"
      },
      {
        "title": "If Ever I Would Leave You",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/jazz/frederick_loewe/if_ever_i_would_leave_you?source=ireal"
      },
      {
        "title": "If I Could Be With You",
        "artist": "James Johnson",
        "url": "https://www.quickchords.org/charts/jazz/james_johnson/if_i_could_be_with_you?source=ireal"
      },
      {
        "title": "If I Didn't Care",
        "artist": "Jack Lawrence",
        "url": "https://www.quickchords.org/charts/jazz/jack_lawrence/if_i_didnt_care?source=ireal"
      },
      {
        "title": "If I Had You",
        "artist": "Campbell-Connelly-Shapiro",
        "url": "https://www.quickchords.org/charts/jazz/campbellconnellyshapiro/if_i_had_you?source=ireal"
      },
      {
        "title": "If I Loved You",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/if_i_loved_you?source=ireal"
      },
      {
        "title": "If I Ruled The World",
        "artist": "Leslie Bricusse",
        "url": "https://www.quickchords.org/charts/jazz/leslie_bricusse/if_i_ruled_the_world?source=ireal"
      },
      {
        "title": "If I Should Lose You",
        "artist": "Ralph Rainger",
        "url": "https://www.quickchords.org/charts/jazz/ralph_rainger/if_i_should_lose_you?source=ireal"
      },
      {
        "title": "If I Were A Bell",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/if_i_were_a_bell?source=ireal"
      },
      {
        "title": "If There Is Someone Lovelier",
        "artist": "Dietz-Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/dietzschwartz/if_there_is_someone_lovelier?source=ireal"
      },
      {
        "title": "If You Could See Me Now",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tadd_dameron/if_you_could_see_me_now?source=ireal"
      },
      {
        "title": "If You Ever Should Leave",
        "artist": "Cahn-Chaplin",
        "url": "https://www.quickchords.org/charts/jazz/cahnchaplin/if_you_ever_should_leave?source=ireal"
      },
      {
        "title": "If You Never Come To Me",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/if_you_never_come_to_me?source=ireal"
      },
      {
        "title": "Ill Wind",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/ill_wind?source=ireal"
      },
      {
        "title": "Imagination",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/imagination?source=ireal"
      },
      {
        "title": "Impressions",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/impressions?source=ireal"
      },
      {
        "title": "In A Little Spanish Town",
        "artist": "Wayne-Lewis-Young",
        "url": "https://www.quickchords.org/charts/jazz/waynelewisyoung/in_a_little_spanish_town?source=ireal"
      },
      {
        "title": "In A Mellow Tone (In A Mellotone)",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/in_a_mellow_tone_in_a_mellotone?source=ireal"
      },
      {
        "title": "In a Sentimental Mood",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/in_a_sentimental_mood?source=ireal"
      },
      {
        "title": "In A Shanty In Old Shanty Town",
        "artist": "Little-Siras",
        "url": "https://www.quickchords.org/charts/jazz/littlesiras/in_a_shanty_in_old_shanty_town?source=ireal"
      },
      {
        "title": "In Her Family",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/in_her_family?source=ireal"
      },
      {
        "title": "In Love In Vain",
        "artist": "Kern Jerome Robin Leo",
        "url": "https://www.quickchords.org/charts/jazz/kern_jerome_robin_leo/in_love_in_vain?source=ireal"
      },
      {
        "title": "In Pursuit Of The 27th Man",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/in_pursuit_of_the_27th_man?source=ireal"
      },
      {
        "title": "In The Cool, Cool, Cool Of The Evening",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/in_the_cool_cool_cool_of_the_evening?source=ireal"
      },
      {
        "title": "In The Middle Of A Kiss",
        "artist": "Sam Coslow",
        "url": "https://www.quickchords.org/charts/jazz/sam_coslow/in_the_middle_of_a_kiss?source=ireal"
      },
      {
        "title": "In The Still Of The Night",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/in_the_still_of_the_night?source=ireal"
      },
      {
        "title": "In The Wee Small Hours Of The Morning",
        "artist": "Mann-Hilliard",
        "url": "https://www.quickchords.org/charts/jazz/mannhilliard/in_the_wee_small_hours_of_the_morning?source=ireal"
      },
      {
        "title": "In Walked Bud",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/in_walked_bud?source=ireal"
      },
      {
        "title": "In Your Own Sweet Way",
        "artist": "Dave Brubeck",
        "url": "https://www.quickchords.org/charts/jazz/dave_brubeck/in_your_own_sweet_way?source=ireal"
      },
      {
        "title": "Incentive",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/incentive?source=ireal"
      },
      {
        "title": "Indian Summer",
        "artist": "Victor-Aldubin-Herbert",
        "url": "https://www.quickchords.org/charts/jazz/victoraldubinherbert/indian_summer?source=ireal"
      },
      {
        "title": "Indiana (Back Home Again In)",
        "artist": "James Hanley",
        "url": "https://www.quickchords.org/charts/jazz/james_hanley/indiana_back_home_again_in?source=ireal"
      },
      {
        "title": "Infant Eyes",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/infant_eyes?source=ireal"
      },
      {
        "title": "Inner Urge",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/inner_urge?source=ireal"
      },
      {
        "title": "Interplay",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/interplay?source=ireal"
      },
      {
        "title": "Invitation",
        "artist": "Bronislau Kaper",
        "url": "https://www.quickchords.org/charts/jazz/bronislau_kaper/invitation?source=ireal"
      },
      {
        "title": "Iris",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/iris?source=ireal"
      },
      {
        "title": "Irresistable You",
        "artist": "Gene DePaul",
        "url": "https://www.quickchords.org/charts/jazz/gene_depaul/irresistable_you?source=ireal"
      },
      {
        "title": "Is That So?",
        "artist": "Duke Pearson",
        "url": "https://www.quickchords.org/charts/jazz/duke_pearson/is_that_so?source=ireal"
      },
      {
        "title": "Is You Is Or Is You Ain't (Ma' Baby)",
        "artist": "Austin-Jordan",
        "url": "https://www.quickchords.org/charts/jazz/austinjordan/is_you_is_or_is_you_aint_ma_baby?source=ireal"
      },
      {
        "title": "Isfahan",
        "artist": "Strayhorn-Ellington",
        "url": "https://www.quickchords.org/charts/jazz/strayhornellington/isfahan?source=ireal"
      },
      {
        "title": "Island Birdie",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/jazz/mccoy_tyner/island_birdie?source=ireal"
      },
      {
        "title": "Isn't It A Lovely Day (To Be Caught In The Rain)",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/isnt_it_a_lovely_day_to_be_caught_in_the_rain?source=ireal"
      },
      {
        "title": "Isn't It A Pity",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/isnt_it_a_pity?source=ireal"
      },
      {
        "title": "Isn't It Romantic?",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/isnt_it_romantic?source=ireal"
      },
      {
        "title": "Isotope",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/isotope?source=ireal"
      },
      {
        "title": "Israel",
        "artist": "John Carisi",
        "url": "https://www.quickchords.org/charts/jazz/john_carisi/israel?source=ireal"
      },
      {
        "title": "It Ain't Necessarily So",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/it_aint_necessarily_so?source=ireal"
      },
      {
        "title": "It Could Happen To You",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/it_could_happen_to_you?source=ireal"
      },
      {
        "title": "It Don't Mean A Thing",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/it_dont_mean_a_thing?source=ireal"
      },
      {
        "title": "It Had To Be You",
        "artist": "Isham Jones",
        "url": "https://www.quickchords.org/charts/jazz/isham_jones/it_had_to_be_you?source=ireal"
      },
      {
        "title": "It Might As Well Be Spring",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/it_might_as_well_be_spring?source=ireal"
      },
      {
        "title": "It Never Entered My Mind",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/it_never_entered_my_mind?source=ireal"
      },
      {
        "title": "It Only Happens When I Dance With You",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/it_only_happens_when_i_dance_with_you?source=ireal"
      },
      {
        "title": "It Was So Good While It Lasted",
        "artist": "Poll-Ackers",
        "url": "https://www.quickchords.org/charts/jazz/pollackers/it_was_so_good_while_it_lasted?source=ireal"
      },
      {
        "title": "It's A Big Wide Wonderful World",
        "artist": "John Rox",
        "url": "https://www.quickchords.org/charts/jazz/john_rox/its_a_big_wide_wonderful_world?source=ireal"
      },
      {
        "title": "It's A Blue World",
        "artist": "Wright-Forrest",
        "url": "https://www.quickchords.org/charts/jazz/wrightforrest/its_a_blue_world?source=ireal"
      },
      {
        "title": "It's A Dance",
        "artist": "Michel Petrucciani",
        "url": "https://www.quickchords.org/charts/jazz/michel_petrucciani/its_a_dance?source=ireal"
      },
      {
        "title": "It's A Good Day",
        "artist": "Peggy Lee",
        "url": "https://www.quickchords.org/charts/jazz/peggy_lee/its_a_good_day?source=ireal"
      },
      {
        "title": "It's A Lovely Day Today",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/its_a_lovely_day_today?source=ireal"
      },
      {
        "title": "It's A Raggy Waltz",
        "artist": "Dave Brubeck",
        "url": "https://www.quickchords.org/charts/jazz/dave_brubeck/its_a_raggy_waltz?source=ireal"
      },
      {
        "title": "It's All Right With Me",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/its_all_right_with_me?source=ireal"
      },
      {
        "title": "It's Been A Long Long Time",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/its_been_a_long_long_time?source=ireal"
      },
      {
        "title": "It's De-lovely",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/its_delovely?source=ireal"
      },
      {
        "title": "It's Easy To Remember",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/its_easy_to_remember?source=ireal"
      },
      {
        "title": "It's Impossible",
        "artist": "Armando Manzanero",
        "url": "https://www.quickchords.org/charts/jazz/armando_manzanero/its_impossible?source=ireal"
      },
      {
        "title": "It's Just Talk",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/its_just_talk?source=ireal"
      },
      {
        "title": "It's Magic",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/its_magic?source=ireal"
      },
      {
        "title": "It's Only a Paper Moon",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/its_only_a_paper_moon?source=ireal"
      },
      {
        "title": "It's The Talk Of The Town",
        "artist": "Jerry Livingston",
        "url": "https://www.quickchords.org/charts/jazz/jerry_livingston/its_the_talk_of_the_town?source=ireal"
      },
      {
        "title": "It's You Or No One",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/its_you_or_no_one?source=ireal"
      },
      {
        "title": "Jackie-ing",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/jackieing?source=ireal"
      },
      {
        "title": "Jaco",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/jaco?source=ireal"
      },
      {
        "title": "James",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/james?source=ireal"
      },
      {
        "title": "Jazz Folk",
        "artist": "John Abercrombie",
        "url": "https://www.quickchords.org/charts/jazz/john_abercrombie/jazz_folk?source=ireal"
      },
      {
        "title": "Je Ne Sais Pas",
        "artist": "Hampton-Jones",
        "url": "https://www.quickchords.org/charts/jazz/hamptonjones/je_ne_sais_pas?source=ireal"
      },
      {
        "title": "Jeannie's Song",
        "artist": "Marchel Ivery",
        "url": "https://www.quickchords.org/charts/jazz/marchel_ivery/jeannies_song?source=ireal"
      },
      {
        "title": "Jeannine",
        "artist": "Duke Pearson",
        "url": "https://www.quickchords.org/charts/jazz/duke_pearson/jeannine?source=ireal"
      },
      {
        "title": "Jeepers Creepers",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/jeepers_creepers?source=ireal"
      },
      {
        "title": "Jersey Bounce",
        "artist": "Plater-Bradshaw-Johnson",
        "url": "https://www.quickchords.org/charts/jazz/platerbradshawjohnson/jersey_bounce?source=ireal"
      },
      {
        "title": "Jinrikisha",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/jinrikisha?source=ireal"
      },
      {
        "title": "Jitterbug Waltz",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/jazz/fats_waller/jitterbug_waltz?source=ireal"
      },
      {
        "title": "Jody Grind, The",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/jody_grind_the?source=ireal"
      },
      {
        "title": "Joker, The",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/jazz/lee_morgan/joker_the?source=ireal"
      },
      {
        "title": "Jordu",
        "artist": "Duke Jordan",
        "url": "https://www.quickchords.org/charts/jazz/duke_jordan/jordu?source=ireal"
      },
      {
        "title": "Joshua",
        "artist": "Victor Feldman",
        "url": "https://www.quickchords.org/charts/jazz/victor_feldman/joshua?source=ireal"
      },
      {
        "title": "Joy Spring",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/jazz/clifford_brown/joy_spring?source=ireal"
      },
      {
        "title": "Juju",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/juju?source=ireal"
      },
      {
        "title": "Jumpin With Symphony Sid",
        "artist": "Lester Young",
        "url": "https://www.quickchords.org/charts/jazz/lester_young/jumpin_with_symphony_sid?source=ireal"
      },
      {
        "title": "Just A Gigolo",
        "artist": "Leonello Casucci",
        "url": "https://www.quickchords.org/charts/jazz/leonello_casucci/just_a_gigolo?source=ireal"
      },
      {
        "title": "Just A-Sittin' And A-Rockin",
        "artist": "Ellington-Strayhorn-Gaines",
        "url": "https://www.quickchords.org/charts/jazz/ellingtonstrayhorngaines/just_asittin_and_arockin?source=ireal"
      },
      {
        "title": "Just Friends",
        "artist": "John Klenner",
        "url": "https://www.quickchords.org/charts/jazz/john_klenner/just_friends?source=ireal"
      },
      {
        "title": "Just In Time",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/just_in_time?source=ireal"
      },
      {
        "title": "Just In Tune",
        "artist": "John Abercrombie",
        "url": "https://www.quickchords.org/charts/jazz/john_abercrombie/just_in_tune?source=ireal"
      },
      {
        "title": "Just One More Chance",
        "artist": "Johnston-Coslow",
        "url": "https://www.quickchords.org/charts/jazz/johnstoncoslow/just_one_more_chance?source=ireal"
      },
      {
        "title": "Just One Of Those Things",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/just_one_of_those_things?source=ireal"
      },
      {
        "title": "Just Squeeze Me",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/just_squeeze_me?source=ireal"
      },
      {
        "title": "Just You, Just Me",
        "artist": "Jesse Greer",
        "url": "https://www.quickchords.org/charts/jazz/jesse_greer/just_you_just_me?source=ireal"
      },
      {
        "title": "Kary's Trance",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/jazz/lee_konitz/karys_trance?source=ireal"
      },
      {
        "title": "Katrina Ballerina",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/jazz/woody_shaw/katrina_ballerina?source=ireal"
      },
      {
        "title": "Keepin' Myself For You",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/jazz/vincent_youmans/keepin_myself_for_you?source=ireal"
      },
      {
        "title": "Kicker, The",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/kicker_the?source=ireal"
      },
      {
        "title": "Kids Are Pretty People",
        "artist": "Thad Jones",
        "url": "https://www.quickchords.org/charts/jazz/thad_jones/kids_are_pretty_people?source=ireal"
      },
      {
        "title": "Killer Joe",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/killer_joe?source=ireal"
      },
      {
        "title": "Ko Ko",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/ko_ko?source=ireal"
      },
      {
        "title": "L-O-V-E",
        "artist": "Gabler-Kaempfert",
        "url": "https://www.quickchords.org/charts/jazz/gablerkaempfert/love?source=ireal"
      },
      {
        "title": "La Fiesta",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/la_fiesta?source=ireal"
      },
      {
        "title": "La Vie En Rose",
        "artist": "Louiguy-Piaf",
        "url": "https://www.quickchords.org/charts/jazz/louiguypiaf/la_vie_en_rose?source=ireal"
      },
      {
        "title": "Ladies In Mercedes",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/jazz/steve_swallow/ladies_in_mercedes?source=ireal"
      },
      {
        "title": "Lady Bird",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tadd_dameron/lady_bird?source=ireal"
      },
      {
        "title": "Lady is a Tramp, The",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/lady_is_a_tramp_the?source=ireal"
      },
      {
        "title": "Lady's In Love With You, The",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/ladys_in_love_with_you_the?source=ireal"
      },
      {
        "title": "Lakes",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/lakes?source=ireal"
      },
      {
        "title": "Lament",
        "artist": "J.J. Johnson",
        "url": "https://www.quickchords.org/charts/jazz/jj_johnson/lament?source=ireal"
      },
      {
        "title": "Lamp Is Low, The",
        "artist": "DeRose-Shefter",
        "url": "https://www.quickchords.org/charts/jazz/deroseshefter/lamp_is_low_the?source=ireal"
      },
      {
        "title": "Last Night When We Were Young",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/last_night_when_we_were_young?source=ireal"
      },
      {
        "title": "Last Time I Saw Paris, The",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/jazz/henry_mancini/last_time_i_saw_paris_the?source=ireal"
      },
      {
        "title": "Last Train Home",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/last_train_home?source=ireal"
      },
      {
        "title": "Laura",
        "artist": "David Raksin",
        "url": "https://www.quickchords.org/charts/jazz/david_raksin/laura?source=ireal"
      },
      {
        "title": "Laurie",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/laurie?source=ireal"
      },
      {
        "title": "Lazy Afternoon",
        "artist": "Latouche-Moross",
        "url": "https://www.quickchords.org/charts/jazz/latouchemoross/lazy_afternoon?source=ireal"
      },
      {
        "title": "Lazy Bird",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/lazy_bird?source=ireal"
      },
      {
        "title": "Lazy River",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/lazy_river?source=ireal"
      },
      {
        "title": "Lazybones",
        "artist": "Carmichael-Mercer",
        "url": "https://www.quickchords.org/charts/jazz/carmichaelmercer/lazybones?source=ireal"
      },
      {
        "title": "Leaving",
        "artist": "Richie Beirach",
        "url": "https://www.quickchords.org/charts/jazz/richie_beirach/leaving?source=ireal"
      },
      {
        "title": "Leila",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/leila?source=ireal"
      },
      {
        "title": "Lennie-Bird",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/jazz/lennie_tristano/lenniebird?source=ireal"
      },
      {
        "title": "Lennie's Pennies",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/jazz/lennie_tristano/lennies_pennies?source=ireal"
      },
      {
        "title": "Let There Be Love",
        "artist": "Rand-Grant",
        "url": "https://www.quickchords.org/charts/jazz/randgrant/let_there_be_love?source=ireal"
      },
      {
        "title": "Let There Be You",
        "artist": "Young-Cavanaugh",
        "url": "https://www.quickchords.org/charts/jazz/youngcavanaugh/let_there_be_you?source=ireal"
      },
      {
        "title": "Let's Call The Whole Thing Off",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/lets_call_the_whole_thing_off?source=ireal"
      },
      {
        "title": "Let's Call This",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/lets_call_this?source=ireal"
      },
      {
        "title": "Let's Cool One",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/lets_cool_one?source=ireal"
      },
      {
        "title": "Let's Do It (Let's Fall In Love)",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/lets_do_it_lets_fall_in_love?source=ireal"
      },
      {
        "title": "Let's Face The Music And Dance",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/lets_face_the_music_and_dance?source=ireal"
      },
      {
        "title": "Let's Fall In Love",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/lets_fall_in_love?source=ireal"
      },
      {
        "title": "Let's Get Away From It All",
        "artist": "Dennis-Adair",
        "url": "https://www.quickchords.org/charts/jazz/dennisadair/lets_get_away_from_it_all?source=ireal"
      },
      {
        "title": "Let's Get Lost",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/lets_get_lost?source=ireal"
      },
      {
        "title": "Li'l Darling",
        "artist": "Neal Hefti",
        "url": "https://www.quickchords.org/charts/jazz/neal_hefti/lil_darling?source=ireal"
      },
      {
        "title": "Light Blue",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/light_blue?source=ireal"
      },
      {
        "title": "Ligia",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/ligia?source=ireal"
      },
      {
        "title": "Like A Lover",
        "artist": "Motta Caymmi-Nelson Dori",
        "url": "https://www.quickchords.org/charts/jazz/motta_caymminelson_dori/like_a_lover?source=ireal"
      },
      {
        "title": "Like Someone In Love",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/like_someone_in_love?source=ireal"
      },
      {
        "title": "Like Sonny",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/like_sonny?source=ireal"
      },
      {
        "title": "Lily of The Valley",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/lily_of_the_valley?source=ireal"
      },
      {
        "title": "Limbo",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/limbo?source=ireal"
      },
      {
        "title": "Limehouse Blues",
        "artist": "Braham-Furber",
        "url": "https://www.quickchords.org/charts/jazz/brahamfurber/limehouse_blues?source=ireal"
      },
      {
        "title": "Line For Lyons",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/jazz/gerry_mulligan/line_for_lyons?source=ireal"
      },
      {
        "title": "Linger Awhile",
        "artist": "Vincent Rose",
        "url": "https://www.quickchords.org/charts/jazz/vincent_rose/linger_awhile?source=ireal"
      },
      {
        "title": "Litha",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/litha?source=ireal"
      },
      {
        "title": "Little B's Poem",
        "artist": "Bobby Hutcherson",
        "url": "https://www.quickchords.org/charts/jazz/bobby_hutcherson/little_bs_poem?source=ireal"
      },
      {
        "title": "Little Boat (O Barquinho)",
        "artist": "Roberto Menescal",
        "url": "https://www.quickchords.org/charts/jazz/roberto_menescal/little_boat_o_barquinho?source=ireal"
      },
      {
        "title": "Little Chicago Fire",
        "artist": "Frank Foster",
        "url": "https://www.quickchords.org/charts/jazz/frank_foster/little_chicago_fire?source=ireal"
      },
      {
        "title": "Little Dancer",
        "artist": "Tom Harrell",
        "url": "https://www.quickchords.org/charts/jazz/tom_harrell/little_dancer?source=ireal"
      },
      {
        "title": "Little Girl Blue",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/little_girl_blue?source=ireal"
      },
      {
        "title": "Little Niles",
        "artist": "Randy Weston",
        "url": "https://www.quickchords.org/charts/jazz/randy_weston/little_niles?source=ireal"
      },
      {
        "title": "Little Peace In C For You",
        "artist": "Michel Petrucciani",
        "url": "https://www.quickchords.org/charts/jazz/michel_petrucciani/little_peace_in_c_for_you?source=ireal"
      },
      {
        "title": "Little Rootie Tootie",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/little_rootie_tootie?source=ireal"
      },
      {
        "title": "Little Sunflower",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/jazz/freddie_hubbard/little_sunflower?source=ireal"
      },
      {
        "title": "Little Waltz",
        "artist": "Ron Carter",
        "url": "https://www.quickchords.org/charts/jazz/ron_carter/little_waltz?source=ireal"
      },
      {
        "title": "Little Willie Leaps",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/little_willie_leaps?source=ireal"
      },
      {
        "title": "Liza",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/liza?source=ireal"
      },
      {
        "title": "Locomotion",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/locomotion?source=ireal"
      },
      {
        "title": "Lone Jack (Page 1)",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/lone_jack_page_1?source=ireal"
      },
      {
        "title": "Lone Jack (Page 2 - Solos)",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/lone_jack_page_2__solos?source=ireal"
      },
      {
        "title": "Lonely Dreams",
        "artist": "Terry Gibbs",
        "url": "https://www.quickchords.org/charts/jazz/terry_gibbs/lonely_dreams?source=ireal"
      },
      {
        "title": "Lonesome Road, The",
        "artist": "Austin-Shilkret",
        "url": "https://www.quickchords.org/charts/jazz/austinshilkret/lonesome_road_the?source=ireal"
      },
      {
        "title": "Long Ago And Far Away",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/long_ago_and_far_away?source=ireal"
      },
      {
        "title": "Lonnie's Lament",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/lonnies_lament?source=ireal"
      },
      {
        "title": "Look For The Silver Lining",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/look_for_the_silver_lining?source=ireal"
      },
      {
        "title": "Look Of Love, The",
        "artist": "Burt Bacharach",
        "url": "https://www.quickchords.org/charts/jazz/burt_bacharach/look_of_love_the?source=ireal"
      },
      {
        "title": "Look To The Rainbow",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/look_to_the_rainbow?source=ireal"
      },
      {
        "title": "Look To The Sky",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/look_to_the_sky?source=ireal"
      },
      {
        "title": "Looking Up",
        "artist": "Michel Petrucciani",
        "url": "https://www.quickchords.org/charts/jazz/michel_petrucciani/looking_up?source=ireal"
      },
      {
        "title": "Loop, The",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/loop_the?source=ireal"
      },
      {
        "title": "Lotus Blossom",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/lotus_blossom?source=ireal"
      },
      {
        "title": "Lotus Eaters Bittersweet",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/lotus_eaters_bittersweet?source=ireal"
      },
      {
        "title": "Love For Sale",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/love_for_sale?source=ireal"
      },
      {
        "title": "Love Is Just Around The Corner",
        "artist": "Lewis Gensler",
        "url": "https://www.quickchords.org/charts/jazz/lewis_gensler/love_is_just_around_the_corner?source=ireal"
      },
      {
        "title": "Love Me Or Leave Me",
        "artist": "Walter Donaldson",
        "url": "https://www.quickchords.org/charts/jazz/walter_donaldson/love_me_or_leave_me?source=ireal"
      },
      {
        "title": "Love Nest, The",
        "artist": "Louis Hirsch",
        "url": "https://www.quickchords.org/charts/jazz/louis_hirsch/love_nest_the?source=ireal"
      },
      {
        "title": "Love Vibrations",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/love_vibrations?source=ireal"
      },
      {
        "title": "Love Walked In",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/love_walked_in?source=ireal"
      },
      {
        "title": "Lover",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/lover?source=ireal"
      },
      {
        "title": "Lover Man",
        "artist": "Davis-Ramirez-Sherman",
        "url": "https://www.quickchords.org/charts/jazz/davisramirezsherman/lover_man?source=ireal"
      },
      {
        "title": "Lover, Come Back To Me",
        "artist": "Sigmund Romberg",
        "url": "https://www.quickchords.org/charts/jazz/sigmund_romberg/lover_come_back_to_me?source=ireal"
      },
      {
        "title": "Lucky Southern",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/lucky_southern?source=ireal"
      },
      {
        "title": "Lullaby In Rhythm",
        "artist": "Goodman-Hirsch",
        "url": "https://www.quickchords.org/charts/jazz/goodmanhirsch/lullaby_in_rhythm?source=ireal"
      },
      {
        "title": "Lullaby Of Birdland",
        "artist": "George Shearing",
        "url": "https://www.quickchords.org/charts/jazz/george_shearing/lullaby_of_birdland?source=ireal"
      },
      {
        "title": "Lullaby Of The Leaves",
        "artist": "Bernice Petkere",
        "url": "https://www.quickchords.org/charts/jazz/bernice_petkere/lullaby_of_the_leaves?source=ireal"
      },
      {
        "title": "Lulu's Back In Town",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/lulus_back_in_town?source=ireal"
      },
      {
        "title": "Lush Life",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/lush_life?source=ireal"
      },
      {
        "title": "Lyresto",
        "artist": "Kenny Burrell",
        "url": "https://www.quickchords.org/charts/jazz/kenny_burrell/lyresto?source=ireal"
      },
      {
        "title": "Ma Belle Hélène",
        "artist": "Kenny Wheeler",
        "url": "https://www.quickchords.org/charts/jazz/kenny_wheeler/ma_belle_hlne?source=ireal"
      },
      {
        "title": "Mack The Knife",
        "artist": "Weill-Brecht",
        "url": "https://www.quickchords.org/charts/jazz/weillbrecht/mack_the_knife?source=ireal"
      },
      {
        "title": "Mahjong",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/mahjong?source=ireal"
      },
      {
        "title": "Maiden Voyage",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/maiden_voyage?source=ireal"
      },
      {
        "title": "Make Someone Happy",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/make_someone_happy?source=ireal"
      },
      {
        "title": "Making Whoopee",
        "artist": "Walter Donaldson",
        "url": "https://www.quickchords.org/charts/jazz/walter_donaldson/making_whoopee?source=ireal"
      },
      {
        "title": "Mambo Inn",
        "artist": "Bauza-Sampson-Woodlen",
        "url": "https://www.quickchords.org/charts/jazz/bauzasampsonwoodlen/mambo_inn?source=ireal"
      },
      {
        "title": "Man I Love, The",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/man_i_love_the?source=ireal"
      },
      {
        "title": "Man That Got Away, The",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/man_that_got_away_the?source=ireal"
      },
      {
        "title": "Manha De Carnaval (Black Orpheus)",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/jazz/luiz_bonfa/manha_de_carnaval_black_orpheus?source=ireal"
      },
      {
        "title": "Manhattan",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/manhattan?source=ireal"
      },
      {
        "title": "Manoir De Mes Rêves (Django's Castle)",
        "artist": "Django Reinhardt",
        "url": "https://www.quickchords.org/charts/jazz/django_reinhardt/manoir_de_mes_rves_djangos_castle?source=ireal"
      },
      {
        "title": "Manteca",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/manteca?source=ireal"
      },
      {
        "title": "Mas Que Nada",
        "artist": "Jorge Ben",
        "url": "https://www.quickchords.org/charts/jazz/jorge_ben/mas_que_nada?source=ireal"
      },
      {
        "title": "Masquerade Is Over, The",
        "artist": "Allie Wrubel",
        "url": "https://www.quickchords.org/charts/jazz/allie_wrubel/masquerade_is_over_the?source=ireal"
      },
      {
        "title": "Maybe I Should Change My Ways",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/maybe_i_should_change_my_ways?source=ireal"
      },
      {
        "title": "Maybe September",
        "artist": "Percy Faith",
        "url": "https://www.quickchords.org/charts/jazz/percy_faith/maybe_september?source=ireal"
      },
      {
        "title": "Maze, The",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/maze_the?source=ireal"
      },
      {
        "title": "Mc Jolt",
        "artist": "Richie Beirach",
        "url": "https://www.quickchords.org/charts/jazz/richie_beirach/mc_jolt?source=ireal"
      },
      {
        "title": "Mean To Me",
        "artist": "Turk-Ahlert",
        "url": "https://www.quickchords.org/charts/jazz/turkahlert/mean_to_me?source=ireal"
      },
      {
        "title": "Meaning Of The Blues, The",
        "artist": "Worth-Troup",
        "url": "https://www.quickchords.org/charts/jazz/worthtroup/meaning_of_the_blues_the?source=ireal"
      },
      {
        "title": "Meditation",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/meditation?source=ireal"
      },
      {
        "title": "Memories Of Tomorrow",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/memories_of_tomorrow?source=ireal"
      },
      {
        "title": "Memories Of You",
        "artist": "Eubie Blake",
        "url": "https://www.quickchords.org/charts/jazz/eubie_blake/memories_of_you?source=ireal"
      },
      {
        "title": "Mercy Mercy Mercy",
        "artist": "Joe Zawinul",
        "url": "https://www.quickchords.org/charts/jazz/joe_zawinul/mercy_mercy_mercy?source=ireal"
      },
      {
        "title": "Midnight Blue",
        "artist": "Kenny Burrell",
        "url": "https://www.quickchords.org/charts/jazz/kenny_burrell/midnight_blue?source=ireal"
      },
      {
        "title": "Midnight Mood",
        "artist": "Joe Zawinul",
        "url": "https://www.quickchords.org/charts/jazz/joe_zawinul/midnight_mood?source=ireal"
      },
      {
        "title": "Midnight Sun",
        "artist": "Hampton-Burke-Mercer",
        "url": "https://www.quickchords.org/charts/jazz/hamptonburkemercer/midnight_sun?source=ireal"
      },
      {
        "title": "Milano",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/jazz/john_lewis/milano?source=ireal"
      },
      {
        "title": "Miles Ahead",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/miles_ahead?source=ireal"
      },
      {
        "title": "Milestones (New)",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/milestones_new?source=ireal"
      },
      {
        "title": "Milestones (Old)",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/milestones_old?source=ireal"
      },
      {
        "title": "Mimi",
        "artist": "Richard Rogers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rogers/mimi?source=ireal"
      },
      {
        "title": "Mimosa",
        "artist": "George Benson",
        "url": "https://www.quickchords.org/charts/jazz/george_benson/mimosa?source=ireal"
      },
      {
        "title": "Minoat",
        "artist": "Mal Waldron",
        "url": "https://www.quickchords.org/charts/jazz/mal_waldron/minoat?source=ireal"
      },
      {
        "title": "Minor Mishap",
        "artist": "Tommy Flanagan",
        "url": "https://www.quickchords.org/charts/jazz/tommy_flanagan/minor_mishap?source=ireal"
      },
      {
        "title": "Minor Mood",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/jazz/clifford_brown/minor_mood?source=ireal"
      },
      {
        "title": "Minor Strain",
        "artist": "Bobby Timmons",
        "url": "https://www.quickchords.org/charts/jazz/bobby_timmons/minor_strain?source=ireal"
      },
      {
        "title": "Minority",
        "artist": "Gigi Gryce",
        "url": "https://www.quickchords.org/charts/jazz/gigi_gryce/minority?source=ireal"
      },
      {
        "title": "Mirror, Mirror",
        "artist": "Corea Chick",
        "url": "https://www.quickchords.org/charts/jazz/corea_chick/mirror_mirror?source=ireal"
      },
      {
        "title": "Misterioso",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/misterioso?source=ireal"
      },
      {
        "title": "Misty",
        "artist": "Erroll Garner",
        "url": "https://www.quickchords.org/charts/jazz/erroll_garner/misty?source=ireal"
      },
      {
        "title": "Miyako",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/miyako?source=ireal"
      },
      {
        "title": "Moanin'",
        "artist": "Bobby Timmons",
        "url": "https://www.quickchords.org/charts/jazz/bobby_timmons/moanin?source=ireal"
      },
      {
        "title": "Moment's Notice",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/moments_notice?source=ireal"
      },
      {
        "title": "Moments To Remember",
        "artist": "Robert Allen",
        "url": "https://www.quickchords.org/charts/jazz/robert_allen/moments_to_remember?source=ireal"
      },
      {
        "title": "Mona Lisa",
        "artist": "Livingston-Evans",
        "url": "https://www.quickchords.org/charts/jazz/livingstonevans/mona_lisa?source=ireal"
      },
      {
        "title": "Monk's Dream",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/monks_dream?source=ireal"
      },
      {
        "title": "Monk's Mood",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/monks_mood?source=ireal"
      },
      {
        "title": "Mood Indigo",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/mood_indigo?source=ireal"
      },
      {
        "title": "Moon Alley",
        "artist": "Tom Harrell",
        "url": "https://www.quickchords.org/charts/jazz/tom_harrell/moon_alley?source=ireal"
      },
      {
        "title": "Moon And Sand",
        "artist": "Wilder-Palitz",
        "url": "https://www.quickchords.org/charts/jazz/wilderpalitz/moon_and_sand?source=ireal"
      },
      {
        "title": "Moon Mist",
        "artist": "Ellington-Mercer",
        "url": "https://www.quickchords.org/charts/jazz/ellingtonmercer/moon_mist?source=ireal"
      },
      {
        "title": "Moon Rays",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/moon_rays?source=ireal"
      },
      {
        "title": "Moon River",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/jazz/henry_mancini/moon_river?source=ireal"
      },
      {
        "title": "Moonchild",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/moonchild?source=ireal"
      },
      {
        "title": "Moondance",
        "artist": "Van Morrison",
        "url": "https://www.quickchords.org/charts/jazz/van_morrison/moondance?source=ireal"
      },
      {
        "title": "Moonglow",
        "artist": "Hudson-Lange-Mills",
        "url": "https://www.quickchords.org/charts/jazz/hudsonlangemills/moonglow?source=ireal"
      },
      {
        "title": "Moonlight Becomes You",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/moonlight_becomes_you?source=ireal"
      },
      {
        "title": "Moonlight In Vermont",
        "artist": "Karl Suessdorf",
        "url": "https://www.quickchords.org/charts/jazz/karl_suessdorf/moonlight_in_vermont?source=ireal"
      },
      {
        "title": "Moonlight Saving Time",
        "artist": "Irving Kahal",
        "url": "https://www.quickchords.org/charts/jazz/irving_kahal/moonlight_saving_time?source=ireal"
      },
      {
        "title": "Moonlight Serenade",
        "artist": "Miller-Parish",
        "url": "https://www.quickchords.org/charts/jazz/millerparish/moonlight_serenade?source=ireal"
      },
      {
        "title": "Moontrane, The",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/jazz/woody_shaw/moontrane_the?source=ireal"
      },
      {
        "title": "Moose The Mooche",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/moose_the_mooche?source=ireal"
      },
      {
        "title": "More I See You, The",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/more_i_see_you_the?source=ireal"
      },
      {
        "title": "More Than You Know",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/jazz/vincent_youmans/more_than_you_know?source=ireal"
      },
      {
        "title": "Morgan The Pirate",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/jazz/lee_morgan/morgan_the_pirate?source=ireal"
      },
      {
        "title": "Morning",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/jazz/clare_fischer/morning?source=ireal"
      },
      {
        "title": "Moten Swing",
        "artist": "Bennie Moten",
        "url": "https://www.quickchords.org/charts/jazz/bennie_moten/moten_swing?source=ireal"
      },
      {
        "title": "Mountain Greenery",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/mountain_greenery?source=ireal"
      },
      {
        "title": "Move",
        "artist": "Denzil Best",
        "url": "https://www.quickchords.org/charts/jazz/denzil_best/move?source=ireal"
      },
      {
        "title": "Mr. P.C.",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/mr_pc?source=ireal"
      },
      {
        "title": "My Baby Just Cares For Me",
        "artist": "Walter Donaldson",
        "url": "https://www.quickchords.org/charts/jazz/walter_donaldson/my_baby_just_cares_for_me?source=ireal"
      },
      {
        "title": "My Buddy",
        "artist": "Walter Donaldson",
        "url": "https://www.quickchords.org/charts/jazz/walter_donaldson/my_buddy?source=ireal"
      },
      {
        "title": "My Favorite Things",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/my_favorite_things?source=ireal"
      },
      {
        "title": "My Foolish Heart",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/jazz/victor_young/my_foolish_heart?source=ireal"
      },
      {
        "title": "My Funny Valentine",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/my_funny_valentine?source=ireal"
      },
      {
        "title": "My Heart Belongs To Daddy",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/my_heart_belongs_to_daddy?source=ireal"
      },
      {
        "title": "My Heart Stood Still",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/my_heart_stood_still?source=ireal"
      },
      {
        "title": "My Ideal",
        "artist": "Richard Whiting",
        "url": "https://www.quickchords.org/charts/jazz/richard_whiting/my_ideal?source=ireal"
      },
      {
        "title": "My Last Affair",
        "artist": "Haven Johnson",
        "url": "https://www.quickchords.org/charts/jazz/haven_johnson/my_last_affair?source=ireal"
      },
      {
        "title": "My Little Brown Book",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/my_little_brown_book?source=ireal"
      },
      {
        "title": "My Little Suede Shoes",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/my_little_suede_shoes?source=ireal"
      },
      {
        "title": "My Lucky Star",
        "artist": "DeSylva-Brown-Henderson",
        "url": "https://www.quickchords.org/charts/jazz/desylvabrownhenderson/my_lucky_star?source=ireal"
      },
      {
        "title": "My Man's Gone Now",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/my_mans_gone_now?source=ireal"
      },
      {
        "title": "My Melancholy Baby",
        "artist": "Burnett-Norton",
        "url": "https://www.quickchords.org/charts/jazz/burnettnorton/my_melancholy_baby?source=ireal"
      },
      {
        "title": "My Old Flame",
        "artist": "Johnson-Coslow",
        "url": "https://www.quickchords.org/charts/jazz/johnsoncoslow/my_old_flame?source=ireal"
      },
      {
        "title": "My One And Only Love",
        "artist": "Wood-Mellin",
        "url": "https://www.quickchords.org/charts/jazz/woodmellin/my_one_and_only_love?source=ireal"
      },
      {
        "title": "My Romance",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/my_romance?source=ireal"
      },
      {
        "title": "My Secret Love",
        "artist": "Roger Vogel",
        "url": "https://www.quickchords.org/charts/jazz/roger_vogel/my_secret_love?source=ireal"
      },
      {
        "title": "My Shining Hour",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/my_shining_hour?source=ireal"
      },
      {
        "title": "My Ship",
        "artist": "Kurt Weill",
        "url": "https://www.quickchords.org/charts/jazz/kurt_weill/my_ship?source=ireal"
      },
      {
        "title": "My Song",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/my_song?source=ireal"
      },
      {
        "title": "My Way",
        "artist": "Revaux-Francois-Thibaud-Anka",
        "url": "https://www.quickchords.org/charts/jazz/revauxfrancoisthibaudanka/my_way?source=ireal"
      },
      {
        "title": "Nacada",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/nacada?source=ireal"
      },
      {
        "title": "Naima",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/naima?source=ireal"
      },
      {
        "title": "Nancy (With The Laughing Face)",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/nancy_with_the_laughing_face?source=ireal"
      },
      {
        "title": "Nardis",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/nardis?source=ireal"
      },
      {
        "title": "Nascimento",
        "artist": "Barry Harris",
        "url": "https://www.quickchords.org/charts/jazz/barry_harris/nascimento?source=ireal"
      },
      {
        "title": "Nature Boy",
        "artist": "Eden Ahbez",
        "url": "https://www.quickchords.org/charts/jazz/eden_ahbez/nature_boy?source=ireal"
      },
      {
        "title": "Nearness Of You, The",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/nearness_of_you_the?source=ireal"
      },
      {
        "title": "Nefertiti",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/nefertiti?source=ireal"
      },
      {
        "title": "Never Let Me Go",
        "artist": "Jay Livingston",
        "url": "https://www.quickchords.org/charts/jazz/jay_livingston/never_let_me_go?source=ireal"
      },
      {
        "title": "Never Will I Marry",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/never_will_i_marry?source=ireal"
      },
      {
        "title": "Nevertheless",
        "artist": "Kalmar-Ruby",
        "url": "https://www.quickchords.org/charts/jazz/kalmarruby/nevertheless?source=ireal"
      },
      {
        "title": "New Picture",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_heath/new_picture?source=ireal"
      },
      {
        "title": "New York, New York",
        "artist": "John Kander",
        "url": "https://www.quickchords.org/charts/jazz/john_kander/new_york_new_york?source=ireal"
      },
      {
        "title": "Nica's Dream",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/nicas_dream?source=ireal"
      },
      {
        "title": "Nice 'n Easy",
        "artist": "Spence-Bergman-Keith",
        "url": "https://www.quickchords.org/charts/jazz/spencebergmankeith/nice_n_easy?source=ireal"
      },
      {
        "title": "Nice Work If You Can Get It",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/nice_work_if_you_can_get_it?source=ireal"
      },
      {
        "title": "Nicolette",
        "artist": "Kenny Wheeler",
        "url": "https://www.quickchords.org/charts/jazz/kenny_wheeler/nicolette?source=ireal"
      },
      {
        "title": "Night And Day",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/night_and_day?source=ireal"
      },
      {
        "title": "Night Dreamer",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/night_dreamer?source=ireal"
      },
      {
        "title": "Night Has A Thousand Eyes, The",
        "artist": "Jerry-Brainin",
        "url": "https://www.quickchords.org/charts/jazz/jerrybrainin/night_has_a_thousand_eyes_the?source=ireal"
      },
      {
        "title": "Night We Called It A Day, The",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/jazz/matt_dennis/night_we_called_it_a_day_the?source=ireal"
      },
      {
        "title": "No Moe",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/no_moe?source=ireal"
      },
      {
        "title": "No Moon At All",
        "artist": "David Mann",
        "url": "https://www.quickchords.org/charts/jazz/david_mann/no_moon_at_all?source=ireal"
      },
      {
        "title": "No Splice",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/jazz/lee_konitz/no_splice?source=ireal"
      },
      {
        "title": "Nobody Else But Me",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/nobody_else_but_me?source=ireal"
      },
      {
        "title": "Nostalgia In Times Square",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/jazz/charles_mingus/nostalgia_in_times_square?source=ireal"
      },
      {
        "title": "Nothing Personal",
        "artist": "Don Grolnick",
        "url": "https://www.quickchords.org/charts/jazz/don_grolnick/nothing_personal?source=ireal"
      },
      {
        "title": "Now's The Time",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/nows_the_time?source=ireal"
      },
      {
        "title": "Nuages",
        "artist": "Django Reinhardt",
        "url": "https://www.quickchords.org/charts/jazz/django_reinhardt/nuages?source=ireal"
      },
      {
        "title": "Nutty",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/nutty?source=ireal"
      },
      {
        "title": "Nutville",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/nutville?source=ireal"
      },
      {
        "title": "O Grande Amor",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/o_grande_amor?source=ireal"
      },
      {
        "title": "Odd Couple, The",
        "artist": "Neal Hefti",
        "url": "https://www.quickchords.org/charts/jazz/neal_hefti/odd_couple_the?source=ireal"
      },
      {
        "title": "Off Minor",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/off_minor?source=ireal"
      },
      {
        "title": "Oh, Lady Be Good",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/oh_lady_be_good?source=ireal"
      },
      {
        "title": "Oh, What A Beautiful Mornin'",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/oh_what_a_beautiful_mornin?source=ireal"
      },
      {
        "title": "Oh! Look At Me Now",
        "artist": "DeVries-Bushkin",
        "url": "https://www.quickchords.org/charts/jazz/devriesbushkin/oh_look_at_me_now?source=ireal"
      },
      {
        "title": "Ol' Man River",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/ol_man_river?source=ireal"
      },
      {
        "title": "Old Cape Cod",
        "artist": "Rothrock-Vakus-Jeffrey",
        "url": "https://www.quickchords.org/charts/jazz/rothrockvakusjeffrey/old_cape_cod?source=ireal"
      },
      {
        "title": "Old Country, The",
        "artist": "Adderley-Lewis",
        "url": "https://www.quickchords.org/charts/jazz/adderleylewis/old_country_the?source=ireal"
      },
      {
        "title": "Old Devil Moon",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/old_devil_moon?source=ireal"
      },
      {
        "title": "Old Folks",
        "artist": "Willard Robison",
        "url": "https://www.quickchords.org/charts/jazz/willard_robison/old_folks?source=ireal"
      },
      {
        "title": "Oleo",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/oleo?source=ireal"
      },
      {
        "title": "Oliloqui Valley",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/oliloqui_valley?source=ireal"
      },
      {
        "title": "On A Clear Day",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/jazz/burton_lane/on_a_clear_day?source=ireal"
      },
      {
        "title": "On A Slow Boat To China",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/on_a_slow_boat_to_china?source=ireal"
      },
      {
        "title": "On Broadway",
        "artist": "Mann-Weil-Stoller-Leiber",
        "url": "https://www.quickchords.org/charts/jazz/mannweilstollerleiber/on_broadway?source=ireal"
      },
      {
        "title": "On Green Dolphin Street",
        "artist": "Bronislau Kaper",
        "url": "https://www.quickchords.org/charts/jazz/bronislau_kaper/on_green_dolphin_street?source=ireal"
      },
      {
        "title": "On The Street Where You Live",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/jazz/frederick_loewe/on_the_street_where_you_live?source=ireal"
      },
      {
        "title": "On The Sunny Side Of The Street",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/on_the_sunny_side_of_the_street?source=ireal"
      },
      {
        "title": "On The Trail",
        "artist": "Ferde Grofe",
        "url": "https://www.quickchords.org/charts/jazz/ferde_grofe/on_the_trail?source=ireal"
      },
      {
        "title": "Once I Loved",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/once_i_loved?source=ireal"
      },
      {
        "title": "Once In A While",
        "artist": "Michael Edwards",
        "url": "https://www.quickchords.org/charts/jazz/michael_edwards/once_in_a_while?source=ireal"
      },
      {
        "title": "Once Upon A Summertime (La Valse Des Lilas)",
        "artist": "Legrand-Barclay-Marnay-Mercer",
        "url": "https://www.quickchords.org/charts/jazz/legrandbarclaymarnaymercer/once_upon_a_summertime_la_valse_des_lilas?source=ireal"
      },
      {
        "title": "One By One",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/one_by_one?source=ireal"
      },
      {
        "title": "One Finger Snap",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/one_finger_snap?source=ireal"
      },
      {
        "title": "One Foot In The Gutter",
        "artist": "Clark Terry",
        "url": "https://www.quickchords.org/charts/jazz/clark_terry/one_foot_in_the_gutter?source=ireal"
      },
      {
        "title": "One For My Baby",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/one_for_my_baby?source=ireal"
      },
      {
        "title": "One I Love (Belongs To Somebody Else), The",
        "artist": "Isham Jones",
        "url": "https://www.quickchords.org/charts/jazz/isham_jones/one_i_love_belongs_to_somebody_else_the?source=ireal"
      },
      {
        "title": "One Morning In May",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/one_morning_in_may?source=ireal"
      },
      {
        "title": "One Note Samba",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/one_note_samba?source=ireal"
      },
      {
        "title": "Only Trust Your Heart",
        "artist": "Benny Carter",
        "url": "https://www.quickchords.org/charts/jazz/benny_carter/only_trust_your_heart?source=ireal"
      },
      {
        "title": "Onmo",
        "artist": "Kenny Wheeler",
        "url": "https://www.quickchords.org/charts/jazz/kenny_wheeler/onmo?source=ireal"
      },
      {
        "title": "Opener, The",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/opener_the?source=ireal"
      },
      {
        "title": "Opus De Funk",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/opus_de_funk?source=ireal"
      },
      {
        "title": "Orange Colored Sky",
        "artist": "DeLugg-Stein",
        "url": "https://www.quickchords.org/charts/jazz/deluggstein/orange_colored_sky?source=ireal"
      },
      {
        "title": "Ornithology",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/ornithology?source=ireal"
      },
      {
        "title": "Our Delight",
        "artist": "Tad Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tad_dameron/our_delight?source=ireal"
      },
      {
        "title": "Our Love is Here to Stay",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/our_love_is_here_to_stay?source=ireal"
      },
      {
        "title": "Out Of Nowhere",
        "artist": "Johnny Green",
        "url": "https://www.quickchords.org/charts/jazz/johnny_green/out_of_nowhere?source=ireal"
      },
      {
        "title": "Out Of This World",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/out_of_this_world?source=ireal"
      },
      {
        "title": "Over The Rainbow (Somewhere)",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/over_the_rainbow_somewhere?source=ireal"
      },
      {
        "title": "P.S. I Love You",
        "artist": "Gordon Jenkins",
        "url": "https://www.quickchords.org/charts/jazz/gordon_jenkins/ps_i_love_you?source=ireal"
      },
      {
        "title": "Palo Alto",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/jazz/lee_konitz/palo_alto?source=ireal"
      },
      {
        "title": "Pannonica",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/pannonica?source=ireal"
      },
      {
        "title": "Paper Doll",
        "artist": "Johnny Black",
        "url": "https://www.quickchords.org/charts/jazz/johnny_black/paper_doll?source=ireal"
      },
      {
        "title": "Parisian Thoroughfare",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/jazz/bud_powell/parisian_thoroughfare?source=ireal"
      },
      {
        "title": "Parker's Mood",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/parkers_mood?source=ireal"
      },
      {
        "title": "Party's Over, The",
        "artist": "Styne-Comden-Green",
        "url": "https://www.quickchords.org/charts/jazz/stynecomdengreen/partys_over_the?source=ireal"
      },
      {
        "title": "Passion Dance",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/jazz/mccoy_tyner/passion_dance?source=ireal"
      },
      {
        "title": "Passion Flower",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/passion_flower?source=ireal"
      },
      {
        "title": "Passport",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/passport?source=ireal"
      },
      {
        "title": "Peace",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/peace?source=ireal"
      },
      {
        "title": "Peacocks, The",
        "artist": "Jimmy Rowles",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_rowles/peacocks_the?source=ireal"
      },
      {
        "title": "Pee Wee",
        "artist": "Tony Williams",
        "url": "https://www.quickchords.org/charts/jazz/tony_williams/pee_wee?source=ireal"
      },
      {
        "title": "Peel Me A Grape",
        "artist": "Dave Frishberg",
        "url": "https://www.quickchords.org/charts/jazz/dave_frishberg/peel_me_a_grape?source=ireal"
      },
      {
        "title": "Pennies From Heaven",
        "artist": "Arthur Johnston",
        "url": "https://www.quickchords.org/charts/jazz/arthur_johnston/pennies_from_heaven?source=ireal"
      },
      {
        "title": "Pensativa",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/jazz/clare_fischer/pensativa?source=ireal"
      },
      {
        "title": "Pent Up House",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/pent_up_house?source=ireal"
      },
      {
        "title": "Penthouse Serenade",
        "artist": "Jason-Burton",
        "url": "https://www.quickchords.org/charts/jazz/jasonburton/penthouse_serenade?source=ireal"
      },
      {
        "title": "People",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/people?source=ireal"
      },
      {
        "title": "People Will Say We're In Love",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/people_will_say_were_in_love?source=ireal"
      },
      {
        "title": "Perdido",
        "artist": "Juan Tizol",
        "url": "https://www.quickchords.org/charts/jazz/juan_tizol/perdido?source=ireal"
      },
      {
        "title": "Perhaps",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/perhaps?source=ireal"
      },
      {
        "title": "Perhaps, Perhaps, Perhaps",
        "artist": "Farres-Davis",
        "url": "https://www.quickchords.org/charts/jazz/farresdavis/perhaps_perhaps_perhaps?source=ireal"
      },
      {
        "title": "Peri's Scope",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/peris_scope?source=ireal"
      },
      {
        "title": "Petit Fleur",
        "artist": "Sidney Bechet",
        "url": "https://www.quickchords.org/charts/jazz/sidney_bechet/petit_fleur?source=ireal"
      },
      {
        "title": "Pfrancing (No Blues)",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/pfrancing_no_blues?source=ireal"
      },
      {
        "title": "Phase Dance",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/phase_dance?source=ireal"
      },
      {
        "title": "Pick Yourself Up",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/pick_yourself_up?source=ireal"
      },
      {
        "title": "Ping Pong",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/ping_pong?source=ireal"
      },
      {
        "title": "Pink Panther, The",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/jazz/henry_mancini/pink_panther_the?source=ireal"
      },
      {
        "title": "Pinocchio",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/pinocchio?source=ireal"
      },
      {
        "title": "Played Twice",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/played_twice?source=ireal"
      },
      {
        "title": "Poinciana",
        "artist": "Nat Simon",
        "url": "https://www.quickchords.org/charts/jazz/nat_simon/poinciana?source=ireal"
      },
      {
        "title": "Polkadots And Moonbeams",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/polkadots_and_moonbeams?source=ireal"
      },
      {
        "title": "Poor Butterfly",
        "artist": "Raymon Hubbell",
        "url": "https://www.quickchords.org/charts/jazz/raymon_hubbell/poor_butterfly?source=ireal"
      },
      {
        "title": "Popsicle Toes",
        "artist": "Michael Franks",
        "url": "https://www.quickchords.org/charts/jazz/michael_franks/popsicle_toes?source=ireal"
      },
      {
        "title": "Portrait Of Jennie",
        "artist": "Burdge-Robinson",
        "url": "https://www.quickchords.org/charts/jazz/burdgerobinson/portrait_of_jennie?source=ireal"
      },
      {
        "title": "Preacher, The",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/preacher_the?source=ireal"
      },
      {
        "title": "Prelude To A Kiss",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/prelude_to_a_kiss?source=ireal"
      },
      {
        "title": "Pretend",
        "artist": "Douglas-Parman-Lavere",
        "url": "https://www.quickchords.org/charts/jazz/douglasparmanlavere/pretend?source=ireal"
      },
      {
        "title": "Prism",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/prism?source=ireal"
      },
      {
        "title": "Progression",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/jazz/lee_konitz/progression?source=ireal"
      },
      {
        "title": "Punjab",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/punjab?source=ireal"
      },
      {
        "title": "Pure Imagination",
        "artist": "Anthony Newley",
        "url": "https://www.quickchords.org/charts/jazz/anthony_newley/pure_imagination?source=ireal"
      },
      {
        "title": "Put On A Happy Face",
        "artist": "Charles Strouse",
        "url": "https://www.quickchords.org/charts/jazz/charles_strouse/put_on_a_happy_face?source=ireal"
      },
      {
        "title": "Puttin' On The Ritz",
        "artist": "Irvin Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irvin_berlin/puttin_on_the_ritz?source=ireal"
      },
      {
        "title": "Quasimodo (Blowing Changes)",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/quasimodo_blowing_changes?source=ireal"
      },
      {
        "title": "Quasimodo (Theme)",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/quasimodo_theme?source=ireal"
      },
      {
        "title": "Questar",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/questar?source=ireal"
      },
      {
        "title": "Question And Answer",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/question_and_answer?source=ireal"
      },
      {
        "title": "Quiet Now",
        "artist": "Denny Zeitlin",
        "url": "https://www.quickchords.org/charts/jazz/denny_zeitlin/quiet_now?source=ireal"
      },
      {
        "title": "Radio",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/jazz/steve_swallow/radio?source=ireal"
      },
      {
        "title": "Rainbow Connection, The",
        "artist": "Williams-Ascher",
        "url": "https://www.quickchords.org/charts/jazz/williamsascher/rainbow_connection_the?source=ireal"
      },
      {
        "title": "Raincheck",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/raincheck?source=ireal"
      },
      {
        "title": "Re: Person I Knew",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/re_person_i_knew?source=ireal"
      },
      {
        "title": "Recado Bossa Nova",
        "artist": "Djalma Ferreira",
        "url": "https://www.quickchords.org/charts/jazz/djalma_ferreira/recado_bossa_nova?source=ireal"
      },
      {
        "title": "Recordame",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/recordame?source=ireal"
      },
      {
        "title": "Red Clay",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/jazz/freddie_hubbard/red_clay?source=ireal"
      },
      {
        "title": "Red Top",
        "artist": "Lionel Hampton",
        "url": "https://www.quickchords.org/charts/jazz/lionel_hampton/red_top?source=ireal"
      },
      {
        "title": "Reflections",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/reflections?source=ireal"
      },
      {
        "title": "Relaxin' At Camarillo",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/relaxin_at_camarillo?source=ireal"
      },
      {
        "title": "Remember",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/remember?source=ireal"
      },
      {
        "title": "Rhythm-a-ning",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/rhythmaning?source=ireal"
      },
      {
        "title": "Road Song",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/road_song?source=ireal"
      },
      {
        "title": "Robbin's Nest",
        "artist": "Thompson-Jacquet",
        "url": "https://www.quickchords.org/charts/jazz/thompsonjacquet/robbins_nest?source=ireal"
      },
      {
        "title": "Rockin' Chair",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/rockin_chair?source=ireal"
      },
      {
        "title": "Room 608",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/room_608?source=ireal"
      },
      {
        "title": "Rose Room",
        "artist": "Art Hickman",
        "url": "https://www.quickchords.org/charts/jazz/art_hickman/rose_room?source=ireal"
      },
      {
        "title": "Rosetta",
        "artist": "Earl Hines",
        "url": "https://www.quickchords.org/charts/jazz/earl_hines/rosetta?source=ireal"
      },
      {
        "title": "Round Midnight",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/round_midnight?source=ireal"
      },
      {
        "title": "Route 66",
        "artist": "Bobby Troup",
        "url": "https://www.quickchords.org/charts/jazz/bobby_troup/route_66?source=ireal"
      },
      {
        "title": "Ruby, My Dear",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/ruby_my_dear?source=ireal"
      },
      {
        "title": "S.O.S.",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/sos?source=ireal"
      },
      {
        "title": "S' Wonderful",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/s_wonderful?source=ireal"
      },
      {
        "title": "S'posin'",
        "artist": "Paul Denniker",
        "url": "https://www.quickchords.org/charts/jazz/paul_denniker/sposin?source=ireal"
      },
      {
        "title": "Saga Of Harrison Crabfeathers, The",
        "artist": "Steve Kuhn",
        "url": "https://www.quickchords.org/charts/jazz/steve_kuhn/saga_of_harrison_crabfeathers_the?source=ireal"
      },
      {
        "title": "Sail Away",
        "artist": "Tom Harrell",
        "url": "https://www.quickchords.org/charts/jazz/tom_harrell/sail_away?source=ireal"
      },
      {
        "title": "Salt Peanuts",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/salt_peanuts?source=ireal"
      },
      {
        "title": "Samba De Orfeu",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/jazz/luiz_bonfa/samba_de_orfeu?source=ireal"
      },
      {
        "title": "San Francisco Holiday",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/san_francisco_holiday?source=ireal"
      },
      {
        "title": "Sandu",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/jazz/clifford_brown/sandu?source=ireal"
      },
      {
        "title": "Satellite",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/satellite?source=ireal"
      },
      {
        "title": "Satin Doll",
        "artist": "Strayhorn-Ellington",
        "url": "https://www.quickchords.org/charts/jazz/strayhornellington/satin_doll?source=ireal"
      },
      {
        "title": "Save Your Love For Me",
        "artist": "Buddy Johnson",
        "url": "https://www.quickchords.org/charts/jazz/buddy_johnson/save_your_love_for_me?source=ireal"
      },
      {
        "title": "Say It (Over And Over Again)",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/say_it_over_and_over_again?source=ireal"
      },
      {
        "title": "Say the Brother's Name",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/say_the_brothers_name?source=ireal"
      },
      {
        "title": "Scene",
        "artist": "Tom Harrell",
        "url": "https://www.quickchords.org/charts/jazz/tom_harrell/scene?source=ireal"
      },
      {
        "title": "Scotch And Soda",
        "artist": "Dave Guard",
        "url": "https://www.quickchords.org/charts/jazz/dave_guard/scotch_and_soda?source=ireal"
      },
      {
        "title": "Scrapple From The Apple",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/scrapple_from_the_apple?source=ireal"
      },
      {
        "title": "Sea Journey",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/sea_journey?source=ireal"
      },
      {
        "title": "Second Star To The Right, The",
        "artist": "Sammy Fain",
        "url": "https://www.quickchords.org/charts/jazz/sammy_fain/second_star_to_the_right_the?source=ireal"
      },
      {
        "title": "Second Time Around, The",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/second_time_around_the?source=ireal"
      },
      {
        "title": "Secret Love",
        "artist": "Sammy Fain",
        "url": "https://www.quickchords.org/charts/jazz/sammy_fain/secret_love?source=ireal"
      },
      {
        "title": "Segment",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/segment?source=ireal"
      },
      {
        "title": "Sentimental Journey",
        "artist": "Brown-Green-Homer",
        "url": "https://www.quickchords.org/charts/jazz/browngreenhomer/sentimental_journey?source=ireal"
      },
      {
        "title": "September In The Rain",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/september_in_the_rain?source=ireal"
      },
      {
        "title": "September Song",
        "artist": "Kurt Weill",
        "url": "https://www.quickchords.org/charts/jazz/kurt_weill/september_song?source=ireal"
      },
      {
        "title": "Serenade To A Cuckoo",
        "artist": "Roland Kirk",
        "url": "https://www.quickchords.org/charts/jazz/roland_kirk/serenade_to_a_cuckoo?source=ireal"
      },
      {
        "title": "Serenade To A Soul Sister",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/serenade_to_a_soul_sister?source=ireal"
      },
      {
        "title": "Serene",
        "artist": "Eric Dolphy",
        "url": "https://www.quickchords.org/charts/jazz/eric_dolphy/serene?source=ireal"
      },
      {
        "title": "Serenity",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/jazz/joe_henderson/serenity?source=ireal"
      },
      {
        "title": "Serpent's Tooth",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/serpents_tooth?source=ireal"
      },
      {
        "title": "Seven Come Eleven",
        "artist": "Goodman-Christian",
        "url": "https://www.quickchords.org/charts/jazz/goodmanchristian/seven_come_eleven?source=ireal"
      },
      {
        "title": "Seven Steps To Heaven",
        "artist": "Victor Feldman",
        "url": "https://www.quickchords.org/charts/jazz/victor_feldman/seven_steps_to_heaven?source=ireal"
      },
      {
        "title": "Shadow Of Your Smile, The",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/jazz/johnny_mandel/shadow_of_your_smile_the?source=ireal"
      },
      {
        "title": "Shaw 'Nuff",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/shaw_nuff?source=ireal"
      },
      {
        "title": "She's Funny That Way",
        "artist": "Charles Daniels",
        "url": "https://www.quickchords.org/charts/jazz/charles_daniels/shes_funny_that_way?source=ireal"
      },
      {
        "title": "Shine",
        "artist": "Dabney-Mack-Brown",
        "url": "https://www.quickchords.org/charts/jazz/dabneymackbrown/shine?source=ireal"
      },
      {
        "title": "Shiny Stockings",
        "artist": "Frank Foster",
        "url": "https://www.quickchords.org/charts/jazz/frank_foster/shiny_stockings?source=ireal"
      },
      {
        "title": "Shutterbug",
        "artist": "J.J. Johnson",
        "url": "https://www.quickchords.org/charts/jazz/jj_johnson/shutterbug?source=ireal"
      },
      {
        "title": "Si Si",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/si_si?source=ireal"
      },
      {
        "title": "Sid's Delight",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tadd_dameron/sids_delight?source=ireal"
      },
      {
        "title": "Sidewinder",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/jazz/lee_morgan/sidewinder?source=ireal"
      },
      {
        "title": "Silver's Serenade",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/silvers_serenade?source=ireal"
      },
      {
        "title": "Simone",
        "artist": "Frank Foster",
        "url": "https://www.quickchords.org/charts/jazz/frank_foster/simone?source=ireal"
      },
      {
        "title": "Since I Fell For You",
        "artist": "Buddy Johnson",
        "url": "https://www.quickchords.org/charts/jazz/buddy_johnson/since_i_fell_for_you?source=ireal"
      },
      {
        "title": "Sippin' At Bells",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/sippin_at_bells?source=ireal"
      },
      {
        "title": "Sister Sadie",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/sister_sadie?source=ireal"
      },
      {
        "title": "Skating In Central Park",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/jazz/john_lewis/skating_in_central_park?source=ireal"
      },
      {
        "title": "Skippy",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/skippy?source=ireal"
      },
      {
        "title": "Skylark",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/skylark?source=ireal"
      },
      {
        "title": "Skyliner",
        "artist": "Charlie Barnet",
        "url": "https://www.quickchords.org/charts/jazz/charlie_barnet/skyliner?source=ireal"
      },
      {
        "title": "Slipped Disc",
        "artist": "Benny Goodman",
        "url": "https://www.quickchords.org/charts/jazz/benny_goodman/slipped_disc?source=ireal"
      },
      {
        "title": "Slow Hot Wind",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/jazz/henry_mancini/slow_hot_wind?source=ireal"
      },
      {
        "title": "Smile",
        "artist": "Charles Chaplin",
        "url": "https://www.quickchords.org/charts/jazz/charles_chaplin/smile?source=ireal"
      },
      {
        "title": "Smoke Gets In Your Eyes",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/smoke_gets_in_your_eyes?source=ireal"
      },
      {
        "title": "Smoke Rings",
        "artist": "Gifford-Washington",
        "url": "https://www.quickchords.org/charts/jazz/giffordwashington/smoke_rings?source=ireal"
      },
      {
        "title": "Sno' Peas",
        "artist": "Phil Markowitz",
        "url": "https://www.quickchords.org/charts/jazz/phil_markowitz/sno_peas?source=ireal"
      },
      {
        "title": "Só Danço Samba",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/s_dano_samba?source=ireal"
      },
      {
        "title": "So In Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/so_in_love?source=ireal"
      },
      {
        "title": "So Many Stars",
        "artist": "Sergio Mendez",
        "url": "https://www.quickchords.org/charts/jazz/sergio_mendez/so_many_stars?source=ireal"
      },
      {
        "title": "So Nice (Summer Samba)",
        "artist": "Marco Valles",
        "url": "https://www.quickchords.org/charts/jazz/marco_valles/so_nice_summer_samba?source=ireal"
      },
      {
        "title": "So Tender",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/jazz/keith_jarrett/so_tender?source=ireal"
      },
      {
        "title": "So What",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/so_what?source=ireal"
      },
      {
        "title": "Softly, As In A Morning Sunrise",
        "artist": "Sigmund Romberg",
        "url": "https://www.quickchords.org/charts/jazz/sigmund_romberg/softly_as_in_a_morning_sunrise?source=ireal"
      },
      {
        "title": "Solar",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/solar?source=ireal"
      },
      {
        "title": "Solitude",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/solitude?source=ireal"
      },
      {
        "title": "Some Enchanted Evening",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/some_enchanted_evening?source=ireal"
      },
      {
        "title": "Some Other Blues",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/some_other_blues?source=ireal"
      },
      {
        "title": "Some Other Spring",
        "artist": "Herzog-Kitchings",
        "url": "https://www.quickchords.org/charts/jazz/herzogkitchings/some_other_spring?source=ireal"
      },
      {
        "title": "Some Other Time",
        "artist": "Leonard Bernstein",
        "url": "https://www.quickchords.org/charts/jazz/leonard_bernstein/some_other_time?source=ireal"
      },
      {
        "title": "Somebody Loves Me",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/somebody_loves_me?source=ireal"
      },
      {
        "title": "Someday (You'll Be Sorry)",
        "artist": "Louis Armstrong",
        "url": "https://www.quickchords.org/charts/jazz/louis_armstrong/someday_youll_be_sorry?source=ireal"
      },
      {
        "title": "Someday My Prince Will Come",
        "artist": "Frank Churchill",
        "url": "https://www.quickchords.org/charts/jazz/frank_churchill/someday_my_prince_will_come?source=ireal"
      },
      {
        "title": "Someday You'll Be Sorry",
        "artist": "Louis Armstrong",
        "url": "https://www.quickchords.org/charts/jazz/louis_armstrong/someday_youll_be_sorry?source=ireal"
      },
      {
        "title": "Someone To Watch Over Me",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/someone_to_watch_over_me?source=ireal"
      },
      {
        "title": "Sometime Ago",
        "artist": "Sergio Mikanovich",
        "url": "https://www.quickchords.org/charts/jazz/sergio_mikanovich/sometime_ago?source=ireal"
      },
      {
        "title": "Sometimes I'm Happy",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/jazz/vincent_youmans/sometimes_im_happy?source=ireal"
      },
      {
        "title": "Somewhere",
        "artist": "Leonard Bernstein",
        "url": "https://www.quickchords.org/charts/jazz/leonard_bernstein/somewhere?source=ireal"
      },
      {
        "title": "Song For My Father",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/song_for_my_father?source=ireal"
      },
      {
        "title": "Song For My Lady",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/jazz/mccoy_tyner/song_for_my_lady?source=ireal"
      },
      {
        "title": "Song Is You, The",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/song_is_you_the?source=ireal"
      },
      {
        "title": "Sonnymoon For Two",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/sonnymoon_for_two?source=ireal"
      },
      {
        "title": "Soon",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/soon?source=ireal"
      },
      {
        "title": "Sophisticated Lady",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/sophisticated_lady?source=ireal"
      },
      {
        "title": "Sorcerer, The",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/sorcerer_the?source=ireal"
      },
      {
        "title": "Soul Eyes",
        "artist": "Mal Waldron",
        "url": "https://www.quickchords.org/charts/jazz/mal_waldron/soul_eyes?source=ireal"
      },
      {
        "title": "Soultrane",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tadd_dameron/soultrane?source=ireal"
      },
      {
        "title": "Sound Lee",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/jazz/lee_konitz/sound_lee?source=ireal"
      },
      {
        "title": "Souvenir",
        "artist": "Benny Carter",
        "url": "https://www.quickchords.org/charts/jazz/benny_carter/souvenir?source=ireal"
      },
      {
        "title": "Spain",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/spain?source=ireal"
      },
      {
        "title": "Speak Like A Child",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/speak_like_a_child?source=ireal"
      },
      {
        "title": "Speak Low",
        "artist": "Kurt Weill",
        "url": "https://www.quickchords.org/charts/jazz/kurt_weill/speak_low?source=ireal"
      },
      {
        "title": "Speak No Evil",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/speak_no_evil?source=ireal"
      },
      {
        "title": "Spiral",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/spiral?source=ireal"
      },
      {
        "title": "Spring Can Really Hang You Up The Most",
        "artist": "Tommy Wolf",
        "url": "https://www.quickchords.org/charts/jazz/tommy_wolf/spring_can_really_hang_you_up_the_most?source=ireal"
      },
      {
        "title": "Spring Is Here",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/spring_is_here?source=ireal"
      },
      {
        "title": "St. James Infirmary",
        "artist": "Joe Primrose",
        "url": "https://www.quickchords.org/charts/jazz/joe_primrose/st_james_infirmary?source=ireal"
      },
      {
        "title": "St. Louis Blues",
        "artist": "W.C. Handy",
        "url": "https://www.quickchords.org/charts/jazz/wc_handy/st_louis_blues?source=ireal"
      },
      {
        "title": "St. Thomas",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/st_thomas?source=ireal"
      },
      {
        "title": "Stablemates",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/stablemates?source=ireal"
      },
      {
        "title": "Stairway To The Stars",
        "artist": "Matt Maineck",
        "url": "https://www.quickchords.org/charts/jazz/matt_maineck/stairway_to_the_stars?source=ireal"
      },
      {
        "title": "Star Dust",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/star_dust?source=ireal"
      },
      {
        "title": "Star Eyes",
        "artist": "Gene DePaul",
        "url": "https://www.quickchords.org/charts/jazz/gene_depaul/star_eyes?source=ireal"
      },
      {
        "title": "Star-Crossed Lovers, The",
        "artist": "Strayhorn-Ellington",
        "url": "https://www.quickchords.org/charts/jazz/strayhornellington/starcrossed_lovers_the?source=ireal"
      },
      {
        "title": "Stars Fell On Alabama",
        "artist": "Frank Perkins",
        "url": "https://www.quickchords.org/charts/jazz/frank_perkins/stars_fell_on_alabama?source=ireal"
      },
      {
        "title": "Stella By Starlight",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/jazz/victor_young/stella_by_starlight?source=ireal"
      },
      {
        "title": "Stolen Moments",
        "artist": "Oliver Nelson",
        "url": "https://www.quickchords.org/charts/jazz/oliver_nelson/stolen_moments?source=ireal"
      },
      {
        "title": "Stompin' At The Savoy",
        "artist": "Webb-Goodman-Sampson",
        "url": "https://www.quickchords.org/charts/jazz/webbgoodmansampson/stompin_at_the_savoy?source=ireal"
      },
      {
        "title": "Stormy Weather",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/stormy_weather?source=ireal"
      },
      {
        "title": "Straight Life",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/jazz/freddie_hubbard/straight_life?source=ireal"
      },
      {
        "title": "Straight No Chaser",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/straight_no_chaser?source=ireal"
      },
      {
        "title": "Straight Street",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/straight_street?source=ireal"
      },
      {
        "title": "Straighten Up And Fly Right",
        "artist": "Cole-Mills",
        "url": "https://www.quickchords.org/charts/jazz/colemills/straighten_up_and_fly_right?source=ireal"
      },
      {
        "title": "Strangers In The Night",
        "artist": "Bert Kaempfert",
        "url": "https://www.quickchords.org/charts/jazz/bert_kaempfert/strangers_in_the_night?source=ireal"
      },
      {
        "title": "Strayhorn 2",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/jazz/gerry_mulligan/strayhorn_2?source=ireal"
      },
      {
        "title": "Street Of Dreams",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/jazz/victor_young/street_of_dreams?source=ireal"
      },
      {
        "title": "Strike Up The Band",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/strike_up_the_band?source=ireal"
      },
      {
        "title": "Strode Rode",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/strode_rode?source=ireal"
      },
      {
        "title": "Strollin'",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/strollin?source=ireal"
      },
      {
        "title": "Struttin' With Some Barbecue",
        "artist": "Lillian Armstrong",
        "url": "https://www.quickchords.org/charts/jazz/lillian_armstrong/struttin_with_some_barbecue?source=ireal"
      },
      {
        "title": "Subconscious Lee",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/jazz/lee_konitz/subconscious_lee?source=ireal"
      },
      {
        "title": "Suddenly It's Spring",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_vanheusen/suddenly_its_spring?source=ireal"
      },
      {
        "title": "Sugar",
        "artist": "Stanley Turrentine",
        "url": "https://www.quickchords.org/charts/jazz/stanley_turrentine/sugar?source=ireal"
      },
      {
        "title": "Summer Band Camp",
        "artist": "Mick Goodrick",
        "url": "https://www.quickchords.org/charts/jazz/mick_goodrick/summer_band_camp?source=ireal"
      },
      {
        "title": "Summer In Central Park",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/summer_in_central_park?source=ireal"
      },
      {
        "title": "Summer Knows, The",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/jazz/michel_legrand/summer_knows_the?source=ireal"
      },
      {
        "title": "Summer Serenade",
        "artist": "Benny Carter",
        "url": "https://www.quickchords.org/charts/jazz/benny_carter/summer_serenade?source=ireal"
      },
      {
        "title": "Summer Wind, The",
        "artist": "Meyer-Mercer",
        "url": "https://www.quickchords.org/charts/jazz/meyermercer/summer_wind_the?source=ireal"
      },
      {
        "title": "Summertime",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/summertime?source=ireal"
      },
      {
        "title": "Sun down",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/sun_down?source=ireal"
      },
      {
        "title": "Sunny",
        "artist": "Bobby Hebb",
        "url": "https://www.quickchords.org/charts/jazz/bobby_hebb/sunny?source=ireal"
      },
      {
        "title": "Sunshower",
        "artist": "Kenny Barron",
        "url": "https://www.quickchords.org/charts/jazz/kenny_barron/sunshower?source=ireal"
      },
      {
        "title": "Surrey With The Fringe On The Top",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/surrey_with_the_fringe_on_the_top?source=ireal"
      },
      {
        "title": "Sway",
        "artist": "Ruiz-Gimbel",
        "url": "https://www.quickchords.org/charts/jazz/ruizgimbel/sway?source=ireal"
      },
      {
        "title": "Sweeping Up",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/jazz/steve_swallow/sweeping_up?source=ireal"
      },
      {
        "title": "Sweet And Lovely",
        "artist": "Arnheim-Daniels-Tobias",
        "url": "https://www.quickchords.org/charts/jazz/arnheimdanielstobias/sweet_and_lovely?source=ireal"
      },
      {
        "title": "Sweet Georgia Bright",
        "artist": "Charles Lloyd",
        "url": "https://www.quickchords.org/charts/jazz/charles_lloyd/sweet_georgia_bright?source=ireal"
      },
      {
        "title": "Sweet Georgia Brown",
        "artist": "Pinkard-Casey-Bernie",
        "url": "https://www.quickchords.org/charts/jazz/pinkardcaseybernie/sweet_georgia_brown?source=ireal"
      },
      {
        "title": "Sweet Lorraine",
        "artist": "Cliff Burwell",
        "url": "https://www.quickchords.org/charts/jazz/cliff_burwell/sweet_lorraine?source=ireal"
      },
      {
        "title": "Sweet Sue, Just You",
        "artist": "Harris-Young",
        "url": "https://www.quickchords.org/charts/jazz/harrisyoung/sweet_sue_just_you?source=ireal"
      },
      {
        "title": "Sweetest Sounds, The",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/sweetest_sounds_the?source=ireal"
      },
      {
        "title": "Swinging At The Haven",
        "artist": "Ellis Marsalis",
        "url": "https://www.quickchords.org/charts/jazz/ellis_marsalis/swinging_at_the_haven?source=ireal"
      },
      {
        "title": "Swinging Shepherd Blues, The",
        "artist": "Koffman-Roberts-Jacobson",
        "url": "https://www.quickchords.org/charts/jazz/koffmanrobertsjacobson/swinging_shepherd_blues_the?source=ireal"
      },
      {
        "title": "Tadd's Delight",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/jazz/tadd_dameron/tadds_delight?source=ireal"
      },
      {
        "title": "Take Five",
        "artist": "Paul Desmond",
        "url": "https://www.quickchords.org/charts/jazz/paul_desmond/take_five?source=ireal"
      },
      {
        "title": "Take The A Train",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/take_the_a_train?source=ireal"
      },
      {
        "title": "Taking A Chance On Love",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/jazz/vernon_duke/taking_a_chance_on_love?source=ireal"
      },
      {
        "title": "Tangerine",
        "artist": "Victor Schertzinger",
        "url": "https://www.quickchords.org/charts/jazz/victor_schertzinger/tangerine?source=ireal"
      },
      {
        "title": "Tautology",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/jazz/lee_konitz/tautology?source=ireal"
      },
      {
        "title": "Tea For Two",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/jazz/vincent_youmans/tea_for_two?source=ireal"
      },
      {
        "title": "Teach Me Tonight",
        "artist": "Gene DePaul",
        "url": "https://www.quickchords.org/charts/jazz/gene_depaul/teach_me_tonight?source=ireal"
      },
      {
        "title": "Tell me a bedtime story",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/tell_me_a_bedtime_story?source=ireal"
      },
      {
        "title": "Tempus Fugit",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/jazz/bud_powell/tempus_fugit?source=ireal"
      },
      {
        "title": "Tenderly",
        "artist": "Walter Gross",
        "url": "https://www.quickchords.org/charts/jazz/walter_gross/tenderly?source=ireal"
      },
      {
        "title": "Tenor Madness",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/tenor_madness?source=ireal"
      },
      {
        "title": "Thanks For The Memory",
        "artist": "Leo Robin",
        "url": "https://www.quickchords.org/charts/jazz/leo_robin/thanks_for_the_memory?source=ireal"
      },
      {
        "title": "That Old Black Magic",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/that_old_black_magic?source=ireal"
      },
      {
        "title": "That Old Devil Called Love",
        "artist": "Doris Fisher",
        "url": "https://www.quickchords.org/charts/jazz/doris_fisher/that_old_devil_called_love?source=ireal"
      },
      {
        "title": "That Old Feeling",
        "artist": "Brown-Fain",
        "url": "https://www.quickchords.org/charts/jazz/brownfain/that_old_feeling?source=ireal"
      },
      {
        "title": "That's All",
        "artist": "Haymes-Brandt",
        "url": "https://www.quickchords.org/charts/jazz/haymesbrandt/thats_all?source=ireal"
      },
      {
        "title": "That's Life",
        "artist": "Kay-Gordon",
        "url": "https://www.quickchords.org/charts/jazz/kaygordon/thats_life?source=ireal"
      },
      {
        "title": "Thelonious",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/thelonious?source=ireal"
      },
      {
        "title": "Them There Eyes",
        "artist": "Tracy-Tauber-Pinkard",
        "url": "https://www.quickchords.org/charts/jazz/tracytauberpinkard/them_there_eyes?source=ireal"
      },
      {
        "title": "Theme, The",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/theme_the?source=ireal"
      },
      {
        "title": "There Is No Greater Love",
        "artist": "Isham Jones",
        "url": "https://www.quickchords.org/charts/jazz/isham_jones/there_is_no_greater_love?source=ireal"
      },
      {
        "title": "There Will Never Be Another You",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/there_will_never_be_another_you?source=ireal"
      },
      {
        "title": "There'll Be Some Changes Made",
        "artist": "Benton Overstreet",
        "url": "https://www.quickchords.org/charts/jazz/benton_overstreet/therell_be_some_changes_made?source=ireal"
      },
      {
        "title": "There's A Lull In My Life",
        "artist": "Harry Revel",
        "url": "https://www.quickchords.org/charts/jazz/harry_revel/theres_a_lull_in_my_life?source=ireal"
      },
      {
        "title": "There's A Small Hotel",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/theres_a_small_hotel?source=ireal"
      },
      {
        "title": "There's No You",
        "artist": "Hal Hopper",
        "url": "https://www.quickchords.org/charts/jazz/hal_hopper/theres_no_you?source=ireal"
      },
      {
        "title": "These Foolish Things",
        "artist": "Strachey-Link",
        "url": "https://www.quickchords.org/charts/jazz/stracheylink/these_foolish_things?source=ireal"
      },
      {
        "title": "They All Laughed",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/they_all_laughed?source=ireal"
      },
      {
        "title": "They Can't Take That Away From Me",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/they_cant_take_that_away_from_me?source=ireal"
      },
      {
        "title": "They Didn't Believe Me",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/they_didnt_believe_me?source=ireal"
      },
      {
        "title": "They Say",
        "artist": "Heyman-Mann-Weiss",
        "url": "https://www.quickchords.org/charts/jazz/heymanmannweiss/they_say?source=ireal"
      },
      {
        "title": "They Say It's Wonderful",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/they_say_its_wonderful?source=ireal"
      },
      {
        "title": "Things Ain't What They Used To Be",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/things_aint_what_they_used_to_be?source=ireal"
      },
      {
        "title": "Things We Did Last Summer, The",
        "artist": "Cahn-Styne",
        "url": "https://www.quickchords.org/charts/jazz/cahnstyne/things_we_did_last_summer_the?source=ireal"
      },
      {
        "title": "Think Of One",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/think_of_one?source=ireal"
      },
      {
        "title": "This Can't Be Love",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/this_cant_be_love?source=ireal"
      },
      {
        "title": "This Could Be The Start Of Something Good",
        "artist": "Steve Allen",
        "url": "https://www.quickchords.org/charts/jazz/steve_allen/this_could_be_the_start_of_something_good?source=ireal"
      },
      {
        "title": "This I Dig Of You",
        "artist": "Hank Mobley",
        "url": "https://www.quickchords.org/charts/jazz/hank_mobley/this_i_dig_of_you?source=ireal"
      },
      {
        "title": "This Is All I Ask",
        "artist": "Gordon Jenkins",
        "url": "https://www.quickchords.org/charts/jazz/gordon_jenkins/this_is_all_i_ask?source=ireal"
      },
      {
        "title": "This Is New",
        "artist": "Kurt Weill",
        "url": "https://www.quickchords.org/charts/jazz/kurt_weill/this_is_new?source=ireal"
      },
      {
        "title": "This Masquerade",
        "artist": "Leon Russell",
        "url": "https://www.quickchords.org/charts/jazz/leon_russell/this_masquerade?source=ireal"
      },
      {
        "title": "This Time The Dream's On Me",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/this_time_the_dreams_on_me?source=ireal"
      },
      {
        "title": "This Year's Kisses",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/this_years_kisses?source=ireal"
      },
      {
        "title": "Thou Swell",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/thou_swell?source=ireal"
      },
      {
        "title": "Three Little Words",
        "artist": "Harry Ruby",
        "url": "https://www.quickchords.org/charts/jazz/harry_ruby/three_little_words?source=ireal"
      },
      {
        "title": "Thrill Is Gone, The",
        "artist": "Ray Henderson",
        "url": "https://www.quickchords.org/charts/jazz/ray_henderson/thrill_is_gone_the?source=ireal"
      },
      {
        "title": "Thriving From A Riff",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/thriving_from_a_riff?source=ireal"
      },
      {
        "title": "Tickle-Toe",
        "artist": "Lester Young",
        "url": "https://www.quickchords.org/charts/jazz/lester_young/tickletoe?source=ireal"
      },
      {
        "title": "Till There Was You",
        "artist": "Meredith Wilson",
        "url": "https://www.quickchords.org/charts/jazz/meredith_wilson/till_there_was_you?source=ireal"
      },
      {
        "title": "Time After Time",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/jazz/jule_styne/time_after_time?source=ireal"
      },
      {
        "title": "Time On My Hands",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/jazz/vincent_youmans/time_on_my_hands?source=ireal"
      },
      {
        "title": "Time Remembered",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/time_remembered?source=ireal"
      },
      {
        "title": "Tin Tin Deo",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/tin_tin_deo?source=ireal"
      },
      {
        "title": "Tiny Capers",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/jazz/clifford_brown/tiny_capers?source=ireal"
      },
      {
        "title": "Tippin'",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/tippin?source=ireal"
      },
      {
        "title": "Tis Autumn",
        "artist": "Henry Nemo",
        "url": "https://www.quickchords.org/charts/jazz/henry_nemo/tis_autumn?source=ireal"
      },
      {
        "title": "Tokyo Blues",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/jazz/horace_silver/tokyo_blues?source=ireal"
      },
      {
        "title": "Tones For Joan's Bones",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/tones_for_joans_bones?source=ireal"
      },
      {
        "title": "Tonight",
        "artist": "Bernstein-Sondheim",
        "url": "https://www.quickchords.org/charts/jazz/bernsteinsondheim/tonight?source=ireal"
      },
      {
        "title": "Tonight I Shall Sleep",
        "artist": "Ellington-Mercer",
        "url": "https://www.quickchords.org/charts/jazz/ellingtonmercer/tonight_i_shall_sleep?source=ireal"
      },
      {
        "title": "Tonight You Belong To Me",
        "artist": "Rose-David",
        "url": "https://www.quickchords.org/charts/jazz/rosedavid/tonight_you_belong_to_me?source=ireal"
      },
      {
        "title": "Too Close For Comfort",
        "artist": "Bock-Weiss-Holofcener",
        "url": "https://www.quickchords.org/charts/jazz/bockweissholofcener/too_close_for_comfort?source=ireal"
      },
      {
        "title": "Too Marvelous For Words",
        "artist": "Richard Whiting",
        "url": "https://www.quickchords.org/charts/jazz/richard_whiting/too_marvelous_for_words?source=ireal"
      },
      {
        "title": "Too Young",
        "artist": "Lippman-Dee",
        "url": "https://www.quickchords.org/charts/jazz/lippmandee/too_young?source=ireal"
      },
      {
        "title": "Too Young To Go Steady",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/too_young_to_go_steady?source=ireal"
      },
      {
        "title": "Touch Of Your Lips, The",
        "artist": "Ray Noble",
        "url": "https://www.quickchords.org/charts/jazz/ray_noble/touch_of_your_lips_the?source=ireal"
      },
      {
        "title": "Tour De Force",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/tour_de_force?source=ireal"
      },
      {
        "title": "Toy Tune",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/toy_tune?source=ireal"
      },
      {
        "title": "Toys",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/toys?source=ireal"
      },
      {
        "title": "Training",
        "artist": "Michel Petrucciani",
        "url": "https://www.quickchords.org/charts/jazz/michel_petrucciani/training?source=ireal"
      },
      {
        "title": "Trane’s Blues",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/jazz/john_coltrane/tranes_blues?source=ireal"
      },
      {
        "title": "Travels",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/travels?source=ireal"
      },
      {
        "title": "Tricotism",
        "artist": "Oscar Pettiford",
        "url": "https://www.quickchords.org/charts/jazz/oscar_pettiford/tricotism?source=ireal"
      },
      {
        "title": "Trinkle Tinkle",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/trinkle_tinkle?source=ireal"
      },
      {
        "title": "Triste",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/triste?source=ireal"
      },
      {
        "title": "Troubled Waters",
        "artist": "Arthur Johnston",
        "url": "https://www.quickchords.org/charts/jazz/arthur_johnston/troubled_waters?source=ireal"
      },
      {
        "title": "Try A Little Tenderness",
        "artist": "Harry Woods",
        "url": "https://www.quickchords.org/charts/jazz/harry_woods/try_a_little_tenderness?source=ireal"
      },
      {
        "title": "Tune Up",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/tune_up?source=ireal"
      },
      {
        "title": "Turn Out The Stars",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/turn_out_the_stars?source=ireal"
      },
      {
        "title": "Turnaround",
        "artist": "Ornette Coleman",
        "url": "https://www.quickchords.org/charts/jazz/ornette_coleman/turnaround?source=ireal"
      },
      {
        "title": "Twisted",
        "artist": "Wardell Gray",
        "url": "https://www.quickchords.org/charts/jazz/wardell_gray/twisted?source=ireal"
      },
      {
        "title": "Twisted Blues",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/twisted_blues?source=ireal"
      },
      {
        "title": "Two For The Road",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/jazz/henry_mancini/two_for_the_road?source=ireal"
      },
      {
        "title": "Two Not One",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/jazz/lennie_tristano/two_not_one?source=ireal"
      },
      {
        "title": "Two Sleepy People",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/jazz/hoagy_carmichael/two_sleepy_people?source=ireal"
      },
      {
        "title": "Ugly Beauty",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/ugly_beauty?source=ireal"
      },
      {
        "title": "Undecided",
        "artist": "Charlie Shavers",
        "url": "https://www.quickchords.org/charts/jazz/charlie_shavers/undecided?source=ireal"
      },
      {
        "title": "Under A Blanket Of Blue",
        "artist": "Jerry Livingston",
        "url": "https://www.quickchords.org/charts/jazz/jerry_livingston/under_a_blanket_of_blue?source=ireal"
      },
      {
        "title": "Unforgettable",
        "artist": "Gordon Irving",
        "url": "https://www.quickchords.org/charts/jazz/gordon_irving/unforgettable?source=ireal"
      },
      {
        "title": "Unit Seven",
        "artist": "Sam Jones",
        "url": "https://www.quickchords.org/charts/jazz/sam_jones/unit_seven?source=ireal"
      },
      {
        "title": "United",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/united?source=ireal"
      },
      {
        "title": "Unity Village",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/jazz/pat_metheny/unity_village?source=ireal"
      },
      {
        "title": "Unrequited",
        "artist": "Brad Mehldau",
        "url": "https://www.quickchords.org/charts/jazz/brad_mehldau/unrequited?source=ireal"
      },
      {
        "title": "Up Jumped Spring",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/jazz/freddie_hubbard/up_jumped_spring?source=ireal"
      },
      {
        "title": "Up With The Lark",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/up_with_the_lark?source=ireal"
      },
      {
        "title": "Upper Manhattan Medical Group",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/jazz/billy_strayhorn/upper_manhattan_medical_group?source=ireal"
      },
      {
        "title": "Valse Hot",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/jazz/sonny_rollins/valse_hot?source=ireal"
      },
      {
        "title": "Very Early",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/very_early?source=ireal"
      },
      {
        "title": "Very Thought Of You, The",
        "artist": "Ray Noble",
        "url": "https://www.quickchords.org/charts/jazz/ray_noble/very_thought_of_you_the?source=ireal"
      },
      {
        "title": "Violets For Your Furs",
        "artist": "Adair-Dennis",
        "url": "https://www.quickchords.org/charts/jazz/adairdennis/violets_for_your_furs?source=ireal"
      },
      {
        "title": "Virgo",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/virgo?source=ireal"
      },
      {
        "title": "Voyage",
        "artist": "Kenny Barron",
        "url": "https://www.quickchords.org/charts/jazz/kenny_barron/voyage?source=ireal"
      },
      {
        "title": "Wait Till You See Her",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/wait_till_you_see_her?source=ireal"
      },
      {
        "title": "Walk Tall",
        "artist": "Cannonball Adderley",
        "url": "https://www.quickchords.org/charts/jazz/cannonball_adderley/walk_tall?source=ireal"
      },
      {
        "title": "Walkin'",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/jazz/miles_davis/walkin?source=ireal"
      },
      {
        "title": "Walkin' My Baby Back Home",
        "artist": "Ahlert-Turk",
        "url": "https://www.quickchords.org/charts/jazz/ahlertturk/walkin_my_baby_back_home?source=ireal"
      },
      {
        "title": "Walkin' Shoes",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/jazz/gerry_mulligan/walkin_shoes?source=ireal"
      },
      {
        "title": "Walkin' up",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/walkin_up?source=ireal"
      },
      {
        "title": "Waltz For Debby",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/waltz_for_debby?source=ireal"
      },
      {
        "title": "Warm Valley",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/jazz/duke_ellington/warm_valley?source=ireal"
      },
      {
        "title": "Watch What Happens",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/jazz/michel_legrand/watch_what_happens?source=ireal"
      },
      {
        "title": "Watermelon Man",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/jazz/herbie_hancock/watermelon_man?source=ireal"
      },
      {
        "title": "Wave",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/wave?source=ireal"
      },
      {
        "title": "Way You Look Tonight, The",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/way_you_look_tonight_the?source=ireal"
      },
      {
        "title": "Wayne's Thang",
        "artist": "Kenny Garrett",
        "url": "https://www.quickchords.org/charts/jazz/kenny_garrett/waynes_thang?source=ireal"
      },
      {
        "title": "We See",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/we_see?source=ireal"
      },
      {
        "title": "We Will Meet Again",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/jazz/bill_evans/we_will_meet_again?source=ireal"
      },
      {
        "title": "We'll Be Together Again",
        "artist": "Carl Fisher",
        "url": "https://www.quickchords.org/charts/jazz/carl_fisher/well_be_together_again?source=ireal"
      },
      {
        "title": "Webb City",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/jazz/bud_powell/webb_city?source=ireal"
      },
      {
        "title": "Well You Needn't",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/jazz/thelonious_monk/well_you_neednt?source=ireal"
      },
      {
        "title": "Wendy",
        "artist": "Paul Desmond",
        "url": "https://www.quickchords.org/charts/jazz/paul_desmond/wendy?source=ireal"
      },
      {
        "title": "West Coast Blues",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/jazz/wes_montgomery/west_coast_blues?source=ireal"
      },
      {
        "title": "What A Difference A Day Made",
        "artist": "Maria Grever",
        "url": "https://www.quickchords.org/charts/jazz/maria_grever/what_a_difference_a_day_made?source=ireal"
      },
      {
        "title": "What A Little Moonlight Can Do",
        "artist": "Harry Woods",
        "url": "https://www.quickchords.org/charts/jazz/harry_woods/what_a_little_moonlight_can_do?source=ireal"
      },
      {
        "title": "What A Wonderful World",
        "artist": "Weiss-Thiele",
        "url": "https://www.quickchords.org/charts/jazz/weissthiele/what_a_wonderful_world?source=ireal"
      },
      {
        "title": "What Are You Doing New Years",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/jazz/frank_loesser/what_are_you_doing_new_years?source=ireal"
      },
      {
        "title": "What Are You Doing The Rest Of Your Life?",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/jazz/michel_legrand/what_are_you_doing_the_rest_of_your_life?source=ireal"
      },
      {
        "title": "What Is This Thing Called Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/what_is_this_thing_called_love?source=ireal"
      },
      {
        "title": "What'll I Do",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/whatll_i_do?source=ireal"
      },
      {
        "title": "What's New",
        "artist": "Bob Haggard",
        "url": "https://www.quickchords.org/charts/jazz/bob_haggard/whats_new?source=ireal"
      },
      {
        "title": "When I Fall In Love",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/jazz/victor_young/when_i_fall_in_love?source=ireal"
      },
      {
        "title": "When It Rains",
        "artist": "Brad Mehldau",
        "url": "https://www.quickchords.org/charts/jazz/brad_mehldau/when_it_rains?source=ireal"
      },
      {
        "title": "When It's Sleepy Time Down South",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/when_its_sleepy_time_down_south?source=ireal"
      },
      {
        "title": "When Lights Are Low",
        "artist": "Benny Carter",
        "url": "https://www.quickchords.org/charts/jazz/benny_carter/when_lights_are_low?source=ireal"
      },
      {
        "title": "When Sunny Gets Blue",
        "artist": "Marvin Fisher",
        "url": "https://www.quickchords.org/charts/jazz/marvin_fisher/when_sunny_gets_blue?source=ireal"
      },
      {
        "title": "When The Saints Go Marching In",
        "artist": "Traditional",
        "url": "https://www.quickchords.org/charts/jazz/traditional/when_the_saints_go_marching_in?source=ireal"
      },
      {
        "title": "When The Sun Comes Out",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/jazz/harold_arlen/when_the_sun_comes_out?source=ireal"
      },
      {
        "title": "When You Wish Upon A Star",
        "artist": "Leigh Harline",
        "url": "https://www.quickchords.org/charts/jazz/leigh_harline/when_you_wish_upon_a_star?source=ireal"
      },
      {
        "title": "When You're Smilin'",
        "artist": "Goodwin - Fisher - Shay",
        "url": "https://www.quickchords.org/charts/jazz/goodwin__fisher__shay/when_youre_smilin?source=ireal"
      },
      {
        "title": "Where Are You?",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/jazz/jimmy_mchugh/where_are_you?source=ireal"
      },
      {
        "title": "Where Or When",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/where_or_when?source=ireal"
      },
      {
        "title": "While We're Young",
        "artist": "Wilder-Palitz",
        "url": "https://www.quickchords.org/charts/jazz/wilderpalitz/while_were_young?source=ireal"
      },
      {
        "title": "Whisper Not",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/jazz/benny_golson/whisper_not?source=ireal"
      },
      {
        "title": "Who Can I Turn To",
        "artist": "Newley-Bricusse",
        "url": "https://www.quickchords.org/charts/jazz/newleybricusse/who_can_i_turn_to?source=ireal"
      },
      {
        "title": "Who Cares",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/jazz/george_gershwin/who_cares?source=ireal"
      },
      {
        "title": "Who's Sorry Now?",
        "artist": "Snyder-Kalmar-Ruby",
        "url": "https://www.quickchords.org/charts/jazz/snyderkalmarruby/whos_sorry_now?source=ireal"
      },
      {
        "title": "Why Do I Love You?",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/why_do_i_love_you?source=ireal"
      },
      {
        "title": "Why Don't You Do Right?",
        "artist": "Kansas-Joe McCoy",
        "url": "https://www.quickchords.org/charts/jazz/kansasjoe_mccoy/why_dont_you_do_right?source=ireal"
      },
      {
        "title": "Wild Flower",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/wild_flower?source=ireal"
      },
      {
        "title": "Will You Still Be Mine?",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/jazz/matt_dennis/will_you_still_be_mine?source=ireal"
      },
      {
        "title": "Willow Weep For Me",
        "artist": "Ann Ronell",
        "url": "https://www.quickchords.org/charts/jazz/ann_ronell/willow_weep_for_me?source=ireal"
      },
      {
        "title": "Windows",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/windows?source=ireal"
      },
      {
        "title": "Witch Hunt",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/witch_hunt?source=ireal"
      },
      {
        "title": "Witchcraft",
        "artist": "Cy Coleman",
        "url": "https://www.quickchords.org/charts/jazz/cy_coleman/witchcraft?source=ireal"
      },
      {
        "title": "With A Song In My Heart",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/with_a_song_in_my_heart?source=ireal"
      },
      {
        "title": "With The Wind And The Rain In Hair",
        "artist": "Clare Edwards",
        "url": "https://www.quickchords.org/charts/jazz/clare_edwards/with_the_wind_and_the_rain_in_hair?source=ireal"
      },
      {
        "title": "Without A Song",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/jazz/vincent_youmans/without_a_song?source=ireal"
      },
      {
        "title": "Wives And Lovers",
        "artist": "Burt Bacharach",
        "url": "https://www.quickchords.org/charts/jazz/burt_bacharach/wives_and_lovers?source=ireal"
      },
      {
        "title": "Woody'n You",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/jazz/dizzy_gillespie/woodyn_you?source=ireal"
      },
      {
        "title": "Work Song",
        "artist": "Nat Adderley",
        "url": "https://www.quickchords.org/charts/jazz/nat_adderley/work_song?source=ireal"
      },
      {
        "title": "Worth The Wait",
        "artist": "Peter Erskine",
        "url": "https://www.quickchords.org/charts/jazz/peter_erskine/worth_the_wait?source=ireal"
      },
      {
        "title": "Wouldn't It Be Loverly",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/jazz/frederick_loewe/wouldnt_it_be_loverly?source=ireal"
      },
      {
        "title": "Wow",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/jazz/lennie_tristano/wow?source=ireal"
      },
      {
        "title": "Wrap Your Troubles In Dreams",
        "artist": "Harry Barris",
        "url": "https://www.quickchords.org/charts/jazz/harry_barris/wrap_your_troubles_in_dreams?source=ireal"
      },
      {
        "title": "Yardbird Suite",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/jazz/charlie_parker/yardbird_suite?source=ireal"
      },
      {
        "title": "Yes And No",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/jazz/wayne_shorter/yes_and_no?source=ireal"
      },
      {
        "title": "Yesterday's Gardenias",
        "artist": "Robertson Mysels",
        "url": "https://www.quickchords.org/charts/jazz/robertson_mysels/yesterdays_gardenias?source=ireal"
      },
      {
        "title": "Yesterdays",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/jazz/jerome_kern/yesterdays?source=ireal"
      },
      {
        "title": "You And The Night And The Music",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/jazz/arthur_schwartz/you_and_the_night_and_the_music?source=ireal"
      },
      {
        "title": "You Are Too Beautiful",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/you_are_too_beautiful?source=ireal"
      },
      {
        "title": "You Better Go Now",
        "artist": "Reichner-Graham",
        "url": "https://www.quickchords.org/charts/jazz/reichnergraham/you_better_go_now?source=ireal"
      },
      {
        "title": "You Better Leave it Alone",
        "artist": "Clifford Jordan",
        "url": "https://www.quickchords.org/charts/jazz/clifford_jordan/you_better_leave_it_alone?source=ireal"
      },
      {
        "title": "You Brought A New Kind Of Love",
        "artist": "Fain-Kaval-Norman",
        "url": "https://www.quickchords.org/charts/jazz/fainkavalnorman/you_brought_a_new_kind_of_love?source=ireal"
      },
      {
        "title": "You Can Depend On Me",
        "artist": "Carpenter-Dunlap-Hines",
        "url": "https://www.quickchords.org/charts/jazz/carpenterdunlaphines/you_can_depend_on_me?source=ireal"
      },
      {
        "title": "You Do Something To Me",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/you_do_something_to_me?source=ireal"
      },
      {
        "title": "You Don't Know What Love Is",
        "artist": "Raye-DePaul",
        "url": "https://www.quickchords.org/charts/jazz/rayedepaul/you_dont_know_what_love_is?source=ireal"
      },
      {
        "title": "You Go To My Head",
        "artist": "Fred Coots",
        "url": "https://www.quickchords.org/charts/jazz/fred_coots/you_go_to_my_head?source=ireal"
      },
      {
        "title": "You Keep Coming Back Like A Song",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/you_keep_coming_back_like_a_song?source=ireal"
      },
      {
        "title": "You Made Me Love You",
        "artist": "James Monaco",
        "url": "https://www.quickchords.org/charts/jazz/james_monaco/you_made_me_love_you?source=ireal"
      },
      {
        "title": "You Make Me Feel So Young",
        "artist": "Josef Myrow",
        "url": "https://www.quickchords.org/charts/jazz/josef_myrow/you_make_me_feel_so_young?source=ireal"
      },
      {
        "title": "You Must Believe In Spring",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/jazz/michel_legrand/you_must_believe_in_spring?source=ireal"
      },
      {
        "title": "You Stepped Out Of A Dream",
        "artist": "Nacio-Herb-Brown",
        "url": "https://www.quickchords.org/charts/jazz/nacioherbbrown/you_stepped_out_of_a_dream?source=ireal"
      },
      {
        "title": "You Took Advantage Of Me",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/jazz/richard_rodgers/you_took_advantage_of_me?source=ireal"
      },
      {
        "title": "You Turned The Tables on Me",
        "artist": "Louis Alter",
        "url": "https://www.quickchords.org/charts/jazz/louis_alter/you_turned_the_tables_on_me?source=ireal"
      },
      {
        "title": "You Won't Forget Me",
        "artist": "Goell-Spielman",
        "url": "https://www.quickchords.org/charts/jazz/goellspielman/you_wont_forget_me?source=ireal"
      },
      {
        "title": "You'd Be So Nice To Come Home To",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/youd_be_so_nice_to_come_home_to?source=ireal"
      },
      {
        "title": "You're Blasé",
        "artist": "Ord Hamilton",
        "url": "https://www.quickchords.org/charts/jazz/ord_hamilton/youre_blas?source=ireal"
      },
      {
        "title": "You're Everything",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/jazz/chick_corea/youre_everything?source=ireal"
      },
      {
        "title": "You're Laughing At Me",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/jazz/irving_berlin/youre_laughing_at_me?source=ireal"
      },
      {
        "title": "You're My Everything",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/jazz/harry_warren/youre_my_everything?source=ireal"
      },
      {
        "title": "You're My Thrill",
        "artist": "Jay Gorney",
        "url": "https://www.quickchords.org/charts/jazz/jay_gorney/youre_my_thrill?source=ireal"
      },
      {
        "title": "You're Nobody Till Somebody Loves You",
        "artist": "Morgan-Stock-Cavanaugh",
        "url": "https://www.quickchords.org/charts/jazz/morganstockcavanaugh/youre_nobody_till_somebody_loves_you?source=ireal"
      },
      {
        "title": "You're The Top",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/jazz/cole_porter/youre_the_top?source=ireal"
      },
      {
        "title": "You've Changed",
        "artist": "Carl Fisher",
        "url": "https://www.quickchords.org/charts/jazz/carl_fisher/youve_changed?source=ireal"
      },
      {
        "title": "Young And Foolish",
        "artist": "Albert Hague",
        "url": "https://www.quickchords.org/charts/jazz/albert_hague/young_and_foolish?source=ireal"
      },
      {
        "title": "Young At Heart",
        "artist": "Johnny Richards",
        "url": "https://www.quickchords.org/charts/jazz/johnny_richards/young_at_heart?source=ireal"
      },
      {
        "title": "Zing Went The Strings Of My Heart",
        "artist": "James Hanley",
        "url": "https://www.quickchords.org/charts/jazz/james_hanley/zing_went_the_strings_of_my_heart?source=ireal"
      },
      {
        "title": "Zingaro (Retrato Em Branco E Preto)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/jazz/antoniocarlos_jobim/zingaro_retrato_em_branco_e_preto?source=ireal"
      },
      {
        "title": "Zoltan",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/jazz/woody_shaw/zoltan?source=ireal"
      }
    ]
  },
  {
    "title": "Latin",
    "items": [
      {
        "title": "11 y 6 (Euforia)",
        "artist": "Fito Páez",
        "url": "https://www.quickchords.org/charts/latin/fito_pez/11_y_6_euforia?source=ireal"
      },
      {
        "title": "Abrazame",
        "artist": "Rafael Ferro",
        "url": "https://www.quickchords.org/charts/latin/rafael_ferro/abrazame?source=ireal"
      },
      {
        "title": "Allí",
        "artist": "Pedro Flores",
        "url": "https://www.quickchords.org/charts/latin/pedro_flores/all?source=ireal"
      },
      {
        "title": "Amar Y Querer",
        "artist": "José José",
        "url": "https://www.quickchords.org/charts/latin/jos_jos/amar_y_querer?source=ireal"
      },
      {
        "title": "Anhelante",
        "artist": "José Sifontes",
        "url": "https://www.quickchords.org/charts/latin/jos_sifontes/anhelante?source=ireal"
      },
      {
        "title": "Bella María De Mi Alma",
        "artist": "Los Lobos",
        "url": "https://www.quickchords.org/charts/latin/los_lobos/bella_mara_de_mi_alma?source=ireal"
      },
      {
        "title": "Cancion Para Mi Muerte",
        "artist": "Charly Garcia",
        "url": "https://www.quickchords.org/charts/latin/charly_garcia/cancion_para_mi_muerte?source=ireal"
      },
      {
        "title": "Capullito De Alelí",
        "artist": "Rafael Hernandez",
        "url": "https://www.quickchords.org/charts/latin/rafael_hernandez/capullito_de_alel?source=ireal"
      },
      {
        "title": "Chan Chan",
        "artist": "Compay Segundo",
        "url": "https://www.quickchords.org/charts/latin/compay_segundo/chan_chan?source=ireal"
      },
      {
        "title": "Claudia",
        "artist": "Chucho Valdés",
        "url": "https://www.quickchords.org/charts/latin/chucho_valds/claudia?source=ireal"
      },
      {
        "title": "Como Fue (as sang by Beny More)",
        "artist": "Ernesto Duarte",
        "url": "https://www.quickchords.org/charts/latin/ernesto_duarte/como_fue_as_sang_by_beny_more?source=ireal"
      },
      {
        "title": "Como Fue (as sang by Luis Miguel)",
        "artist": "Ernesto Duarte",
        "url": "https://www.quickchords.org/charts/latin/ernesto_duarte/como_fue_as_sang_by_luis_miguel?source=ireal"
      },
      {
        "title": "Compadre Pedro Juan",
        "artist": "Luis Alberti",
        "url": "https://www.quickchords.org/charts/latin/luis_alberti/compadre_pedro_juan?source=ireal"
      },
      {
        "title": "Contigo Aprendi",
        "artist": "Armando Manzanero",
        "url": "https://www.quickchords.org/charts/latin/armando_manzanero/contigo_aprendi?source=ireal"
      },
      {
        "title": "Contigo En La Distancia",
        "artist": "Luz La De Portillo Cesar",
        "url": "https://www.quickchords.org/charts/latin/luz_la_de_portillo_cesar/contigo_en_la_distancia?source=ireal"
      },
      {
        "title": "Copacabana",
        "artist": "Barry Manilow",
        "url": "https://www.quickchords.org/charts/latin/barry_manilow/copacabana?source=ireal"
      },
      {
        "title": "Corazón Partido",
        "artist": "Alejandro Sanz",
        "url": "https://www.quickchords.org/charts/latin/alejandro_sanz/corazn_partido?source=ireal"
      },
      {
        "title": "Dos gardenias",
        "artist": "Isolina Carrillo",
        "url": "https://www.quickchords.org/charts/latin/isolina_carrillo/dos_gardenias?source=ireal"
      },
      {
        "title": "El Bodeguero",
        "artist": "Orquesta Aragón (Richard Egües)",
        "url": "https://www.quickchords.org/charts/latin/orquesta_aragn_richard_eges/el_bodeguero?source=ireal"
      },
      {
        "title": "El Cuarto de Tula",
        "artist": "Sergio González-Siaba",
        "url": "https://www.quickchords.org/charts/latin/sergio_gonzlezsiaba/el_cuarto_de_tula?source=ireal"
      },
      {
        "title": "El Reloj",
        "artist": "Roberto Cantoral",
        "url": "https://www.quickchords.org/charts/latin/roberto_cantoral/el_reloj?source=ireal"
      },
      {
        "title": "Guateque Campesino",
        "artist": "Celia Romero",
        "url": "https://www.quickchords.org/charts/latin/celia_romero/guateque_campesino?source=ireal"
      },
      {
        "title": "Hasta Mañana",
        "artist": "Alonso Curet Tite",
        "url": "https://www.quickchords.org/charts/latin/alonso_curet_tite/hasta_maana?source=ireal"
      },
      {
        "title": "Historia de un amor",
        "artist": "Luis Miguel (Carlos Eleta-Almaran)",
        "url": "https://www.quickchords.org/charts/latin/luis_miguel_carlos_eletaalmaran/historia_de_un_amor?source=ireal"
      },
      {
        "title": "La Gloria Eres Tu",
        "artist": "Mendez Antonio Jose",
        "url": "https://www.quickchords.org/charts/latin/mendez_antonio_jose/la_gloria_eres_tu?source=ireal"
      },
      {
        "title": "Lágrimas Negras",
        "artist": "Miguel Matamoros",
        "url": "https://www.quickchords.org/charts/latin/miguel_matamoros/lgrimas_negras?source=ireal"
      },
      {
        "title": "Llegaste Tarde",
        "artist": "Invisibles Amigos Los",
        "url": "https://www.quickchords.org/charts/latin/invisibles_amigos_los/llegaste_tarde?source=ireal"
      },
      {
        "title": "Lloraras",
        "artist": "Oscar D'Leon",
        "url": "https://www.quickchords.org/charts/latin/oscar_dleon/lloraras?source=ireal"
      },
      {
        "title": "Mambo Influenciado",
        "artist": "Chucho Valdés",
        "url": "https://www.quickchords.org/charts/latin/chucho_valds/mambo_influenciado?source=ireal"
      },
      {
        "title": "Mariposa Traicionera",
        "artist": "Olvera Fher",
        "url": "https://www.quickchords.org/charts/latin/olvera_fher/mariposa_traicionera?source=ireal"
      },
      {
        "title": "Mi Historia Entre Tus Dedos",
        "artist": "Grigniani Gianluca",
        "url": "https://www.quickchords.org/charts/latin/grigniani_gianluca/mi_historia_entre_tus_dedos?source=ireal"
      },
      {
        "title": "Moliendo Café",
        "artist": "Hugo Blanco",
        "url": "https://www.quickchords.org/charts/latin/hugo_blanco/moliendo_caf?source=ireal"
      },
      {
        "title": "Morena Yo Soy Tu Marido",
        "artist": "Raulin Rodriguez",
        "url": "https://www.quickchords.org/charts/latin/raulin_rodriguez/morena_yo_soy_tu_marido?source=ireal"
      },
      {
        "title": "Motivos",
        "artist": "Italo Pizzolante",
        "url": "https://www.quickchords.org/charts/latin/italo_pizzolante/motivos?source=ireal"
      },
      {
        "title": "Nostalgias",
        "artist": "Cobián-Cadícamo",
        "url": "https://www.quickchords.org/charts/latin/cobincadcamo/nostalgias?source=ireal"
      },
      {
        "title": "Obsesión",
        "artist": "Pedro Flores",
        "url": "https://www.quickchords.org/charts/latin/pedro_flores/obsesin?source=ireal"
      },
      {
        "title": "Oye Como Va",
        "artist": "Tito Puente",
        "url": "https://www.quickchords.org/charts/latin/tito_puente/oye_como_va?source=ireal"
      },
      {
        "title": "Perfidia",
        "artist": "Alberto Dominguez",
        "url": "https://www.quickchords.org/charts/latin/alberto_dominguez/perfidia?source=ireal"
      },
      {
        "title": "Quizás, Quizás, Quizás",
        "artist": "Osvaldo Farrés",
        "url": "https://www.quickchords.org/charts/latin/osvaldo_farrs/quizs_quizs_quizs?source=ireal"
      },
      {
        "title": "Solamente Una Vez",
        "artist": "Agustín Lara",
        "url": "https://www.quickchords.org/charts/latin/agustn_lara/solamente_una_vez?source=ireal"
      },
      {
        "title": "Somos Novios",
        "artist": "Armando Manzanero",
        "url": "https://www.quickchords.org/charts/latin/armando_manzanero/somos_novios?source=ireal"
      },
      {
        "title": "Te Desafío",
        "artist": "Tito Puente (Roberto Yanes)",
        "url": "https://www.quickchords.org/charts/latin/tito_puente_roberto_yanes/te_desafo?source=ireal"
      },
      {
        "title": "Tres Palabras",
        "artist": "Osvaldo Farrés",
        "url": "https://www.quickchords.org/charts/latin/osvaldo_farrs/tres_palabras?source=ireal"
      },
      {
        "title": "Tu Me Acostumbraste",
        "artist": "Frank Dominquez",
        "url": "https://www.quickchords.org/charts/latin/frank_dominquez/tu_me_acostumbraste?source=ireal"
      },
      {
        "title": "Uno",
        "artist": "Mores-Discépolo",
        "url": "https://www.quickchords.org/charts/latin/moresdiscpolo/uno?source=ireal"
      },
      {
        "title": "Usted",
        "artist": "Jose Feliciano (Monis-Ruíz-Zorrilla)",
        "url": "https://www.quickchords.org/charts/latin/jose_feliciano_monisruzzorrilla/usted?source=ireal"
      },
      {
        "title": "Usted Abusó",
        "artist": "Figueiredo Carlos Jose",
        "url": "https://www.quickchords.org/charts/latin/figueiredo_carlos_jose/usted_abus?source=ireal"
      },
      {
        "title": "Veinte Años",
        "artist": "Vera Teresa Maria",
        "url": "https://www.quickchords.org/charts/latin/vera_teresa_maria/veinte_aos?source=ireal"
      },
      {
        "title": "Volver",
        "artist": "Carlos Gardel",
        "url": "https://www.quickchords.org/charts/latin/carlos_gardel/volver?source=ireal"
      },
      {
        "title": "Yolanda",
        "artist": "Pablo Milanés",
        "url": "https://www.quickchords.org/charts/latin/pablo_milans/yolanda?source=ireal"
      }
    ]
  },
  {
    "title": "More Blues Exercises",
    "items": [
      {
        "title": "II - V - I  Dur",
        "artist": "Exercise",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/exercise/ii__v__i__dur?source=ireal"
      },
      {
        "title": "II-V-I in all Keys",
        "artist": "Exercise",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/exercise/iivi_in_all_keys?source=ireal"
      },
      {
        "title": "Blues Basic 1",
        "artist": "Exercise",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/exercise/blues_basic_1?source=ireal"
      },
      {
        "title": "Blues Basic 2",
        "artist": "Exercise",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/exercise/blues_basic_2?source=ireal"
      },
      {
        "title": "Basic Blues - Quick Change",
        "artist": "Exercise",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/exercise/basic_blues__quick_change?source=ireal"
      },
      {
        "title": "Cantaloupe Island",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/herbie_hancock/cantaloupe_island?source=ireal"
      },
      {
        "title": "Knockin On Heavens Door",
        "artist": "Bob Dylan",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/bob_dylan/knockin_on_heavens_door?source=ireal"
      },
      {
        "title": "Turnaround 1",
        "artist": "Exercise",
        "url": "https://www.quickchords.org/charts/more_blues_exercises/exercise/turnaround_1?source=ireal"
      }
    ]
  },
  {
    "title": "Pink Floyd",
    "items": [
      {
        "title": "A Pillow Of Wind",
        "artist": "Gilmour-Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/gilmourwaters_pink_floyd/a_pillow_of_wind?source=ireal"
      },
      {
        "title": "Another Brick In The Wall (Part 2)",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/another_brick_in_the_wall_part_2?source=ireal"
      },
      {
        "title": "Any Color You Like",
        "artist": "Gilmour-Wright-Mason (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/gilmourwrightmason_pink_floyd/any_color_you_like?source=ireal"
      },
      {
        "title": "Brain Damage",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/brain_damage?source=ireal"
      },
      {
        "title": "Breathe",
        "artist": "Gilmour-Waters-Wright (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/gilmourwaterswright_pink_floyd/breathe?source=ireal"
      },
      {
        "title": "Burning Bridges",
        "artist": "Wright-Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/wrightwaters_pink_floyd/burning_bridges?source=ireal"
      },
      {
        "title": "Childhood's End",
        "artist": "David Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/david_gilmour_pink_floyd/childhoods_end?source=ireal"
      },
      {
        "title": "Cirrus Minor",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/cirrus_minor?source=ireal"
      },
      {
        "title": "Comfortably Numb",
        "artist": "Gilmour-Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/gilmourwaters_pink_floyd/comfortably_numb?source=ireal"
      },
      {
        "title": "Dogs (p1)",
        "artist": "Waters-Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/watersgilmour_pink_floyd/dogs_p1?source=ireal"
      },
      {
        "title": "Dogs (p2)",
        "artist": "Waters-Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/watersgilmour_pink_floyd/dogs_p2?source=ireal"
      },
      {
        "title": "Dogs (p3)",
        "artist": "Waters-Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/watersgilmour_pink_floyd/dogs_p3?source=ireal"
      },
      {
        "title": "Echoes",
        "artist": "Pink Floyd",
        "url": "https://www.quickchords.org/charts/pink_floyd/pink_floyd/echoes?source=ireal"
      },
      {
        "title": "Eclipse",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/eclipse?source=ireal"
      },
      {
        "title": "Fat Old Sun",
        "artist": "David Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/david_gilmour_pink_floyd/fat_old_sun?source=ireal"
      },
      {
        "title": "Gold It's In The..., The",
        "artist": "Waters-Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/watersgilmour_pink_floyd/gold_its_in_the_the?source=ireal"
      },
      {
        "title": "Great Gig In The Sky, The",
        "artist": "Wright-Torry (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/wrighttorry_pink_floyd/great_gig_in_the_sky_the?source=ireal"
      },
      {
        "title": "If (Pink Floyd)",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/if_pink_floyd?source=ireal"
      },
      {
        "title": "Money",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/money?source=ireal"
      },
      {
        "title": "Mudmen",
        "artist": "Wright-Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/wrightgilmour_pink_floyd/mudmen?source=ireal"
      },
      {
        "title": "Nile Song, The",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/nile_song_the?source=ireal"
      },
      {
        "title": "Pigs On the Wing",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/pigs_on_the_wing?source=ireal"
      },
      {
        "title": "See Emily Play",
        "artist": "Syd Barrett (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/syd_barrett_pink_floyd/see_emily_play?source=ireal"
      },
      {
        "title": "Shine On You Crazy Diamond - Parts I-V (p1)",
        "artist": "Pink Floyd",
        "url": "https://www.quickchords.org/charts/pink_floyd/pink_floyd/shine_on_you_crazy_diamond__parts_iv_p1?source=ireal"
      },
      {
        "title": "Shine On You Crazy Diamond - Parts I-V (p2)",
        "artist": "Pink Floyd",
        "url": "https://www.quickchords.org/charts/pink_floyd/pink_floyd/shine_on_you_crazy_diamond__parts_iv_p2?source=ireal"
      },
      {
        "title": "Shine On You Crazy Diamond - Parts I-V (p3)",
        "artist": "Pink Floyd",
        "url": "https://www.quickchords.org/charts/pink_floyd/pink_floyd/shine_on_you_crazy_diamond__parts_iv_p3?source=ireal"
      },
      {
        "title": "Shine On You Crazy Diamond - Parts I-V (p4)",
        "artist": "Pink Floyd",
        "url": "https://www.quickchords.org/charts/pink_floyd/pink_floyd/shine_on_you_crazy_diamond__parts_iv_p4?source=ireal"
      },
      {
        "title": "Stay",
        "artist": "Waters-Wright (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/waterswright_pink_floyd/stay?source=ireal"
      },
      {
        "title": "Summer '68",
        "artist": "Richard Wright (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/richard_wright_pink_floyd/summer_68?source=ireal"
      },
      {
        "title": "Time",
        "artist": "Pink Floyd",
        "url": "https://www.quickchords.org/charts/pink_floyd/pink_floyd/time?source=ireal"
      },
      {
        "title": "Us And Them",
        "artist": "Wright-Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/wrightwaters_pink_floyd/us_and_them?source=ireal"
      },
      {
        "title": "Welcome To The Machine",
        "artist": "Roger Waters (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/roger_waters_pink_floyd/welcome_to_the_machine?source=ireal"
      },
      {
        "title": "Wish You Were Here",
        "artist": "Waters-Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/watersgilmour_pink_floyd/wish_you_were_here?source=ireal"
      },
      {
        "title": "Wot's... Uh The Deal?",
        "artist": "Waters-Gilmour (Pink Floyd)",
        "url": "https://www.quickchords.org/charts/pink_floyd/watersgilmour_pink_floyd/wots_uh_the_deal?source=ireal"
      }
    ]
  },
  {
    "title": "Pop",
    "items": [
      {
        "title": "ABC",
        "artist": "The Jackson 5 (Mizell-Perren-Richards-Gordy)",
        "url": "https://www.quickchords.org/charts/pop/the_jackson_5_mizellperrenrichardsgordy/abc?source=ireal"
      },
      {
        "title": "Across the Universe",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/across_the_universe?source=ireal"
      },
      {
        "title": "Adagio",
        "artist": "Lara Fabian (Albinoni)",
        "url": "https://www.quickchords.org/charts/pop/lara_fabian_albinoni/adagio?source=ireal"
      },
      {
        "title": "Africa",
        "artist": "Toto Paich-Porcaro)",
        "url": "https://www.quickchords.org/charts/pop/toto_paichporcaro/africa?source=ireal"
      },
      {
        "title": "Ain't No Mountain High Enough",
        "artist": "Marvin Gaye-Tammi Terrell (Ashford-Simpson)",
        "url": "https://www.quickchords.org/charts/pop/marvin_gayetammi_terrell_ashfordsimpson/aint_no_mountain_high_enough?source=ireal"
      },
      {
        "title": "Ain't No Sunshine",
        "artist": "Bill Withers",
        "url": "https://www.quickchords.org/charts/pop/bill_withers/aint_no_sunshine?source=ireal"
      },
      {
        "title": "Ain't Nobody",
        "artist": "Rufus and Chaka Khan (Hawk Woliski)",
        "url": "https://www.quickchords.org/charts/pop/rufus_and_chaka_khan_hawk_woliski/aint_nobody?source=ireal"
      },
      {
        "title": "Ain't Nothing Like The Real Thing",
        "artist": "Marvin Gaye-Tammi Terrell (Ashford-Simpson)",
        "url": "https://www.quickchords.org/charts/pop/marvin_gayetammi_terrell_ashfordsimpson/aint_nothing_like_the_real_thing?source=ireal"
      },
      {
        "title": "Aja",
        "artist": "Steely Dan (Becker-Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_beckerfagen/aja?source=ireal"
      },
      {
        "title": "All Day Music",
        "artist": "War (Jerry Goldstein-War)",
        "url": "https://www.quickchords.org/charts/pop/war_jerry_goldsteinwar/all_day_music?source=ireal"
      },
      {
        "title": "All In Love Is Fair",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/all_in_love_is_fair?source=ireal"
      },
      {
        "title": "All My Loving",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/all_my_loving?source=ireal"
      },
      {
        "title": "All You Need Is Love",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/all_you_need_is_love?source=ireal"
      },
      {
        "title": "Alley Cat",
        "artist": "Bent Fabric",
        "url": "https://www.quickchords.org/charts/pop/bent_fabric/alley_cat?source=ireal"
      },
      {
        "title": "Alone Again (Naturally)",
        "artist": "Gilbert O'Sullivan",
        "url": "https://www.quickchords.org/charts/pop/gilbert_osullivan/alone_again_naturally?source=ireal"
      },
      {
        "title": "Always and Forever",
        "artist": "Heatwave (Rod Temperton)",
        "url": "https://www.quickchords.org/charts/pop/heatwave_rod_temperton/always_and_forever?source=ireal"
      },
      {
        "title": "Always On My Mind",
        "artist": "Brenda Lee (Christopher-James-Carson)",
        "url": "https://www.quickchords.org/charts/pop/brenda_lee_christopherjamescarson/always_on_my_mind?source=ireal"
      },
      {
        "title": "American Boy",
        "artist": "West Kanye - Estelle",
        "url": "https://www.quickchords.org/charts/pop/west_kanye__estelle/american_boy?source=ireal"
      },
      {
        "title": "And I Love Her",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/and_i_love_her?source=ireal"
      },
      {
        "title": "Angel",
        "artist": "Jimi Hendrix",
        "url": "https://www.quickchords.org/charts/pop/jimi_hendrix/angel?source=ireal"
      },
      {
        "title": "Angel (Sarah McLachlan)",
        "artist": "Sarah McLachlan",
        "url": "https://www.quickchords.org/charts/pop/sarah_mclachlan/angel_sarah_mclachlan?source=ireal"
      },
      {
        "title": "Angels",
        "artist": "Robbie Williams (Williams-Chambers-Heffernan)",
        "url": "https://www.quickchords.org/charts/pop/robbie_williams_williamschambersheffernan/angels?source=ireal"
      },
      {
        "title": "Another Day",
        "artist": "Jamie Lidell",
        "url": "https://www.quickchords.org/charts/pop/jamie_lidell/another_day?source=ireal"
      },
      {
        "title": "Another One Bites The Dust",
        "artist": "Queen (John Deacon)",
        "url": "https://www.quickchords.org/charts/pop/queen_john_deacon/another_one_bites_the_dust?source=ireal"
      },
      {
        "title": "Another Star",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/another_star?source=ireal"
      },
      {
        "title": "As",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/as?source=ireal"
      },
      {
        "title": "At The Chime Of A City Clock",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/at_the_chime_of_a_city_clock?source=ireal"
      },
      {
        "title": "Baby Love",
        "artist": "The Supremes (Holland–Dozier–Holland)",
        "url": "https://www.quickchords.org/charts/pop/the_supremes_hollanddozierholland/baby_love?source=ireal"
      },
      {
        "title": "Babylon Sisters",
        "artist": "Steely Dan (Becker-Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_beckerfagen/babylon_sisters?source=ireal"
      },
      {
        "title": "Baker Street",
        "artist": "Gerry Rafferty",
        "url": "https://www.quickchords.org/charts/pop/gerry_rafferty/baker_street?source=ireal"
      },
      {
        "title": "Bats",
        "artist": "Paul Dempsey",
        "url": "https://www.quickchords.org/charts/pop/paul_dempsey/bats?source=ireal"
      },
      {
        "title": "Ben",
        "artist": "Michael Jackson (Black, Scharf)",
        "url": "https://www.quickchords.org/charts/pop/michael_jackson_black_scharf/ben?source=ireal"
      },
      {
        "title": "Better",
        "artist": "Boyzone (Baxter, Semple)",
        "url": "https://www.quickchords.org/charts/pop/boyzone_baxter_semple/better?source=ireal"
      },
      {
        "title": "Big Yellow Taxi",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/big_yellow_taxi?source=ireal"
      },
      {
        "title": "Billie Jean",
        "artist": "Michael Jackson",
        "url": "https://www.quickchords.org/charts/pop/michael_jackson/billie_jean?source=ireal"
      },
      {
        "title": "Black Velvet",
        "artist": "Alannah Myles (Tyson-Ward)",
        "url": "https://www.quickchords.org/charts/pop/alannah_myles_tysonward/black_velvet?source=ireal"
      },
      {
        "title": "Blackbird",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/blackbird?source=ireal"
      },
      {
        "title": "Blame It On The Sun",
        "artist": "Stevie Wonder (Wonder-Wright)",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder_wonderwright/blame_it_on_the_sun?source=ireal"
      },
      {
        "title": "Blue",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/blue?source=ireal"
      },
      {
        "title": "Blue Suede Shoes",
        "artist": "Elvis Presley (Carl Perkins)",
        "url": "https://www.quickchords.org/charts/pop/elvis_presley_carl_perkins/blue_suede_shoes?source=ireal"
      },
      {
        "title": "Blue Tango",
        "artist": "Leroy Anderson",
        "url": "https://www.quickchords.org/charts/pop/leroy_anderson/blue_tango?source=ireal"
      },
      {
        "title": "Both Sides Now",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/both_sides_now?source=ireal"
      },
      {
        "title": "Breakaway",
        "artist": "Clarkson (Lavigne-Benenate-Gerrard)",
        "url": "https://www.quickchords.org/charts/pop/clarkson_lavignebenenategerrard/breakaway?source=ireal"
      },
      {
        "title": "Breakdown",
        "artist": "Tom Petty and the Heartbreakers (Tom Petty)",
        "url": "https://www.quickchords.org/charts/pop/tom_petty_and_the_heartbreakers_tom_petty/breakdown?source=ireal"
      },
      {
        "title": "Bring It On Home To Me",
        "artist": "Sam Cooke",
        "url": "https://www.quickchords.org/charts/pop/sam_cooke/bring_it_on_home_to_me?source=ireal"
      },
      {
        "title": "Brown Eyed Girl",
        "artist": "Van Morrison",
        "url": "https://www.quickchords.org/charts/pop/van_morrison/brown_eyed_girl?source=ireal"
      },
      {
        "title": "Can You Feel The Love Tonight",
        "artist": "Rice John-Tim Elton",
        "url": "https://www.quickchords.org/charts/pop/rice_johntim_elton/can_you_feel_the_love_tonight?source=ireal"
      },
      {
        "title": "Can't Buy Me Love",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/cant_buy_me_love?source=ireal"
      },
      {
        "title": "Can't Get Enough Of Your Love, Babe",
        "artist": "Barry White",
        "url": "https://www.quickchords.org/charts/pop/barry_white/cant_get_enough_of_your_love_babe?source=ireal"
      },
      {
        "title": "Can't Help Falling In Love",
        "artist": "Elvis Presley (Peretti-Creatore-Weiss)",
        "url": "https://www.quickchords.org/charts/pop/elvis_presley_peretticreatoreweiss/cant_help_falling_in_love?source=ireal"
      },
      {
        "title": "Can't Take My Eyes Off You",
        "artist": "Frankie Valli (Crewe-Gaudio)",
        "url": "https://www.quickchords.org/charts/pop/frankie_valli_crewegaudio/cant_take_my_eyes_off_you?source=ireal"
      },
      {
        "title": "Careless Whisper",
        "artist": "George Michael (Michael-Ridgeley)",
        "url": "https://www.quickchords.org/charts/pop/george_michael_michaelridgeley/careless_whisper?source=ireal"
      },
      {
        "title": "Caught Up In The Rapture",
        "artist": "Anita Baker (Quander, Glenn)",
        "url": "https://www.quickchords.org/charts/pop/anita_baker_quander_glenn/caught_up_in_the_rapture?source=ireal"
      },
      {
        "title": "Cello Song",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/cello_song?source=ireal"
      },
      {
        "title": "Chain Lightning",
        "artist": "Steely Dan (Becker-Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_beckerfagen/chain_lightning?source=ireal"
      },
      {
        "title": "Chain Of Fools",
        "artist": "Aretha Franklin (Don Covay)",
        "url": "https://www.quickchords.org/charts/pop/aretha_franklin_don_covay/chain_of_fools?source=ireal"
      },
      {
        "title": "Change Is Gonna Come",
        "artist": "Sam Cooke",
        "url": "https://www.quickchords.org/charts/pop/sam_cooke/change_is_gonna_come?source=ireal"
      },
      {
        "title": "Change The World",
        "artist": "Eric Clapton (Sims-Kennedy-Kirkpatrick)",
        "url": "https://www.quickchords.org/charts/pop/eric_clapton_simskennedykirkpatrick/change_the_world?source=ireal"
      },
      {
        "title": "Cherish The Day",
        "artist": "Sade (Adu, Hale, Matthewman)",
        "url": "https://www.quickchords.org/charts/pop/sade_adu_hale_matthewman/cherish_the_day?source=ireal"
      },
      {
        "title": "Circle Game, The",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/circle_game_the?source=ireal"
      },
      {
        "title": "Close To You (They Long To Be)",
        "artist": "The Carpenters (Bacharach, David)",
        "url": "https://www.quickchords.org/charts/pop/the_carpenters_bacharach_david/close_to_you_they_long_to_be?source=ireal"
      },
      {
        "title": "Cocaine",
        "artist": "Eric Clapton (J.J. Cale)",
        "url": "https://www.quickchords.org/charts/pop/eric_clapton_jj_cale/cocaine?source=ireal"
      },
      {
        "title": "Color My World",
        "artist": "Chicago (James Pankow)",
        "url": "https://www.quickchords.org/charts/pop/chicago_james_pankow/color_my_world?source=ireal"
      },
      {
        "title": "Come Away With Me",
        "artist": "Norah Jones",
        "url": "https://www.quickchords.org/charts/pop/norah_jones/come_away_with_me?source=ireal"
      },
      {
        "title": "Come Together ",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/come_together_?source=ireal"
      },
      {
        "title": "Could You Be Loved",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/pop/bob_marley/could_you_be_loved?source=ireal"
      },
      {
        "title": "Crazy (Gnarls Barkley)",
        "artist": "Gnarls Barkley (Burton, Callaway, Reverberi)",
        "url": "https://www.quickchords.org/charts/pop/gnarls_barkley_burton_callaway_reverberi/crazy_gnarls_barkley?source=ireal"
      },
      {
        "title": "Creep",
        "artist": "Radiohead (Radiohead, Hammond, Hazelwood)",
        "url": "https://www.quickchords.org/charts/pop/radiohead_radiohead_hammond_hazelwood/creep?source=ireal"
      },
      {
        "title": "Dancing In The Dark 1",
        "artist": "Bruce Springsteen",
        "url": "https://www.quickchords.org/charts/pop/bruce_springsteen/dancing_in_the_dark_1?source=ireal"
      },
      {
        "title": "Daniel",
        "artist": "Elton John (John, Taupin)",
        "url": "https://www.quickchords.org/charts/pop/elton_john_john_taupin/daniel?source=ireal"
      },
      {
        "title": "Day Is Done",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/day_is_done?source=ireal"
      },
      {
        "title": "Daydream Believer",
        "artist": "The Monkees (John Stewart)",
        "url": "https://www.quickchords.org/charts/pop/the_monkees_john_stewart/daydream_believer?source=ireal"
      },
      {
        "title": "Deacon Blues (Page 1)",
        "artist": "Steely Dan (Becker-Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_beckerfagen/deacon_blues_page_1?source=ireal"
      },
      {
        "title": "Deacon Blues (Page 2)",
        "artist": "Steely Dan (Becker-Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_beckerfagen/deacon_blues_page_2?source=ireal"
      },
      {
        "title": "Delilah",
        "artist": "Tom Jones (Mason-Reed)",
        "url": "https://www.quickchords.org/charts/pop/tom_jones_masonreed/delilah?source=ireal"
      },
      {
        "title": "Don't Go Breaking My Heart",
        "artist": "Elton John and Kiki Dee (John, Taupin)",
        "url": "https://www.quickchords.org/charts/pop/elton_john_and_kiki_dee_john_taupin/dont_go_breaking_my_heart?source=ireal"
      },
      {
        "title": "Don't Know Why I Didn't Come",
        "artist": "Norah Jones (Jessie Harris)",
        "url": "https://www.quickchords.org/charts/pop/norah_jones_jessie_harris/dont_know_why_i_didnt_come?source=ireal"
      },
      {
        "title": "Don't Let The Sun Go Down On Me",
        "artist": "Elton John (John, Taupin)",
        "url": "https://www.quickchords.org/charts/pop/elton_john_john_taupin/dont_let_the_sun_go_down_on_me?source=ireal"
      },
      {
        "title": "Don't Speak",
        "artist": "No Doubt (Stefani, Stefani)",
        "url": "https://www.quickchords.org/charts/pop/no_doubt_stefani_stefani/dont_speak?source=ireal"
      },
      {
        "title": "Don't Stop Me Now",
        "artist": "Queen (Freddie Mercury)",
        "url": "https://www.quickchords.org/charts/pop/queen_freddie_mercury/dont_stop_me_now?source=ireal"
      },
      {
        "title": "Don't You Worry 'Bout A Thing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/dont_you_worry_bout_a_thing?source=ireal"
      },
      {
        "title": "Dream Brother",
        "artist": "Jeff Buckley (Buckley, Grondahl, Johnson)",
        "url": "https://www.quickchords.org/charts/pop/jeff_buckley_buckley_grondahl_johnson/dream_brother?source=ireal"
      },
      {
        "title": "Drive My Car",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/drive_my_car?source=ireal"
      },
      {
        "title": "Easy",
        "artist": "The Commodores (Lionel Richie)",
        "url": "https://www.quickchords.org/charts/pop/the_commodores_lionel_richie/easy?source=ireal"
      },
      {
        "title": "Echoes Part 1",
        "artist": "Pink Floyd (Waters, Wright, Mason, Gilmour)",
        "url": "https://www.quickchords.org/charts/pop/pink_floyd_waters_wright_mason_gilmour/echoes_part_1?source=ireal"
      },
      {
        "title": "Eight Days A Week",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/eight_days_a_week?source=ireal"
      },
      {
        "title": "Eleanor Rigby",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/eleanor_rigby?source=ireal"
      },
      {
        "title": "Englishman In New York",
        "artist": "Sting (Gordon Sumner)",
        "url": "https://www.quickchords.org/charts/pop/sting_gordon_sumner/englishman_in_new_york?source=ireal"
      },
      {
        "title": "Eternal Flame",
        "artist": "The Bangles (Steinberg-Kelly-Hoffs)",
        "url": "https://www.quickchords.org/charts/pop/the_bangles_steinbergkellyhoffs/eternal_flame?source=ireal"
      },
      {
        "title": "Every Breath You Take",
        "artist": "The Police (Sting)",
        "url": "https://www.quickchords.org/charts/pop/the_police_sting/every_breath_you_take?source=ireal"
      },
      {
        "title": "Every Little Thing She Does Is Magic",
        "artist": "The Police (Sting)",
        "url": "https://www.quickchords.org/charts/pop/the_police_sting/every_little_thing_she_does_is_magic?source=ireal"
      },
      {
        "title": "Everybody Needs Somebody To Love",
        "artist": "The Blues Brothers (Berns-Burke-Wexler)",
        "url": "https://www.quickchords.org/charts/pop/the_blues_brothers_bernsburkewexler/everybody_needs_somebody_to_love?source=ireal"
      },
      {
        "title": "Everything I Miss At Home",
        "artist": "Cherrelle Lewis-Jam)",
        "url": "https://www.quickchords.org/charts/pop/cherrelle_lewisjam/everything_i_miss_at_home?source=ireal"
      },
      {
        "title": "Faith",
        "artist": "George Michael",
        "url": "https://www.quickchords.org/charts/pop/george_michael/faith?source=ireal"
      },
      {
        "title": "Falling",
        "artist": "Jamiroquai (Kay, Smith)",
        "url": "https://www.quickchords.org/charts/pop/jamiroquai_kay_smith/falling?source=ireal"
      },
      {
        "title": "Fast Car",
        "artist": "Tracy Chapman",
        "url": "https://www.quickchords.org/charts/pop/tracy_chapman/fast_car?source=ireal"
      },
      {
        "title": "Femme Fatale",
        "artist": "The Velvet Underground (Lou Reed)",
        "url": "https://www.quickchords.org/charts/pop/the_velvet_underground_lou_reed/femme_fatale?source=ireal"
      },
      {
        "title": "Fields Of Gold",
        "artist": "Sting",
        "url": "https://www.quickchords.org/charts/pop/sting/fields_of_gold?source=ireal"
      },
      {
        "title": "Fifty Ways To Leave Your Lover",
        "artist": "Paul Simon",
        "url": "https://www.quickchords.org/charts/pop/paul_simon/fifty_ways_to_leave_your_lover?source=ireal"
      },
      {
        "title": "Firework ",
        "artist": "Perry (Eriksen-Hermansen-Wilhem-Dean)",
        "url": "https://www.quickchords.org/charts/pop/perry_eriksenhermansenwilhemdean/firework_?source=ireal"
      },
      {
        "title": "First Time Ever I Saw Your Face, The",
        "artist": "Roberta Flack (Ewan MacColl)",
        "url": "https://www.quickchords.org/charts/pop/roberta_flack_ewan_maccoll/first_time_ever_i_saw_your_face_the?source=ireal"
      },
      {
        "title": "Fix You",
        "artist": "Coldplay",
        "url": "https://www.quickchords.org/charts/pop/coldplay/fix_you?source=ireal"
      },
      {
        "title": "Fly",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/fly?source=ireal"
      },
      {
        "title": "Fly Away",
        "artist": "Lenny Kravitz",
        "url": "https://www.quickchords.org/charts/pop/lenny_kravitz/fly_away?source=ireal"
      },
      {
        "title": "Fly Like An Eagle",
        "artist": "Steve Miller",
        "url": "https://www.quickchords.org/charts/pop/steve_miller/fly_like_an_eagle?source=ireal"
      },
      {
        "title": "Fool On The Hill, The",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/fool_on_the_hill_the?source=ireal"
      },
      {
        "title": "For No One",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/for_no_one?source=ireal"
      },
      {
        "title": "For Once In My Life 1",
        "artist": "Stevie Wonder (Miller, Murden)",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder_miller_murden/for_once_in_my_life_1?source=ireal"
      },
      {
        "title": "Fragile",
        "artist": "Sting (Gordon Sumner)",
        "url": "https://www.quickchords.org/charts/pop/sting_gordon_sumner/fragile?source=ireal"
      },
      {
        "title": "Free As A Bird",
        "artist": "The Beatles",
        "url": "https://www.quickchords.org/charts/pop/the_beatles/free_as_a_bird?source=ireal"
      },
      {
        "title": "Fruit Tree",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/fruit_tree?source=ireal"
      },
      {
        "title": "Game Of Love, The",
        "artist": "Santana (Alexander, Nowels)",
        "url": "https://www.quickchords.org/charts/pop/santana_alexander_nowels/game_of_love_the?source=ireal"
      },
      {
        "title": "Get Back",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/get_back?source=ireal"
      },
      {
        "title": "Get Here",
        "artist": "Brenda Russell",
        "url": "https://www.quickchords.org/charts/pop/brenda_russell/get_here?source=ireal"
      },
      {
        "title": "Girl",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/girl?source=ireal"
      },
      {
        "title": "Girls Just Wanna Have Fun",
        "artist": "Cyndi Lauper (Robert Hazard)",
        "url": "https://www.quickchords.org/charts/pop/cyndi_lauper_robert_hazard/girls_just_wanna_have_fun?source=ireal"
      },
      {
        "title": "Give A Little Bit",
        "artist": "Supertramp (Roger Hodgson)",
        "url": "https://www.quickchords.org/charts/pop/supertramp_roger_hodgson/give_a_little_bit?source=ireal"
      },
      {
        "title": "Give Me Forever I Do",
        "artist": "Tesh Ingram-John James",
        "url": "https://www.quickchords.org/charts/pop/tesh_ingramjohn_james/give_me_forever_i_do?source=ireal"
      },
      {
        "title": "Give Me Strength",
        "artist": "Eric Clapton",
        "url": "https://www.quickchords.org/charts/pop/eric_clapton/give_me_strength?source=ireal"
      },
      {
        "title": "Give Me The Night",
        "artist": "George Benson (Rod Temperton)",
        "url": "https://www.quickchords.org/charts/pop/george_benson_rod_temperton/give_me_the_night?source=ireal"
      },
      {
        "title": "Golden Lady",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/golden_lady?source=ireal"
      },
      {
        "title": "Good Day Sunshine",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/good_day_sunshine?source=ireal"
      },
      {
        "title": "Good Times",
        "artist": "Chic (Edwards, Rodgers)",
        "url": "https://www.quickchords.org/charts/pop/chic_edwards_rodgers/good_times?source=ireal"
      },
      {
        "title": "Goodbye Yellow Brick Road",
        "artist": "Elton John (John, Taupin)",
        "url": "https://www.quickchords.org/charts/pop/elton_john_john_taupin/goodbye_yellow_brick_road?source=ireal"
      },
      {
        "title": "Gravity",
        "artist": "John Mayer",
        "url": "https://www.quickchords.org/charts/pop/john_mayer/gravity?source=ireal"
      },
      {
        "title": "Greatest Love Of All, The",
        "artist": "Whitney Houston (Masser, Creed)",
        "url": "https://www.quickchords.org/charts/pop/whitney_houston_masser_creed/greatest_love_of_all_the?source=ireal"
      },
      {
        "title": "Green Is The Colour",
        "artist": "Pink Floyd (Roger Waters)",
        "url": "https://www.quickchords.org/charts/pop/pink_floyd_roger_waters/green_is_the_colour?source=ireal"
      },
      {
        "title": "Groovin'",
        "artist": "The Young Rascals (Cavaliere-Brigati)",
        "url": "https://www.quickchords.org/charts/pop/the_young_rascals_cavalierebrigati/groovin?source=ireal"
      },
      {
        "title": "Hallelujah",
        "artist": "Leonard Cohen",
        "url": "https://www.quickchords.org/charts/pop/leonard_cohen/hallelujah?source=ireal"
      },
      {
        "title": "Happy Xmas (War Is Over)",
        "artist": "Ono Lennon-Yoko John",
        "url": "https://www.quickchords.org/charts/pop/ono_lennonyoko_john/happy_xmas_war_is_over?source=ireal"
      },
      {
        "title": "Hard Day's Night, A",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/hard_days_night_a?source=ireal"
      },
      {
        "title": "Hard To Say I'm Sorry",
        "artist": "Chicago Cetera-Foster)",
        "url": "https://www.quickchords.org/charts/pop/chicago_ceterafoster/hard_to_say_im_sorry?source=ireal"
      },
      {
        "title": "Have I Told You Lately",
        "artist": "Rod Stewart (Van Morrison)",
        "url": "https://www.quickchords.org/charts/pop/rod_stewart_van_morrison/have_i_told_you_lately?source=ireal"
      },
      {
        "title": "Heart Of Glass",
        "artist": "Blondie Harry-Stein)",
        "url": "https://www.quickchords.org/charts/pop/blondie_harrystein/heart_of_glass?source=ireal"
      },
      {
        "title": "Heart of Rock and Roll, The",
        "artist": "Huey Lewis and The News (Colla, Lewis)",
        "url": "https://www.quickchords.org/charts/pop/huey_lewis_and_the_news_colla_lewis/heart_of_rock_and_roll_the?source=ireal"
      },
      {
        "title": "Heartbreak Hotel",
        "artist": "Elvis Presley (Axton-Durden-Presley)",
        "url": "https://www.quickchords.org/charts/pop/elvis_presley_axtondurdenpresley/heartbreak_hotel?source=ireal"
      },
      {
        "title": "Hello",
        "artist": "Shakespears Sisters (Fahey-Detroit-Guiot)",
        "url": "https://www.quickchords.org/charts/pop/shakespears_sisters_faheydetroitguiot/hello?source=ireal"
      },
      {
        "title": "Hello, Goodbye",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/hello_goodbye?source=ireal"
      },
      {
        "title": "Here, There, And Everywhere",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/here_there_and_everywhere?source=ireal"
      },
      {
        "title": "Hero",
        "artist": "Mariah Carey (Carey- Afanasieff)",
        "url": "https://www.quickchords.org/charts/pop/mariah_carey_carey_afanasieff/hero?source=ireal"
      },
      {
        "title": "Hey Jude",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/hey_jude?source=ireal"
      },
      {
        "title": "Hi Ho Silver Lining",
        "artist": "Jeff Beck (English, Weiss)",
        "url": "https://www.quickchords.org/charts/pop/jeff_beck_english_weiss/hi_ho_silver_lining?source=ireal"
      },
      {
        "title": "Higher And Higher (Your Love Keeps Lifting Me)",
        "artist": "Jackie Wilson (Jackson, Miner, Smith)",
        "url": "https://www.quickchords.org/charts/pop/jackie_wilson_jackson_miner_smith/higher_and_higher_your_love_keeps_lifting_me?source=ireal"
      },
      {
        "title": "Highway To Hell",
        "artist": "AC DC (Scott-Young-Young)",
        "url": "https://www.quickchords.org/charts/pop/ac_dc_scottyoungyoung/highway_to_hell?source=ireal"
      },
      {
        "title": "Hit The Road Jack",
        "artist": "Ray Charles (Percy Mayfield)",
        "url": "https://www.quickchords.org/charts/pop/ray_charles_percy_mayfield/hit_the_road_jack?source=ireal"
      },
      {
        "title": "Home Again",
        "artist": "Carole King",
        "url": "https://www.quickchords.org/charts/pop/carole_king/home_again?source=ireal"
      },
      {
        "title": "Home At Last 1",
        "artist": "Steely Dan (Becker, Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_becker_fagen/home_at_last_1?source=ireal"
      },
      {
        "title": "Honesty",
        "artist": "Billy Joel",
        "url": "https://www.quickchords.org/charts/pop/billy_joel/honesty?source=ireal"
      },
      {
        "title": "Hot Stuff",
        "artist": "Donna Summer (Bellote-Faltermeyer-Forsey)",
        "url": "https://www.quickchords.org/charts/pop/donna_summer_bellotefaltermeyerforsey/hot_stuff?source=ireal"
      },
      {
        "title": "House Of The Rising Sun, The",
        "artist": "The Animals (Unknown Composer)",
        "url": "https://www.quickchords.org/charts/pop/the_animals_unknown_composer/house_of_the_rising_sun_the?source=ireal"
      },
      {
        "title": "How Can You Mend A Broken Heart",
        "artist": "Bee Gees (Barry Gibb-Robin Gibb)",
        "url": "https://www.quickchords.org/charts/pop/bee_gees_barry_gibbrobin_gibb/how_can_you_mend_a_broken_heart?source=ireal"
      },
      {
        "title": "How Deep Is Your Love?",
        "artist": "The Bee Gees (Gibb, Gibb, Gibb)",
        "url": "https://www.quickchords.org/charts/pop/the_bee_gees_gibb_gibb_gibb/how_deep_is_your_love?source=ireal"
      },
      {
        "title": "How Sweet It Is To Be Loved By You",
        "artist": "Marvin Gaye (Holland, Dozier, Holland)",
        "url": "https://www.quickchords.org/charts/pop/marvin_gaye_holland_dozier_holland/how_sweet_it_is_to_be_loved_by_you?source=ireal"
      },
      {
        "title": "Human",
        "artist": "The Killers",
        "url": "https://www.quickchords.org/charts/pop/the_killers/human?source=ireal"
      },
      {
        "title": "Hyperballad",
        "artist": "Björk (Björk, Hooper, De Vries)",
        "url": "https://www.quickchords.org/charts/pop/bjrk_bjrk_hooper_de_vries/hyperballad?source=ireal"
      },
      {
        "title": "I Believe I Can Fly",
        "artist": "R. Kelly",
        "url": "https://www.quickchords.org/charts/pop/r_kelly/i_believe_i_can_fly?source=ireal"
      },
      {
        "title": "I Can See Clearly Now",
        "artist": "Johnny Nash",
        "url": "https://www.quickchords.org/charts/pop/johnny_nash/i_can_see_clearly_now?source=ireal"
      },
      {
        "title": "I Can't Help It",
        "artist": "Michael Jackson (Wonder-Greene)",
        "url": "https://www.quickchords.org/charts/pop/michael_jackson_wondergreene/i_cant_help_it?source=ireal"
      },
      {
        "title": "I Can't Make You Love Me",
        "artist": "Bonnie Raitt (Reid-Shamblin)",
        "url": "https://www.quickchords.org/charts/pop/bonnie_raitt_reidshamblin/i_cant_make_you_love_me?source=ireal"
      },
      {
        "title": "I Feel The Earth",
        "artist": "Carole King",
        "url": "https://www.quickchords.org/charts/pop/carole_king/i_feel_the_earth?source=ireal"
      },
      {
        "title": "I Got A Woman",
        "artist": "Richard Charles-Renald Ray",
        "url": "https://www.quickchords.org/charts/pop/richard_charlesrenald_ray/i_got_a_woman?source=ireal"
      },
      {
        "title": "I Heard It Through The Grapevine",
        "artist": "Marvin Gaye (Whitfield-Strong)",
        "url": "https://www.quickchords.org/charts/pop/marvin_gaye_whitfieldstrong/i_heard_it_through_the_grapevine?source=ireal"
      },
      {
        "title": "I Left My Heart In San Francisco 1",
        "artist": "Tony Bennett (Cory-Cross)",
        "url": "https://www.quickchords.org/charts/pop/tony_bennett_corycross/i_left_my_heart_in_san_francisco_1?source=ireal"
      },
      {
        "title": "I Saw Her Standing There",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/i_saw_her_standing_there?source=ireal"
      },
      {
        "title": "I Say A Little Prayer For You",
        "artist": "Dionne Warwick (Bacharach-David)",
        "url": "https://www.quickchords.org/charts/pop/dionne_warwick_bacharachdavid/i_say_a_little_prayer_for_you?source=ireal"
      },
      {
        "title": "I Shot The Sheriff",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/pop/bob_marley/i_shot_the_sheriff?source=ireal"
      },
      {
        "title": "I Still Haven't Found What I'm Looking For",
        "artist": "U2",
        "url": "https://www.quickchords.org/charts/pop/u2/i_still_havent_found_what_im_looking_for?source=ireal"
      },
      {
        "title": "I Want To Hold Your Hand",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/i_want_to_hold_your_hand?source=ireal"
      },
      {
        "title": "I Want You Back",
        "artist": "The Jackson 5 (Gordy, Perren, Mizell, Richards)",
        "url": "https://www.quickchords.org/charts/pop/the_jackson_5_gordy_perren_mizell_richards/i_want_you_back?source=ireal"
      },
      {
        "title": "I Will Survive",
        "artist": "Gloria Gaynor (Perren-Fekaris)",
        "url": "https://www.quickchords.org/charts/pop/gloria_gaynor_perrenfekaris/i_will_survive?source=ireal"
      },
      {
        "title": "I Wish",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/i_wish?source=ireal"
      },
      {
        "title": "I'm A Believer",
        "artist": "The Monkees (Neil Diamond)",
        "url": "https://www.quickchords.org/charts/pop/the_monkees_neil_diamond/im_a_believer?source=ireal"
      },
      {
        "title": "I'm Yours",
        "artist": "Jason Mraz",
        "url": "https://www.quickchords.org/charts/pop/jason_mraz/im_yours?source=ireal"
      },
      {
        "title": "If I Ain't Got You ",
        "artist": "Alicia Keys",
        "url": "https://www.quickchords.org/charts/pop/alicia_keys/if_i_aint_got_you_?source=ireal"
      },
      {
        "title": "If I Fell",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/if_i_fell?source=ireal"
      },
      {
        "title": "Imagine",
        "artist": "John Lennon",
        "url": "https://www.quickchords.org/charts/pop/john_lennon/imagine?source=ireal"
      },
      {
        "title": "Immigrant Song",
        "artist": "Led Zeppelin (Page, Plant)",
        "url": "https://www.quickchords.org/charts/pop/led_zeppelin_page_plant/immigrant_song?source=ireal"
      },
      {
        "title": "In Crowd, The",
        "artist": "Dobie Gray (Billy Page)",
        "url": "https://www.quickchords.org/charts/pop/dobie_gray_billy_page/in_crowd_the?source=ireal"
      },
      {
        "title": "In My Life",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/in_my_life?source=ireal"
      },
      {
        "title": "In The Midnight Hour",
        "artist": "Wilson Pickett (Pickett, Cropper)",
        "url": "https://www.quickchords.org/charts/pop/wilson_pickett_pickett_cropper/in_the_midnight_hour?source=ireal"
      },
      {
        "title": "Isn't She Lovely?",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/isnt_she_lovely?source=ireal"
      },
      {
        "title": "It's A Man's World",
        "artist": "James Brown (Brown-Newsome)",
        "url": "https://www.quickchords.org/charts/pop/james_brown_brownnewsome/its_a_mans_world?source=ireal"
      },
      {
        "title": "It's probably me",
        "artist": "Sting Sting-Kamen-Clapton)",
        "url": "https://www.quickchords.org/charts/pop/sting_stingkamenclapton/its_probably_me?source=ireal"
      },
      {
        "title": "It's Too Late",
        "artist": "Carole King",
        "url": "https://www.quickchords.org/charts/pop/carole_king/its_too_late?source=ireal"
      },
      {
        "title": "Itch, The",
        "artist": "Keb' Mo' (Keb' Mo'-Jeff Paris)",
        "url": "https://www.quickchords.org/charts/pop/keb_mo_keb_mojeff_paris/itch_the?source=ireal"
      },
      {
        "title": "Jealous Guy",
        "artist": "John Lennon",
        "url": "https://www.quickchords.org/charts/pop/john_lennon/jealous_guy?source=ireal"
      },
      {
        "title": "Jóga",
        "artist": "Björk (Björk, Sjón)",
        "url": "https://www.quickchords.org/charts/pop/bjrk_bjrk_sjn/jga?source=ireal"
      },
      {
        "title": "Just The Two Of Us",
        "artist": "Bill Withers (Withers-MacDonald-Salter)",
        "url": "https://www.quickchords.org/charts/pop/bill_withers_withersmacdonaldsalter/just_the_two_of_us?source=ireal"
      },
      {
        "title": "Just The Way You Are (Page 1)",
        "artist": "Billy Joel",
        "url": "https://www.quickchords.org/charts/pop/billy_joel/just_the_way_you_are_page_1?source=ireal"
      },
      {
        "title": "Just The Way You Are (Page 2)",
        "artist": "Billie Joel",
        "url": "https://www.quickchords.org/charts/pop/billie_joel/just_the_way_you_are_page_2?source=ireal"
      },
      {
        "title": "Kid Charlemagne (Page 1)",
        "artist": "Steely Dan (Becker, Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_becker_fagen/kid_charlemagne_page_1?source=ireal"
      },
      {
        "title": "Kid Charlemagne (Page 2)",
        "artist": "Steely Dan (Becker, Fagen)",
        "url": "https://www.quickchords.org/charts/pop/steely_dan_becker_fagen/kid_charlemagne_page_2?source=ireal"
      },
      {
        "title": "Killer Queen",
        "artist": "Queen (Freddie Mercury)",
        "url": "https://www.quickchords.org/charts/pop/queen_freddie_mercury/killer_queen?source=ireal"
      },
      {
        "title": "Killing Me Softly With His Song",
        "artist": "Roberta Flack (Fox, Gimbel)",
        "url": "https://www.quickchords.org/charts/pop/roberta_flack_fox_gimbel/killing_me_softly_with_his_song?source=ireal"
      },
      {
        "title": "Knock On Wood",
        "artist": "Eddie Floyd (Floyd, Cropper)",
        "url": "https://www.quickchords.org/charts/pop/eddie_floyd_floyd_cropper/knock_on_wood?source=ireal"
      },
      {
        "title": "Knockin' On Heaven's Door",
        "artist": "Bob Dylan",
        "url": "https://www.quickchords.org/charts/pop/bob_dylan/knockin_on_heavens_door?source=ireal"
      },
      {
        "title": "Knocks Me Off My Feet ",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/knocks_me_off_my_feet_?source=ireal"
      },
      {
        "title": "Kodachrome",
        "artist": "Paul Simon",
        "url": "https://www.quickchords.org/charts/pop/paul_simon/kodachrome?source=ireal"
      },
      {
        "title": "Lady In My Life, The",
        "artist": "Michael Jackson (Rod Temperton)",
        "url": "https://www.quickchords.org/charts/pop/michael_jackson_rod_temperton/lady_in_my_life_the?source=ireal"
      },
      {
        "title": "Lady Valentine",
        "artist": "David Gates",
        "url": "https://www.quickchords.org/charts/pop/david_gates/lady_valentine?source=ireal"
      },
      {
        "title": "Lately",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/lately?source=ireal"
      },
      {
        "title": "Layla (Single)",
        "artist": "Eric Clapton (Clapton, Gordon)",
        "url": "https://www.quickchords.org/charts/pop/eric_clapton_clapton_gordon/layla_single?source=ireal"
      },
      {
        "title": "Le Jour Se Leve",
        "artist": "Patricia Kaas",
        "url": "https://www.quickchords.org/charts/pop/patricia_kaas/le_jour_se_leve?source=ireal"
      },
      {
        "title": "Let It Be",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/let_it_be?source=ireal"
      },
      {
        "title": "Let's Get It On",
        "artist": "Marvin Gaye",
        "url": "https://www.quickchords.org/charts/pop/marvin_gaye/lets_get_it_on?source=ireal"
      },
      {
        "title": "Let's Groove",
        "artist": "Earth, Wind and Fire (White, Vaughn)",
        "url": "https://www.quickchords.org/charts/pop/earth_wind_and_fire_white_vaughn/lets_groove?source=ireal"
      },
      {
        "title": "Let's Stay Together",
        "artist": "Al Green (Green-Mitchell-Jackson Jr.)",
        "url": "https://www.quickchords.org/charts/pop/al_green_greenmitchelljackson_jr/lets_stay_together?source=ireal"
      },
      {
        "title": "Letter, The",
        "artist": "The Box Tops (Wayne Carson Thompson)",
        "url": "https://www.quickchords.org/charts/pop/the_box_tops_wayne_carson_thompson/letter_the?source=ireal"
      },
      {
        "title": "Life On Mars",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/pop/david_bowie/life_on_mars?source=ireal"
      },
      {
        "title": "Light My Fire",
        "artist": "The Doors",
        "url": "https://www.quickchords.org/charts/pop/the_doors/light_my_fire?source=ireal"
      },
      {
        "title": "Like A Rolling Stone",
        "artist": "Bob Dylan",
        "url": "https://www.quickchords.org/charts/pop/bob_dylan/like_a_rolling_stone?source=ireal"
      },
      {
        "title": "Like A Star",
        "artist": "Rae Bailey Corinne",
        "url": "https://www.quickchords.org/charts/pop/rae_bailey_corinne/like_a_star?source=ireal"
      },
      {
        "title": "Like A Virgin",
        "artist": "Madonna Steinberg-Kelly)",
        "url": "https://www.quickchords.org/charts/pop/madonna_steinbergkelly/like_a_virgin?source=ireal"
      },
      {
        "title": "Little Green",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/little_green?source=ireal"
      },
      {
        "title": "Little Wing",
        "artist": "Jimi Hendrix",
        "url": "https://www.quickchords.org/charts/pop/jimi_hendrix/little_wing?source=ireal"
      },
      {
        "title": "Living For The City Page 1",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/living_for_the_city_page_1?source=ireal"
      },
      {
        "title": "Living For The City Page 2",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/living_for_the_city_page_2?source=ireal"
      },
      {
        "title": "Long And Winding Road",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/long_and_winding_road?source=ireal"
      },
      {
        "title": "Long Train Runnin'",
        "artist": "Doobie Brothers (Tom Johnston)",
        "url": "https://www.quickchords.org/charts/pop/doobie_brothers_tom_johnston/long_train_runnin?source=ireal"
      },
      {
        "title": "Longest Time, The",
        "artist": "Billy Joel",
        "url": "https://www.quickchords.org/charts/pop/billy_joel/longest_time_the?source=ireal"
      },
      {
        "title": "Love",
        "artist": "John Lennon",
        "url": "https://www.quickchords.org/charts/pop/john_lennon/love?source=ireal"
      },
      {
        "title": "Love and Happiness",
        "artist": "Hodges Green-Teenie Al",
        "url": "https://www.quickchords.org/charts/pop/hodges_greenteenie_al/love_and_happiness?source=ireal"
      },
      {
        "title": "Love Is All Around",
        "artist": "The Troggs (Reg Presley)",
        "url": "https://www.quickchords.org/charts/pop/the_troggs_reg_presley/love_is_all_around?source=ireal"
      },
      {
        "title": "Love Me Tender",
        "artist": "Elvis Presley (Presley-Matson)",
        "url": "https://www.quickchords.org/charts/pop/elvis_presley_presleymatson/love_me_tender?source=ireal"
      },
      {
        "title": "Love To Love You Less",
        "artist": "Nikka Costa",
        "url": "https://www.quickchords.org/charts/pop/nikka_costa/love_to_love_you_less?source=ireal"
      },
      {
        "title": "Love's In Need Of LoveToday",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/loves_in_need_of_lovetoday?source=ireal"
      },
      {
        "title": "Lovely Day",
        "artist": "Bill Withers (Withers, Scarborough)",
        "url": "https://www.quickchords.org/charts/pop/bill_withers_withers_scarborough/lovely_day?source=ireal"
      },
      {
        "title": "Mademoiselle Chante Le Blues",
        "artist": "Patricia Kaas (Barbelivien, Medhi)",
        "url": "https://www.quickchords.org/charts/pop/patricia_kaas_barbelivien_medhi/mademoiselle_chante_le_blues?source=ireal"
      },
      {
        "title": "Maggie May",
        "artist": "Rod Stewart (Stewart, Quittenton)",
        "url": "https://www.quickchords.org/charts/pop/rod_stewart_stewart_quittenton/maggie_may?source=ireal"
      },
      {
        "title": "Mama Told Me (Not To Come)",
        "artist": "Three Dog Night (Randy Newman)",
        "url": "https://www.quickchords.org/charts/pop/three_dog_night_randy_newman/mama_told_me_not_to_come?source=ireal"
      },
      {
        "title": "Mary Jane's Last Dance",
        "artist": "Tom Petty",
        "url": "https://www.quickchords.org/charts/pop/tom_petty/mary_janes_last_dance?source=ireal"
      },
      {
        "title": "Massachusetts",
        "artist": "Bee Gees (Gibb-Gibb-Gibb)",
        "url": "https://www.quickchords.org/charts/pop/bee_gees_gibbgibbgibb/massachusetts?source=ireal"
      },
      {
        "title": "Me And Mrs. Jones",
        "artist": "Billy Paul (Gamble, Huff, Gilbert)",
        "url": "https://www.quickchords.org/charts/pop/billy_paul_gamble_huff_gilbert/me_and_mrs_jones?source=ireal"
      },
      {
        "title": "Mercy",
        "artist": "Duffy (Duffy, Booker)",
        "url": "https://www.quickchords.org/charts/pop/duffy_duffy_booker/mercy?source=ireal"
      },
      {
        "title": "Michelle",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/michelle?source=ireal"
      },
      {
        "title": "Midnight At The Oasis",
        "artist": "Maria Muldaur (David Nichtern)",
        "url": "https://www.quickchords.org/charts/pop/maria_muldaur_david_nichtern/midnight_at_the_oasis?source=ireal"
      },
      {
        "title": "Midnight Train To Georgia",
        "artist": "Gladys Knight and The Pips (Jim Weatherly)",
        "url": "https://www.quickchords.org/charts/pop/gladys_knight_and_the_pips_jim_weatherly/midnight_train_to_georgia?source=ireal"
      },
      {
        "title": "Mon Mec A Moi",
        "artist": "Kaas (Barbelivien-Bernheim)",
        "url": "https://www.quickchords.org/charts/pop/kaas_barbelivienbernheim/mon_mec_a_moi?source=ireal"
      },
      {
        "title": "Moon Over Bourbon Street",
        "artist": "Sting",
        "url": "https://www.quickchords.org/charts/pop/sting/moon_over_bourbon_street?source=ireal"
      },
      {
        "title": "Moondance 1",
        "artist": "Van Morrison",
        "url": "https://www.quickchords.org/charts/pop/van_morrison/moondance_1?source=ireal"
      },
      {
        "title": "More Than One Way Home",
        "artist": "Keb' Mo' (Lewis Parker-Moore)",
        "url": "https://www.quickchords.org/charts/pop/keb_mo_lewis_parkermoore/more_than_one_way_home?source=ireal"
      },
      {
        "title": "Morning MorganTown",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/morning_morgantown?source=ireal"
      },
      {
        "title": "Mustang Sally ",
        "artist": "Wilson Pickett (Mack Rice)",
        "url": "https://www.quickchords.org/charts/pop/wilson_pickett_mack_rice/mustang_sally_?source=ireal"
      },
      {
        "title": "My Cherie Amour",
        "artist": "Stevie Wonder (Wonder, Cosby, Moy)",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder_wonder_cosby_moy/my_cherie_amour?source=ireal"
      },
      {
        "title": "My Girl",
        "artist": "The Temptations (Robinson, White)",
        "url": "https://www.quickchords.org/charts/pop/the_temptations_robinson_white/my_girl?source=ireal"
      },
      {
        "title": "My Immortal",
        "artist": "Evanescence Moody-Lee)",
        "url": "https://www.quickchords.org/charts/pop/evanescence_moodylee/my_immortal?source=ireal"
      },
      {
        "title": "Na Na Hey Hey Kiss Him Goodbye",
        "artist": "Steam Leka-Frashuer-DeCarlo)",
        "url": "https://www.quickchords.org/charts/pop/steam_lekafrashuerdecarlo/na_na_hey_hey_kiss_him_goodbye?source=ireal"
      },
      {
        "title": "Natural Woman (You Make Me Feel Like)",
        "artist": "Aretha Franklin (Goffin, King, Wexler)",
        "url": "https://www.quickchords.org/charts/pop/aretha_franklin_goffin_king_wexler/natural_woman_you_make_me_feel_like?source=ireal"
      },
      {
        "title": "Never Dreamed You'd Leave In Summer",
        "artist": "Stevie Wonder (Wonder, Wright)",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder_wonder_wright/never_dreamed_youd_leave_in_summer?source=ireal"
      },
      {
        "title": "Never Saw Blue Like That",
        "artist": "Shawn Colvin",
        "url": "https://www.quickchords.org/charts/pop/shawn_colvin/never_saw_blue_like_that?source=ireal"
      },
      {
        "title": "New York State Of Mind",
        "artist": "Billy Joel",
        "url": "https://www.quickchords.org/charts/pop/billy_joel/new_york_state_of_mind?source=ireal"
      },
      {
        "title": "Night Fever",
        "artist": "Bee Gees (Gibb-Gibb-Gibb)",
        "url": "https://www.quickchords.org/charts/pop/bee_gees_gibbgibbgibb/night_fever?source=ireal"
      },
      {
        "title": "Nikita",
        "artist": "Elton John (John-Taupin)",
        "url": "https://www.quickchords.org/charts/pop/elton_john_johntaupin/nikita?source=ireal"
      },
      {
        "title": "No Woman, No Cry",
        "artist": "Bob Marley (Vincent Ford)",
        "url": "https://www.quickchords.org/charts/pop/bob_marley_vincent_ford/no_woman_no_cry?source=ireal"
      },
      {
        "title": "Northern Sky",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/northern_sky?source=ireal"
      },
      {
        "title": "Norwegian Wood",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/norwegian_wood?source=ireal"
      },
      {
        "title": "Nothing Rhymed",
        "artist": "Gilbert O'Sullivan",
        "url": "https://www.quickchords.org/charts/pop/gilbert_osullivan/nothing_rhymed?source=ireal"
      },
      {
        "title": "Nowhere Man",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/nowhere_man?source=ireal"
      },
      {
        "title": "Oceania",
        "artist": "Björk (Björk, Sjon)",
        "url": "https://www.quickchords.org/charts/pop/bjrk_bjrk_sjon/oceania?source=ireal"
      },
      {
        "title": "Oh! Darling",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/oh_darling?source=ireal"
      },
      {
        "title": "Ol' 55",
        "artist": "Tom Waits",
        "url": "https://www.quickchords.org/charts/pop/tom_waits/ol_55?source=ireal"
      },
      {
        "title": "Old Love",
        "artist": "Clapton Eric/Cray Robert",
        "url": "https://www.quickchords.org/charts/pop/clapton_ericcray_robert/old_love?source=ireal"
      },
      {
        "title": "One",
        "artist": "U2",
        "url": "https://www.quickchords.org/charts/pop/u2/one?source=ireal"
      },
      {
        "title": "One Day I'll Fly Away",
        "artist": "Randy Crawford (Sample-Jennings)",
        "url": "https://www.quickchords.org/charts/pop/randy_crawford_samplejennings/one_day_ill_fly_away?source=ireal"
      },
      {
        "title": "One Hundred Ways",
        "artist": "James Ingram (Wakefield-Wright-Coleman)",
        "url": "https://www.quickchords.org/charts/pop/james_ingram_wakefieldwrightcoleman/one_hundred_ways?source=ireal"
      },
      {
        "title": "One Of These Things First",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/one_of_these_things_first?source=ireal"
      },
      {
        "title": "Only the Lonely (Know the Way I Feel)",
        "artist": "Roy Orbison (Orbison-Melson)",
        "url": "https://www.quickchords.org/charts/pop/roy_orbison_orbisonmelson/only_the_lonely_know_the_way_i_feel?source=ireal"
      },
      {
        "title": "Ordinary People",
        "artist": "John Legend (Legend, will i am)",
        "url": "https://www.quickchords.org/charts/pop/john_legend_legend_will_i_am/ordinary_people?source=ireal"
      },
      {
        "title": "Overjoyed",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/overjoyed?source=ireal"
      },
      {
        "title": "Pagan Poetry",
        "artist": "Björk",
        "url": "https://www.quickchords.org/charts/pop/bjrk/pagan_poetry?source=ireal"
      },
      {
        "title": "Papa Was A Rollin' Stone",
        "artist": "The Temptations (Whitfield-Strong)",
        "url": "https://www.quickchords.org/charts/pop/the_temptations_whitfieldstrong/papa_was_a_rollin_stone?source=ireal"
      },
      {
        "title": "Papa's Got A Brand New Bag",
        "artist": "James Brown",
        "url": "https://www.quickchords.org/charts/pop/james_brown/papas_got_a_brand_new_bag?source=ireal"
      },
      {
        "title": "Pearls",
        "artist": "Sade (Adu, Hale)",
        "url": "https://www.quickchords.org/charts/pop/sade_adu_hale/pearls?source=ireal"
      },
      {
        "title": "Penny Lane",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/penny_lane?source=ireal"
      },
      {
        "title": "People Make The World Go Round",
        "artist": "Stylistics (Creed-Bell)",
        "url": "https://www.quickchords.org/charts/pop/stylistics_creedbell/people_make_the_world_go_round?source=ireal"
      },
      {
        "title": "Piece of my heart",
        "artist": "Janis Joplin (Ragovoy-Berns)",
        "url": "https://www.quickchords.org/charts/pop/janis_joplin_ragovoyberns/piece_of_my_heart?source=ireal"
      },
      {
        "title": "Pigs On the Wing",
        "artist": "Pink Floyd (Roger Waters)",
        "url": "https://www.quickchords.org/charts/pop/pink_floyd_roger_waters/pigs_on_the_wing?source=ireal"
      },
      {
        "title": "Pleasant Valley Sunday",
        "artist": "The Monkees (Goffin-King)",
        "url": "https://www.quickchords.org/charts/pop/the_monkees_goffinking/pleasant_valley_sunday?source=ireal"
      },
      {
        "title": "Please Send Me Someone To Love",
        "artist": "Percy Mayfield",
        "url": "https://www.quickchords.org/charts/pop/percy_mayfield/please_send_me_someone_to_love?source=ireal"
      },
      {
        "title": "Poetry Man",
        "artist": "Phoebe Snow",
        "url": "https://www.quickchords.org/charts/pop/phoebe_snow/poetry_man?source=ireal"
      },
      {
        "title": "Poker Face",
        "artist": "Lady Gaga (Germanotta, Khayat)",
        "url": "https://www.quickchords.org/charts/pop/lady_gaga_germanotta_khayat/poker_face?source=ireal"
      },
      {
        "title": "Put your records on",
        "artist": "Corinne Bailey Rae (Bailey Rae-Chrisanthou-Beck)",
        "url": "https://www.quickchords.org/charts/pop/corinne_bailey_rae_bailey_raechrisanthoubeck/put_your_records_on?source=ireal"
      },
      {
        "title": "Rainbow Connection, The 1",
        "artist": "Williams P./Ascher K.",
        "url": "https://www.quickchords.org/charts/pop/williams_pascher_k/rainbow_connection_the_1?source=ireal"
      },
      {
        "title": "Rehab",
        "artist": "Amy Winehouse",
        "url": "https://www.quickchords.org/charts/pop/amy_winehouse/rehab?source=ireal"
      },
      {
        "title": "Reminiscing",
        "artist": "Little River Band (Graeham Goble)",
        "url": "https://www.quickchords.org/charts/pop/little_river_band_graeham_goble/reminiscing?source=ireal"
      },
      {
        "title": "Respect",
        "artist": "Aretha Franklin (Shannon, Redding)",
        "url": "https://www.quickchords.org/charts/pop/aretha_franklin_shannon_redding/respect?source=ireal"
      },
      {
        "title": "Ribbon In The Sky",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/ribbon_in_the_sky?source=ireal"
      },
      {
        "title": "River",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/river?source=ireal"
      },
      {
        "title": "River Man",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/river_man?source=ireal"
      },
      {
        "title": "Rock With  You",
        "artist": "Michael Jackson (Rod Temperton)",
        "url": "https://www.quickchords.org/charts/pop/michael_jackson_rod_temperton/rock_with__you?source=ireal"
      },
      {
        "title": "Rocket Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/rocket_love?source=ireal"
      },
      {
        "title": "Rocket Man",
        "artist": "Elton John (John, Taupin)",
        "url": "https://www.quickchords.org/charts/pop/elton_john_john_taupin/rocket_man?source=ireal"
      },
      {
        "title": "Rolling In The Deep",
        "artist": "Adele Atkins-Epworth)",
        "url": "https://www.quickchords.org/charts/pop/adele_atkinsepworth/rolling_in_the_deep?source=ireal"
      },
      {
        "title": "Rose, The",
        "artist": "Bette Midler (Amanda McBroom)",
        "url": "https://www.quickchords.org/charts/pop/bette_midler_amanda_mcbroom/rose_the?source=ireal"
      },
      {
        "title": "Roxanne",
        "artist": "The Police (Sting)",
        "url": "https://www.quickchords.org/charts/pop/the_police_sting/roxanne?source=ireal"
      },
      {
        "title": "Santeria",
        "artist": "Sublime Nowell)",
        "url": "https://www.quickchords.org/charts/pop/sublime_nowell/santeria?source=ireal"
      },
      {
        "title": "Saturday In The Park",
        "artist": "Chicago (Robert Lamm)",
        "url": "https://www.quickchords.org/charts/pop/chicago_robert_lamm/saturday_in_the_park?source=ireal"
      },
      {
        "title": "Saturday Sun",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/saturday_sun?source=ireal"
      },
      {
        "title": "Saucerful of Secrets, A",
        "artist": "Pink Floyd (Waters, Gilmour, Mason, Wright)",
        "url": "https://www.quickchords.org/charts/pop/pink_floyd_waters_gilmour_mason_wright/saucerful_of_secrets_a?source=ireal"
      },
      {
        "title": "Save Me",
        "artist": "Queen (Brian May)",
        "url": "https://www.quickchords.org/charts/pop/queen_brian_may/save_me?source=ireal"
      },
      {
        "title": "Save The Last Dance For Me",
        "artist": "The Drifters (Pomus-Shuman)",
        "url": "https://www.quickchords.org/charts/pop/the_drifters_pomusshuman/save_the_last_dance_for_me?source=ireal"
      },
      {
        "title": "Saving All My Love For You",
        "artist": "Whitney Houston (Goffin, Masser)",
        "url": "https://www.quickchords.org/charts/pop/whitney_houston_goffin_masser/saving_all_my_love_for_you?source=ireal"
      },
      {
        "title": "Scarborough Fair",
        "artist": "Garfunkel and Simon",
        "url": "https://www.quickchords.org/charts/pop/garfunkel_and_simon/scarborough_fair?source=ireal"
      },
      {
        "title": "Scatterbrain",
        "artist": "Jeff Beck",
        "url": "https://www.quickchords.org/charts/pop/jeff_beck/scatterbrain?source=ireal"
      },
      {
        "title": "Scientist, The",
        "artist": "Coldplay (Berryman, Buckland, Champion, Martin)",
        "url": "https://www.quickchords.org/charts/pop/coldplay_berryman_buckland_champion_martin/scientist_the?source=ireal"
      },
      {
        "title": "See Emily Play",
        "artist": "Pink Floyd (Syd Barrett)",
        "url": "https://www.quickchords.org/charts/pop/pink_floyd_syd_barrett/see_emily_play?source=ireal"
      },
      {
        "title": "September",
        "artist": "Earth, Wind and Fire (Willis, White, Mckay)",
        "url": "https://www.quickchords.org/charts/pop/earth_wind_and_fire_willis_white_mckay/september?source=ireal"
      },
      {
        "title": "Set The Controls For The Heart Of The Sun",
        "artist": "Pink Floyd (Roger Waters)",
        "url": "https://www.quickchords.org/charts/pop/pink_floyd_roger_waters/set_the_controls_for_the_heart_of_the_sun?source=ireal"
      },
      {
        "title": "Seven Days",
        "artist": "Sting (Gordon Sumner)",
        "url": "https://www.quickchords.org/charts/pop/sting_gordon_sumner/seven_days?source=ireal"
      },
      {
        "title": "Sexy Sadie",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/sexy_sadie?source=ireal"
      },
      {
        "title": "She",
        "artist": "Charles Aznavour (Aznavour, Kretzner)",
        "url": "https://www.quickchords.org/charts/pop/charles_aznavour_aznavour_kretzner/she?source=ireal"
      },
      {
        "title": "She Will Be Loved",
        "artist": "Maroon 5 (Levine-Valentine)",
        "url": "https://www.quickchords.org/charts/pop/maroon_5_levinevalentine/she_will_be_loved?source=ireal"
      },
      {
        "title": "She's Always A Woman Part 1",
        "artist": "Billy Joel",
        "url": "https://www.quickchords.org/charts/pop/billy_joel/shes_always_a_woman_part_1?source=ireal"
      },
      {
        "title": "She's Always A Woman Part 2",
        "artist": "Billy Joel",
        "url": "https://www.quickchords.org/charts/pop/billy_joel/shes_always_a_woman_part_2?source=ireal"
      },
      {
        "title": "Shoop Shoop Song (It's in His Kiss), The",
        "artist": "Betty Everett (Rudy Clark)",
        "url": "https://www.quickchords.org/charts/pop/betty_everett_rudy_clark/shoop_shoop_song_its_in_his_kiss_the?source=ireal"
      },
      {
        "title": "Shout",
        "artist": "Brothers Isley The",
        "url": "https://www.quickchords.org/charts/pop/brothers_isley_the/shout?source=ireal"
      },
      {
        "title": "Sir Duke",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/sir_duke?source=ireal"
      },
      {
        "title": "Sister Moon",
        "artist": "Sting (Gordon Sumner)",
        "url": "https://www.quickchords.org/charts/pop/sting_gordon_sumner/sister_moon?source=ireal"
      },
      {
        "title": "Sitting On The Dock Of The Bay",
        "artist": "Otis Redding (Redding, Cropper)",
        "url": "https://www.quickchords.org/charts/pop/otis_redding_redding_cropper/sitting_on_the_dock_of_the_bay?source=ireal"
      },
      {
        "title": "So Amazing",
        "artist": "Luther Vandross",
        "url": "https://www.quickchords.org/charts/pop/luther_vandross/so_amazing?source=ireal"
      },
      {
        "title": "So High",
        "artist": "John Legend (Legend-Harris-Hill)",
        "url": "https://www.quickchords.org/charts/pop/john_legend_legendharrishill/so_high?source=ireal"
      },
      {
        "title": "So Real",
        "artist": "Jeff Buckley",
        "url": "https://www.quickchords.org/charts/pop/jeff_buckley/so_real?source=ireal"
      },
      {
        "title": "Some Kinda Wonderful",
        "artist": "Grand Funk Railroad (John Ellison)",
        "url": "https://www.quickchords.org/charts/pop/grand_funk_railroad_john_ellison/some_kinda_wonderful?source=ireal"
      },
      {
        "title": "Somebody To Love",
        "artist": "Queen (Freddie Mercury)",
        "url": "https://www.quickchords.org/charts/pop/queen_freddie_mercury/somebody_to_love?source=ireal"
      },
      {
        "title": "Something",
        "artist": "The Beatles (George Harrison)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_george_harrison/something?source=ireal"
      },
      {
        "title": "Son Of A Preacher Man",
        "artist": "Dusty Springfield (Hurley, Wilkins)",
        "url": "https://www.quickchords.org/charts/pop/dusty_springfield_hurley_wilkins/son_of_a_preacher_man?source=ireal"
      },
      {
        "title": "Son Of Mr. Green Genes",
        "artist": "Frank Zappa",
        "url": "https://www.quickchords.org/charts/pop/frank_zappa/son_of_mr_green_genes?source=ireal"
      },
      {
        "title": "Song For You, A",
        "artist": "Leon Russell",
        "url": "https://www.quickchords.org/charts/pop/leon_russell/song_for_you_a?source=ireal"
      },
      {
        "title": "Sound of Silence, The",
        "artist": "Simon and Garfunkel (Paul Simon)",
        "url": "https://www.quickchords.org/charts/pop/simon_and_garfunkel_paul_simon/sound_of_silence_the?source=ireal"
      },
      {
        "title": "Stand By Me",
        "artist": "Ben E. King (King, Leiber, Stoller)",
        "url": "https://www.quickchords.org/charts/pop/ben_e_king_king_leiber_stoller/stand_by_me?source=ireal"
      },
      {
        "title": "Stayin' Alive",
        "artist": "Bee Gees (Gibb-Gibb-Gibb)",
        "url": "https://www.quickchords.org/charts/pop/bee_gees_gibbgibbgibb/stayin_alive?source=ireal"
      },
      {
        "title": "Still A Friend Of Mine",
        "artist": "Incognito (Maunick, Jean, Bull, Richard)",
        "url": "https://www.quickchords.org/charts/pop/incognito_maunick_jean_bull_richard/still_a_friend_of_mine?source=ireal"
      },
      {
        "title": "Still Got The Blues",
        "artist": "Gary Moore",
        "url": "https://www.quickchords.org/charts/pop/gary_moore/still_got_the_blues?source=ireal"
      },
      {
        "title": "Street Life",
        "artist": "The Crusaders (Sample-Jennings)",
        "url": "https://www.quickchords.org/charts/pop/the_crusaders_samplejennings/street_life?source=ireal"
      },
      {
        "title": "Summer In The City",
        "artist": "The Lovin' Spoonful (Sebastian-Boone-Sebastian)",
        "url": "https://www.quickchords.org/charts/pop/the_lovin_spoonful_sebastianboonesebastian/summer_in_the_city?source=ireal"
      },
      {
        "title": "Summer Of '69",
        "artist": "Bryan Adams (Adams, Vallance)",
        "url": "https://www.quickchords.org/charts/pop/bryan_adams_adams_vallance/summer_of_69?source=ireal"
      },
      {
        "title": "Sun Goddess",
        "artist": "Earth, Wind and Fire-Ramsey Lewis (Lind-White)",
        "url": "https://www.quickchords.org/charts/pop/earth_wind_and_fireramsey_lewis_lindwhite/sun_goddess?source=ireal"
      },
      {
        "title": "Sunshine Of Your Love, The",
        "artist": "Cream Bruce-Brown-Clapton)",
        "url": "https://www.quickchords.org/charts/pop/cream_brucebrownclapton/sunshine_of_your_love_the?source=ireal"
      },
      {
        "title": "Superstar",
        "artist": "The Carpenters (Russell, Bramlett)",
        "url": "https://www.quickchords.org/charts/pop/the_carpenters_russell_bramlett/superstar?source=ireal"
      },
      {
        "title": "Superstition",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/superstition?source=ireal"
      },
      {
        "title": "Surfin' USA",
        "artist": "The Beach Boys (Berry-Wilson)",
        "url": "https://www.quickchords.org/charts/pop/the_beach_boys_berrywilson/surfin_usa?source=ireal"
      },
      {
        "title": "Sweet Caroline",
        "artist": "Neil Diamond",
        "url": "https://www.quickchords.org/charts/pop/neil_diamond/sweet_caroline?source=ireal"
      },
      {
        "title": "Sweet Love",
        "artist": "Anita Baker (Baker, Johnson, Bias)",
        "url": "https://www.quickchords.org/charts/pop/anita_baker_baker_johnson_bias/sweet_love?source=ireal"
      },
      {
        "title": "Tears In Heaven",
        "artist": "Eric Clapton",
        "url": "https://www.quickchords.org/charts/pop/eric_clapton/tears_in_heaven?source=ireal"
      },
      {
        "title": "Tell Me Something Good",
        "artist": "Rufus and Chaka Khan (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/pop/rufus_and_chaka_khan_stevie_wonder/tell_me_something_good?source=ireal"
      },
      {
        "title": "Tequila",
        "artist": "The Champs (Daniel Flores)",
        "url": "https://www.quickchords.org/charts/pop/the_champs_daniel_flores/tequila?source=ireal"
      },
      {
        "title": "That's The Way Of The World",
        "artist": "Earth, Wind and Fire (White-Stepney-White)",
        "url": "https://www.quickchords.org/charts/pop/earth_wind_and_fire_whitestepneywhite/thats_the_way_of_the_world?source=ireal"
      },
      {
        "title": "That's What Friends Are For",
        "artist": "Dionne Warwick and Friends (Bacharach, Sager)",
        "url": "https://www.quickchords.org/charts/pop/dionne_warwick_and_friends_bacharach_sager/thats_what_friends_are_for?source=ireal"
      },
      {
        "title": "Think",
        "artist": "Aretha Franklin (Franklin, White)",
        "url": "https://www.quickchords.org/charts/pop/aretha_franklin_franklin_white/think?source=ireal"
      },
      {
        "title": "Three Hours",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/three_hours?source=ireal"
      },
      {
        "title": "Tie A Yellow Ribbon",
        "artist": "Dawn (Levine, Brown)",
        "url": "https://www.quickchords.org/charts/pop/dawn_levine_brown/tie_a_yellow_ribbon?source=ireal"
      },
      {
        "title": "Time",
        "artist": "Pink Floyd (Gilmour, Mason, Waters, White)",
        "url": "https://www.quickchords.org/charts/pop/pink_floyd_gilmour_mason_waters_white/time?source=ireal"
      },
      {
        "title": "Time After Time (Cyndi Lauper)",
        "artist": "Cyndi Lauper (Lauper, Hyman)",
        "url": "https://www.quickchords.org/charts/pop/cyndi_lauper_lauper_hyman/time_after_time_cyndi_lauper?source=ireal"
      },
      {
        "title": "Time Has Told Me",
        "artist": "Nick Drake",
        "url": "https://www.quickchords.org/charts/pop/nick_drake/time_has_told_me?source=ireal"
      },
      {
        "title": "To Be With You",
        "artist": "Mr.Big Martin-Grahame)",
        "url": "https://www.quickchords.org/charts/pop/mrbig_martingrahame/to_be_with_you?source=ireal"
      },
      {
        "title": "To Love Somebody",
        "artist": "Bee Gees (Barry Gibb-Robin Gibb)",
        "url": "https://www.quickchords.org/charts/pop/bee_gees_barry_gibbrobin_gibb/to_love_somebody?source=ireal"
      },
      {
        "title": "To Make You Feel My Love",
        "artist": "Bob Dylan",
        "url": "https://www.quickchords.org/charts/pop/bob_dylan/to_make_you_feel_my_love?source=ireal"
      },
      {
        "title": "Too Shy To Say",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/too_shy_to_say?source=ireal"
      },
      {
        "title": "Top Of The World",
        "artist": "The Carpenters (Carpenter, Bettis)",
        "url": "https://www.quickchords.org/charts/pop/the_carpenters_carpenter_bettis/top_of_the_world?source=ireal"
      },
      {
        "title": "Twist and Shout",
        "artist": "The Beatles (Medley-Russell)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_medleyrussell/twist_and_shout?source=ireal"
      },
      {
        "title": "Umbrella",
        "artist": "Rihanna Jay-Z-Harrell-Nash-Stewart)",
        "url": "https://www.quickchords.org/charts/pop/rihanna_jayzharrellnashstewart/umbrella?source=ireal"
      },
      {
        "title": "Un-Break My Heart",
        "artist": "Toni Braxton (Diane Warren)",
        "url": "https://www.quickchords.org/charts/pop/toni_braxton_diane_warren/unbreak_my_heart?source=ireal"
      },
      {
        "title": "Unchained Melody",
        "artist": "The Righteous Brothers (North-Zaret)",
        "url": "https://www.quickchords.org/charts/pop/the_righteous_brothers_northzaret/unchained_melody?source=ireal"
      },
      {
        "title": "Uninvited",
        "artist": "Alanis Morissette",
        "url": "https://www.quickchords.org/charts/pop/alanis_morissette/uninvited?source=ireal"
      },
      {
        "title": "Venus As A Boy",
        "artist": "Björk",
        "url": "https://www.quickchords.org/charts/pop/bjrk/venus_as_a_boy?source=ireal"
      },
      {
        "title": "Virtual Insanity",
        "artist": "Jamiroquai Kay-Smith)",
        "url": "https://www.quickchords.org/charts/pop/jamiroquai_kaysmith/virtual_insanity?source=ireal"
      },
      {
        "title": "Waiting On The World To Change",
        "artist": "John Mayer",
        "url": "https://www.quickchords.org/charts/pop/john_mayer/waiting_on_the_world_to_change?source=ireal"
      },
      {
        "title": "Wake Me Up Before You Go-Go",
        "artist": "Wham! (George Michael)",
        "url": "https://www.quickchords.org/charts/pop/wham_george_michael/wake_me_up_before_you_gogo?source=ireal"
      },
      {
        "title": "Walk On By",
        "artist": "Dionne Warwick (Bacharach-David)",
        "url": "https://www.quickchords.org/charts/pop/dionne_warwick_bacharachdavid/walk_on_by?source=ireal"
      },
      {
        "title": "Walking On Sunshine",
        "artist": "Katrina And The Waves (Kimberley Rew)",
        "url": "https://www.quickchords.org/charts/pop/katrina_and_the_waves_kimberley_rew/walking_on_sunshine?source=ireal"
      },
      {
        "title": "Walking Spanish",
        "artist": "Tom Waits",
        "url": "https://www.quickchords.org/charts/pop/tom_waits/walking_spanish?source=ireal"
      },
      {
        "title": "Warwick Avenue",
        "artist": "Duffy Duffy-Hogarth-White)",
        "url": "https://www.quickchords.org/charts/pop/duffy_duffyhogarthwhite/warwick_avenue?source=ireal"
      },
      {
        "title": "We Are The Champions",
        "artist": "Queen (Freddie Mercury)",
        "url": "https://www.quickchords.org/charts/pop/queen_freddie_mercury/we_are_the_champions?source=ireal"
      },
      {
        "title": "We Weren't Born To Follow",
        "artist": "Bon Jovi (Bon Jovi, Sambora)",
        "url": "https://www.quickchords.org/charts/pop/bon_jovi_bon_jovi_sambora/we_werent_born_to_follow?source=ireal"
      },
      {
        "title": "We've Only Just Begun",
        "artist": "The Carpenters (Williams, Nichols)",
        "url": "https://www.quickchords.org/charts/pop/the_carpenters_williams_nichols/weve_only_just_begun?source=ireal"
      },
      {
        "title": "What'd I Say",
        "artist": "Ray Charles",
        "url": "https://www.quickchords.org/charts/pop/ray_charles/whatd_i_say?source=ireal"
      },
      {
        "title": "What's Going On",
        "artist": "Marvin Gaye (Benson, Cleveland, Gaye)",
        "url": "https://www.quickchords.org/charts/pop/marvin_gaye_benson_cleveland_gaye/whats_going_on?source=ireal"
      },
      {
        "title": "What's Love Got To Do With It",
        "artist": "Tina Turner (Lyle, Britten)",
        "url": "https://www.quickchords.org/charts/pop/tina_turner_lyle_britten/whats_love_got_to_do_with_it?source=ireal"
      },
      {
        "title": "When I Give My Love To You",
        "artist": "Michael Franks",
        "url": "https://www.quickchords.org/charts/pop/michael_franks/when_i_give_my_love_to_you?source=ireal"
      },
      {
        "title": "When I'm 64",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/when_im_64?source=ireal"
      },
      {
        "title": "Where Did Our Love Go",
        "artist": "The Supremes (Holland–Dozier–Holland)",
        "url": "https://www.quickchords.org/charts/pop/the_supremes_hollanddozierholland/where_did_our_love_go?source=ireal"
      },
      {
        "title": "While My Guitar Gently Weeps",
        "artist": "The Beatles (George Harrison)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_george_harrison/while_my_guitar_gently_weeps?source=ireal"
      },
      {
        "title": "Whiter Shade of Pale, A ",
        "artist": "Procol Harum (Brooker-Fisher-Reid)",
        "url": "https://www.quickchords.org/charts/pop/procol_harum_brookerfisherreid/whiter_shade_of_pale_a_?source=ireal"
      },
      {
        "title": "Who Says",
        "artist": "John Mayer",
        "url": "https://www.quickchords.org/charts/pop/john_mayer/who_says?source=ireal"
      },
      {
        "title": "Wild Thing",
        "artist": "The Troggs (Chip Taylor)",
        "url": "https://www.quickchords.org/charts/pop/the_troggs_chip_taylor/wild_thing?source=ireal"
      },
      {
        "title": "Will You Still Love Me Tomorrow",
        "artist": "Carole King",
        "url": "https://www.quickchords.org/charts/pop/carole_king/will_you_still_love_me_tomorrow?source=ireal"
      },
      {
        "title": "Wives And Lovers 1",
        "artist": "Jack Jones (Bacharach, David)",
        "url": "https://www.quickchords.org/charts/pop/jack_jones_bacharach_david/wives_and_lovers_1?source=ireal"
      },
      {
        "title": "Woman",
        "artist": "John Lennon",
        "url": "https://www.quickchords.org/charts/pop/john_lennon/woman?source=ireal"
      },
      {
        "title": "Woman In Love",
        "artist": "Barbra Streisand (Gibb-Gibb)",
        "url": "https://www.quickchords.org/charts/pop/barbra_streisand_gibbgibb/woman_in_love?source=ireal"
      },
      {
        "title": "Wonderful Tonight",
        "artist": "Eric Clapton",
        "url": "https://www.quickchords.org/charts/pop/eric_clapton/wonderful_tonight?source=ireal"
      },
      {
        "title": "Wonderwall",
        "artist": "Oasis (Noel Gallagher)",
        "url": "https://www.quickchords.org/charts/pop/oasis_noel_gallagher/wonderwall?source=ireal"
      },
      {
        "title": "Woodstock",
        "artist": "Joni Mitchell",
        "url": "https://www.quickchords.org/charts/pop/joni_mitchell/woodstock?source=ireal"
      },
      {
        "title": "Word, The",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/word_the?source=ireal"
      },
      {
        "title": "Yellow",
        "artist": "Coldplay (Berryman, Buckland, Champion, Martin)",
        "url": "https://www.quickchords.org/charts/pop/coldplay_berryman_buckland_champion_martin/yellow?source=ireal"
      },
      {
        "title": "Yesterday",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/pop/the_beatles_lennon_mccartney/yesterday?source=ireal"
      },
      {
        "title": "Yesterday Once More",
        "artist": "The Carpenters (Carpenter, Bettis)",
        "url": "https://www.quickchords.org/charts/pop/the_carpenters_carpenter_bettis/yesterday_once_more?source=ireal"
      },
      {
        "title": "You Are So Beautiful",
        "artist": "Joe Cocker (Preston, Fisher, Wilson)",
        "url": "https://www.quickchords.org/charts/pop/joe_cocker_preston_fisher_wilson/you_are_so_beautiful?source=ireal"
      },
      {
        "title": "You Are The Sunshine Of My Life",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/pop/stevie_wonder/you_are_the_sunshine_of_my_life?source=ireal"
      },
      {
        "title": "You Sexy Thing",
        "artist": "Hot Chocolate (Wilson, Brown)",
        "url": "https://www.quickchords.org/charts/pop/hot_chocolate_wilson_brown/you_sexy_thing?source=ireal"
      },
      {
        "title": "You Take My Breath Away",
        "artist": "Queen (Freddie Mercury)",
        "url": "https://www.quickchords.org/charts/pop/queen_freddie_mercury/you_take_my_breath_away?source=ireal"
      },
      {
        "title": "You've Got A Friend",
        "artist": "Carole King",
        "url": "https://www.quickchords.org/charts/pop/carole_king/youve_got_a_friend?source=ireal"
      },
      {
        "title": "You've Lost That Lovin' Feelin'",
        "artist": "The Righteous Brothers (Spector, Mann, Weil)",
        "url": "https://www.quickchords.org/charts/pop/the_righteous_brothers_spector_mann_weil/youve_lost_that_lovin_feelin?source=ireal"
      },
      {
        "title": "Your song",
        "artist": "Elton John (John, Taupin)",
        "url": "https://www.quickchords.org/charts/pop/elton_john_john_taupin/your_song?source=ireal"
      }
    ]
  },
  {
    "title": "Reggae",
    "items": [
      {
        "title": "Stir It Up",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/stir_it_up?source=ireal"
      },
      {
        "title": "No Woman, No Cry",
        "artist": "Marley,Bob (Vincent_Ford)",
        "url": "https://www.quickchords.org/charts/reggae/marleybob_vincent_ford/no_woman_no_cry?source=ireal"
      },
      {
        "title": "Could You Be Loved",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/could_you_be_loved?source=ireal"
      },
      {
        "title": "Is This Love?",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/is_this_love?source=ireal"
      },
      {
        "title": "Turn Your Lights Down Low",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/turn_your_lights_down_low?source=ireal"
      },
      {
        "title": "I Shot The Sheriff",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/i_shot_the_sheriff?source=ireal"
      },
      {
        "title": "Three Little Birds",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/three_little_birds?source=ireal"
      },
      {
        "title": "Natural Mystic",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/natural_mystic?source=ireal"
      },
      {
        "title": "Jammin",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/jammin?source=ireal"
      },
      {
        "title": "Burning and Looting",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/burning_and_looting?source=ireal"
      },
      {
        "title": "Burning and Looting",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/burning_and_looting?source=ireal"
      },
      {
        "title": "Redemption Song",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/redemption_song?source=ireal"
      },
      {
        "title": "Red Red Wine Ub40 Version",
        "artist": "Neil Diamond",
        "url": "https://www.quickchords.org/charts/reggae/neil_diamond/red_red_wine_ub40_version?source=ireal"
      },
      {
        "title": "Get up (stand up)",
        "artist": "Marley Bob Composer",
        "url": "https://www.quickchords.org/charts/reggae/marley_bob_composer/get_up_stand_up?source=ireal"
      },
      {
        "title": "Waiting In Vain",
        "artist": "Bob Marley",
        "url": "https://www.quickchords.org/charts/reggae/bob_marley/waiting_in_vain?source=ireal"
      }
    ]
  },
  {
    "title": "Ted Green Blues Progressions",
    "items": [
      {
        "title": "Blues Basic*",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_basic?source=ireal"
      },
      {
        "title": "Blues 2",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_2?source=ireal"
      },
      {
        "title": "Blues 3",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_3?source=ireal"
      },
      {
        "title": "Blues 4",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_4?source=ireal"
      },
      {
        "title": "Blues 5",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_5?source=ireal"
      },
      {
        "title": "Blues 6",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_6?source=ireal"
      },
      {
        "title": "Blues 7",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_7?source=ireal"
      },
      {
        "title": "Blues 8",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_8?source=ireal"
      },
      {
        "title": "Blues 9",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_9?source=ireal"
      },
      {
        "title": "Blues 10",
        "artist": "Ted Greene",
        "url": "https://www.quickchords.org/charts/ted_green_blues_progressions/ted_greene/blues_10?source=ireal"
      }
    ]
  },
  {
    "title": "The Beatles",
    "items": [
      {
        "title": "Across The Universe",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/across_the_universe?source=ireal"
      },
      {
        "title": "Act Naturally (Beatles)",
        "artist": "Russell-Morrison",
        "url": "https://www.quickchords.org/charts/the_beatles/russellmorrison/act_naturally_beatles?source=ireal"
      },
      {
        "title": "All My Loving",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/all_my_loving?source=ireal"
      },
      {
        "title": "All You Need Is Love",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/all_you_need_is_love?source=ireal"
      },
      {
        "title": "And I Love Her",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/and_i_love_her?source=ireal"
      },
      {
        "title": "Another Day (It's Just)  (qtr 115)",
        "artist": "Paul McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/paul_mccartney/another_day_its_just__qtr_115?source=ireal"
      },
      {
        "title": "Because",
        "artist": "McCartney Paul and Lennon John",
        "url": "https://www.quickchords.org/charts/the_beatles/mccartney_paul_and_lennon_john/because?source=ireal"
      },
      {
        "title": "Blackbird",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/blackbird?source=ireal"
      },
      {
        "title": "Can't Buy Me Love",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/cant_buy_me_love?source=ireal"
      },
      {
        "title": "Chains (The Beatles)",
        "artist": "King - Goffin",
        "url": "https://www.quickchords.org/charts/the_beatles/king__goffin/chains_the_beatles?source=ireal"
      },
      {
        "title": "Come Together ",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/come_together_?source=ireal"
      },
      {
        "title": "Drive My Car",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/drive_my_car?source=ireal"
      },
      {
        "title": "Eight Days A Week",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/eight_days_a_week?source=ireal"
      },
      {
        "title": "Eleanor Rigby",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/eleanor_rigby?source=ireal"
      },
      {
        "title": "Fool On The Hill, The",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/fool_on_the_hill_the?source=ireal"
      },
      {
        "title": "For No One",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/for_no_one?source=ireal"
      },
      {
        "title": "Free As A Bird",
        "artist": "The Beatles",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles/free_as_a_bird?source=ireal"
      },
      {
        "title": "Get Back",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/get_back?source=ireal"
      },
      {
        "title": "Girl",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/girl?source=ireal"
      },
      {
        "title": "Golden Slumbers (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/golden_slumbers_beatles?source=ireal"
      },
      {
        "title": "Good Day Sunshine",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/good_day_sunshine?source=ireal"
      },
      {
        "title": "Good Day Sunshine (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/good_day_sunshine_beatles?source=ireal"
      },
      {
        "title": "Good Day Sunshine (revised, in A)",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/good_day_sunshine_revised_in_a?source=ireal"
      },
      {
        "title": "Good Day Sunshine 1",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/good_day_sunshine_1?source=ireal"
      },
      {
        "title": "Got To Get You Into My Life",
        "artist": "Beatles",
        "url": "https://www.quickchords.org/charts/the_beatles/beatles/got_to_get_you_into_my_life?source=ireal"
      },
      {
        "title": "Happy Xmas (War Is Over)",
        "artist": "Ono Lennon-Yoko John",
        "url": "https://www.quickchords.org/charts/the_beatles/ono_lennonyoko_john/happy_xmas_war_is_over?source=ireal"
      },
      {
        "title": "Hard Day's Night, A",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/hard_days_night_a?source=ireal"
      },
      {
        "title": "Heart of the Country",
        "artist": "Paul McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/paul_mccartney/heart_of_the_country?source=ireal"
      },
      {
        "title": "Hello, Goodbye",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/hello_goodbye?source=ireal"
      },
      {
        "title": "Here, There, And Everywhere",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/here_there_and_everywhere?source=ireal"
      },
      {
        "title": "Hey Jude",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/hey_jude?source=ireal"
      },
      {
        "title": "I Am The Walrus (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/i_am_the_walrus_beatles?source=ireal"
      },
      {
        "title": "I Saw Her Standing There",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/i_saw_her_standing_there?source=ireal"
      },
      {
        "title": "I Want To Hold Your Hand",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/i_want_to_hold_your_hand?source=ireal"
      },
      {
        "title": "I'll Follow The Sun",
        "artist": "John Lennon",
        "url": "https://www.quickchords.org/charts/the_beatles/john_lennon/ill_follow_the_sun?source=ireal"
      },
      {
        "title": "I'm So Tired",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/im_so_tired?source=ireal"
      },
      {
        "title": "I'm So Tired (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/im_so_tired_beatles?source=ireal"
      },
      {
        "title": "I'm So Tired (The Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/im_so_tired_the_beatles?source=ireal"
      },
      {
        "title": "If I Fell",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/if_i_fell?source=ireal"
      },
      {
        "title": "Imagine",
        "artist": "John Lennon",
        "url": "https://www.quickchords.org/charts/the_beatles/john_lennon/imagine?source=ireal"
      },
      {
        "title": "In My Life",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/in_my_life?source=ireal"
      },
      {
        "title": "Julia (The Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/julia_the_beatles?source=ireal"
      },
      {
        "title": "Junk",
        "artist": "The Beatles",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles/junk?source=ireal"
      },
      {
        "title": "Lady Madonna",
        "artist": "Lennon McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennon_mccartney/lady_madonna?source=ireal"
      },
      {
        "title": "Lady Madonna (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/lady_madonna_beatles?source=ireal"
      },
      {
        "title": "Let It Be",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/let_it_be?source=ireal"
      },
      {
        "title": "Long And Winding Road",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/long_and_winding_road?source=ireal"
      },
      {
        "title": "Lucy In The Sky With Diamonds (The Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/lucy_in_the_sky_with_diamonds_the_beatles?source=ireal"
      },
      {
        "title": "Martha My Dear",
        "artist": "Beatles",
        "url": "https://www.quickchords.org/charts/the_beatles/beatles/martha_my_dear?source=ireal"
      },
      {
        "title": "Michelle",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/michelle?source=ireal"
      },
      {
        "title": "Mother Nature's Son (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/mother_natures_son_beatles?source=ireal"
      },
      {
        "title": "My Sweet Lord",
        "artist": "George Harrison",
        "url": "https://www.quickchords.org/charts/the_beatles/george_harrison/my_sweet_lord?source=ireal"
      },
      {
        "title": "Norwegian Wood",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/norwegian_wood?source=ireal"
      },
      {
        "title": "Nowhere Man",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/nowhere_man?source=ireal"
      },
      {
        "title": "Oh! Darling",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/oh_darling?source=ireal"
      },
      {
        "title": "Penny Lane",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/penny_lane?source=ireal"
      },
      {
        "title": "Please Mr Postman",
        "artist": "Holland/Gorman and Bateman",
        "url": "https://www.quickchords.org/charts/the_beatles/hollandgorman_and_bateman/please_mr_postman?source=ireal"
      },
      {
        "title": "Sexy Sadie",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/sexy_sadie?source=ireal"
      },
      {
        "title": "She Came In Through The Bathroom Window (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/she_came_in_through_the_bathroom_window_beatles?source=ireal"
      },
      {
        "title": "She's So Heavy (The Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/shes_so_heavy_the_beatles?source=ireal"
      },
      {
        "title": "Something 1",
        "artist": "The Beatles (George Harrison)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_george_harrison/something_1?source=ireal"
      },
      {
        "title": "Taxman (The Beatles)",
        "artist": "Harrison",
        "url": "https://www.quickchords.org/charts/the_beatles/harrison/taxman_the_beatles?source=ireal"
      },
      {
        "title": "There's a place",
        "artist": "Lennon- McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennon_mccartney/theres_a_place?source=ireal"
      },
      {
        "title": "Things We Said Today (Beatles)",
        "artist": "Lennon-McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennonmccartney/things_we_said_today_beatles?source=ireal"
      },
      {
        "title": "Twist And Shout",
        "artist": "The Beatles (Medley-Russell)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_medleyrussell/twist_and_shout?source=ireal"
      },
      {
        "title": "When I'm 64",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/when_im_64?source=ireal"
      },
      {
        "title": "While My Guitar Gently Weeps",
        "artist": "The Beatles (George Harrison)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_george_harrison/while_my_guitar_gently_weeps?source=ireal"
      },
      {
        "title": "Word, The",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/word_the?source=ireal"
      },
      {
        "title": "Yesterday",
        "artist": "The Beatles (Lennon, McCartney)",
        "url": "https://www.quickchords.org/charts/the_beatles/the_beatles_lennon_mccartney/yesterday?source=ireal"
      },
      {
        "title": "You Can't Do That",
        "artist": "Lennon McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennon_mccartney/you_cant_do_that?source=ireal"
      },
      {
        "title": "You Won't See Me",
        "artist": "Lennon McCartney",
        "url": "https://www.quickchords.org/charts/the_beatles/lennon_mccartney/you_wont_see_me?source=ireal"
      }
    ]
  },
  {
    "title": "The Grateful Dead",
    "items": [
      {
        "title": "Morning Dew",
        "artist": "Joan Baez",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/joan_baez/morning_dew?source=ireal"
      },
      {
        "title": "Other One, The",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/other_one_the?source=ireal"
      },
      {
        "title": "Alligator",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/grateful_dead/alligator?source=ireal"
      },
      {
        "title": "Cosmic Charlie",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/cosmic_charlie?source=ireal"
      },
      {
        "title": "Dupree's Diamond Blues",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/duprees_diamond_blues?source=ireal"
      },
      {
        "title": "Doing That Rag",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/doing_that_rag?source=ireal"
      },
      {
        "title": "Saint Stephen",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/grateful_dead/saint_stephen?source=ireal"
      },
      {
        "title": "Eleven, The",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/grateful_dead/eleven_the?source=ireal"
      },
      {
        "title": "Chinacat Sunflower",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/chinacat_sunflower?source=ireal"
      },
      {
        "title": "I Know You Rider",
        "artist": "Traditional Folk",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/traditional_folk/i_know_you_rider?source=ireal"
      },
      {
        "title": "Dark Star",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/dark_star?source=ireal"
      },
      {
        "title": "Cold Rain And Snow",
        "artist": "Traditional Traditional",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/traditional_traditional/cold_rain_and_snow?source=ireal"
      },
      {
        "title": "Uncle John's Band",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/uncle_johns_band?source=ireal"
      },
      {
        "title": "High Time",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/high_time?source=ireal"
      },
      {
        "title": "Dire Wolf",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/dire_wolf?source=ireal"
      },
      {
        "title": "Casey Jones",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/casey_jones?source=ireal"
      },
      {
        "title": "New Speedway Boogie",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/new_speedway_boogie?source=ireal"
      },
      {
        "title": "Friend Of The Devil",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/friend_of_the_devil?source=ireal"
      },
      {
        "title": "Candyman",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/candyman?source=ireal"
      },
      {
        "title": "Till The Morning Comes",
        "artist": "Garcia Hunter/",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/garcia_hunter/till_the_morning_comes?source=ireal"
      },
      {
        "title": "Loser",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/loser?source=ireal"
      },
      {
        "title": "Mama Tried",
        "artist": "Merle Haggard",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/merle_haggard/mama_tried?source=ireal"
      },
      {
        "title": "Goin' Down The Road Feelin' Bad",
        "artist": "Traditional Folk",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/traditional_folk/goin_down_the_road_feelin_bad?source=ireal"
      },
      {
        "title": "Me And My Uncle",
        "artist": "Cowboy Bob",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/cowboy_bob/me_and_my_uncle?source=ireal"
      },
      {
        "title": "Brown Eyed Women",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/brown_eyed_women?source=ireal"
      },
      {
        "title": "Jack Straw",
        "artist": "Bob Wier",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/bob_wier/jack_straw?source=ireal"
      },
      {
        "title": "Ramble On Rose",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/ramble_on_rose?source=ireal"
      },
      {
        "title": "Deal",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/deal?source=ireal"
      },
      {
        "title": "Bird Song",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/bird_song?source=ireal"
      },
      {
        "title": "Sugaree",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/sugaree?source=ireal"
      },
      {
        "title": "Eyes Of The World",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/eyes_of_the_world?source=ireal"
      },
      {
        "title": "Scarlet Begonias",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/scarlet_begonias?source=ireal"
      },
      {
        "title": "Ship Of Fools",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/ship_of_fools?source=ireal"
      },
      {
        "title": "Franklin's Tower",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/franklins_tower?source=ireal"
      },
      {
        "title": "Crazy Fingers",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/crazy_fingers?source=ireal"
      },
      {
        "title": "Peggy-O",
        "artist": "Traditional Folk",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/traditional_folk/peggyo?source=ireal"
      },
      {
        "title": "Althea",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/althea?source=ireal"
      },
      {
        "title": "Lazy River Road",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/the_grateful_dead/jerry_garcia/lazy_river_road?source=ireal"
      }
    ]
  },
  {
    "title": "The Real Book - Volume 1",
    "items": [
      {
        "title": "12-4 2-4 Duplicities",
        "artist": "Jack Stock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jack_stock/124_24_duplicities?source=ireal"
      },
      {
        "title": "500 Miles High",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/500_miles_high?source=ireal"
      },
      {
        "title": "502 Blues",
        "artist": "Jimmy Rowles",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_rowles/502_blues?source=ireal"
      },
      {
        "title": "African Flower",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/african_flower?source=ireal"
      },
      {
        "title": "Afro Blue",
        "artist": "Mongo Santamaria",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/mongo_santamaria/afro_blue?source=ireal"
      },
      {
        "title": "Afternoon In Paris",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_lewis/afternoon_in_paris?source=ireal"
      },
      {
        "title": "Airegin",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/sonny_rollins/airegin?source=ireal"
      },
      {
        "title": "Alice In Wonderland",
        "artist": "Sammy Fain",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/sammy_fain/alice_in_wonderland?source=ireal"
      },
      {
        "title": "All In Love Is Fair",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/stevie_wonder/all_in_love_is_fair?source=ireal"
      },
      {
        "title": "All My Tomorrows",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_vanheusen/all_my_tomorrows?source=ireal"
      },
      {
        "title": "All Of Me",
        "artist": "Gerald Marks",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gerald_marks/all_of_me?source=ireal"
      },
      {
        "title": "All Of You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cole_porter/all_of_you?source=ireal"
      },
      {
        "title": "All The Things You Are",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jerome_kern/all_the_things_you_are?source=ireal"
      },
      {
        "title": "Alone Together",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/arthur_schwartz/alone_together?source=ireal"
      },
      {
        "title": "Ana Maria",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/ana_maria?source=ireal"
      },
      {
        "title": "And On The Third Day",
        "artist": "Michael Gibbs",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/michael_gibbs/and_on_the_third_day?source=ireal"
      },
      {
        "title": "Angel Eyes",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/matt_dennis/angel_eyes?source=ireal"
      },
      {
        "title": "Anthropology",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/anthropology?source=ireal"
      },
      {
        "title": "April In Paris",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/vernon_duke/april_in_paris?source=ireal"
      },
      {
        "title": "April Joy",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/pat_metheny/april_joy?source=ireal"
      },
      {
        "title": "Arise, Her Eyes",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/arise_her_eyes?source=ireal"
      },
      {
        "title": "Armageddon",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/armageddon?source=ireal"
      },
      {
        "title": "As Time Goes By",
        "artist": "Herman Hupfeld",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herman_hupfeld/as_time_goes_by?source=ireal"
      },
      {
        "title": "Au Privave",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/au_privave?source=ireal"
      },
      {
        "title": "Autumn In New York",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/vernon_duke/autumn_in_new_york?source=ireal"
      },
      {
        "title": "Autumn Leaves",
        "artist": "Joseph Kosma",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joseph_kosma/autumn_leaves?source=ireal"
      },
      {
        "title": "Beautiful Love",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/victor_young/beautiful_love?source=ireal"
      },
      {
        "title": "Beauty And The Beast",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/beauty_and_the_beast?source=ireal"
      },
      {
        "title": "Bessie's Blues",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/bessies_blues?source=ireal"
      },
      {
        "title": "Bewitched",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/bewitched?source=ireal"
      },
      {
        "title": "Big Nick",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/big_nick?source=ireal"
      },
      {
        "title": "Black Diamonds",
        "artist": "Roland Kirk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/roland_kirk/black_diamonds?source=ireal"
      },
      {
        "title": "Black Narcissus",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joe_henderson/black_narcissus?source=ireal"
      },
      {
        "title": "Black Nile",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/black_nile?source=ireal"
      },
      {
        "title": "Black Orpheus (Manha De Carnaval)",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/luiz_bonfa/black_orpheus_manha_de_carnaval?source=ireal"
      },
      {
        "title": "Blessed Relief",
        "artist": "Frank Zappa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/frank_zappa/blessed_relief?source=ireal"
      },
      {
        "title": "Blue Comedy",
        "artist": "Michael Gibbs",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/michael_gibbs/blue_comedy?source=ireal"
      },
      {
        "title": "Blue Room",
        "artist": "Rodgers-Hart",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/rodgershart/blue_room?source=ireal"
      },
      {
        "title": "Blue Trane",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/blue_trane?source=ireal"
      },
      {
        "title": "Blues For Alice",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/blues_for_alice?source=ireal"
      },
      {
        "title": "Body And Soul",
        "artist": "Johnny Green",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/johnny_green/body_and_soul?source=ireal"
      },
      {
        "title": "Boplicity",
        "artist": "Cleo Henry",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cleo_henry/boplicity?source=ireal"
      },
      {
        "title": "Boston Marathon",
        "artist": "Gary Burton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gary_burton/boston_marathon?source=ireal"
      },
      {
        "title": "Bright Size Life",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/pat_metheny/bright_size_life?source=ireal"
      },
      {
        "title": "Brownout",
        "artist": "Gary Burton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gary_burton/brownout?source=ireal"
      },
      {
        "title": "But Beautiful",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_vanheusen/but_beautiful?source=ireal"
      },
      {
        "title": "Butterfly",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herbie_hancock/butterfly?source=ireal"
      },
      {
        "title": "Call For All Demons, A",
        "artist": "Sun Ra",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/sun_ra/call_for_all_demons_a?source=ireal"
      },
      {
        "title": "Captain Marvel",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/captain_marvel?source=ireal"
      },
      {
        "title": "Central Park West",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/central_park_west?source=ireal"
      },
      {
        "title": "Ceora",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/lee_morgan/ceora?source=ireal"
      },
      {
        "title": "Chega De Saudade",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/chega_de_saudade?source=ireal"
      },
      {
        "title": "Chelsea Bells",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/chelsea_bells?source=ireal"
      },
      {
        "title": "Chelsea Bridge",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/billy_strayhorn/chelsea_bridge?source=ireal"
      },
      {
        "title": "Chicken Feathers",
        "artist": "Steve Kuhn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_kuhn/chicken_feathers?source=ireal"
      },
      {
        "title": "Child Is Born, A",
        "artist": "Thad Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/thad_jones/child_is_born_a?source=ireal"
      },
      {
        "title": "Chippie",
        "artist": "Ornette Coleman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/ornette_coleman/chippie?source=ireal"
      },
      {
        "title": "Come Sunday",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/come_sunday?source=ireal"
      },
      {
        "title": "Como en Vietnam",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/como_en_vietnam?source=ireal"
      },
      {
        "title": "Con Alma",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dizzy_gillespie/con_alma?source=ireal"
      },
      {
        "title": "Conception",
        "artist": "George Shearing",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/george_shearing/conception?source=ireal"
      },
      {
        "title": "Conference Of The Birds",
        "artist": "Dave Holland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dave_holland/conference_of_the_birds?source=ireal"
      },
      {
        "title": "Confirmation",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/confirmation?source=ireal"
      },
      {
        "title": "Coral",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/coral?source=ireal"
      },
      {
        "title": "Corcovado",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/corcovado?source=ireal"
      },
      {
        "title": "Cottontail",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/cottontail?source=ireal"
      },
      {
        "title": "Could It Be You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cole_porter/could_it_be_you?source=ireal"
      },
      {
        "title": "Countdown",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/countdown?source=ireal"
      },
      {
        "title": "Country Roads",
        "artist": "Swallow Burton-Steve Gary",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/swallow_burtonsteve_gary/country_roads?source=ireal"
      },
      {
        "title": "Crescent",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/crescent?source=ireal"
      },
      {
        "title": "Crystal Silence",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/crystal_silence?source=ireal"
      },
      {
        "title": "Daahoud",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/clifford_brown/daahoud?source=ireal"
      },
      {
        "title": "Dancing On The Ceiling",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/dancing_on_the_ceiling?source=ireal"
      },
      {
        "title": "Darn That Dream",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_vanheusen/darn_that_dream?source=ireal"
      },
      {
        "title": "Day Waves",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/day_waves?source=ireal"
      },
      {
        "title": "Days And Nights Waiting",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/days_and_nights_waiting?source=ireal"
      },
      {
        "title": "Days Of Wine And Roses",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/henry_mancini/days_of_wine_and_roses?source=ireal"
      },
      {
        "title": "Dear Old Stockholm",
        "artist": "Varmeland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/varmeland/dear_old_stockholm?source=ireal"
      },
      {
        "title": "Dearly Beloved",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jerome_kern/dearly_beloved?source=ireal"
      },
      {
        "title": "Delores",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/delores?source=ireal"
      },
      {
        "title": "Deluge",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/deluge?source=ireal"
      },
      {
        "title": "Depois Do Amor o Vazio",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/depois_do_amor_o_vazio?source=ireal"
      },
      {
        "title": "Desafinado",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/desafinado?source=ireal"
      },
      {
        "title": "Desert Air",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/desert_air?source=ireal"
      },
      {
        "title": "Dexterity",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/dexterity?source=ireal"
      },
      {
        "title": "Django",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_lewis/django?source=ireal"
      },
      {
        "title": "Doin' the Pig",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/doin_the_pig?source=ireal"
      },
      {
        "title": "Dolphin Dance",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herbie_hancock/dolphin_dance?source=ireal"
      },
      {
        "title": "Dolphin, The",
        "artist": "Luiz Eca",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/luiz_eca/dolphin_the?source=ireal"
      },
      {
        "title": "Domino Biscuit",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/domino_biscuit?source=ireal"
      },
      {
        "title": "Don't Blame Me",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_mchugh/dont_blame_me?source=ireal"
      },
      {
        "title": "Don't Get Around Much Anymore",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/dont_get_around_much_anymore?source=ireal"
      },
      {
        "title": "Donna Lee",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/donna_lee?source=ireal"
      },
      {
        "title": "Duke, The",
        "artist": "Dave Brubeck",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dave_brubeck/duke_the?source=ireal"
      },
      {
        "title": "E.S.P.",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/esp?source=ireal"
      },
      {
        "title": "Easy Living",
        "artist": "Ralph Rainger",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/ralph_rainger/easy_living?source=ireal"
      },
      {
        "title": "Easy To Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cole_porter/easy_to_love?source=ireal"
      },
      {
        "title": "Ecclusiastics",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/ecclusiastics?source=ireal"
      },
      {
        "title": "Eiderdown",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/eiderdown?source=ireal"
      },
      {
        "title": "Eighty One",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/eighty_one?source=ireal"
      },
      {
        "title": "El Gaucho",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/el_gaucho?source=ireal"
      },
      {
        "title": "Elizete",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/clare_fischer/elizete?source=ireal"
      },
      {
        "title": "Epistrophy",
        "artist": "Monk Thelonious/Clarke Kenny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/monk_theloniousclarke_kenny/epistrophy?source=ireal"
      },
      {
        "title": "Equinox",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/equinox?source=ireal"
      },
      {
        "title": "Exercise #3",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/pat_metheny/exercise_3?source=ireal"
      },
      {
        "title": "Exercise #6 ",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/pat_metheny/exercise_6_?source=ireal"
      },
      {
        "title": "Fables of Faubus",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/fables_of_faubus?source=ireal"
      },
      {
        "title": "Fall",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/fall?source=ireal"
      },
      {
        "title": "Falling Grace",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/falling_grace?source=ireal"
      },
      {
        "title": "Fee-Fi-Fo-Fum",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/feefifofum?source=ireal"
      },
      {
        "title": "Fields we Know, The",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/fields_we_know_the?source=ireal"
      },
      {
        "title": "Fine Romance, A",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jerome_kern/fine_romance_a?source=ireal"
      },
      {
        "title": "Foggy Day, A",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/george_gershwin/foggy_day_a?source=ireal"
      },
      {
        "title": "Footprints",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/footprints?source=ireal"
      },
      {
        "title": "For Heaven's Sake",
        "artist": "Edwards-Meyer-Bretton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/edwardsmeyerbretton/for_heavens_sake?source=ireal"
      },
      {
        "title": "Forest Flower",
        "artist": "Charles Lloyd",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_lloyd/forest_flower?source=ireal"
      },
      {
        "title": "Fortune Smiles",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/fortune_smiles?source=ireal"
      },
      {
        "title": "Four",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/four?source=ireal"
      },
      {
        "title": "Four On Six",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wes_montgomery/four_on_six?source=ireal"
      },
      {
        "title": "Freddie Freeloader",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/freddie_freeloader?source=ireal"
      },
      {
        "title": "Freedom Jazz Dance",
        "artist": "Eddie Harris",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/eddie_harris/freedom_jazz_dance?source=ireal"
      },
      {
        "title": "Garota de Ipanema",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/garota_de_ipanema?source=ireal"
      },
      {
        "title": "Gary's Waltz",
        "artist": "Gary McFarland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gary_mcfarland/garys_waltz?source=ireal"
      },
      {
        "title": "Gemini",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_heath/gemini?source=ireal"
      },
      {
        "title": "General Mojo's Well Laid Plan",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/general_mojos_well_laid_plan?source=ireal"
      },
      {
        "title": "Gentle Rain",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/luiz_bonfa/gentle_rain?source=ireal"
      },
      {
        "title": "Gloria's Step",
        "artist": "Scott LaFaro",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/scott_lafaro/glorias_step?source=ireal"
      },
      {
        "title": "God Bless The Child",
        "artist": "Herzog-Holiday",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herzogholiday/god_bless_the_child?source=ireal"
      },
      {
        "title": "Golden Lady",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/stevie_wonder/golden_lady?source=ireal"
      },
      {
        "title": "Good Evening Mr and Mrs America",
        "artist": "John Guerin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_guerin/good_evening_mr_and_mrs_america?source=ireal"
      },
      {
        "title": "Goodbye Pork Pie Hat",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/goodbye_pork_pie_hat?source=ireal"
      },
      {
        "title": "Grand Central",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/grand_central?source=ireal"
      },
      {
        "title": "Green Dolphin Street",
        "artist": "Bronislau Kaper",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bronislau_kaper/green_dolphin_street?source=ireal"
      },
      {
        "title": "Green Mountains",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/green_mountains?source=ireal"
      },
      {
        "title": "Grow Your Own",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/grow_your_own?source=ireal"
      },
      {
        "title": "Half Nelson",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/half_nelson?source=ireal"
      },
      {
        "title": "Have You Met Miss Jones?",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/have_you_met_miss_jones?source=ireal"
      },
      {
        "title": "Heaven",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/heaven?source=ireal"
      },
      {
        "title": "Hello Young Lovers",
        "artist": "Richard Rogers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rogers/hello_young_lovers?source=ireal"
      },
      {
        "title": "Henniger Flats",
        "artist": "David Pritchard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/david_pritchard/henniger_flats?source=ireal"
      },
      {
        "title": "Here's That Rainy Day",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_vanheusen/heres_that_rainy_day?source=ireal"
      },
      {
        "title": "Hey There",
        "artist": "Alder-Ross",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/alderross/hey_there?source=ireal"
      },
      {
        "title": "Hold Out Yout Hand",
        "artist": "Steve Kuhn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_kuhn/hold_out_yout_hand?source=ireal"
      },
      {
        "title": "House Of Jade",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/house_of_jade?source=ireal"
      },
      {
        "title": "How High The Moon",
        "artist": "Morgan Lewis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/morgan_lewis/how_high_the_moon?source=ireal"
      },
      {
        "title": "How My Heart Sings",
        "artist": "Earl Zindars",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/earl_zindars/how_my_heart_sings?source=ireal"
      },
      {
        "title": "Hullo Bolinas",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/hullo_bolinas?source=ireal"
      },
      {
        "title": "I Can't Get Started",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/vernon_duke/i_cant_get_started?source=ireal"
      },
      {
        "title": "I Could Write A Book",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/i_could_write_a_book?source=ireal"
      },
      {
        "title": "I Got It Bad",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/i_got_it_bad?source=ireal"
      },
      {
        "title": "I Let A Song (Go Out Of My Heart)",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/i_let_a_song_go_out_of_my_heart?source=ireal"
      },
      {
        "title": "I Love You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cole_porter/i_love_you?source=ireal"
      },
      {
        "title": "I Mean You",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/thelonious_monk/i_mean_you?source=ireal"
      },
      {
        "title": "I Remember Clifford",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/benny_golson/i_remember_clifford?source=ireal"
      },
      {
        "title": "I Should Care",
        "artist": "Cahn-Stordahl-Weston",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cahnstordahlweston/i_should_care?source=ireal"
      },
      {
        "title": "I'll Remember April",
        "artist": "Raye-DePaul",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/rayedepaul/ill_remember_april?source=ireal"
      },
      {
        "title": "I'm All Smiles",
        "artist": "Leonard-Martin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/leonardmartin/im_all_smiles?source=ireal"
      },
      {
        "title": "I'm Your Pal",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/im_your_pal?source=ireal"
      },
      {
        "title": "Icarus",
        "artist": "Ralph Towner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/ralph_towner/icarus?source=ireal"
      },
      {
        "title": "Impressions",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/impressions?source=ireal"
      },
      {
        "title": "In A Mellow Tone (In A Mellotone)",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/in_a_mellow_tone_in_a_mellotone?source=ireal"
      },
      {
        "title": "In Your Own Sweet Way",
        "artist": "Dave Brubeck",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dave_brubeck/in_your_own_sweet_way?source=ireal"
      },
      {
        "title": "In Your Quiet Place",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/in_your_quiet_place?source=ireal"
      },
      {
        "title": "In a Sentimental Mood",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/in_a_sentimental_mood?source=ireal"
      },
      {
        "title": "Inchworm",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/frank_loesser/inchworm?source=ireal"
      },
      {
        "title": "Indian Lady",
        "artist": "Don Ellis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/don_ellis/indian_lady?source=ireal"
      },
      {
        "title": "Inner Urge",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joe_henderson/inner_urge?source=ireal"
      },
      {
        "title": "Insensatez",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/insensatez?source=ireal"
      },
      {
        "title": "Interplay",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bill_evans/interplay?source=ireal"
      },
      {
        "title": "Intrepid fox",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/freddie_hubbard/intrepid_fox?source=ireal"
      },
      {
        "title": "Inutil Paisagem (If You Never Come to me)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/inutil_paisagem_if_you_never_come_to_me?source=ireal"
      },
      {
        "title": "Invitation",
        "artist": "Bronislau Kaper",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bronislau_kaper/invitation?source=ireal"
      },
      {
        "title": "Iris",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/iris?source=ireal"
      },
      {
        "title": "Isn't It Romantic?",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/isnt_it_romantic?source=ireal"
      },
      {
        "title": "Isotope",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joe_henderson/isotope?source=ireal"
      },
      {
        "title": "Israel",
        "artist": "John Carisi",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_carisi/israel?source=ireal"
      },
      {
        "title": "It Don't Mean A Thing",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/it_dont_mean_a_thing?source=ireal"
      },
      {
        "title": "It's A Raggy Waltz",
        "artist": "Dave Brubeck",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dave_brubeck/its_a_raggy_waltz?source=ireal"
      },
      {
        "title": "Jelly Roll",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/jelly_roll?source=ireal"
      },
      {
        "title": "Jinrikisha",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joe_henderson/jinrikisha?source=ireal"
      },
      {
        "title": "Jordu",
        "artist": "Duke Jordan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_jordan/jordu?source=ireal"
      },
      {
        "title": "Journey to Recife",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bill_evans/journey_to_recife?source=ireal"
      },
      {
        "title": "Joy Spring",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/clifford_brown/joy_spring?source=ireal"
      },
      {
        "title": "Juju",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/juju?source=ireal"
      },
      {
        "title": "Jump Monk",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/jump_monk?source=ireal"
      },
      {
        "title": "June 15,1967",
        "artist": "Michael Gibbs",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/michael_gibbs/june_151967?source=ireal"
      },
      {
        "title": "Just Friends",
        "artist": "John Klenner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_klenner/just_friends?source=ireal"
      },
      {
        "title": "La Fiesta",
        "artist": "Corea Chick",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/corea_chick/la_fiesta?source=ireal"
      },
      {
        "title": "Lament",
        "artist": "J.J. Johnson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jj_johnson/lament?source=ireal"
      },
      {
        "title": "Las Vegas Tango",
        "artist": "Gil EVans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gil_evans/las_vegas_tango?source=ireal"
      },
      {
        "title": "Lazy Bird",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/lazy_bird?source=ireal"
      },
      {
        "title": "Leroy, The Magician",
        "artist": "Gary Burton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gary_burton/leroy_the_magician?source=ireal"
      },
      {
        "title": "Lie Awake",
        "artist": "Mitch Coodley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/mitch_coodley/lie_awake?source=ireal"
      },
      {
        "title": "Like Someone In Love",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_vanheusen/like_someone_in_love?source=ireal"
      },
      {
        "title": "Limehouse Blues",
        "artist": "Braham-Furber",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/brahamfurber/limehouse_blues?source=ireal"
      },
      {
        "title": "Litha",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/litha?source=ireal"
      },
      {
        "title": "Little B's Poem",
        "artist": "Bobby Hutcherson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bobby_hutcherson/little_bs_poem?source=ireal"
      },
      {
        "title": "Little Niles",
        "artist": "Randy Weston",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/randy_weston/little_niles?source=ireal"
      },
      {
        "title": "Little Waltz",
        "artist": "Ron Carter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/ron_carter/little_waltz?source=ireal"
      },
      {
        "title": "Liturgy",
        "artist": "Michael Gibbs",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/michael_gibbs/liturgy?source=ireal"
      },
      {
        "title": "Long Ago And Far Away",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jerome_kern/long_ago_and_far_away?source=ireal"
      },
      {
        "title": "Long as you Know you're Living Yours",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/long_as_you_know_youre_living_yours?source=ireal"
      },
      {
        "title": "Lonnie's Lament",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/lonnies_lament?source=ireal"
      },
      {
        "title": "Look To The Sky",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/look_to_the_sky?source=ireal"
      },
      {
        "title": "Looking Back",
        "artist": "Richard Niles",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_niles/looking_back?source=ireal"
      },
      {
        "title": "Lucky Southern",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/lucky_southern?source=ireal"
      },
      {
        "title": "Lullaby Of Birdland",
        "artist": "George Shearing",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/george_shearing/lullaby_of_birdland?source=ireal"
      },
      {
        "title": "Lush Life",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/billy_strayhorn/lush_life?source=ireal"
      },
      {
        "title": "Magician in You, The",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/magician_in_you_the?source=ireal"
      },
      {
        "title": "Mahjong",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/mahjong?source=ireal"
      },
      {
        "title": "Maiden Voyage",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herbie_hancock/maiden_voyage?source=ireal"
      },
      {
        "title": "Mallet Man",
        "artist": "Gordon Beck",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gordon_beck/mallet_man?source=ireal"
      },
      {
        "title": "Man in The Green Shirt",
        "artist": "Weather Report (Joe Zawinul)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/weather_report_joe_zawinul/man_in_the_green_shirt?source=ireal"
      },
      {
        "title": "May Dance",
        "artist": "Dave Holland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dave_holland/may_dance?source=ireal"
      },
      {
        "title": "Meditaçao",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/meditaao?source=ireal"
      },
      {
        "title": "Memories Of Tomorrow",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/memories_of_tomorrow?source=ireal"
      },
      {
        "title": "Memphis Underground",
        "artist": "Herbie Mann",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herbie_mann/memphis_underground?source=ireal"
      },
      {
        "title": "Mevlevia",
        "artist": "Mick Goodrick",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/mick_goodrick/mevlevia?source=ireal"
      },
      {
        "title": "Michelle",
        "artist": "The Beatles (Lennon-McCartney)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/the_beatles_lennonmccartney/michelle?source=ireal"
      },
      {
        "title": "Midnight Mood",
        "artist": "Weather Report (Joe Zawinul)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/weather_report_joe_zawinul/midnight_mood?source=ireal"
      },
      {
        "title": "Milano",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_lewis/milano?source=ireal"
      },
      {
        "title": "Minority",
        "artist": "Gigi Gryce",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gigi_gryce/minority?source=ireal"
      },
      {
        "title": "Misty",
        "artist": "Erroll Garner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/erroll_garner/misty?source=ireal"
      },
      {
        "title": "Miyako",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/miyako?source=ireal"
      },
      {
        "title": "Molten Glass",
        "artist": "Joe Farrell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joe_farrell/molten_glass?source=ireal"
      },
      {
        "title": "Montage",
        "artist": "Stu Balcomb",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/stu_balcomb/montage?source=ireal"
      },
      {
        "title": "Mood Indigo",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/mood_indigo?source=ireal"
      },
      {
        "title": "Moon Germs",
        "artist": "Joe Farrell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joe_farrell/moon_germs?source=ireal"
      },
      {
        "title": "Moonchild",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/moonchild?source=ireal"
      },
      {
        "title": "More I See You, The",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/harry_warren/more_i_see_you_the?source=ireal"
      },
      {
        "title": "Mother of the Dead Man",
        "artist": "Carla Bley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/carla_bley/mother_of_the_dead_man?source=ireal"
      },
      {
        "title": "Mr. P.C.",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/mr_pc?source=ireal"
      },
      {
        "title": "My Favorite Things",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/my_favorite_things?source=ireal"
      },
      {
        "title": "My Foolish Heart",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/victor_young/my_foolish_heart?source=ireal"
      },
      {
        "title": "My Funny Valentine",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/my_funny_valentine?source=ireal"
      },
      {
        "title": "My One And Only Love",
        "artist": "Wood-Mellin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/woodmellin/my_one_and_only_love?source=ireal"
      },
      {
        "title": "My Romance",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/my_romance?source=ireal"
      },
      {
        "title": "My Ship",
        "artist": "Kurt Weill",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/kurt_weill/my_ship?source=ireal"
      },
      {
        "title": "Naima",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_coltrane/naima?source=ireal"
      },
      {
        "title": "Nardis",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/nardis?source=ireal"
      },
      {
        "title": "Nefertiti",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/nefertiti?source=ireal"
      },
      {
        "title": "Never Will I Marry",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/frank_loesser/never_will_i_marry?source=ireal"
      },
      {
        "title": "Nica's Dream",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/horace_silver/nicas_dream?source=ireal"
      },
      {
        "title": "Night And Day",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cole_porter/night_and_day?source=ireal"
      },
      {
        "title": "Night Dreamer",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/night_dreamer?source=ireal"
      },
      {
        "title": "Night Has A Thousand Eyes, The",
        "artist": "Jerry-Brainin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jerrybrainin/night_has_a_thousand_eyes_the?source=ireal"
      },
      {
        "title": "Night In Tunisia, A",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dizzy_gillespie/night_in_tunisia_a?source=ireal"
      },
      {
        "title": "Nimbus",
        "artist": "Ron McClure",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/ron_mcclure/nimbus?source=ireal"
      },
      {
        "title": "Nonsequence",
        "artist": "Micahel Gibbs",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/micahel_gibbs/nonsequence?source=ireal"
      },
      {
        "title": "Nostalgia In Times Square",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/nostalgia_in_times_square?source=ireal"
      },
      {
        "title": "O Barquinho (My Little Boat)",
        "artist": "Roberto Menescal",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/roberto_menescal/o_barquinho_my_little_boat?source=ireal"
      },
      {
        "title": "Oleo",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/sonny_rollins/oleo?source=ireal"
      },
      {
        "title": "Olhos de Gato",
        "artist": "Carla Bley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/carla_bley/olhos_de_gato?source=ireal"
      },
      {
        "title": "Once I Loved",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/once_i_loved?source=ireal"
      },
      {
        "title": "One Finger Snap",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herbie_hancock/one_finger_snap?source=ireal"
      },
      {
        "title": "Open your Eyes you can Fly",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/open_your_eyes_you_can_fly?source=ireal"
      },
      {
        "title": "Orbits",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/orbits?source=ireal"
      },
      {
        "title": "Ornithology",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/ornithology?source=ireal"
      },
      {
        "title": "Out Of Nowhere",
        "artist": "Johnny Green",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/johnny_green/out_of_nowhere?source=ireal"
      },
      {
        "title": "Passion Dance",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/mccoy_tyner/passion_dance?source=ireal"
      },
      {
        "title": "Peace",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/horace_silver/peace?source=ireal"
      },
      {
        "title": "Peaches En Regalia",
        "artist": "Frank Zappa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/frank_zappa/peaches_en_regalia?source=ireal"
      },
      {
        "title": "Pearlie's Swine",
        "artist": "Steve Kuhn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_kuhn/pearlies_swine?source=ireal"
      },
      {
        "title": "Pee Wee",
        "artist": "Tony Williams",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/tony_williams/pee_wee?source=ireal"
      },
      {
        "title": "Peggy's Blue Skylight",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/peggys_blue_skylight?source=ireal"
      },
      {
        "title": "Pensativa",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/clare_fischer/pensativa?source=ireal"
      },
      {
        "title": "Pent Up House",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/sonny_rollins/pent_up_house?source=ireal"
      },
      {
        "title": "Peri's Scope",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bill_evans/peris_scope?source=ireal"
      },
      {
        "title": "Pfrancing (No Blues)",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/pfrancing_no_blues?source=ireal"
      },
      {
        "title": "Pinocchio",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/pinocchio?source=ireal"
      },
      {
        "title": "Pithycanthropus Erectus",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/pithycanthropus_erectus?source=ireal"
      },
      {
        "title": "Played Twice",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/thelonious_monk/played_twice?source=ireal"
      },
      {
        "title": "Portsmouth Figurations",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/portsmouth_figurations?source=ireal"
      },
      {
        "title": "Prelude To A Kiss",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/prelude_to_a_kiss?source=ireal"
      },
      {
        "title": "Prince Of Darkness",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/prince_of_darkness?source=ireal"
      },
      {
        "title": "Pussy Cat Dues",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/pussy_cat_dues?source=ireal"
      },
      {
        "title": "Quiet Now",
        "artist": "Denny Zeitlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/denny_zeitlin/quiet_now?source=ireal"
      },
      {
        "title": "Raven, The",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/raven_the?source=ireal"
      },
      {
        "title": "Real Guitarist, The",
        "artist": "Steve Kuhn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_kuhn/real_guitarist_the?source=ireal"
      },
      {
        "title": "Recordame",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/joe_henderson/recordame?source=ireal"
      },
      {
        "title": "Red Clay",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/freddie_hubbard/red_clay?source=ireal"
      },
      {
        "title": "Reincarnation Of A Lovebird",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/reincarnation_of_a_lovebird?source=ireal"
      },
      {
        "title": "Resolution",
        "artist": "Mahavishnu Orchestra",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/mahavishnu_orchestra/resolution?source=ireal"
      },
      {
        "title": "Round Midnight",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/thelonious_monk/round_midnight?source=ireal"
      },
      {
        "title": "Saga Of Harrison Crabfeathers, The",
        "artist": "Steve Kuhn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_kuhn/saga_of_harrison_crabfeathers_the?source=ireal"
      },
      {
        "title": "Samba de Verao (Summer Samba)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/samba_de_verao_summer_samba?source=ireal"
      },
      {
        "title": "Samba de uma Nota só",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/samba_de_uma_nota_s?source=ireal"
      },
      {
        "title": "Same Shame",
        "artist": "Bobby Hutcherson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bobby_hutcherson/same_shame?source=ireal"
      },
      {
        "title": "Satin Doll",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/satin_doll?source=ireal"
      },
      {
        "title": "Scotch And Soda",
        "artist": "Dave Guard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dave_guard/scotch_and_soda?source=ireal"
      },
      {
        "title": "Scrapple From The Apple",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charlie_parker/scrapple_from_the_apple?source=ireal"
      },
      {
        "title": "Sea Journey",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/sea_journey?source=ireal"
      },
      {
        "title": "Self Portrait in 5 Colors",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_mingus/self_portrait_in_5_colors?source=ireal"
      },
      {
        "title": "Semblance",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/semblance?source=ireal"
      },
      {
        "title": "Serenade To A Cuckoo",
        "artist": "Roland Kirk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/roland_kirk/serenade_to_a_cuckoo?source=ireal"
      },
      {
        "title": "Seven Come Eleven",
        "artist": "Goodman-Christian",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/goodmanchristian/seven_come_eleven?source=ireal"
      },
      {
        "title": "Seven Steps To Heaven",
        "artist": "Victor Feldman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/victor_feldman/seven_steps_to_heaven?source=ireal"
      },
      {
        "title": "Shades of Light",
        "artist": "Hubert Laws",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/hubert_laws/shades_of_light?source=ireal"
      },
      {
        "title": "Shadow Of Your Smile, The",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/johnny_mandel/shadow_of_your_smile_the?source=ireal"
      },
      {
        "title": "Sidewinder",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/lee_morgan/sidewinder?source=ireal"
      },
      {
        "title": "Sing me Softly of the Blues",
        "artist": "Carla Bley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/carla_bley/sing_me_softly_of_the_blues?source=ireal"
      },
      {
        "title": "Skating In Central Park",
        "artist": "John Lewis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/john_lewis/skating_in_central_park?source=ireal"
      },
      {
        "title": "Slowly Gone, by Gone",
        "artist": "Dave Samuels",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dave_samuels/slowly_gone_by_gone?source=ireal"
      },
      {
        "title": "So What",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/so_what?source=ireal"
      },
      {
        "title": "Solitude",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/solitude?source=ireal"
      },
      {
        "title": "Some Other Time",
        "artist": "Leonard Bernstein",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/leonard_bernstein/some_other_time?source=ireal"
      },
      {
        "title": "Someday My Prince Will Come",
        "artist": "Frank Churchill",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/frank_churchill/someday_my_prince_will_come?source=ireal"
      },
      {
        "title": "Sometime Ago",
        "artist": "Sergio Mikanovich",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/sergio_mikanovich/sometime_ago?source=ireal"
      },
      {
        "title": "Son Of Mr. Green Genes",
        "artist": "Frank Zappa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/frank_zappa/son_of_mr_green_genes?source=ireal"
      },
      {
        "title": "Song",
        "artist": "Stu Balcomb",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/stu_balcomb/song?source=ireal"
      },
      {
        "title": "Song For My Father",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/horace_silver/song_for_my_father?source=ireal"
      },
      {
        "title": "Song Is You, The",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jerome_kern/song_is_you_the?source=ireal"
      },
      {
        "title": "Sophisticated Lady",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/sophisticated_lady?source=ireal"
      },
      {
        "title": "Sorcerer, The",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herbie_hancock/sorcerer_the?source=ireal"
      },
      {
        "title": "Speak No Evil",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/speak_no_evil?source=ireal"
      },
      {
        "title": "Spiral Dance",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/keith_jarrett/spiral_dance?source=ireal"
      },
      {
        "title": "Spring Is Here",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/spring_is_here?source=ireal"
      },
      {
        "title": "Star-Crossed Lovers, The",
        "artist": "Strayhorn-Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/strayhornellington/starcrossed_lovers_the?source=ireal"
      },
      {
        "title": "Stella By Starlight",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/victor_young/stella_by_starlight?source=ireal"
      },
      {
        "title": "Steps",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/steps?source=ireal"
      },
      {
        "title": "Stolen Moments",
        "artist": "Oliver Nelson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/oliver_nelson/stolen_moments?source=ireal"
      },
      {
        "title": "Stompin' At The Savoy",
        "artist": "Webb-Goodman-Sampson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/webbgoodmansampson/stompin_at_the_savoy?source=ireal"
      },
      {
        "title": "Stuff",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/stuff?source=ireal"
      },
      {
        "title": "Sugar",
        "artist": "Stanley Turrentine",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/stanley_turrentine/sugar?source=ireal"
      },
      {
        "title": "Swedish Pastry",
        "artist": "Barney Kessel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/barney_kessel/swedish_pastry?source=ireal"
      },
      {
        "title": "Sweet Georgia Bright",
        "artist": "Charles Lloyd",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/charles_lloyd/sweet_georgia_bright?source=ireal"
      },
      {
        "title": "Sweet Henry",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_swallow/sweet_henry?source=ireal"
      },
      {
        "title": "Sweet Rain",
        "artist": "Michael Gibbs",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/michael_gibbs/sweet_rain?source=ireal"
      },
      {
        "title": "Take Five",
        "artist": "Paul Desmond",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/paul_desmond/take_five?source=ireal"
      },
      {
        "title": "Take The A Train",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/billy_strayhorn/take_the_a_train?source=ireal"
      },
      {
        "title": "Tamethy Pen",
        "artist": "Richard Niles",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_niles/tamethy_pen?source=ireal"
      },
      {
        "title": "Tell Me A Bedtime Story",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/herbie_hancock/tell_me_a_bedtime_story?source=ireal"
      },
      {
        "title": "There Is No Greater Love",
        "artist": "Isham Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/isham_jones/there_is_no_greater_love?source=ireal"
      },
      {
        "title": "There Will Never Be Another You",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/harry_warren/there_will_never_be_another_you?source=ireal"
      },
      {
        "title": "They Can't Take That Away From Me",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/george_gershwin/they_cant_take_that_away_from_me?source=ireal"
      },
      {
        "title": "Think On Me",
        "artist": "George Cables",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/george_cables/think_on_me?source=ireal"
      },
      {
        "title": "Three Flowers",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/mccoy_tyner/three_flowers?source=ireal"
      },
      {
        "title": "Time Remembered",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bill_evans/time_remembered?source=ireal"
      },
      {
        "title": "Tones For Joan's Bones",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/tones_for_joans_bones?source=ireal"
      },
      {
        "title": "Tough Talk",
        "artist": "Crusaders",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/crusaders/tough_talk?source=ireal"
      },
      {
        "title": "Train Samba",
        "artist": "Gary McFarland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gary_mcfarland/train_samba?source=ireal"
      },
      {
        "title": "Trance",
        "artist": "Steve Kuhn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/steve_kuhn/trance?source=ireal"
      },
      {
        "title": "Triste",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/triste?source=ireal"
      },
      {
        "title": "Tune Up",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/tune_up?source=ireal"
      },
      {
        "title": "Turn Out The Stars",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bill_evans/turn_out_the_stars?source=ireal"
      },
      {
        "title": "Unquity Road",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/pat_metheny/unquity_road?source=ireal"
      },
      {
        "title": "Up Jumped Spring",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/freddie_hubbard/up_jumped_spring?source=ireal"
      },
      {
        "title": "Upper Manhattan Medical Group",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/billy_strayhorn/upper_manhattan_medical_group?source=ireal"
      },
      {
        "title": "Vashkar",
        "artist": "Carla Bley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/carla_bley/vashkar?source=ireal"
      },
      {
        "title": "Very Early",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bill_evans/very_early?source=ireal"
      },
      {
        "title": "Virgo",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/virgo?source=ireal"
      },
      {
        "title": "Wait Till You See Her",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/wait_till_you_see_her?source=ireal"
      },
      {
        "title": "Walkin'",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/miles_davis/walkin?source=ireal"
      },
      {
        "title": "Walter L.",
        "artist": "Gary Burton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/gary_burton/walter_l?source=ireal"
      },
      {
        "title": "Waltz",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/pat_metheny/waltz?source=ireal"
      },
      {
        "title": "Waltz For Debby",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/bill_evans/waltz_for_debby?source=ireal"
      },
      {
        "title": "Waltz For a Lovely Wife ",
        "artist": "Phil Woods",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/phil_woods/waltz_for_a_lovely_wife_?source=ireal"
      },
      {
        "title": "Waltzin'",
        "artist": "Victor Brasil",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/victor_brasil/waltzin?source=ireal"
      },
      {
        "title": "Wave",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/antoniocarlos_jobim/wave?source=ireal"
      },
      {
        "title": "We'll Be Together Again",
        "artist": "Carl Fisher",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/carl_fisher/well_be_together_again?source=ireal"
      },
      {
        "title": "Well You Needn't",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/thelonious_monk/well_you_neednt?source=ireal"
      },
      {
        "title": "West Coast Blues",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wes_montgomery/west_coast_blues?source=ireal"
      },
      {
        "title": "What Am I Here For",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/duke_ellington/what_am_i_here_for?source=ireal"
      },
      {
        "title": "What Are You Doing The Rest Of Your Life?",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/michel_legrand/what_are_you_doing_the_rest_of_your_life?source=ireal"
      },
      {
        "title": "What Is This Thing Called Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/cole_porter/what_is_this_thing_called_love?source=ireal"
      },
      {
        "title": "What Was",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/what_was?source=ireal"
      },
      {
        "title": "When I Fall In Love",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/victor_young/when_i_fall_in_love?source=ireal"
      },
      {
        "title": "When Sunny Gets Blue",
        "artist": "Marvin Fisher",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/marvin_fisher/when_sunny_gets_blue?source=ireal"
      },
      {
        "title": "Where Are You?",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/jimmy_mchugh/where_are_you?source=ireal"
      },
      {
        "title": "Wild Flower",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/wild_flower?source=ireal"
      },
      {
        "title": "Windows",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/chick_corea/windows?source=ireal"
      },
      {
        "title": "Witch Hunt",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/witch_hunt?source=ireal"
      },
      {
        "title": "Woody'n You",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/dizzy_gillespie/woodyn_you?source=ireal"
      },
      {
        "title": "Yes And No",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/wayne_shorter/yes_and_no?source=ireal"
      },
      {
        "title": "Yesterday",
        "artist": "The Beatles (Lennon-McCartney)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/the_beatles_lennonmccartney/yesterday?source=ireal"
      },
      {
        "title": "You Are The Sunshine Of My Life",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/stevie_wonder/you_are_the_sunshine_of_my_life?source=ireal"
      },
      {
        "title": "You Are Too Beautiful",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/you_are_too_beautiful?source=ireal"
      },
      {
        "title": "You Don't Know What Love Is",
        "artist": "Raye-DePaul",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/rayedepaul/you_dont_know_what_love_is?source=ireal"
      },
      {
        "title": "You Took Advantage Of Me",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_1/richard_rodgers/you_took_advantage_of_me?source=ireal"
      }
    ]
  },
  {
    "title": "The Real Book - Volume 2",
    "items": [
      {
        "title": "52nd Street Theme",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/52nd_street_theme?source=ireal"
      },
      {
        "title": "728",
        "artist": "Johnny Coles",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/johnny_coles/728?source=ireal"
      },
      {
        "title": "Ablution",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lennie_tristano/ablution?source=ireal"
      },
      {
        "title": "Affirmation",
        "artist": "José Feliciano",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jos_feliciano/affirmation?source=ireal"
      },
      {
        "title": "Airmail Special",
        "artist": "Charlie Christian",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_christian/airmail_special?source=ireal"
      },
      {
        "title": "Alfie's Theme",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/alfies_theme?source=ireal"
      },
      {
        "title": "All Alone",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/irving_berlin/all_alone?source=ireal"
      },
      {
        "title": "All God's Chillun Got Rhythm",
        "artist": "Kahn-Kaper",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/kahnkaper/all_gods_chillun_got_rhythm?source=ireal"
      },
      {
        "title": "Aloitis",
        "artist": "Oliver Nelson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/oliver_nelson/aloitis?source=ireal"
      },
      {
        "title": "Another Star",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/stevie_wonder/another_star?source=ireal"
      },
      {
        "title": "April",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lennie_tristano/april?source=ireal"
      },
      {
        "title": "April Skies",
        "artist": "Buddy Collette",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/buddy_collette/april_skies?source=ireal"
      },
      {
        "title": "Ask Me Now",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/ask_me_now?source=ireal"
      },
      {
        "title": "Avalon",
        "artist": "Jolson-Sylva-Rose",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jolsonsylvarose/avalon?source=ireal"
      },
      {
        "title": "Ba-lue Bolivar Ba-lues-are",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/balue_bolivar_baluesare?source=ireal"
      },
      {
        "title": "Backstage Sally",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/wayne_shorter/backstage_sally?source=ireal"
      },
      {
        "title": "Bag's Groove",
        "artist": "Milt Jackson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/milt_jackson/bags_groove?source=ireal"
      },
      {
        "title": "Bags and Trane",
        "artist": "Milt Jackson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/milt_jackson/bags_and_trane?source=ireal"
      },
      {
        "title": "Barbados",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/barbados?source=ireal"
      },
      {
        "title": "Barbara",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/barbara?source=ireal"
      },
      {
        "title": "Basin Street Blues",
        "artist": "S. Williams",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/s_williams/basin_street_blues?source=ireal"
      },
      {
        "title": "Be-Bop",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dizzy_gillespie/bebop?source=ireal"
      },
      {
        "title": "Beethoven's Blue 3rd",
        "artist": "Ed Kaiser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ed_kaiser/beethovens_blue_3rd?source=ireal"
      },
      {
        "title": "Better Git it in your Soul",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charles_mingus/better_git_it_in_your_soul?source=ireal"
      },
      {
        "title": "Beyond all Limits",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/woody_shaw/beyond_all_limits?source=ireal"
      },
      {
        "title": "Big P",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_heath/big_p?source=ireal"
      },
      {
        "title": "Bill's Hit Tune",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bill_evans/bills_hit_tune?source=ireal"
      },
      {
        "title": "Birdland",
        "artist": "Weather Report (Joe Zawinul)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/weather_report_joe_zawinul/birdland?source=ireal"
      },
      {
        "title": "Birk's Works",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dizzy_gillespie/birks_works?source=ireal"
      },
      {
        "title": "Birth Of The Blues, The",
        "artist": "Ray Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ray_henderson/birth_of_the_blues_the?source=ireal"
      },
      {
        "title": "Black and tan Fantasy",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/duke_ellington/black_and_tan_fantasy?source=ireal"
      },
      {
        "title": "Bloomdido",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/bloomdido?source=ireal"
      },
      {
        "title": "Blue And Sentimental",
        "artist": "Livingstone-David-Basie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/livingstonedavidbasie/blue_and_sentimental?source=ireal"
      },
      {
        "title": "Blue Moon",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/richard_rodgers/blue_moon?source=ireal"
      },
      {
        "title": "Blue Seven",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/blue_seven?source=ireal"
      },
      {
        "title": "Blue Silver",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/blue_silver?source=ireal"
      },
      {
        "title": "Blues Ala Mode",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/mccoy_tyner/blues_ala_mode?source=ireal"
      },
      {
        "title": "Blues For Wood",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/woody_shaw/blues_for_wood?source=ireal"
      },
      {
        "title": "Blues In The Closet",
        "artist": "Oscar Pettiford",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/oscar_pettiford/blues_in_the_closet?source=ireal"
      },
      {
        "title": "Blues by Five",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/miles_davis/blues_by_five?source=ireal"
      },
      {
        "title": "Blues for Philly Joe",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/blues_for_philly_joe?source=ireal"
      },
      {
        "title": "Bohemia After Dark",
        "artist": "Oscar Pettiford",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/oscar_pettiford/bohemia_after_dark?source=ireal"
      },
      {
        "title": "Boogie Stop Shuffle",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charles_mingus/boogie_stop_shuffle?source=ireal"
      },
      {
        "title": "Booker's Waltz",
        "artist": "Booker Little",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/booker_little/bookers_waltz?source=ireal"
      },
      {
        "title": "Bouncin' With Bud",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bud_powell/bouncin_with_bud?source=ireal"
      },
      {
        "title": "Brazilian Beat",
        "artist": "Barney Kessel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/barney_kessel/brazilian_beat?source=ireal"
      },
      {
        "title": "Brian’s Song (The Hands of Time)",
        "artist": "Legrand-Berman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/legrandberman/brians_song_the_hands_of_time?source=ireal"
      },
      {
        "title": "Bright Boy",
        "artist": "John Bright",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_bright/bright_boy?source=ireal"
      },
      {
        "title": "Bright Moments",
        "artist": "Roland Kirk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/roland_kirk/bright_moments?source=ireal"
      },
      {
        "title": "Brilliant Corners",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/brilliant_corners?source=ireal"
      },
      {
        "title": "Brown Skin Girl",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/brown_skin_girl?source=ireal"
      },
      {
        "title": "Bud's Bubble",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bud_powell/buds_bubble?source=ireal"
      },
      {
        "title": "Budo",
        "artist": "Davis-Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/davispowell/budo?source=ireal"
      },
      {
        "title": "Bunko",
        "artist": "Lenny Niehaus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lenny_niehaus/bunko?source=ireal"
      },
      {
        "title": "Buster Rider Again",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bud_powell/buster_rider_again?source=ireal"
      },
      {
        "title": "But Not For Me",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_gershwin/but_not_for_me?source=ireal"
      },
      {
        "title": "Bye Bye Blackbird",
        "artist": "Ray Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ray_henderson/bye_bye_blackbird?source=ireal"
      },
      {
        "title": "Byrdlike",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/freddie_hubbard/byrdlike?source=ireal"
      },
      {
        "title": "C'est What",
        "artist": "Bud Shank",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bud_shank/cest_what?source=ireal"
      },
      {
        "title": "Can't we be Freinds",
        "artist": "Jones-Swift",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jonesswift/cant_we_be_freinds?source=ireal"
      },
      {
        "title": "Careful",
        "artist": "Jim Hall",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jim_hall/careful?source=ireal"
      },
      {
        "title": "Careless Love",
        "artist": "Unknown Composer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/unknown_composer/careless_love?source=ireal"
      },
      {
        "title": "Catch Me",
        "artist": "Joe Pass",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joe_pass/catch_me?source=ireal"
      },
      {
        "title": "Chameleon",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/herbie_hancock/chameleon?source=ireal"
      },
      {
        "title": "Chase, The",
        "artist": "Dexter Gordon",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dexter_gordon/chase_the?source=ireal"
      },
      {
        "title": "Chasin' The Train",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/chasin_the_train?source=ireal"
      },
      {
        "title": "Cheese Cake",
        "artist": "Dexter Gordon",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dexter_gordon/cheese_cake?source=ireal"
      },
      {
        "title": "Circle",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/miles_davis/circle?source=ireal"
      },
      {
        "title": "Come Rain Or Come Shine",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/harold_arlen/come_rain_or_come_shine?source=ireal"
      },
      {
        "title": "Comin' Home Baby",
        "artist": "Dorough-Tucker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/doroughtucker/comin_home_baby?source=ireal"
      },
      {
        "title": "Confessin' (That I Love You)",
        "artist": "Daugherty-Neiberg-Reynolds",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/daughertyneibergreynolds/confessin_that_i_love_you?source=ireal"
      },
      {
        "title": "Cookin'",
        "artist": "Lou Donaldson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lou_donaldson/cookin?source=ireal"
      },
      {
        "title": "Cool Blues",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/cool_blues?source=ireal"
      },
      {
        "title": "Core, The",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/freddie_hubbard/core_the?source=ireal"
      },
      {
        "title": "Cork n' Bib",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/cork_n_bib?source=ireal"
      },
      {
        "title": "Cousin Mary",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/cousin_mary?source=ireal"
      },
      {
        "title": "Crazeology",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bud_powell/crazeology?source=ireal"
      },
      {
        "title": "Criss Cross",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/criss_cross?source=ireal"
      },
      {
        "title": "Cute",
        "artist": "Neil Hefti",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/neil_hefti/cute?source=ireal"
      },
      {
        "title": "Day in Vienna, A",
        "artist": "Slide Hampton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/slide_hampton/day_in_vienna_a?source=ireal"
      },
      {
        "title": "Decision",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/decision?source=ireal"
      },
      {
        "title": "Deep Purple",
        "artist": "Peter De-Rose",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/peter_derose/deep_purple?source=ireal"
      },
      {
        "title": "Dewey Square",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/dewey_square?source=ireal"
      },
      {
        "title": "Diane",
        "artist": "Rapee-pollack",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/rapeepollack/diane?source=ireal"
      },
      {
        "title": "Dindi",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/antoniocarlos_jobim/dindi?source=ireal"
      },
      {
        "title": "Do Nothing Til You Hear From Me",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/duke_ellington/do_nothing_til_you_hear_from_me?source=ireal"
      },
      {
        "title": "Do You Know What It Means?",
        "artist": "Louis Alter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/louis_alter/do_you_know_what_it_means?source=ireal"
      },
      {
        "title": "Domingo",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/benny_golson/domingo?source=ireal"
      },
      {
        "title": "Down for Double",
        "artist": "Freddie Green",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/freddie_green/down_for_double?source=ireal"
      },
      {
        "title": "Doxy",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/doxy?source=ireal"
      },
      {
        "title": "Drive, The",
        "artist": "Oliver Nelson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/oliver_nelson/drive_the?source=ireal"
      },
      {
        "title": "Duff",
        "artist": "Hapton Hawes",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hapton_hawes/duff?source=ireal"
      },
      {
        "title": "E.K.'s Blues",
        "artist": "Ed Kaiser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ed_kaiser/eks_blues?source=ireal"
      },
      {
        "title": "Early Autumn",
        "artist": "Burns-Herman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/burnsherman/early_autumn?source=ireal"
      },
      {
        "title": "Eclypso",
        "artist": "Tommy Flanagan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tommy_flanagan/eclypso?source=ireal"
      },
      {
        "title": "Einbahnstrasse",
        "artist": "Ron Carter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ron_carter/einbahnstrasse?source=ireal"
      },
      {
        "title": "Elora",
        "artist": "J.J. Johnson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jj_johnson/elora?source=ireal"
      },
      {
        "title": "Embraceable You",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_gershwin/embraceable_you?source=ireal"
      },
      {
        "title": "Enchance",
        "artist": "Joanne Brackeen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joanne_brackeen/enchance?source=ireal"
      },
      {
        "title": "Epilogue",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bill_evans/epilogue?source=ireal"
      },
      {
        "title": "Evening in Concert",
        "artist": "Joanne Brackeen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joanne_brackeen/evening_in_concert?source=ireal"
      },
      {
        "title": "Everything I Have Is Yours",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/burton_lane/everything_i_have_is_yours?source=ireal"
      },
      {
        "title": "Eye of the Hurricane",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/herbie_hancock/eye_of_the_hurricane?source=ireal"
      },
      {
        "title": "Ezz-Thetic",
        "artist": "George Russell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_russell/ezzthetic?source=ireal"
      },
      {
        "title": "Feels So Good",
        "artist": "Chuck Mangione",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/chuck_mangione/feels_so_good?source=ireal"
      },
      {
        "title": "First Moves",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/first_moves?source=ireal"
      },
      {
        "title": "First Trip",
        "artist": "Ron Carter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ron_carter/first_trip?source=ireal"
      },
      {
        "title": "Five Brothers",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerry_mulligan/five_brothers?source=ireal"
      },
      {
        "title": "Five Spot After Dark",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/benny_golson/five_spot_after_dark?source=ireal"
      },
      {
        "title": "Flim Flam",
        "artist": "Mike Wofford",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/mike_wofford/flim_flam?source=ireal"
      },
      {
        "title": "Flintstones Theme",
        "artist": "Hoyt Curtain",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hoyt_curtain/flintstones_theme?source=ireal"
      },
      {
        "title": "Flower Is A Lovesome Thing, A",
        "artist": "Billy Strayhorn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/billy_strayhorn/flower_is_a_lovesome_thing_a?source=ireal"
      },
      {
        "title": "Fly Me To The Moon",
        "artist": "Bart Howard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bart_howard/fly_me_to_the_moon?source=ireal"
      },
      {
        "title": "Fly by Night",
        "artist": "Dave Grusin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dave_grusin/fly_by_night?source=ireal"
      },
      {
        "title": "Flying Home",
        "artist": "Goodman-Hampton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/goodmanhampton/flying_home?source=ireal"
      },
      {
        "title": "Fools Rush In",
        "artist": "Rube Bloom",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/rube_bloom/fools_rush_in?source=ireal"
      },
      {
        "title": "For Minors Only",
        "artist": "J. Heath",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/j_heath/for_minors_only?source=ireal"
      },
      {
        "title": "Four Brothers",
        "artist": "Jimmy Giuffre",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_giuffre/four_brothers?source=ireal"
      },
      {
        "title": "Freddie Froo",
        "artist": "Pepper Adams",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pepper_adams/freddie_froo?source=ireal"
      },
      {
        "title": "Free Cell Block F, Tis Nazi USA",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charles_mingus/free_cell_block_f_tis_nazi_usa?source=ireal"
      },
      {
        "title": "Friday The 13th",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/friday_the_13th?source=ireal"
      },
      {
        "title": "Funk Dumplin'",
        "artist": "Johnny Coles",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/johnny_coles/funk_dumplin?source=ireal"
      },
      {
        "title": "Funky",
        "artist": "Kenny Burrell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/kenny_burrell/funky?source=ireal"
      },
      {
        "title": "Games People Play",
        "artist": "Joe South",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joe_south/games_people_play?source=ireal"
      },
      {
        "title": "Gentle Rain",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/luiz_bonfa/gentle_rain?source=ireal"
      },
      {
        "title": "Gentlewind and Falling Tear",
        "artist": "Gary Burton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gary_burton/gentlewind_and_falling_tear?source=ireal"
      },
      {
        "title": "Georgia On My Mind",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hoagy_carmichael/georgia_on_my_mind?source=ireal"
      },
      {
        "title": "Get Out Of Town",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/cole_porter/get_out_of_town?source=ireal"
      },
      {
        "title": "Gettin' it Togetha'",
        "artist": "Bobby Timons",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bobby_timons/gettin_it_togetha?source=ireal"
      },
      {
        "title": "Ghost Of A Chance, A",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/victor_young/ghost_of_a_chance_a?source=ireal"
      },
      {
        "title": "Girl Talk",
        "artist": "Neal Hefti",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/neal_hefti/girl_talk?source=ireal"
      },
      {
        "title": "Golden Notebooks",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerry_mulligan/golden_notebooks?source=ireal"
      },
      {
        "title": "Good Bait",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tadd_dameron/good_bait?source=ireal"
      },
      {
        "title": "Gregory Is Here",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/gregory_is_here?source=ireal"
      },
      {
        "title": "Groove Merchant",
        "artist": "Thad Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thad_jones/groove_merchant?source=ireal"
      },
      {
        "title": "Groove Yard",
        "artist": "Carl Perkins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/carl_perkins/groove_yard?source=ireal"
      },
      {
        "title": "Groovy Samba",
        "artist": "Sergio Mendes",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sergio_mendes/groovy_samba?source=ireal"
      },
      {
        "title": "Hackensack",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/hackensack?source=ireal"
      },
      {
        "title": "Hallucinations",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bud_powell/hallucinations?source=ireal"
      },
      {
        "title": "Happy Little Sunbeam",
        "artist": "Russ Freeman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/russ_freeman/happy_little_sunbeam?source=ireal"
      },
      {
        "title": "Harlequin",
        "artist": "Weather Report (Wayne Shorter)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/weather_report_wayne_shorter/harlequin?source=ireal"
      },
      {
        "title": "Havona",
        "artist": "Weather Report (Jaco Pastorius)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/weather_report_jaco_pastorius/havona?source=ireal"
      },
      {
        "title": "Head and Shoulders",
        "artist": "Cedar Walton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/cedar_walton/head_and_shoulders?source=ireal"
      },
      {
        "title": "Hello",
        "artist": "Milt Jackson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/milt_jackson/hello?source=ireal"
      },
      {
        "title": "Here's That Sunny Day",
        "artist": "Barney Kessel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/barney_kessel/heres_that_sunny_day?source=ireal"
      },
      {
        "title": "Hi Beck",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/hi_beck?source=ireal"
      },
      {
        "title": "Hi-Fly",
        "artist": "Randy Weston",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/randy_weston/hifly?source=ireal"
      },
      {
        "title": "Ho-Ba-La-La",
        "artist": "Joao Gilberto",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joao_gilberto/hobalala?source=ireal"
      },
      {
        "title": "Hocus-Pocus",
        "artist": "Lee Morgan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_morgan/hocuspocus?source=ireal"
      },
      {
        "title": "Horace Scope",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/horace_scope?source=ireal"
      },
      {
        "title": "Horizon",
        "artist": "Mike Wofford",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/mike_wofford/horizon?source=ireal"
      },
      {
        "title": "Hummin'",
        "artist": "Nat Adderley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/nat_adderley/hummin?source=ireal"
      },
      {
        "title": "Humpty Dumpty",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/chick_corea/humpty_dumpty?source=ireal"
      },
      {
        "title": "I Believe In You",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/frank_loesser/i_believe_in_you?source=ireal"
      },
      {
        "title": "I Cover The Waterfront",
        "artist": "Johnny Green",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/johnny_green/i_cover_the_waterfront?source=ireal"
      },
      {
        "title": "I Get A Kick Out Of You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/cole_porter/i_get_a_kick_out_of_you?source=ireal"
      },
      {
        "title": "I Hear A Rhapsody",
        "artist": "Fragos-Baker-Gasparre",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/fragosbakergasparre/i_hear_a_rhapsody?source=ireal"
      },
      {
        "title": "I Remember You",
        "artist": "Victor Schertzinger",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/victor_schertzinger/i_remember_you?source=ireal"
      },
      {
        "title": "I Thought About You",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_vanheusen/i_thought_about_you?source=ireal"
      },
      {
        "title": "I Will Wait For You",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/michel_legrand/i_will_wait_for_you?source=ireal"
      },
      {
        "title": "I'm A Fool To Want You",
        "artist": "Herron-Sinatra-Wolf",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/herronsinatrawolf/im_a_fool_to_want_you?source=ireal"
      },
      {
        "title": "I'm Getting Sentimental Over You",
        "artist": "George Bassman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_bassman/im_getting_sentimental_over_you?source=ireal"
      },
      {
        "title": "I've Found A New Baby",
        "artist": "Palmer-Williams",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/palmerwilliams/ive_found_a_new_baby?source=ireal"
      },
      {
        "title": "Ice Cream Konitz",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/ice_cream_konitz?source=ireal"
      },
      {
        "title": "Idol Gossip",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerry_mulligan/idol_gossip?source=ireal"
      },
      {
        "title": "If I Loved You",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/richard_rodgers/if_i_loved_you?source=ireal"
      },
      {
        "title": "If I Should Lose You",
        "artist": "Ralph Rainger",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ralph_rainger/if_i_should_lose_you?source=ireal"
      },
      {
        "title": "If I Were A Bell",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/frank_loesser/if_i_were_a_bell?source=ireal"
      },
      {
        "title": "If You Could See Me Now",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tadd_dameron/if_you_could_see_me_now?source=ireal"
      },
      {
        "title": "Imagination",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_vanheusen/imagination?source=ireal"
      },
      {
        "title": "In Case you Haven't Heard",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/woody_shaw/in_case_you_havent_heard?source=ireal"
      },
      {
        "title": "In Pursuit Of The 27th Man",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/in_pursuit_of_the_27th_man?source=ireal"
      },
      {
        "title": "In Walked Bud",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/in_walked_bud?source=ireal"
      },
      {
        "title": "Incentive",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/incentive?source=ireal"
      },
      {
        "title": "Indiana (Back Home Again In)",
        "artist": "James Hanley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/james_hanley/indiana_back_home_again_in?source=ireal"
      },
      {
        "title": "Is it really True",
        "artist": "Joanne Brackeen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joanne_brackeen/is_it_really_true?source=ireal"
      },
      {
        "title": "Island Birdie",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/mccoy_tyner/island_birdie?source=ireal"
      },
      {
        "title": "It Could Happen To You",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_vanheusen/it_could_happen_to_you?source=ireal"
      },
      {
        "title": "It Had To Be You",
        "artist": "Isham Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/isham_jones/it_had_to_be_you?source=ireal"
      },
      {
        "title": "It Might As Well Be Spring",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/richard_rodgers/it_might_as_well_be_spring?source=ireal"
      },
      {
        "title": "It's Only a Paper Moon",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/harold_arlen/its_only_a_paper_moon?source=ireal"
      },
      {
        "title": "Jackie",
        "artist": "H. Hawes",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/h_hawes/jackie?source=ireal"
      },
      {
        "title": "Jaco",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/jaco?source=ireal"
      },
      {
        "title": "Je Ne Sais Pas",
        "artist": "Hampton-Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hamptonjones/je_ne_sais_pas?source=ireal"
      },
      {
        "title": "Jeannine",
        "artist": "Duke Pearson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/duke_pearson/jeannine?source=ireal"
      },
      {
        "title": "Jitterbug Waltz",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/fats_waller/jitterbug_waltz?source=ireal"
      },
      {
        "title": "Jody Grind, The",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/jody_grind_the?source=ireal"
      },
      {
        "title": "Jorgie's",
        "artist": "D- Byad",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/d_byad/jorgies?source=ireal"
      },
      {
        "title": "Joy To The World",
        "artist": "George Handel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_handel/joy_to_the_world?source=ireal"
      },
      {
        "title": "Joyce's Samba",
        "artist": "Mauricio Einhorn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/mauricio_einhorn/joyces_samba?source=ireal"
      },
      {
        "title": "Jump For Me",
        "artist": "Count Basie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/count_basie/jump_for_me?source=ireal"
      },
      {
        "title": "Jumpin With Symphony Sid",
        "artist": "Lester Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lester_young/jumpin_with_symphony_sid?source=ireal"
      },
      {
        "title": "Just A Few",
        "artist": "Shorty Rogers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/shorty_rogers/just_a_few?source=ireal"
      },
      {
        "title": "Just A-Sittin' And A-Rockin",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/duke_ellington/just_asittin_and_arockin?source=ireal"
      },
      {
        "title": "Just In Time",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jule_styne/just_in_time?source=ireal"
      },
      {
        "title": "Just The Way You Are",
        "artist": "Billy Joel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/billy_joel/just_the_way_you_are?source=ireal"
      },
      {
        "title": "Just You, Just Me",
        "artist": "Jesse Greer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jesse_greer/just_you_just_me?source=ireal"
      },
      {
        "title": "Kary's Trance",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/karys_trance?source=ireal"
      },
      {
        "title": "Katrina Ballerina",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/woody_shaw/katrina_ballerina?source=ireal"
      },
      {
        "title": "Kentucky Oysters",
        "artist": "David Baker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/david_baker/kentucky_oysters?source=ireal"
      },
      {
        "title": "Kicker, The",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joe_henderson/kicker_the?source=ireal"
      },
      {
        "title": "Kids Are Pretty People",
        "artist": "Thad Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thad_jones/kids_are_pretty_people?source=ireal"
      },
      {
        "title": "Killer Joe",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/benny_golson/killer_joe?source=ireal"
      },
      {
        "title": "La Nevada Blues",
        "artist": "Gil Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gil_evans/la_nevada_blues?source=ireal"
      },
      {
        "title": "Lady's Blues",
        "artist": "Roland Kirk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/roland_kirk/ladys_blues?source=ireal"
      },
      {
        "title": "Lakes",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/lakes?source=ireal"
      },
      {
        "title": "Last Page, The",
        "artist": "Woods-Beck",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/woodsbeck/last_page_the?source=ireal"
      },
      {
        "title": "Laura",
        "artist": "David Raskin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/david_raskin/laura?source=ireal"
      },
      {
        "title": "Leila",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/wes_montgomery/leila?source=ireal"
      },
      {
        "title": "Lennie's Pennies",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lennie_tristano/lennies_pennies?source=ireal"
      },
      {
        "title": "Lennie-Bird",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lennie_tristano/lenniebird?source=ireal"
      },
      {
        "title": "Lester Leaps In",
        "artist": "Lester Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lester_young/lester_leaps_in?source=ireal"
      },
      {
        "title": "Let's Cool One",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/lets_cool_one?source=ireal"
      },
      {
        "title": "Liberated Brother",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/liberated_brother?source=ireal"
      },
      {
        "title": "Lies",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/lies?source=ireal"
      },
      {
        "title": "Light As a Feather",
        "artist": "Stanley Clarke",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/stanley_clarke/light_as_a_feather?source=ireal"
      },
      {
        "title": "Like Sonny",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/like_sonny?source=ireal"
      },
      {
        "title": "Limbo",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/wayne_shorter/limbo?source=ireal"
      },
      {
        "title": "Little Chicago Fire, A",
        "artist": "Frank Foster",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/frank_foster/little_chicago_fire_a?source=ireal"
      },
      {
        "title": "Little Rootie Tootie",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/little_rootie_tootie?source=ireal"
      },
      {
        "title": "Little Sunflower",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/freddie_hubbard/little_sunflower?source=ireal"
      },
      {
        "title": "Locomotion",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/locomotion?source=ireal"
      },
      {
        "title": "Lone Jack (Page 1)",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/lone_jack_page_1?source=ireal"
      },
      {
        "title": "Lone Jack (Page 2 - Solos)",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/lone_jack_page_2__solos?source=ireal"
      },
      {
        "title": "Lonely Dreams",
        "artist": "Terry Gibbs",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/terry_gibbs/lonely_dreams?source=ireal"
      },
      {
        "title": "Love For Sale",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/cole_porter/love_for_sale?source=ireal"
      },
      {
        "title": "Love Vibrations",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/love_vibrations?source=ireal"
      },
      {
        "title": "Lover",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/richard_rodgers/lover?source=ireal"
      },
      {
        "title": "Lover Man",
        "artist": "Davis-Ramirez-Sherman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/davisramirezsherman/lover_man?source=ireal"
      },
      {
        "title": "Lunar Tune",
        "artist": "Booker Ervin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/booker_ervin/lunar_tune?source=ireal"
      },
      {
        "title": "Lydian April",
        "artist": "David Baker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/david_baker/lydian_april?source=ireal"
      },
      {
        "title": "Make Someone Happy",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jule_styne/make_someone_happy?source=ireal"
      },
      {
        "title": "Man I Love, The",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_gershwin/man_i_love_the?source=ireal"
      },
      {
        "title": "Manteca",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dizzy_gillespie/manteca?source=ireal"
      },
      {
        "title": "Maok's Shop",
        "artist": "Wes Montgomery",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/wes_montgomery/maoks_shop?source=ireal"
      },
      {
        "title": "May-Reh",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/mayreh?source=ireal"
      },
      {
        "title": "Mellow Mood",
        "artist": "Jimmy Smith",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_smith/mellow_mood?source=ireal"
      },
      {
        "title": "Memories Of You",
        "artist": "Eubie Blake",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/eubie_blake/memories_of_you?source=ireal"
      },
      {
        "title": "Menina Flor",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/luiz_bonfa/menina_flor?source=ireal"
      },
      {
        "title": "Mercy Mercy Mercy",
        "artist": "Weather Report (Joe Zawinul)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/weather_report_joe_zawinul/mercy_mercy_mercy?source=ireal"
      },
      {
        "title": "Miles Ahead",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/miles_davis/miles_ahead?source=ireal"
      },
      {
        "title": "Minor Mishap",
        "artist": "Tommy Flanagan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tommy_flanagan/minor_mishap?source=ireal"
      },
      {
        "title": "Minor Mood",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/clifford_brown/minor_mood?source=ireal"
      },
      {
        "title": "Moanin'",
        "artist": "Bobby Timmons",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bobby_timmons/moanin?source=ireal"
      },
      {
        "title": "Modesty Blues",
        "artist": "Cal Tjader",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/cal_tjader/modesty_blues?source=ireal"
      },
      {
        "title": "Monk's Mood",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/monks_mood?source=ireal"
      },
      {
        "title": "Monk's Sphere",
        "artist": "Gary McFarland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gary_mcfarland/monks_sphere?source=ireal"
      },
      {
        "title": "Moon Rays",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/moon_rays?source=ireal"
      },
      {
        "title": "Moonglow",
        "artist": "Hudson-Lange-Mills",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hudsonlangemills/moonglow?source=ireal"
      },
      {
        "title": "Moontrane, The",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/woody_shaw/moontrane_the?source=ireal"
      },
      {
        "title": "Moose The Mooche",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/moose_the_mooche?source=ireal"
      },
      {
        "title": "Morning",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/clare_fischer/morning?source=ireal"
      },
      {
        "title": "Moten's Swing",
        "artist": "Bennie Moten",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bennie_moten/motens_swing?source=ireal"
      },
      {
        "title": "Move",
        "artist": "Denzil Best",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/denzil_best/move?source=ireal"
      },
      {
        "title": "Moving Out",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/moving_out?source=ireal"
      },
      {
        "title": "Mr Broadway",
        "artist": "Dave Brubeck",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dave_brubeck/mr_broadway?source=ireal"
      },
      {
        "title": "Mr Clean",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/freddie_hubbard/mr_clean?source=ireal"
      },
      {
        "title": "Mr. Jones",
        "artist": "Elvin Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/elvin_jones/mr_jones?source=ireal"
      },
      {
        "title": "Mr. Magic",
        "artist": "Ralph MacDonald",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ralph_macdonald/mr_magic?source=ireal"
      },
      {
        "title": "Mr. Sims",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/mr_sims?source=ireal"
      },
      {
        "title": "Mrs. miniver",
        "artist": "Dexter Gordon",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dexter_gordon/mrs_miniver?source=ireal"
      },
      {
        "title": "Muezzin'",
        "artist": "Petter Adams",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/petter_adams/muezzin?source=ireal"
      },
      {
        "title": "My Little Suede Shoes",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/my_little_suede_shoes?source=ireal"
      },
      {
        "title": "My Old Flame",
        "artist": "Johnson-Coslow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/johnsoncoslow/my_old_flame?source=ireal"
      },
      {
        "title": "Mystic Touch",
        "artist": "Joanne Brackeen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joanne_brackeen/mystic_touch?source=ireal"
      },
      {
        "title": "Nancy Joe",
        "artist": "Gerald Wilson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerald_wilson/nancy_joe?source=ireal"
      },
      {
        "title": "Nature Boy",
        "artist": "Eden Ahbez",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/eden_ahbez/nature_boy?source=ireal"
      },
      {
        "title": "Nearness Of You, The",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hoagy_carmichael/nearness_of_you_the?source=ireal"
      },
      {
        "title": "New Thing, A",
        "artist": "Slide Hampton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/slide_hampton/new_thing_a?source=ireal"
      },
      {
        "title": "No Me Esqueça",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joe_henderson/no_me_esquea?source=ireal"
      },
      {
        "title": "No Moe",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/no_moe?source=ireal"
      },
      {
        "title": "No Splice",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/no_splice?source=ireal"
      },
      {
        "title": "North Atlantic Run",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerry_mulligan/north_atlantic_run?source=ireal"
      },
      {
        "title": "Now's the Time",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/nows_the_time?source=ireal"
      },
      {
        "title": "Nutville",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/nutville?source=ireal"
      },
      {
        "title": "Off Minor",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/off_minor?source=ireal"
      },
      {
        "title": "Oh, Lady Be Good",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_gershwin/oh_lady_be_good?source=ireal"
      },
      {
        "title": "Old Devil Moon",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/burton_lane/old_devil_moon?source=ireal"
      },
      {
        "title": "On A Clear Day",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/burton_lane/on_a_clear_day?source=ireal"
      },
      {
        "title": "On The Stairs",
        "artist": "Pat Martino",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_martino/on_the_stairs?source=ireal"
      },
      {
        "title": "On The Trail",
        "artist": "Ferde Grofe",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ferde_grofe/on_the_trail?source=ireal"
      },
      {
        "title": "Once In A While",
        "artist": "Michael Edwards",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/michael_edwards/once_in_a_while?source=ireal"
      },
      {
        "title": "One By One",
        "artist": "Wayne Shorter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/wayne_shorter/one_by_one?source=ireal"
      },
      {
        "title": "One Foot In The Gutter",
        "artist": "Clark Terry",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/clark_terry/one_foot_in_the_gutter?source=ireal"
      },
      {
        "title": "One For Daddy",
        "artist": "Nat Adderley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/nat_adderley/one_for_daddy?source=ireal"
      },
      {
        "title": "Opus De Funk",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/opus_de_funk?source=ireal"
      },
      {
        "title": "Our Love is Here to Stay",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_gershwin/our_love_is_here_to_stay?source=ireal"
      },
      {
        "title": "Out Back of the Barn",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerry_mulligan/out_back_of_the_barn?source=ireal"
      },
      {
        "title": "Oye Como Va",
        "artist": "Tito Puente",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tito_puente/oye_como_va?source=ireal"
      },
      {
        "title": "Palo-Alto",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/paloalto?source=ireal"
      },
      {
        "title": "Pannonica",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/pannonica?source=ireal"
      },
      {
        "title": "Patterns",
        "artist": "Oliver Nelson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/oliver_nelson/patterns?source=ireal"
      },
      {
        "title": "Pennies From Heaven",
        "artist": "Arthur Johnston",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/arthur_johnston/pennies_from_heaven?source=ireal"
      },
      {
        "title": "Penny Arcade",
        "artist": "Joe Beck",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joe_beck/penny_arcade?source=ireal"
      },
      {
        "title": "People Will Say We're In Love",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/richard_rodgers/people_will_say_were_in_love?source=ireal"
      },
      {
        "title": "Perdido",
        "artist": "Juan Tizol",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/juan_tizol/perdido?source=ireal"
      },
      {
        "title": "Perdido Line",
        "artist": "Terry Hamilton-Clark Jimmy",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/terry_hamiltonclark_jimmy/perdido_line?source=ireal"
      },
      {
        "title": "Petit Fleur",
        "artist": "Sidney Bechet",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sidney_bechet/petit_fleur?source=ireal"
      },
      {
        "title": "Petit Machins",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/miles_davis/petit_machins?source=ireal"
      },
      {
        "title": "Phase Dance",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/phase_dance?source=ireal"
      },
      {
        "title": "Pick Yourself Up",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jerome_kern/pick_yourself_up?source=ireal"
      },
      {
        "title": "Polkadots And Moonbeams",
        "artist": "Jimmy Van-Heusen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_vanheusen/polkadots_and_moonbeams?source=ireal"
      },
      {
        "title": "Portrait Of Jennie",
        "artist": "Burdge-Robinson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/burdgerobinson/portrait_of_jennie?source=ireal"
      },
      {
        "title": "Preacher, The",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/preacher_the?source=ireal"
      },
      {
        "title": "Progression",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/progression?source=ireal"
      },
      {
        "title": "Pursuance (Part 3)",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/pursuance_part_3?source=ireal"
      },
      {
        "title": "Quicksilver",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/quicksilver?source=ireal"
      },
      {
        "title": "Ramblin'",
        "artist": "Ornette Coleman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ornette_coleman/ramblin?source=ireal"
      },
      {
        "title": "Recado Bossa Nova",
        "artist": "Djalma Ferreira",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/djalma_ferreira/recado_bossa_nova?source=ireal"
      },
      {
        "title": "Red Cross",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/red_cross?source=ireal"
      },
      {
        "title": "Remark you Made, A",
        "artist": "Weather Report (Joe Zawinul)",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/weather_report_joe_zawinul/remark_you_made_a?source=ireal"
      },
      {
        "title": "Rhythm-a-ning",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thelonious_monk/rhythmaning?source=ireal"
      },
      {
        "title": "Robbin's Nest",
        "artist": "Thompson-Jacquet",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/thompsonjacquet/robbins_nest?source=ireal"
      },
      {
        "title": "Rubberneck",
        "artist": "Frank Rosolino",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/frank_rosolino/rubberneck?source=ireal"
      },
      {
        "title": "Saint James Infirmary",
        "artist": "Joe Primrose",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joe_primrose/saint_james_infirmary?source=ireal"
      },
      {
        "title": "Salt Peanuts",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dizzy_gillespie/salt_peanuts?source=ireal"
      },
      {
        "title": "Samba du Bois",
        "artist": "Phil Woods",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/phil_woods/samba_du_bois?source=ireal"
      },
      {
        "title": "Sandu",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/clifford_brown/sandu?source=ireal"
      },
      {
        "title": "Scene is Clean, The",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tadd_dameron/scene_is_clean_the?source=ireal"
      },
      {
        "title": "September In The Rain",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/harry_warren/september_in_the_rain?source=ireal"
      },
      {
        "title": "September Song",
        "artist": "Kurt Weill",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/kurt_weill/september_song?source=ireal"
      },
      {
        "title": "Serenade To A Soul Sister",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/serenade_to_a_soul_sister?source=ireal"
      },
      {
        "title": "Serene",
        "artist": "Eric Dolphy",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/eric_dolphy/serene?source=ireal"
      },
      {
        "title": "Serenity",
        "artist": "Joe Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/joe_henderson/serenity?source=ireal"
      },
      {
        "title": "Seventeen West",
        "artist": "Eric Dolphy",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/eric_dolphy/seventeen_west?source=ireal"
      },
      {
        "title": "Shiny Stockings",
        "artist": "Frank Foster",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/frank_foster/shiny_stockings?source=ireal"
      },
      {
        "title": "Short Riff",
        "artist": "Ed Kaiser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ed_kaiser/short_riff?source=ireal"
      },
      {
        "title": "Short Stop",
        "artist": "Shorty Rogers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/shorty_rogers/short_stop?source=ireal"
      },
      {
        "title": "Shutter Bug",
        "artist": "J.J. Johnson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jj_johnson/shutter_bug?source=ireal"
      },
      {
        "title": "Silver's Serenade",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/silvers_serenade?source=ireal"
      },
      {
        "title": "Simone",
        "artist": "Frank Foster",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/frank_foster/simone?source=ireal"
      },
      {
        "title": "Sippin' At Bells",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/miles_davis/sippin_at_bells?source=ireal"
      },
      {
        "title": "Sister Sadie",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/sister_sadie?source=ireal"
      },
      {
        "title": "Sleepin' Bee, A",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/harold_arlen/sleepin_bee_a?source=ireal"
      },
      {
        "title": "Slipped Disc",
        "artist": "Benny Goodman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/benny_goodman/slipped_disc?source=ireal"
      },
      {
        "title": "Slow Hot Wind",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/henry_mancini/slow_hot_wind?source=ireal"
      },
      {
        "title": "Smoke Gets In Your Eyes",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jerome_kern/smoke_gets_in_your_eyes?source=ireal"
      },
      {
        "title": "Softly, As In A Morning Sunrise",
        "artist": "Sigmund Romberg",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sigmund_romberg/softly_as_in_a_morning_sunrise?source=ireal"
      },
      {
        "title": "Some Other Blues",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/some_other_blues?source=ireal"
      },
      {
        "title": "Someone To Watch Over Me",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_gershwin/someone_to_watch_over_me?source=ireal"
      },
      {
        "title": "Song For Bilbao",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/song_for_bilbao?source=ireal"
      },
      {
        "title": "Song for my Lady",
        "artist": "McCoy Tyner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/mccoy_tyner/song_for_my_lady?source=ireal"
      },
      {
        "title": "Soul Eyes",
        "artist": "Mal Waldron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/mal_waldron/soul_eyes?source=ireal"
      },
      {
        "title": "Soultrane",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tadd_dameron/soultrane?source=ireal"
      },
      {
        "title": "Sound Lee",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/sound_lee?source=ireal"
      },
      {
        "title": "Speak Like A Child",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/herbie_hancock/speak_like_a_child?source=ireal"
      },
      {
        "title": "Speak Low",
        "artist": "Kurt Weill",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/kurt_weill/speak_low?source=ireal"
      },
      {
        "title": "Spiral",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/spiral?source=ireal"
      },
      {
        "title": "Spring Can Really Hang You Up The Most",
        "artist": "Tommy Wolf",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tommy_wolf/spring_can_really_hang_you_up_the_most?source=ireal"
      },
      {
        "title": "St. Louis Blues",
        "artist": "Handy C. W.",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/handy_c_w/st_louis_blues?source=ireal"
      },
      {
        "title": "St. Thomas",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/st_thomas?source=ireal"
      },
      {
        "title": "Star Dust",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hoagy_carmichael/star_dust?source=ireal"
      },
      {
        "title": "Star Eyes",
        "artist": "Gene DePaul",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gene_depaul/star_eyes?source=ireal"
      },
      {
        "title": "Stardust",
        "artist": "Hoagy Charmichael",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hoagy_charmichael/stardust?source=ireal"
      },
      {
        "title": "Straight Life",
        "artist": "Freddie Hubbard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/freddie_hubbard/straight_life?source=ireal"
      },
      {
        "title": "Strayhorn 2",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerry_mulligan/strayhorn_2?source=ireal"
      },
      {
        "title": "Strode Rode",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/strode_rode?source=ireal"
      },
      {
        "title": "Strollin'",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/strollin?source=ireal"
      },
      {
        "title": "Struttin With Some Barbecue",
        "artist": "Armstrong H. Lilian",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/armstrong_h_lilian/struttin_with_some_barbecue?source=ireal"
      },
      {
        "title": "Subconscious Lee",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/subconscious_lee?source=ireal"
      },
      {
        "title": "Summer In Central Park",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/summer_in_central_park?source=ireal"
      },
      {
        "title": "Summer Knows, The",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/michel_legrand/summer_knows_the?source=ireal"
      },
      {
        "title": "Summertime",
        "artist": "George Gershwing",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_gershwing/summertime?source=ireal"
      },
      {
        "title": "Sweet Georgia Brown",
        "artist": "Bernie-Pinkard-Casey",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/berniepinkardcasey/sweet_georgia_brown?source=ireal"
      },
      {
        "title": "Sweetest Sounds, The",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/richard_rodgers/sweetest_sounds_the?source=ireal"
      },
      {
        "title": "Swinging Shepherd Blues, The",
        "artist": "Koffman-Roberts-Jacobson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/koffmanrobertsjacobson/swinging_shepherd_blues_the?source=ireal"
      },
      {
        "title": "Syeeda's Song Flute",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/syeedas_song_flute?source=ireal"
      },
      {
        "title": "Tadd's Delight",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/tadd_dameron/tadds_delight?source=ireal"
      },
      {
        "title": "Taking A Chance On Love",
        "artist": "Vernon Duke",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/vernon_duke/taking_a_chance_on_love?source=ireal"
      },
      {
        "title": "Tangerine",
        "artist": "Victor Schertzinger",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/victor_schertzinger/tangerine?source=ireal"
      },
      {
        "title": "Tautology",
        "artist": "Lee Konitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lee_konitz/tautology?source=ireal"
      },
      {
        "title": "Teenie's Blues",
        "artist": "Oliver Nelson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/oliver_nelson/teenies_blues?source=ireal"
      },
      {
        "title": "Tenderly",
        "artist": "Walter Gross",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/walter_gross/tenderly?source=ireal"
      },
      {
        "title": "Tenor Madness",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/sonny_rollins/tenor_madness?source=ireal"
      },
      {
        "title": "Their's Tears",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/clare_fischer/theirs_tears?source=ireal"
      },
      {
        "title": "These Foolish Things",
        "artist": "Strachey-Link",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/stracheylink/these_foolish_things?source=ireal"
      },
      {
        "title": "Things Ain't What They Used To Be",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/duke_ellington/things_aint_what_they_used_to_be?source=ireal"
      },
      {
        "title": "Things to Come",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/dizzy_gillespie/things_to_come?source=ireal"
      },
      {
        "title": "This I Dig Of You",
        "artist": "Hank Mobley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/hank_mobley/this_i_dig_of_you?source=ireal"
      },
      {
        "title": "This Masquerade",
        "artist": "Leon Russell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/leon_russell/this_masquerade?source=ireal"
      },
      {
        "title": "Three Base Hit",
        "artist": "Pat Martino",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_martino/three_base_hit?source=ireal"
      },
      {
        "title": "Thriving From A Riff",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/thriving_from_a_riff?source=ireal"
      },
      {
        "title": "Thumper, The",
        "artist": "Jimmy Heath",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jimmy_heath/thumper_the?source=ireal"
      },
      {
        "title": "Tickle-Toe",
        "artist": "Lester Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lester_young/tickletoe?source=ireal"
      },
      {
        "title": "Till There Was You",
        "artist": "Meredith Wilson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/meredith_wilson/till_there_was_you?source=ireal"
      },
      {
        "title": "Time After Time",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jule_styne/time_after_time?source=ireal"
      },
      {
        "title": "Tippin'",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/horace_silver/tippin?source=ireal"
      },
      {
        "title": "Tomorrow's Destinity",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/woody_shaw/tomorrows_destinity?source=ireal"
      },
      {
        "title": "Trane’s Blues",
        "artist": "John Coltrane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/john_coltrane/tranes_blues?source=ireal"
      },
      {
        "title": "Turnaround",
        "artist": "Ornette Coleman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ornette_coleman/turnaround?source=ireal"
      },
      {
        "title": "Twisted",
        "artist": "Gray Wardell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gray_wardell/twisted?source=ireal"
      },
      {
        "title": "Two not One",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lennie_tristano/two_not_one?source=ireal"
      },
      {
        "title": "Vonetta",
        "artist": "Earl Klugh",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/earl_klugh/vonetta?source=ireal"
      },
      {
        "title": "Walk Tall",
        "artist": "Cannonball Adderley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/cannonball_adderley/walk_tall?source=ireal"
      },
      {
        "title": "Walkin Thing, A",
        "artist": "Benny Carter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/benny_carter/walkin_thing_a?source=ireal"
      },
      {
        "title": "Walkin' Shoes",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/gerry_mulligan/walkin_shoes?source=ireal"
      },
      {
        "title": "Wall Street",
        "artist": "J. Knowlton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/j_knowlton/wall_street?source=ireal"
      },
      {
        "title": "Watch What Happens",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/michel_legrand/watch_what_happens?source=ireal"
      },
      {
        "title": "Water Colors",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/water_colors?source=ireal"
      },
      {
        "title": "Water Sign",
        "artist": "Jeff Lorber",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jeff_lorber/water_sign?source=ireal"
      },
      {
        "title": "Way You Look Tonight, The",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/jerome_kern/way_you_look_tonight_the?source=ireal"
      },
      {
        "title": "Webb City",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bud_powell/webb_city?source=ireal"
      },
      {
        "title": "Weekend Blues",
        "artist": "Ed Kaiser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ed_kaiser/weekend_blues?source=ireal"
      },
      {
        "title": "Wendy",
        "artist": "Paul Desmond",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/paul_desmond/wendy?source=ireal"
      },
      {
        "title": "What's New",
        "artist": "Bob Haggard",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/bob_haggard/whats_new?source=ireal"
      },
      {
        "title": "When Lights Are Low",
        "artist": "Benny Carter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/benny_carter/when_lights_are_low?source=ireal"
      },
      {
        "title": "Whisper Not",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/benny_golson/whisper_not?source=ireal"
      },
      {
        "title": "Who Can I Turn To?",
        "artist": "Newley-Bricusse",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/newleybricusse/who_can_i_turn_to?source=ireal"
      },
      {
        "title": "Willow Weep For Me",
        "artist": "Ann Ronell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/ann_ronell/willow_weep_for_me?source=ireal"
      },
      {
        "title": "Wooper, The",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/wooper_the?source=ireal"
      },
      {
        "title": "Work Song",
        "artist": "Nat Adderley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/nat_adderley/work_song?source=ireal"
      },
      {
        "title": "Wow",
        "artist": "Lennie Tristano",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/lennie_tristano/wow?source=ireal"
      },
      {
        "title": "Wrong is Right",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/pat_metheny/wrong_is_right?source=ireal"
      },
      {
        "title": "Yana Amina",
        "artist": "George Duke",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/george_duke/yana_amina?source=ireal"
      },
      {
        "title": "Yardbird Suite",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/charlie_parker/yardbird_suite?source=ireal"
      },
      {
        "title": "You Better Leave it Alone",
        "artist": "Unknown Composer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/unknown_composer/you_better_leave_it_alone?source=ireal"
      },
      {
        "title": "You Stepped Out Of A Dream",
        "artist": "Nacio-Herb-Brown",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/nacioherbbrown/you_stepped_out_of_a_dream?source=ireal"
      },
      {
        "title": "You'd Be So Nice To Come Home To",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_2/cole_porter/youd_be_so_nice_to_come_home_to?source=ireal"
      }
    ]
  },
  {
    "title": "The Real Book - Volume 3",
    "items": [
      {
        "title": "After You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/after_you?source=ireal"
      },
      {
        "title": "After You've Gone",
        "artist": "Henry Creamer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/henry_creamer/after_youve_gone?source=ireal"
      },
      {
        "title": "Ain't Misbehavin'",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/fats_waller/aint_misbehavin?source=ireal"
      },
      {
        "title": "Alanjuneally",
        "artist": "Kenny Werner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/kenny_werner/alanjuneally?source=ireal"
      },
      {
        "title": "All Or Nothing At All",
        "artist": "Arthur Altman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/arthur_altman/all_or_nothing_at_all?source=ireal"
      },
      {
        "title": "Along Came Betty",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/benny_golson/along_came_betty?source=ireal"
      },
      {
        "title": "Always And Forever",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/pat_metheny/always_and_forever?source=ireal"
      },
      {
        "title": "Angela",
        "artist": "Bob James",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bob_james/angela?source=ireal"
      },
      {
        "title": "Armando's Rhumba",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/armandos_rhumba?source=ireal"
      },
      {
        "title": "Autumn Nocturne",
        "artist": "Gannon-Myrow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gannonmyrow/autumn_nocturne?source=ireal"
      },
      {
        "title": "Autumn in 3",
        "artist": "Kenny Werner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/kenny_werner/autumn_in_3?source=ireal"
      },
      {
        "title": "Avalon Place",
        "artist": "Jack Zucker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jack_zucker/avalon_place?source=ireal"
      },
      {
        "title": "Ballad for Anita",
        "artist": "Bob Fraser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bob_fraser/ballad_for_anita?source=ireal"
      },
      {
        "title": "Ballad for Trane",
        "artist": "Kenny Werner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/kenny_werner/ballad_for_trane?source=ireal"
      },
      {
        "title": "Be My Love",
        "artist": "Nikolaus Brodszky",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/nikolaus_brodszky/be_my_love?source=ireal"
      },
      {
        "title": "Beautiful Friendship, A",
        "artist": "Donald Kahn",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/donald_kahn/beautiful_friendship_a?source=ireal"
      },
      {
        "title": "Bernies's Tune",
        "artist": "Bernie Miller",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bernie_miller/berniess_tune?source=ireal"
      },
      {
        "title": "Beside Myself",
        "artist": "Chip Stephens",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chip_stephens/beside_myself?source=ireal"
      },
      {
        "title": "Bess You Is My Woman",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_gershwin/bess_you_is_my_woman?source=ireal"
      },
      {
        "title": "Best Thing For You Is Me, The",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/irving_berlin/best_thing_for_you_is_me_the?source=ireal"
      },
      {
        "title": "Better Git it in your Soul",
        "artist": "Charles Mingus",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charles_mingus/better_git_it_in_your_soul?source=ireal"
      },
      {
        "title": "Beyond The Bluebird",
        "artist": "Tommy Flanagan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/tommy_flanagan/beyond_the_bluebird?source=ireal"
      },
      {
        "title": "Blue Daniel",
        "artist": "Frank Rosolino",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/frank_rosolino/blue_daniel?source=ireal"
      },
      {
        "title": "Bluebird",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/bluebird?source=ireal"
      },
      {
        "title": "Blues Backstage",
        "artist": "Frank Foster",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/frank_foster/blues_backstage?source=ireal"
      },
      {
        "title": "Bolivia",
        "artist": "Cedar Walton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cedar_walton/bolivia?source=ireal"
      },
      {
        "title": "Bop Boy",
        "artist": "Bob Mintzer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bob_mintzer/bop_boy?source=ireal"
      },
      {
        "title": "Bop Shop",
        "artist": "Paul Ferguson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/paul_ferguson/bop_shop?source=ireal"
      },
      {
        "title": "Born To Be Blue",
        "artist": "Wells-Torme",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/wellstorme/born_to_be_blue?source=ireal"
      },
      {
        "title": "Bossa Rokka",
        "artist": "George Benson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_benson/bossa_rokka?source=ireal"
      },
      {
        "title": "Boy Next Door, The",
        "artist": "Martin-Blane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/martinblane/boy_next_door_the?source=ireal"
      },
      {
        "title": "Bud Powell",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/bud_powell?source=ireal"
      },
      {
        "title": "Bud's Blues",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bud_powell/buds_blues?source=ireal"
      },
      {
        "title": "Busch-Wacked",
        "artist": "Jack Zucker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jack_zucker/buschwacked?source=ireal"
      },
      {
        "title": "Buzzy",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/buzzy?source=ireal"
      },
      {
        "title": "By Myself",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/arthur_schwartz/by_myself?source=ireal"
      },
      {
        "title": "Bye Bye Baby",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jule_styne/bye_bye_baby?source=ireal"
      },
      {
        "title": "Careful",
        "artist": "Jim Hall",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jim_hall/careful?source=ireal"
      },
      {
        "title": "Celia",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bud_powell/celia?source=ireal"
      },
      {
        "title": "Certain Smile, A",
        "artist": "Fain-Webster",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/fainwebster/certain_smile_a?source=ireal"
      },
      {
        "title": "Chariots",
        "artist": "John Scofield",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/john_scofield/chariots?source=ireal"
      },
      {
        "title": "Cheek To Cheek",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/irving_berlin/cheek_to_cheek?source=ireal"
      },
      {
        "title": "Cheryl",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/cheryl?source=ireal"
      },
      {
        "title": "Close Enough For Love",
        "artist": "Mandel-Williams",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/mandelwilliams/close_enough_for_love?source=ireal"
      },
      {
        "title": "Compensation",
        "artist": "Kenny Werner",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/kenny_werner/compensation?source=ireal"
      },
      {
        "title": "Cool Eyes",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/horace_silver/cool_eyes?source=ireal"
      },
      {
        "title": "Cry Me A River",
        "artist": "Arthur Hamilton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/arthur_hamilton/cry_me_a_river?source=ireal"
      },
      {
        "title": "Dacapolypso",
        "artist": "Chuck Israels",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chuck_israels/dacapolypso?source=ireal"
      },
      {
        "title": "Day Dream",
        "artist": "Strayhorn-Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/strayhornellington/day_dream?source=ireal"
      },
      {
        "title": "Day In, Day Out",
        "artist": "Rube Bloom",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/rube_bloom/day_in_day_out?source=ireal"
      },
      {
        "title": "Dig",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/miles_davis/dig?source=ireal"
      },
      {
        "title": "Don't Ask Why",
        "artist": "Alan Broadbent",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/alan_broadbent/dont_ask_why?source=ireal"
      },
      {
        "title": "Don't Look Back",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/johnny_mandel/dont_look_back?source=ireal"
      },
      {
        "title": "Double Clutching",
        "artist": "Chuck Israels",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chuck_israels/double_clutching?source=ireal"
      },
      {
        "title": "Dream Dancing",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/dream_dancing?source=ireal"
      },
      {
        "title": "East Of The Sun (And West of the Moon)",
        "artist": "Brooks Bowman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/brooks_bowman/east_of_the_sun_and_west_of_the_moon?source=ireal"
      },
      {
        "title": "Emanon",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/dizzy_gillespie/emanon?source=ireal"
      },
      {
        "title": "Emily",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/johnny_mandel/emily?source=ireal"
      },
      {
        "title": "End Of A Love Affair, The",
        "artist": "Edward Redding",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/edward_redding/end_of_a_love_affair_the?source=ireal"
      },
      {
        "title": "Endlessly",
        "artist": "Michael Asher",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/michael_asher/endlessly?source=ireal"
      },
      {
        "title": "Estate",
        "artist": "Bruno Martino",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bruno_martino/estate?source=ireal"
      },
      {
        "title": "Eternal Triangle",
        "artist": "Sonny Stitt",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/sonny_stitt/eternal_triangle?source=ireal"
      },
      {
        "title": "Ev'ry Time We Say Goodbye",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/evry_time_we_say_goodbye?source=ireal"
      },
      {
        "title": "Everything Happens To Me",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/matt_dennis/everything_happens_to_me?source=ireal"
      },
      {
        "title": "Everything I Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/everything_i_love?source=ireal"
      },
      {
        "title": "Father",
        "artist": "George Coleman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_coleman/father?source=ireal"
      },
      {
        "title": "Favela",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/antoniocarlos_jobim/favela?source=ireal"
      },
      {
        "title": "Feel Like Makin' Love",
        "artist": "Eugene McDaniels",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/eugene_mcdaniels/feel_like_makin_love?source=ireal"
      },
      {
        "title": "For Heaven's Sake",
        "artist": "Edwards-Meyer-Bretton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/edwardsmeyerbretton/for_heavens_sake?source=ireal"
      },
      {
        "title": "Freight Trane",
        "artist": "Tommy Flanagan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/tommy_flanagan/freight_trane?source=ireal"
      },
      {
        "title": "French Waltz",
        "artist": "Dudley Moore",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/dudley_moore/french_waltz?source=ireal"
      },
      {
        "title": "Friday The 13th",
        "artist": "Thelonious Monk",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/thelonious_monk/friday_the_13th?source=ireal"
      },
      {
        "title": "From Now On",
        "artist": "Tom Harrell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/tom_harrell/from_now_on?source=ireal"
      },
      {
        "title": "From This Moment On",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/from_this_moment_on?source=ireal"
      },
      {
        "title": "From the Heart",
        "artist": "Gary Aprile",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gary_aprile/from_the_heart?source=ireal"
      },
      {
        "title": "Full Moon and Empty Arms",
        "artist": "Buddy Kaye",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/buddy_kaye/full_moon_and_empty_arms?source=ireal"
      },
      {
        "title": "Funkallero",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bill_evans/funkallero?source=ireal"
      },
      {
        "title": "Gaviota",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/clare_fischer/gaviota?source=ireal"
      },
      {
        "title": "Gnu Blu",
        "artist": "Ron Busch",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ron_busch/gnu_blu?source=ireal"
      },
      {
        "title": "Godchild",
        "artist": "George Wallington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_wallington/godchild?source=ireal"
      },
      {
        "title": "Gone With The Wind",
        "artist": "Allie Wrubel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/allie_wrubel/gone_with_the_wind?source=ireal"
      },
      {
        "title": "Goodbye",
        "artist": "Gordon Jenkins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gordon_jenkins/goodbye?source=ireal"
      },
      {
        "title": "Got A Match?",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/got_a_match?source=ireal"
      },
      {
        "title": "H and H",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/pat_metheny/h_and_h?source=ireal"
      },
      {
        "title": "Harlem Nocturne",
        "artist": "Earle Hagen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/earle_hagen/harlem_nocturne?source=ireal"
      },
      {
        "title": "Heartsong",
        "artist": "Fred Hersch",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/fred_hersch/heartsong?source=ireal"
      },
      {
        "title": "High Hopes",
        "artist": "James Heusen Van",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/james_heusen_van/high_hopes?source=ireal"
      },
      {
        "title": "Highwire the Aerialist",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/highwire_the_aerialist?source=ireal"
      },
      {
        "title": "Hot House",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/tadd_dameron/hot_house?source=ireal"
      },
      {
        "title": "How About You",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/burton_lane/how_about_you?source=ireal"
      },
      {
        "title": "How Deep Is The Ocean",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/irving_berlin/how_deep_is_the_ocean?source=ireal"
      },
      {
        "title": "How Long Has This Been Going On?",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_gershwin/how_long_has_this_been_going_on?source=ireal"
      },
      {
        "title": "I Concentrate On You",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/i_concentrate_on_you?source=ireal"
      },
      {
        "title": "I Didn't Know What Time It Was",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/i_didnt_know_what_time_it_was?source=ireal"
      },
      {
        "title": "I Fall in Love too Easily",
        "artist": "Unknown Composer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/unknown_composer/i_fall_in_love_too_easily?source=ireal"
      },
      {
        "title": "I Left My Heart In San Francisco",
        "artist": "George Cory",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_cory/i_left_my_heart_in_san_francisco?source=ireal"
      },
      {
        "title": "I Loves You Porgy",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_gershwin/i_loves_you_porgy?source=ireal"
      },
      {
        "title": "I Need you Here",
        "artist": "Makoto Ozone",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/makoto_ozone/i_need_you_here?source=ireal"
      },
      {
        "title": "I Wish You Love",
        "artist": "Charles Trenet",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charles_trenet/i_wish_you_love?source=ireal"
      },
      {
        "title": "I'll Be Around",
        "artist": "Alec Wilder",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/alec_wilder/ill_be_around?source=ireal"
      },
      {
        "title": "I'll Be Seeing You",
        "artist": "Sammy Fain",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/sammy_fain/ill_be_seeing_you?source=ireal"
      },
      {
        "title": "I'll Close My Eyes",
        "artist": "Billy Reid",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/billy_reid/ill_close_my_eyes?source=ireal"
      },
      {
        "title": "I'll Take Romance",
        "artist": "Ben Oakland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ben_oakland/ill_take_romance?source=ireal"
      },
      {
        "title": "I'm Glad There Is You",
        "artist": "Jimmy Dorsey",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jimmy_dorsey/im_glad_there_is_you?source=ireal"
      },
      {
        "title": "I'm Old Fashioned",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jerome_kern/im_old_fashioned?source=ireal"
      },
      {
        "title": "I'm Through With Love",
        "artist": "Kahn-Malneck-Livingston",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/kahnmalnecklivingston/im_through_with_love?source=ireal"
      },
      {
        "title": "I've Got A Crush On You",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_gershwin/ive_got_a_crush_on_you?source=ireal"
      },
      {
        "title": "I've Got The World On A String",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_arlen/ive_got_the_world_on_a_string?source=ireal"
      },
      {
        "title": "I've Got You Under My Skin",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/ive_got_you_under_my_skin?source=ireal"
      },
      {
        "title": "I've Grown Accustomed To Her Face",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/frederick_loewe/ive_grown_accustomed_to_her_face?source=ireal"
      },
      {
        "title": "I've Never Been in Love Before",
        "artist": "Frank Loesser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/frank_loesser/ive_never_been_in_love_before?source=ireal"
      },
      {
        "title": "Ill Wind",
        "artist": "Arlen-Koehler",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/arlenkoehler/ill_wind?source=ireal"
      },
      {
        "title": "In Her Family",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/pat_metheny/in_her_family?source=ireal"
      },
      {
        "title": "In Love In Vain",
        "artist": "Kern Jerome Robin Leo",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/kern_jerome_robin_leo/in_love_in_vain?source=ireal"
      },
      {
        "title": "In The Days of Our Love",
        "artist": "Marian McPartland",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/marian_mcpartland/in_the_days_of_our_love?source=ireal"
      },
      {
        "title": "In a Capricornian Way",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/woody_shaw/in_a_capricornian_way?source=ireal"
      },
      {
        "title": "Indian Summer",
        "artist": "Victor-Aldubin-Herbert",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/victoraldubinherbert/indian_summer?source=ireal"
      },
      {
        "title": "Irv's at Midnight",
        "artist": "Ernie Krivda",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ernie_krivda/irvs_at_midnight?source=ireal"
      },
      {
        "title": "Isfahan",
        "artist": "Strayhorn-Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/strayhornellington/isfahan?source=ireal"
      },
      {
        "title": "It Never Entered My Mind",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/it_never_entered_my_mind?source=ireal"
      },
      {
        "title": "It's All Right With Me",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/its_all_right_with_me?source=ireal"
      },
      {
        "title": "It's You Or No One",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jule_styne/its_you_or_no_one?source=ireal"
      },
      {
        "title": "Japanese Waltz, A",
        "artist": "Unknown Composer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/unknown_composer/japanese_waltz_a?source=ireal"
      },
      {
        "title": "Jersey Bounce",
        "artist": "Plater-Bradshaw-Johnson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/platerbradshawjohnson/jersey_bounce?source=ireal"
      },
      {
        "title": "Jitterbug Waltz",
        "artist": "Fats Waller",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/fats_waller/jitterbug_waltz?source=ireal"
      },
      {
        "title": "Jive Samba",
        "artist": "Nat Adderley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/nat_adderley/jive_samba?source=ireal"
      },
      {
        "title": "Julian",
        "artist": "George Mraz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_mraz/julian?source=ireal"
      },
      {
        "title": "Just One Of Those Things",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/just_one_of_those_things?source=ireal"
      },
      {
        "title": "Just Squeeze Me",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/duke_ellington/just_squeeze_me?source=ireal"
      },
      {
        "title": "Ladies In Mercedes",
        "artist": "Steve Swallow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/steve_swallow/ladies_in_mercedes?source=ireal"
      },
      {
        "title": "Lady is a Tramp, The",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/lady_is_a_tramp_the?source=ireal"
      },
      {
        "title": "Lazy Afternoon",
        "artist": "Latouche-Moross",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/latouchemoross/lazy_afternoon?source=ireal"
      },
      {
        "title": "Leap of Faith",
        "artist": "Chuck Israels",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chuck_israels/leap_of_faith?source=ireal"
      },
      {
        "title": "Let's Fall In Love",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_arlen/lets_fall_in_love?source=ireal"
      },
      {
        "title": "Li'l Darling",
        "artist": "Neal Hefti",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/neal_hefti/lil_darling?source=ireal"
      },
      {
        "title": "Line For Lyons",
        "artist": "Gerry Mulligan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gerry_mulligan/line_for_lyons?source=ireal"
      },
      {
        "title": "Little Face",
        "artist": "Ernie Krivda",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ernie_krivda/little_face?source=ireal"
      },
      {
        "title": "Little Girl Blue",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/little_girl_blue?source=ireal"
      },
      {
        "title": "Little Willie Leaps",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/little_willie_leaps?source=ireal"
      },
      {
        "title": "Long View, The",
        "artist": "Paul Ferguson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/paul_ferguson/long_view_the?source=ireal"
      },
      {
        "title": "Loop, The",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/loop_the?source=ireal"
      },
      {
        "title": "Lotus on Irish Streams, A",
        "artist": "John McLaughlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/john_mclaughlin/lotus_on_irish_streams_a?source=ireal"
      },
      {
        "title": "Loud-Zee",
        "artist": "Jerry Bergonzi",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jerry_bergonzi/loudzee?source=ireal"
      },
      {
        "title": "Love Walked In",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_gershwin/love_walked_in?source=ireal"
      },
      {
        "title": "Lovers Rain Dance",
        "artist": "Chip Stephens",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chip_stephens/lovers_rain_dance?source=ireal"
      },
      {
        "title": "Lullaby Of The Leaves",
        "artist": "Bernice Petkere",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bernice_petkere/lullaby_of_the_leaves?source=ireal"
      },
      {
        "title": "Lulu's Back In Town",
        "artist": "Harry Warren",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harry_warren/lulus_back_in_town?source=ireal"
      },
      {
        "title": "Making Whoopee",
        "artist": "Walter Donaldson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/walter_donaldson/making_whoopee?source=ireal"
      },
      {
        "title": "Mandala",
        "artist": "Bill Dobbins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bill_dobbins/mandala?source=ireal"
      },
      {
        "title": "Manhattan",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/manhattan?source=ireal"
      },
      {
        "title": "Matrix",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/matrix?source=ireal"
      },
      {
        "title": "May-Reh",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/horace_silver/mayreh?source=ireal"
      },
      {
        "title": "Meaning Of The Blues, The",
        "artist": "Worth-Troup",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/worthtroup/meaning_of_the_blues_the?source=ireal"
      },
      {
        "title": "Mi Boj a Samba",
        "artist": "Samba",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/samba/mi_boj_a_samba?source=ireal"
      },
      {
        "title": "Midnight Sun, The",
        "artist": "Hampton-Burke-Mercer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/hamptonburkemercer/midnight_sun_the?source=ireal"
      },
      {
        "title": "Milestones (Old)",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/miles_davis/milestones_old?source=ireal"
      },
      {
        "title": "Moment to Moment",
        "artist": "Henry Mancini",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/henry_mancini/moment_to_moment?source=ireal"
      },
      {
        "title": "Monster And The Flower, The",
        "artist": "Claudio Roditi",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/claudio_roditi/monster_and_the_flower_the?source=ireal"
      },
      {
        "title": "Moon And Sand",
        "artist": "Wilder-Palitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/wilderpalitz/moon_and_sand?source=ireal"
      },
      {
        "title": "Moonlight In Vermont",
        "artist": "Karl Suessdorf",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/karl_suessdorf/moonlight_in_vermont?source=ireal"
      },
      {
        "title": "Mountain Greenery",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/mountain_greenery?source=ireal"
      },
      {
        "title": "Muezzin'",
        "artist": "Petter Adams",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/petter_adams/muezzin?source=ireal"
      },
      {
        "title": "My Heart Stood Still",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/my_heart_stood_still?source=ireal"
      },
      {
        "title": "My Man's Gone Now",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_gershwin/my_mans_gone_now?source=ireal"
      },
      {
        "title": "Neal's Blues",
        "artist": "Creque-Fraser",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/crequefraser/neals_blues?source=ireal"
      },
      {
        "title": "Never Let Me Go",
        "artist": "Jay Livingston",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jay_livingston/never_let_me_go?source=ireal"
      },
      {
        "title": "Nice 'n Easy",
        "artist": "Spence-Bergman-Keith",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/spencebergmankeith/nice_n_easy?source=ireal"
      },
      {
        "title": "Night We Called It A Day, The",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/matt_dennis/night_we_called_it_a_day_the?source=ireal"
      },
      {
        "title": "Nightingale Sang In Berkeley Square, A",
        "artist": "Manning Sherwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/manning_sherwin/nightingale_sang_in_berkeley_square_a?source=ireal"
      },
      {
        "title": "Nobody Else But Me",
        "artist": "Jerome Kern",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jerome_kern/nobody_else_but_me?source=ireal"
      },
      {
        "title": "Now He Beats the Drum - Now He Stops",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/now_he_beats_the_drum__now_he_stops?source=ireal"
      },
      {
        "title": "Number 6",
        "artist": "Unknown Composer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/unknown_composer/number_6?source=ireal"
      },
      {
        "title": "Old Folks",
        "artist": "Willard Robison",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/willard_robison/old_folks?source=ireal"
      },
      {
        "title": "On A Clear Day",
        "artist": "Burton Lane",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/burton_lane/on_a_clear_day?source=ireal"
      },
      {
        "title": "On The Street Where You Live",
        "artist": "Frederick Loewe",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/frederick_loewe/on_the_street_where_you_live?source=ireal"
      },
      {
        "title": "On the Sly",
        "artist": "Chuck Israels",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chuck_israels/on_the_sly?source=ireal"
      },
      {
        "title": "On the Sunny Side Of The Street",
        "artist": "Jimmy McHugh",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jimmy_mchugh/on_the_sunny_side_of_the_street?source=ireal"
      },
      {
        "title": "Only you Know",
        "artist": "Chip Stephens",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chip_stephens/only_you_know?source=ireal"
      },
      {
        "title": "Our Delight",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/tadd_dameron/our_delight?source=ireal"
      },
      {
        "title": "Out Of This World",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_arlen/out_of_this_world?source=ireal"
      },
      {
        "title": "Over The Rainbow (Somewhere)",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_arlen/over_the_rainbow_somewhere?source=ireal"
      },
      {
        "title": "Ow!",
        "artist": "Dizzy Gillespie",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/dizzy_gillespie/ow?source=ireal"
      },
      {
        "title": "Panhandle Hook",
        "artist": "Ernie Krivda",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ernie_krivda/panhandle_hook?source=ireal"
      },
      {
        "title": "Party's Over, The",
        "artist": "Styne-Comden-Green",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/stynecomdengreen/partys_over_the?source=ireal"
      },
      {
        "title": "Passport",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/passport?source=ireal"
      },
      {
        "title": "Patz Blues",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/pat_metheny/patz_blues?source=ireal"
      },
      {
        "title": "People",
        "artist": "Jule Styne",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jule_styne/people?source=ireal"
      },
      {
        "title": "Perhaps",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/perhaps?source=ireal"
      },
      {
        "title": "Picadilly Lilly",
        "artist": "Dave Liebman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/dave_liebman/picadilly_lilly?source=ireal"
      },
      {
        "title": "Poinciana",
        "artist": "Nat Simon",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/nat_simon/poinciana?source=ireal"
      },
      {
        "title": "Point of Return",
        "artist": "Paul Ferguson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/paul_ferguson/point_of_return?source=ireal"
      },
      {
        "title": "Poor Butterfly",
        "artist": "Raymon Hubbell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/raymon_hubbell/poor_butterfly?source=ireal"
      },
      {
        "title": "Por Causa de Voçe (Don't Ever Go Away)",
        "artist": "Antonio-Carlos Jobim",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/antoniocarlos_jobim/por_causa_de_voe_dont_ever_go_away?source=ireal"
      },
      {
        "title": "Pretty Girl Is Like A Melody, A",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/irving_berlin/pretty_girl_is_like_a_melody_a?source=ireal"
      },
      {
        "title": "Prism",
        "artist": "Keith Jarrett",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/keith_jarrett/prism?source=ireal"
      },
      {
        "title": "Pure Imagination",
        "artist": "Anthony Newley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/anthony_newley/pure_imagination?source=ireal"
      },
      {
        "title": "Rahsaan's Run",
        "artist": "Unknown Composer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/unknown_composer/rahsaans_run?source=ireal"
      },
      {
        "title": "Re-Re",
        "artist": "Bob Mintzer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bob_mintzer/rere?source=ireal"
      },
      {
        "title": "Re: Person I Knew",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bill_evans/re_person_i_knew?source=ireal"
      },
      {
        "title": "Relaxin' At Camarillo",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/relaxin_at_camarillo?source=ireal"
      },
      {
        "title": "Room 608",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/horace_silver/room_608?source=ireal"
      },
      {
        "title": "Rosewood",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/woody_shaw/rosewood?source=ireal"
      },
      {
        "title": "Samba De Orfeu",
        "artist": "Luiz Bonfa",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/luiz_bonfa/samba_de_orfeu?source=ireal"
      },
      {
        "title": "Sambacide",
        "artist": "Bill Dobbins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bill_dobbins/sambacide?source=ireal"
      },
      {
        "title": "Santurce",
        "artist": "Eddie Gomez",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/eddie_gomez/santurce?source=ireal"
      },
      {
        "title": "Seabrook Revisited",
        "artist": "Jack Sucker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jack_sucker/seabrook_revisited?source=ireal"
      },
      {
        "title": "Secret Love",
        "artist": "Sammy Fain",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/sammy_fain/secret_love?source=ireal"
      },
      {
        "title": "Seems",
        "artist": "Pat Scott",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/pat_scott/seems?source=ireal"
      },
      {
        "title": "Serpent's Tooth",
        "artist": "Miles Davis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/miles_davis/serpents_tooth?source=ireal"
      },
      {
        "title": "Shaw 'Nuff",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/shaw_nuff?source=ireal"
      },
      {
        "title": "Sister Sadie",
        "artist": "Horace Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/horace_silver/sister_sadie?source=ireal"
      },
      {
        "title": "Skylark",
        "artist": "Hoagy Carmichael",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/hoagy_carmichael/skylark?source=ireal"
      },
      {
        "title": "Sleepin' Bee, A",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_arlen/sleepin_bee_a?source=ireal"
      },
      {
        "title": "So In Love",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/so_in_love?source=ireal"
      },
      {
        "title": "Some Nerve",
        "artist": "John Scofield",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/john_scofield/some_nerve?source=ireal"
      },
      {
        "title": "Something From Everyone",
        "artist": "Paul Ferguson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/paul_ferguson/something_from_everyone?source=ireal"
      },
      {
        "title": "Song for Sisyphus",
        "artist": "Phil Woods",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/phil_woods/song_for_sisyphus?source=ireal"
      },
      {
        "title": "Sonnymoon For Two",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/sonny_rollins/sonnymoon_for_two?source=ireal"
      },
      {
        "title": "Soon",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/george_gershwin/soon?source=ireal"
      },
      {
        "title": "Spirit Samba",
        "artist": "Ron Eschete",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ron_eschete/spirit_samba?source=ireal"
      },
      {
        "title": "Spring Can Really Hang You Up The Most",
        "artist": "Tommy Wolf",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/tommy_wolf/spring_can_really_hang_you_up_the_most?source=ireal"
      },
      {
        "title": "Squirrel",
        "artist": "Tadd Dameron",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/tadd_dameron/squirrel?source=ireal"
      },
      {
        "title": "St. Thomas",
        "artist": "Sonny Rollins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/sonny_rollins/st_thomas?source=ireal"
      },
      {
        "title": "Stablemates",
        "artist": "Benny Golson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/benny_golson/stablemates?source=ireal"
      },
      {
        "title": "Star Eyes",
        "artist": "Gene DePaul",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gene_depaul/star_eyes?source=ireal"
      },
      {
        "title": "Stars Fell On Alabama",
        "artist": "Frank Perkins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/frank_perkins/stars_fell_on_alabama?source=ireal"
      },
      {
        "title": "Steeple Chase",
        "artist": "Charlie Parker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/charlie_parker/steeple_chase?source=ireal"
      },
      {
        "title": "Stormy Weather",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_arlen/stormy_weather?source=ireal"
      },
      {
        "title": "Street Of Dreams",
        "artist": "Victor Young",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/victor_young/street_of_dreams?source=ireal"
      },
      {
        "title": "Sunny",
        "artist": "Bobby Hebb",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bobby_hebb/sunny?source=ireal"
      },
      {
        "title": "Sweet Lorraine",
        "artist": "Cliff Burwell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cliff_burwell/sweet_lorraine?source=ireal"
      },
      {
        "title": "Swing Dentz Swing",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/swing_dentz_swing?source=ireal"
      },
      {
        "title": "Swing Shift",
        "artist": "Chuck Israels",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chuck_israels/swing_shift?source=ireal"
      },
      {
        "title": "Sy Clone",
        "artist": "Jack Zucker",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jack_zucker/sy_clone?source=ireal"
      },
      {
        "title": "T. J. R. C.",
        "artist": "Bill Dobbins",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bill_dobbins/t_j_r_c?source=ireal"
      },
      {
        "title": "Tea For Two",
        "artist": "Vincent Youmans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/vincent_youmans/tea_for_two?source=ireal"
      },
      {
        "title": "Teach Me Tonight",
        "artist": "Gene DePaul",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gene_depaul/teach_me_tonight?source=ireal"
      },
      {
        "title": "That Old Feeling",
        "artist": "Brown-Fain",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/brownfain/that_old_feeling?source=ireal"
      },
      {
        "title": "That's All",
        "artist": "Haymes-Brandt",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/haymesbrandt/thats_all?source=ireal"
      },
      {
        "title": "Their's Tears",
        "artist": "Clare Fischer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/clare_fischer/theirs_tears?source=ireal"
      },
      {
        "title": "Theme For Maxine",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/woody_shaw/theme_for_maxine?source=ireal"
      },
      {
        "title": "Then I'll be Tired of You",
        "artist": "Haeburg-Schwartz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/haeburgschwartz/then_ill_be_tired_of_you?source=ireal"
      },
      {
        "title": "There Goes My Heart",
        "artist": "Davis-Silver",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/davissilver/there_goes_my_heart?source=ireal"
      },
      {
        "title": "They Say It's Wonderful",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/irving_berlin/they_say_its_wonderful?source=ireal"
      },
      {
        "title": "Things Ain't What They Used To Be",
        "artist": "Duke Ellington",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/duke_ellington/things_aint_what_they_used_to_be?source=ireal"
      },
      {
        "title": "This Can't Be Love",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/this_cant_be_love?source=ireal"
      },
      {
        "title": "Three And One",
        "artist": "Thad Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/thad_jones/three_and_one?source=ireal"
      },
      {
        "title": "Thrill Is Gone, The",
        "artist": "Ray Henderson",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ray_henderson/thrill_is_gone_the?source=ireal"
      },
      {
        "title": "Thyme's Time",
        "artist": "Dean Newton",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/dean_newton/thymes_time?source=ireal"
      },
      {
        "title": "Tidal Breeze",
        "artist": "Harold Danko",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_danko/tidal_breeze?source=ireal"
      },
      {
        "title": "Time For Love, A",
        "artist": "Johnny Mandel",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/johnny_mandel/time_for_love_a?source=ireal"
      },
      {
        "title": "Time Was (Dreaming)",
        "artist": "Keith-Prado",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/keithprado/time_was_dreaming?source=ireal"
      },
      {
        "title": "Time's Lie",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/times_lie?source=ireal"
      },
      {
        "title": "Tiny Capers",
        "artist": "Clifford Brown",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/clifford_brown/tiny_capers?source=ireal"
      },
      {
        "title": "Tis'",
        "artist": "Thad Jones",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/thad_jones/tis?source=ireal"
      },
      {
        "title": "To Kill a Brick",
        "artist": "Woody Shaw",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/woody_shaw/to_kill_a_brick?source=ireal"
      },
      {
        "title": "Too Close For Comfort",
        "artist": "Bock-Weiss-Holofcener",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bockweissholofcener/too_close_for_comfort?source=ireal"
      },
      {
        "title": "Too Marvelous For Words",
        "artist": "Richard Whiting",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_whiting/too_marvelous_for_words?source=ireal"
      },
      {
        "title": "Touch Of Your Lips, The",
        "artist": "Ray Noble",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ray_noble/touch_of_your_lips_the?source=ireal"
      },
      {
        "title": "Tricotism",
        "artist": "Oscar Pettiford",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/oscar_pettiford/tricotism?source=ireal"
      },
      {
        "title": "Tune 88",
        "artist": "Jeff Lorber",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/jeff_lorber/tune_88?source=ireal"
      },
      {
        "title": "Un Poco Loco",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bud_powell/un_poco_loco?source=ireal"
      },
      {
        "title": "Unforgettable",
        "artist": "Gordon Irving",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gordon_irving/unforgettable?source=ireal"
      },
      {
        "title": "Very Thought Of You, The",
        "artist": "Ray Noble",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ray_noble/very_thought_of_you_the?source=ireal"
      },
      {
        "title": "Violets For Your Furs",
        "artist": "Adair-Dennis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/adairdennis/violets_for_your_furs?source=ireal"
      },
      {
        "title": "Wail",
        "artist": "Bud Powell",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bud_powell/wail?source=ireal"
      },
      {
        "title": "Wall-Eye Blues",
        "artist": "Arnold Loupacci",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/arnold_loupacci/walleye_blues?source=ireal"
      },
      {
        "title": "Watch What Happens",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/michel_legrand/watch_what_happens?source=ireal"
      },
      {
        "title": "Watermelon Man",
        "artist": "Herbie Hancock",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/herbie_hancock/watermelon_man?source=ireal"
      },
      {
        "title": "Wes Side Stroll",
        "artist": "Gary Aprile",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/gary_aprile/wes_side_stroll?source=ireal"
      },
      {
        "title": "What A Difference A Day Made",
        "artist": "Maria Grever",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/maria_grever/what_a_difference_a_day_made?source=ireal"
      },
      {
        "title": "What Kind of Fool am I",
        "artist": "Bricusse-Newley",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bricussenewley/what_kind_of_fool_am_i?source=ireal"
      },
      {
        "title": "When The Sun Comes Out",
        "artist": "Harold Arlen",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harold_arlen/when_the_sun_comes_out?source=ireal"
      },
      {
        "title": "When Your Lover Has Gone",
        "artist": "Einar Swan",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/einar_swan/when_your_lover_has_gone?source=ireal"
      },
      {
        "title": "Where Or When",
        "artist": "Richard Rodgers",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/richard_rodgers/where_or_when?source=ireal"
      },
      {
        "title": "While We're Young",
        "artist": "Wilder-Palitz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/wilderpalitz/while_were_young?source=ireal"
      },
      {
        "title": "Who Can I Turn To?",
        "artist": "Newley-Bricusse",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/newleybricusse/who_can_i_turn_to?source=ireal"
      },
      {
        "title": "Why Did I Choose You",
        "artist": "Bill Evans",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/bill_evans/why_did_i_choose_you?source=ireal"
      },
      {
        "title": "Will You Still Be Mine?",
        "artist": "Matt Dennis",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/matt_dennis/will_you_still_be_mine?source=ireal"
      },
      {
        "title": "Witchcraft",
        "artist": "Cy Coleman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cy_coleman/witchcraft?source=ireal"
      },
      {
        "title": "With Every Breath I Take",
        "artist": "Cy Coleman",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cy_coleman/with_every_breath_i_take?source=ireal"
      },
      {
        "title": "Wrap Your Troubles In Dreams",
        "artist": "Harry Barris",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/harry_barris/wrap_your_troubles_in_dreams?source=ireal"
      },
      {
        "title": "You And The Night And The Music",
        "artist": "Arthur Schwartz",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/arthur_schwartz/you_and_the_night_and_the_music?source=ireal"
      },
      {
        "title": "You Do Something To Me",
        "artist": "Cole Porter",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/cole_porter/you_do_something_to_me?source=ireal"
      },
      {
        "title": "You Go To My Head",
        "artist": "Fred Coots",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/fred_coots/you_go_to_my_head?source=ireal"
      },
      {
        "title": "You Make Me Feel So Young",
        "artist": "Josef Myrow",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/josef_myrow/you_make_me_feel_so_young?source=ireal"
      },
      {
        "title": "You Must Believe In Spring",
        "artist": "Michel Legrand",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/michel_legrand/you_must_believe_in_spring?source=ireal"
      },
      {
        "title": "You're Everything",
        "artist": "Chick Corea",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/chick_corea/youre_everything?source=ireal"
      },
      {
        "title": "You've Changed",
        "artist": "Carl Fisher",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/carl_fisher/youve_changed?source=ireal"
      },
      {
        "title": "Younger Than Springtime",
        "artist": "Rodgers-Hammerstein",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/rodgershammerstein/younger_than_springtime?source=ireal"
      },
      {
        "title": "Yours Is My Heart Alone",
        "artist": "Ludwig Herzer",
        "url": "https://www.quickchords.org/charts/the_real_book__volume_3/ludwig_herzer/yours_is_my_heart_alone?source=ireal"
      }
    ]
  },
  {
    "title": "Unfiled",
    "items": [
      {
        "title": "Man Who Sold The World, The",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/man_who_sold_the_world_the?source=ireal"
      },
      {
        "title": "Space Oddity",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/space_oddity?source=ireal"
      },
      {
        "title": "China Girl",
        "artist": "Bowie David and Pop Iggy",
        "url": "https://www.quickchords.org/charts/unfiled/bowie_david_and_pop_iggy/china_girl?source=ireal"
      },
      {
        "title": "Everything's allright",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/everythings_allright?source=ireal"
      },
      {
        "title": "Sound and Vision",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/sound_and_vision?source=ireal"
      },
      {
        "title": "Out On The Weekend",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/out_on_the_weekend?source=ireal"
      },
      {
        "title": "Harvest",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/harvest?source=ireal"
      },
      {
        "title": "A Man Needs A Maid",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/a_man_needs_a_maid?source=ireal"
      },
      {
        "title": "Heart Of Gold",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/heart_of_gold?source=ireal"
      },
      {
        "title": "Are You Ready For The Country",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/are_you_ready_for_the_country?source=ireal"
      },
      {
        "title": "Old Man",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/old_man?source=ireal"
      },
      {
        "title": "There's a World",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/theres_a_world?source=ireal"
      },
      {
        "title": "Alabama",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/alabama?source=ireal"
      },
      {
        "title": "Needle And The Damage Done, The",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/needle_and_the_damage_done_the?source=ireal"
      },
      {
        "title": "Words (Between The Lines Of Age)",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/words_between_the_lines_of_age?source=ireal"
      },
      {
        "title": "Out On The Weekend",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/out_on_the_weekend?source=ireal"
      },
      {
        "title": "Harvest",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/harvest?source=ireal"
      },
      {
        "title": "A Man Needs A Maid",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/a_man_needs_a_maid?source=ireal"
      },
      {
        "title": "Heart Of Gold",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/heart_of_gold?source=ireal"
      },
      {
        "title": "Are You Ready For The Country",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/are_you_ready_for_the_country?source=ireal"
      },
      {
        "title": "Old Man",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/old_man?source=ireal"
      },
      {
        "title": "There's a World",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/theres_a_world?source=ireal"
      },
      {
        "title": "Alabama",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/alabama?source=ireal"
      },
      {
        "title": "Needle And The Damage Done, The",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/needle_and_the_damage_done_the?source=ireal"
      },
      {
        "title": "Words (Between The Lines Of Age)",
        "artist": "Neil Young",
        "url": "https://www.quickchords.org/charts/unfiled/neil_young/words_between_the_lines_of_age?source=ireal"
      },
      {
        "title": "All I Do",
        "artist": "Wonder-Paul-Broadnax",
        "url": "https://www.quickchords.org/charts/unfiled/wonderpaulbroadnax/all_i_do?source=ireal"
      },
      {
        "title": "All In Love Is Fair",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/all_in_love_is_fair?source=ireal"
      },
      {
        "title": "Another Star",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/another_star?source=ireal"
      },
      {
        "title": "As",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as?source=ireal"
      },
      {
        "title": "Blame It On The Sun",
        "artist": "Stevie Wonder (Wonder-Wright)",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder_wonderwright/blame_it_on_the_sun?source=ireal"
      },
      {
        "title": "Creepin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/creepin?source=ireal"
      },
      {
        "title": "Don't You Worry 'Bout A Thing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/dont_you_worry_bout_a_thing?source=ireal"
      },
      {
        "title": "For Once In My Life (Stevie Wonder version)",
        "artist": "Miller-Murden",
        "url": "https://www.quickchords.org/charts/unfiled/millermurden/for_once_in_my_life_stevie_wonder_version?source=ireal"
      },
      {
        "title": "Golden Lady",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/golden_lady?source=ireal"
      },
      {
        "title": "I Wish",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_wish?source=ireal"
      },
      {
        "title": "Isn't She Lovely?",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/isnt_she_lovely?source=ireal"
      },
      {
        "title": "Knocks Me Off My Feet ",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/knocks_me_off_my_feet_?source=ireal"
      },
      {
        "title": "Lately",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/lately?source=ireal"
      },
      {
        "title": "Living For The City (Page 1)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city_page_1?source=ireal"
      },
      {
        "title": "Living For The City (Page 2)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city_page_2?source=ireal"
      },
      {
        "title": "Love's In Need Of Love Today",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/loves_in_need_of_love_today?source=ireal"
      },
      {
        "title": "Moon Blue",
        "artist": "Wonder-Busia",
        "url": "https://www.quickchords.org/charts/unfiled/wonderbusia/moon_blue?source=ireal"
      },
      {
        "title": "My Cherie Amour",
        "artist": "Wonder-Cosby-Moy",
        "url": "https://www.quickchords.org/charts/unfiled/wondercosbymoy/my_cherie_amour?source=ireal"
      },
      {
        "title": "Never Dreamed You'd Leave In Summer",
        "artist": "Wonder-Wright",
        "url": "https://www.quickchords.org/charts/unfiled/wonderwright/never_dreamed_youd_leave_in_summer?source=ireal"
      },
      {
        "title": "Overjoyed",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/overjoyed?source=ireal"
      },
      {
        "title": "Part Time Lover",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/part_time_lover?source=ireal"
      },
      {
        "title": "Ribbon In The Sky",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ribbon_in_the_sky?source=ireal"
      },
      {
        "title": "Rocket Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/rocket_love?source=ireal"
      },
      {
        "title": "Sir Duke",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/sir_duke?source=ireal"
      },
      {
        "title": "Superstition",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superstition?source=ireal"
      },
      {
        "title": "Tell Me Something Good",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/tell_me_something_good?source=ireal"
      },
      {
        "title": "Too Shy To Say",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/too_shy_to_say?source=ireal"
      },
      {
        "title": "Visions",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/visions?source=ireal"
      },
      {
        "title": "You And I",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_and_i?source=ireal"
      },
      {
        "title": "You Are The Sunshine Of My Life",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_are_the_sunshine_of_my_life?source=ireal"
      },
      {
        "title": "All I Do",
        "artist": "Wonder-Paul-Broadnax",
        "url": "https://www.quickchords.org/charts/unfiled/wonderpaulbroadnax/all_i_do?source=ireal"
      },
      {
        "title": "All In Love Is Fair",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/all_in_love_is_fair?source=ireal"
      },
      {
        "title": "Another Star",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/another_star?source=ireal"
      },
      {
        "title": "As",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as?source=ireal"
      },
      {
        "title": "Blame It On The Sun",
        "artist": "Stevie Wonder (Wonder-Wright)",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder_wonderwright/blame_it_on_the_sun?source=ireal"
      },
      {
        "title": "Creepin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/creepin?source=ireal"
      },
      {
        "title": "Don't You Worry 'Bout A Thing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/dont_you_worry_bout_a_thing?source=ireal"
      },
      {
        "title": "For Once In My Life (Stevie Wonder version)",
        "artist": "Miller-Murden",
        "url": "https://www.quickchords.org/charts/unfiled/millermurden/for_once_in_my_life_stevie_wonder_version?source=ireal"
      },
      {
        "title": "Golden Lady",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/golden_lady?source=ireal"
      },
      {
        "title": "I Wish",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_wish?source=ireal"
      },
      {
        "title": "Isn't She Lovely?",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/isnt_she_lovely?source=ireal"
      },
      {
        "title": "Knocks Me Off My Feet ",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/knocks_me_off_my_feet_?source=ireal"
      },
      {
        "title": "Lately",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/lately?source=ireal"
      },
      {
        "title": "Living For The City (Page 1)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city_page_1?source=ireal"
      },
      {
        "title": "Living For The City (Page 2)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city_page_2?source=ireal"
      },
      {
        "title": "Love's In Need Of Love Today",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/loves_in_need_of_love_today?source=ireal"
      },
      {
        "title": "Moon Blue",
        "artist": "Wonder-Busia",
        "url": "https://www.quickchords.org/charts/unfiled/wonderbusia/moon_blue?source=ireal"
      },
      {
        "title": "My Cherie Amour",
        "artist": "Wonder-Cosby-Moy",
        "url": "https://www.quickchords.org/charts/unfiled/wondercosbymoy/my_cherie_amour?source=ireal"
      },
      {
        "title": "Never Dreamed You'd Leave In Summer",
        "artist": "Wonder-Wright",
        "url": "https://www.quickchords.org/charts/unfiled/wonderwright/never_dreamed_youd_leave_in_summer?source=ireal"
      },
      {
        "title": "Overjoyed",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/overjoyed?source=ireal"
      },
      {
        "title": "Part Time Lover",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/part_time_lover?source=ireal"
      },
      {
        "title": "Ribbon In The Sky",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ribbon_in_the_sky?source=ireal"
      },
      {
        "title": "Rocket Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/rocket_love?source=ireal"
      },
      {
        "title": "Sir Duke",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/sir_duke?source=ireal"
      },
      {
        "title": "Superstition",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superstition?source=ireal"
      },
      {
        "title": "Tell Me Something Good",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/tell_me_something_good?source=ireal"
      },
      {
        "title": "Too Shy To Say",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/too_shy_to_say?source=ireal"
      },
      {
        "title": "Visions",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/visions?source=ireal"
      },
      {
        "title": "You And I",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_and_i?source=ireal"
      },
      {
        "title": "You Are The Sunshine Of My Life",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_are_the_sunshine_of_my_life?source=ireal"
      },
      {
        "title": "Desperado",
        "artist": "Henley/frey",
        "url": "https://www.quickchords.org/charts/unfiled/henleyfrey/desperado?source=ireal"
      },
      {
        "title": "Take It Easy",
        "artist": "Frey Brown-Glenn Jackson",
        "url": "https://www.quickchords.org/charts/unfiled/frey_brownglenn_jackson/take_it_easy?source=ireal"
      },
      {
        "title": "Tequila Sunrise",
        "artist": "Henley Frey/",
        "url": "https://www.quickchords.org/charts/unfiled/henley_frey/tequila_sunrise?source=ireal"
      },
      {
        "title": "New Kid In Town-The Eagles",
        "artist": "Frey-Henley-Souther",
        "url": "https://www.quickchords.org/charts/unfiled/freyhenleysouther/new_kid_in_townthe_eagles?source=ireal"
      },
      {
        "title": "Please Come Home For Christmas",
        "artist": "Brown-Redd",
        "url": "https://www.quickchords.org/charts/unfiled/brownredd/please_come_home_for_christmas?source=ireal"
      },
      {
        "title": "I Can't Tell You Why",
        "artist": "Schmit/Frey/Henley",
        "url": "https://www.quickchords.org/charts/unfiled/schmitfreyhenley/i_cant_tell_you_why?source=ireal"
      },
      {
        "title": "Lyin' Eyes",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/lyin_eyes?source=ireal"
      },
      {
        "title": "Take It Easy (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/take_it_easy_toms?source=ireal"
      },
      {
        "title": "Tequila Sunrise (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/tequila_sunrise_toms?source=ireal"
      },
      {
        "title": "Lyin Eyes (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/lyin_eyes_toms?source=ireal"
      },
      {
        "title": "Peaceful, Easy Feeling (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/peaceful_easy_feeling_toms?source=ireal"
      },
      {
        "title": "Take It Easy (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/take_it_easy_toms?source=ireal"
      },
      {
        "title": "Tequila Sunrise (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/tequila_sunrise_toms?source=ireal"
      },
      {
        "title": "Lyin Eyes (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/lyin_eyes_toms?source=ireal"
      },
      {
        "title": "Peaceful, Easy Feeling (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/peaceful_easy_feeling_toms?source=ireal"
      },
      {
        "title": "Night Life",
        "artist": "Aretha Franklin",
        "url": "https://www.quickchords.org/charts/unfiled/aretha_franklin/night_life?source=ireal"
      },
      {
        "title": "Until You Come Back To Me",
        "artist": "Aretha Franklin",
        "url": "https://www.quickchords.org/charts/unfiled/aretha_franklin/until_you_come_back_to_me?source=ireal"
      },
      {
        "title": "Ain't No Way",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/aint_no_way?source=ireal"
      },
      {
        "title": "All The Kings Horses",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/all_the_kings_horses?source=ireal"
      },
      {
        "title": "Angel Aretha",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/angel_aretha?source=ireal"
      },
      {
        "title": "Bridge Over Troubled Water",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/bridge_over_troubled_water?source=ireal"
      },
      {
        "title": "Chain Of Fools",
        "artist": "Toni Cm Franklin (Don Covay)",
        "url": "https://www.quickchords.org/charts/unfiled/toni_cm_franklin_don_covay/chain_of_fools?source=ireal"
      },
      {
        "title": "Day Dreaming - Aretha",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/day_dreaming__aretha?source=ireal"
      },
      {
        "title": "Dont Play That Song For Me",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/dont_play_that_song_for_me?source=ireal"
      },
      {
        "title": "Dr. Feelgood",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/dr_feelgood?source=ireal"
      },
      {
        "title": "Lord Will Make A Way, The",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/lord_will_make_a_way_the?source=ireal"
      },
      {
        "title": "Natural Woman (You Make Me Feel Like)",
        "artist": "Bb Toni/A Lily",
        "url": "https://www.quickchords.org/charts/unfiled/bb_tonia_lily/natural_woman_you_make_me_feel_like?source=ireal"
      },
      {
        "title": "Oh Me Oh My",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/oh_me_oh_my?source=ireal"
      },
      {
        "title": "Respect",
        "artist": "Aretha Franklin (Shannon, Redding)",
        "url": "https://www.quickchords.org/charts/unfiled/aretha_franklin_shannon_redding/respect?source=ireal"
      },
      {
        "title": "Think",
        "artist": "Franklin Aretha of arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/think?source=ireal"
      },
      {
        "title": "Trouble In Mind",
        "artist": "Franklin Aretha of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/trouble_in_mind?source=ireal"
      },
      {
        "title": "Until You Come Back To Me",
        "artist": "A Toni",
        "url": "https://www.quickchords.org/charts/unfiled/a_toni/until_you_come_back_to_me?source=ireal"
      },
      {
        "title": "I Never Loved A Man",
        "artist": "Franklin Aretha Of Arr. Walkupmusic.com",
        "url": "https://www.quickchords.org/charts/unfiled/franklin_aretha_of_arr_walkupmusiccom/i_never_loved_a_man?source=ireal"
      },
      {
        "title": "Since You've Been Gone (Sweet Sweet Baby)",
        "artist": "Aretha Franklin",
        "url": "https://www.quickchords.org/charts/unfiled/aretha_franklin/since_youve_been_gone_sweet_sweet_baby?source=ireal"
      },
      {
        "title": "Baby I Love You",
        "artist": "Aretha Franklin",
        "url": "https://www.quickchords.org/charts/unfiled/aretha_franklin/baby_i_love_you?source=ireal"
      },
      {
        "title": "Sweet Lover",
        "artist": "Aretha Franklin",
        "url": "https://www.quickchords.org/charts/unfiled/aretha_franklin/sweet_lover?source=ireal"
      },
      {
        "title": "House that Jack Built",
        "artist": "Aretha Franklin",
        "url": "https://www.quickchords.org/charts/unfiled/aretha_franklin/house_that_jack_built?source=ireal"
      },
      {
        "title": "It Ain't Necessarily So (aretha)",
        "artist": "George Gershwin",
        "url": "https://www.quickchords.org/charts/unfiled/george_gershwin/it_aint_necessarily_so_aretha?source=ireal"
      },
      {
        "title": "Respect (Aretha Franklin)",
        "artist": "Redding",
        "url": "https://www.quickchords.org/charts/unfiled/redding/respect_aretha_franklin?source=ireal"
      },
      {
        "title": "Today I sing The Blues (Aretha Franklin 1960)",
        "artist": "Curtis Lewis",
        "url": "https://www.quickchords.org/charts/unfiled/curtis_lewis/today_i_sing_the_blues_aretha_franklin_1960?source=ireal"
      },
      {
        "title": "Natural Woman (C)",
        "artist": "Goffin-King-Wexler",
        "url": "https://www.quickchords.org/charts/unfiled/goffinkingwexler/natural_woman_c?source=ireal"
      },
      {
        "title": "Natural Woman (You Make Me Feel Like A)",
        "artist": "Goffin-King-Wexler (Aretha Franklin)",
        "url": "https://www.quickchords.org/charts/unfiled/goffinkingwexler_aretha_franklin/natural_woman_you_make_me_feel_like_a?source=ireal"
      },
      {
        "title": "Respect",
        "artist": "Otis Redding (Aretha Franklin)",
        "url": "https://www.quickchords.org/charts/unfiled/otis_redding_aretha_franklin/respect?source=ireal"
      },
      {
        "title": "TVC 15",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/tvc_15?source=ireal"
      },
      {
        "title": "Fame",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/fame?source=ireal"
      },
      {
        "title": "Ebony Eyes",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ebony_eyes?source=ireal"
      },
      {
        "title": "Until You Come Back To Me (That's What I'm Gonna Do)",
        "artist": "Broadnax-Paul-Wonder (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/unfiled/broadnaxpaulwonder_stevie_wonder/until_you_come_back_to_me_thats_what_im_gonna_do?source=ireal"
      },
      {
        "title": "All The Young Dudes",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/all_the_young_dudes?source=ireal"
      },
      {
        "title": "Star Man",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/star_man?source=ireal"
      },
      {
        "title": "Life On Mars",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/life_on_mars?source=ireal"
      },
      {
        "title": "This is not Ａmerica",
        "artist": "Pat Metheny",
        "url": "https://www.quickchords.org/charts/unfiled/pat_metheny/this_is_not_merica?source=ireal"
      },
      {
        "title": "Starman",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/starman?source=ireal"
      },
      {
        "title": "Ziggy Stardust",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/ziggy_stardust?source=ireal"
      },
      {
        "title": "It Ain't Easy",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/it_aint_easy?source=ireal"
      },
      {
        "title": "Let's Dance",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/lets_dance?source=ireal"
      },
      {
        "title": "You And I",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_and_i?source=ireal"
      },
      {
        "title": "Don't You Worry 'Bout A Thing 1",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/dont_you_worry_bout_a_thing_1?source=ireal"
      },
      {
        "title": "All I Do",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/all_i_do?source=ireal"
      },
      {
        "title": "Higher Ground",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/higher_ground?source=ireal"
      },
      {
        "title": "Living For The City",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city?source=ireal"
      },
      {
        "title": "As",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as?source=ireal"
      },
      {
        "title": "Do, I Do",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/do_i_do?source=ireal"
      },
      {
        "title": "I don't know why I love you (but I love you)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_dont_know_why_i_love_you_but_i_love_you?source=ireal"
      },
      {
        "title": "Visions",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/visions?source=ireal"
      },
      {
        "title": "Shelter in the Rain",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/shelter_in_the_rain?source=ireal"
      },
      {
        "title": "Jesus Children Of America",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/jesus_children_of_america?source=ireal"
      },
      {
        "title": "Moon Blue (stevie)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/moon_blue_stevie?source=ireal"
      },
      {
        "title": "Signed, Sealed, Delivered I'm Yours",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/signed_sealed_delivered_im_yours?source=ireal"
      },
      {
        "title": "Creepin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/creepin?source=ireal"
      },
      {
        "title": "Happy Birthday ",
        "artist": "Steve Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/steve_wonder/happy_birthday_?source=ireal"
      },
      {
        "title": "Contusion",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/contusion?source=ireal"
      },
      {
        "title": "Boogie On Reggae Woman",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/boogie_on_reggae_woman?source=ireal"
      },
      {
        "title": "Do I Do",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/do_i_do?source=ireal"
      },
      {
        "title": "As (Tom's)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as_toms?source=ireal"
      },
      {
        "title": "Boogie On Reggae Woman 1",
        "artist": "Steveland Morris",
        "url": "https://www.quickchords.org/charts/unfiled/steveland_morris/boogie_on_reggae_woman_1?source=ireal"
      },
      {
        "title": "Don't You Worry 'Bout A Thing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/dont_you_worry_bout_a_thing?source=ireal"
      },
      {
        "title": "For Once In My Life (Tom's)",
        "artist": "Stevie Wonder (Miller, Murden)",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder_miller_murden/for_once_in_my_life_toms?source=ireal"
      },
      {
        "title": "Golden Lady",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/golden_lady?source=ireal"
      },
      {
        "title": "I Wish",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_wish?source=ireal"
      },
      {
        "title": "Isn't She Lovely? (Tom's)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/isnt_she_lovely_toms?source=ireal"
      },
      {
        "title": "Living For The City",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city?source=ireal"
      },
      {
        "title": "My Cherie Amour (Tom's Arr)",
        "artist": "Stevie Wonder (Wonder, Cosby, Moy)",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder_wonder_cosby_moy/my_cherie_amour_toms_arr?source=ireal"
      },
      {
        "title": "Superstition",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superstition?source=ireal"
      },
      {
        "title": "Yester Me Yester You Yesterday (Tom's)",
        "artist": "Unknown Composer",
        "url": "https://www.quickchords.org/charts/unfiled/unknown_composer/yester_me_yester_you_yesterday_toms?source=ireal"
      },
      {
        "title": "You Are The Sunshine Of My Life (Tom's Arr)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_are_the_sunshine_of_my_life_toms_arr?source=ireal"
      },
      {
        "title": "Isn't She Lovely",
        "artist": "Wooten Victor Version",
        "url": "https://www.quickchords.org/charts/unfiled/wooten_victor_version/isnt_she_lovely?source=ireal"
      },
      {
        "title": "Boogie On Reggae Woman 1",
        "artist": "Steveland Morris",
        "url": "https://www.quickchords.org/charts/unfiled/steveland_morris/boogie_on_reggae_woman_1?source=ireal"
      },
      {
        "title": "Creepin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/creepin?source=ireal"
      },
      {
        "title": "Too High",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/too_high?source=ireal"
      },
      {
        "title": "Part Time Lover",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/part_time_lover?source=ireal"
      },
      {
        "title": "All I Do",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/all_i_do?source=ireal"
      },
      {
        "title": "Moon Blue",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/moon_blue?source=ireal"
      },
      {
        "title": "Let's Dance",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/lets_dance?source=ireal"
      },
      {
        "title": "Space Oddity",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/space_oddity?source=ireal"
      },
      {
        "title": "Space Oddity",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/space_oddity?source=ireal"
      },
      {
        "title": "Queen Bitch",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/queen_bitch?source=ireal"
      },
      {
        "title": "Moonage Daydream",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/moonage_daydream?source=ireal"
      },
      {
        "title": "Suffragette City",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/suffragette_city?source=ireal"
      },
      {
        "title": "Hang On To Yourself",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/hang_on_to_yourself?source=ireal"
      },
      {
        "title": "Rock 'n' Roll Suicide",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/rock_n_roll_suicide?source=ireal"
      },
      {
        "title": "Five Years",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/five_years?source=ireal"
      },
      {
        "title": "Soul Love",
        "artist": "David Bowie",
        "url": "https://www.quickchords.org/charts/unfiled/david_bowie/soul_love?source=ireal"
      },
      {
        "title": "Signed, Sealed, Delivered",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/signed_sealed_delivered?source=ireal"
      },
      {
        "title": "Take It To The Limit",
        "artist": "The Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/the_eagles/take_it_to_the_limit?source=ireal"
      },
      {
        "title": "Desperado",
        "artist": "Frey-Henley Eagles)",
        "url": "https://www.quickchords.org/charts/unfiled/freyhenley_eagles/desperado?source=ireal"
      },
      {
        "title": "Heartache Tonight (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/heartache_tonight_toms?source=ireal"
      },
      {
        "title": "Hotel California (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/hotel_california_toms?source=ireal"
      },
      {
        "title": "I Can't Tell You Why (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/i_cant_tell_you_why_toms?source=ireal"
      },
      {
        "title": "Lyin Eyes (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/lyin_eyes_toms?source=ireal"
      },
      {
        "title": "New Kid in Town (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/new_kid_in_town_toms?source=ireal"
      },
      {
        "title": "One of These Nights (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/one_of_these_nights_toms?source=ireal"
      },
      {
        "title": "Peaceful, Easy Feeling (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/peaceful_easy_feeling_toms?source=ireal"
      },
      {
        "title": "Take It Easy (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/take_it_easy_toms?source=ireal"
      },
      {
        "title": "Tequila Sunrise (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/tequila_sunrise_toms?source=ireal"
      },
      {
        "title": "Witchy Woman (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/witchy_woman_toms?source=ireal"
      },
      {
        "title": "Heartache Tonight (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/heartache_tonight_toms?source=ireal"
      },
      {
        "title": "Hotel California (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/hotel_california_toms?source=ireal"
      },
      {
        "title": "I Can't Tell You Why (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/i_cant_tell_you_why_toms?source=ireal"
      },
      {
        "title": "Lyin Eyes (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/lyin_eyes_toms?source=ireal"
      },
      {
        "title": "New Kid in Town (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/new_kid_in_town_toms?source=ireal"
      },
      {
        "title": "One of These Nights (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/one_of_these_nights_toms?source=ireal"
      },
      {
        "title": "Peaceful, Easy Feeling (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/peaceful_easy_feeling_toms?source=ireal"
      },
      {
        "title": "Take It Easy (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/take_it_easy_toms?source=ireal"
      },
      {
        "title": "Tequila Sunrise (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/tequila_sunrise_toms?source=ireal"
      },
      {
        "title": "Witchy Woman (Tom's)",
        "artist": "Eagles",
        "url": "https://www.quickchords.org/charts/unfiled/eagles/witchy_woman_toms?source=ireal"
      },
      {
        "title": "Think",
        "artist": "Franklin-White (Aretha Franklin)",
        "url": "https://www.quickchords.org/charts/unfiled/franklinwhite_aretha_franklin/think?source=ireal"
      },
      {
        "title": "Chain Of Fools",
        "artist": "Don Covay (Aretha Franklin)",
        "url": "https://www.quickchords.org/charts/unfiled/don_covay_aretha_franklin/chain_of_fools?source=ireal"
      },
      {
        "title": "Tennessee Jed",
        "artist": "Garcia - Hunter",
        "url": "https://www.quickchords.org/charts/unfiled/garcia__hunter/tennessee_jed?source=ireal"
      },
      {
        "title": "Russian Lullaby",
        "artist": "Irving Berlin",
        "url": "https://www.quickchords.org/charts/unfiled/irving_berlin/russian_lullaby?source=ireal"
      },
      {
        "title": "Rockin' Chair (Garcia) (rob)",
        "artist": "Hoagy Carmichael (1930)",
        "url": "https://www.quickchords.org/charts/unfiled/hoagy_carmichael_1930/rockin_chair_garcia_rob?source=ireal"
      },
      {
        "title": "Touch Of Grey",
        "artist": "Hunter/Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/huntergarcia/touch_of_grey?source=ireal"
      },
      {
        "title": "Dire Wolf",
        "artist": "Dead",
        "url": "https://www.quickchords.org/charts/unfiled/dead/dire_wolf?source=ireal"
      },
      {
        "title": "Mississippi Half-step Uptown Toodleoo 1",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/unfiled/grateful_dead/mississippi_halfstep_uptown_toodleoo_1?source=ireal"
      },
      {
        "title": "Fire On The Mountain (GD)",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/unfiled/grateful_dead/fire_on_the_mountain_gd?source=ireal"
      },
      {
        "title": "Row Jimmy",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/unfiled/grateful_dead/row_jimmy?source=ireal"
      },
      {
        "title": "Candyman",
        "artist": "Dead Grateful Hunter-Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/dead_grateful_huntergarcia/candyman?source=ireal"
      },
      {
        "title": "Morning Dew",
        "artist": "Joan Baez",
        "url": "https://www.quickchords.org/charts/unfiled/joan_baez/morning_dew?source=ireal"
      },
      {
        "title": "Other One, The",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/other_one_the?source=ireal"
      },
      {
        "title": "Alligator",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/unfiled/grateful_dead/alligator?source=ireal"
      },
      {
        "title": "Cosmic Charlie",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/cosmic_charlie?source=ireal"
      },
      {
        "title": "Dupree's Diamond Blues",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/duprees_diamond_blues?source=ireal"
      },
      {
        "title": "Doing That Rag",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/doing_that_rag?source=ireal"
      },
      {
        "title": "Saint Stephen",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/unfiled/grateful_dead/saint_stephen?source=ireal"
      },
      {
        "title": "Eleven, The",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/unfiled/grateful_dead/eleven_the?source=ireal"
      },
      {
        "title": "Chinacat Sunflower",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/chinacat_sunflower?source=ireal"
      },
      {
        "title": "I Know You Rider",
        "artist": "Traditional Folk",
        "url": "https://www.quickchords.org/charts/unfiled/traditional_folk/i_know_you_rider?source=ireal"
      },
      {
        "title": "Dark Star",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/dark_star?source=ireal"
      },
      {
        "title": "Cold Rain And Snow",
        "artist": "Traditional Traditional",
        "url": "https://www.quickchords.org/charts/unfiled/traditional_traditional/cold_rain_and_snow?source=ireal"
      },
      {
        "title": "Uncle John's Band",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/uncle_johns_band?source=ireal"
      },
      {
        "title": "High Time",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/high_time?source=ireal"
      },
      {
        "title": "Dire Wolf",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/dire_wolf?source=ireal"
      },
      {
        "title": "Casey Jones",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/casey_jones?source=ireal"
      },
      {
        "title": "New Speedway Boogie",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/new_speedway_boogie?source=ireal"
      },
      {
        "title": "Friend Of The Devil",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/friend_of_the_devil?source=ireal"
      },
      {
        "title": "Candyman",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/candyman?source=ireal"
      },
      {
        "title": "Till The Morning Comes",
        "artist": "Garcia Hunter/",
        "url": "https://www.quickchords.org/charts/unfiled/garcia_hunter/till_the_morning_comes?source=ireal"
      },
      {
        "title": "Loser",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/loser?source=ireal"
      },
      {
        "title": "Mama Tried",
        "artist": "Merle Haggard",
        "url": "https://www.quickchords.org/charts/unfiled/merle_haggard/mama_tried?source=ireal"
      },
      {
        "title": "Goin' Down The Road Feelin' Bad",
        "artist": "Traditional Folk",
        "url": "https://www.quickchords.org/charts/unfiled/traditional_folk/goin_down_the_road_feelin_bad?source=ireal"
      },
      {
        "title": "Me And My Uncle",
        "artist": "Cowboy Bob",
        "url": "https://www.quickchords.org/charts/unfiled/cowboy_bob/me_and_my_uncle?source=ireal"
      },
      {
        "title": "Brown Eyed Women",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/brown_eyed_women?source=ireal"
      },
      {
        "title": "Jack Straw",
        "artist": "Bob Wier",
        "url": "https://www.quickchords.org/charts/unfiled/bob_wier/jack_straw?source=ireal"
      },
      {
        "title": "Ramble On Rose",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/ramble_on_rose?source=ireal"
      },
      {
        "title": "Deal",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/deal?source=ireal"
      },
      {
        "title": "Bird Song",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/bird_song?source=ireal"
      },
      {
        "title": "Sugaree",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/sugaree?source=ireal"
      },
      {
        "title": "Eyes Of The World",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/eyes_of_the_world?source=ireal"
      },
      {
        "title": "Scarlet Begonias",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/scarlet_begonias?source=ireal"
      },
      {
        "title": "Ship Of Fools",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/ship_of_fools?source=ireal"
      },
      {
        "title": "Franklin's Tower",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/franklins_tower?source=ireal"
      },
      {
        "title": "Crazy Fingers",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/crazy_fingers?source=ireal"
      },
      {
        "title": "Peggy-O",
        "artist": "Traditional Folk",
        "url": "https://www.quickchords.org/charts/unfiled/traditional_folk/peggyo?source=ireal"
      },
      {
        "title": "Althea",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/althea?source=ireal"
      },
      {
        "title": "Lazy River Road",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/lazy_river_road?source=ireal"
      },
      {
        "title": "Box of Rain",
        "artist": "Robert Hunter",
        "url": "https://www.quickchords.org/charts/unfiled/robert_hunter/box_of_rain?source=ireal"
      },
      {
        "title": "Box of Rain 1",
        "artist": "Robert Hunter",
        "url": "https://www.quickchords.org/charts/unfiled/robert_hunter/box_of_rain_1?source=ireal"
      },
      {
        "title": "Deal",
        "artist": "Jerry Garcia",
        "url": "https://www.quickchords.org/charts/unfiled/jerry_garcia/deal?source=ireal"
      },
      {
        "title": "Mississippi Half-step Uptown Toodleoo",
        "artist": "Grateful Dead",
        "url": "https://www.quickchords.org/charts/unfiled/grateful_dead/mississippi_halfstep_uptown_toodleoo?source=ireal"
      },
      {
        "title": "Another Star",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/another_star?source=ireal"
      },
      {
        "title": "As",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as?source=ireal"
      },
      {
        "title": "As If You Read My Mind",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as_if_you_read_my_mind?source=ireal"
      },
      {
        "title": "Boogie On Reggae Woman",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/boogie_on_reggae_woman?source=ireal"
      },
      {
        "title": "Creepin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/creepin?source=ireal"
      },
      {
        "title": "Do Like You",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/do_like_you?source=ireal"
      },
      {
        "title": "Don't You Worry 'Bout A Thing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/dont_you_worry_bout_a_thing?source=ireal"
      },
      {
        "title": "For Once In My Life",
        "artist": "Miller-Murden (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/unfiled/millermurden_stevie_wonder/for_once_in_my_life?source=ireal"
      },
      {
        "title": "For Your Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/for_your_love?source=ireal"
      },
      {
        "title": "Happy Birthday (Stevie Wonder)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/happy_birthday_stevie_wonder?source=ireal"
      },
      {
        "title": "Heaven Help Us All",
        "artist": "Ronald Miller (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/unfiled/ronald_miller_stevie_wonder/heaven_help_us_all?source=ireal"
      },
      {
        "title": "Higher Ground",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/higher_ground?source=ireal"
      },
      {
        "title": "I Ain't Gonna Stand For It",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_aint_gonna_stand_for_it?source=ireal"
      },
      {
        "title": "I Just Called To Say I Love You",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_just_called_to_say_i_love_you?source=ireal"
      },
      {
        "title": "I Was Made To Love Her",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_was_made_to_love_her?source=ireal"
      },
      {
        "title": "I Wish",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_wish?source=ireal"
      },
      {
        "title": "If You Really Love Me",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/if_you_really_love_me?source=ireal"
      },
      {
        "title": "Isn't She Lovely",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/isnt_she_lovely?source=ireal"
      },
      {
        "title": "Knocks Me Off My Feet",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/knocks_me_off_my_feet?source=ireal"
      },
      {
        "title": "Living For The City",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city?source=ireal"
      },
      {
        "title": "Master Blaster",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/master_blaster?source=ireal"
      },
      {
        "title": "My Cherie Amour",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/my_cherie_amour?source=ireal"
      },
      {
        "title": "My Love (Iglesias-Wonder)",
        "artist": "Wonder Iglesias-Stevie Julio",
        "url": "https://www.quickchords.org/charts/unfiled/wonder_iglesiasstevie_julio/my_love_iglesiaswonder?source=ireal"
      },
      {
        "title": "Ngiculela - Es Una Historia - I Am Singing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ngiculela__es_una_historia__i_am_singing?source=ireal"
      },
      {
        "title": "Overjoyed",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/overjoyed?source=ireal"
      },
      {
        "title": "Pastime Paradise",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/pastime_paradise?source=ireal"
      },
      {
        "title": "Ribbon In The Sky",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ribbon_in_the_sky?source=ireal"
      },
      {
        "title": "Rocket Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/rocket_love?source=ireal"
      },
      {
        "title": "Send One Your Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/send_one_your_love?source=ireal"
      },
      {
        "title": "Signed, Sealed, Delivered I'm Yours",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/signed_sealed_delivered_im_yours?source=ireal"
      },
      {
        "title": "Sir Duke",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/sir_duke?source=ireal"
      },
      {
        "title": "Smile Please",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/smile_please?source=ireal"
      },
      {
        "title": "Someday At Christmas",
        "artist": "Miller-Wells (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/unfiled/millerwells_stevie_wonder/someday_at_christmas?source=ireal"
      },
      {
        "title": "Summer Soft (p1)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/summer_soft_p1?source=ireal"
      },
      {
        "title": "Summer Soft (p2)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/summer_soft_p2?source=ireal"
      },
      {
        "title": "Superstition",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superstition?source=ireal"
      },
      {
        "title": "Superwoman (Where Were You When I Needed You) p1",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superwoman_where_were_you_when_i_needed_you_p1?source=ireal"
      },
      {
        "title": "Superwoman (Where Were You When I Needed You) p2",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superwoman_where_were_you_when_i_needed_you_p2?source=ireal"
      },
      {
        "title": "That Girl",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/that_girl?source=ireal"
      },
      {
        "title": "Uptight",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/uptight?source=ireal"
      },
      {
        "title": "Visions",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/visions?source=ireal"
      },
      {
        "title": "You Are The Sunshine Of My Life",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_are_the_sunshine_of_my_life?source=ireal"
      },
      {
        "title": "Another Star",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/another_star?source=ireal"
      },
      {
        "title": "As",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as?source=ireal"
      },
      {
        "title": "As If You Read My Mind",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as_if_you_read_my_mind?source=ireal"
      },
      {
        "title": "Boogie On Reggae Woman",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/boogie_on_reggae_woman?source=ireal"
      },
      {
        "title": "Creepin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/creepin?source=ireal"
      },
      {
        "title": "Do Like You",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/do_like_you?source=ireal"
      },
      {
        "title": "Don't You Worry 'Bout A Thing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/dont_you_worry_bout_a_thing?source=ireal"
      },
      {
        "title": "For Once In My Life",
        "artist": "Miller-Murden (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/unfiled/millermurden_stevie_wonder/for_once_in_my_life?source=ireal"
      },
      {
        "title": "For Your Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/for_your_love?source=ireal"
      },
      {
        "title": "Happy Birthday (Stevie Wonder)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/happy_birthday_stevie_wonder?source=ireal"
      },
      {
        "title": "Heaven Help Us All",
        "artist": "Ronald Miller (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/unfiled/ronald_miller_stevie_wonder/heaven_help_us_all?source=ireal"
      },
      {
        "title": "Higher Ground",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/higher_ground?source=ireal"
      },
      {
        "title": "I Ain't Gonna Stand For It",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_aint_gonna_stand_for_it?source=ireal"
      },
      {
        "title": "I Just Called To Say I Love You",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_just_called_to_say_i_love_you?source=ireal"
      },
      {
        "title": "I Was Made To Love Her",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_was_made_to_love_her?source=ireal"
      },
      {
        "title": "I Wish",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_wish?source=ireal"
      },
      {
        "title": "If You Really Love Me",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/if_you_really_love_me?source=ireal"
      },
      {
        "title": "Isn't She Lovely",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/isnt_she_lovely?source=ireal"
      },
      {
        "title": "Knocks Me Off My Feet",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/knocks_me_off_my_feet?source=ireal"
      },
      {
        "title": "Living For The City",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/living_for_the_city?source=ireal"
      },
      {
        "title": "Master Blaster",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/master_blaster?source=ireal"
      },
      {
        "title": "My Cherie Amour",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/my_cherie_amour?source=ireal"
      },
      {
        "title": "My Love (Iglesias-Wonder)",
        "artist": "Wonder Iglesias-Stevie Julio",
        "url": "https://www.quickchords.org/charts/unfiled/wonder_iglesiasstevie_julio/my_love_iglesiaswonder?source=ireal"
      },
      {
        "title": "Ngiculela - Es Una Historia - I Am Singing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ngiculela__es_una_historia__i_am_singing?source=ireal"
      },
      {
        "title": "Overjoyed",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/overjoyed?source=ireal"
      },
      {
        "title": "Pastime Paradise",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/pastime_paradise?source=ireal"
      },
      {
        "title": "Ribbon In The Sky",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ribbon_in_the_sky?source=ireal"
      },
      {
        "title": "Rocket Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/rocket_love?source=ireal"
      },
      {
        "title": "Send One Your Love",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/send_one_your_love?source=ireal"
      },
      {
        "title": "Signed, Sealed, Delivered I'm Yours",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/signed_sealed_delivered_im_yours?source=ireal"
      },
      {
        "title": "Sir Duke",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/sir_duke?source=ireal"
      },
      {
        "title": "Smile Please",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/smile_please?source=ireal"
      },
      {
        "title": "Someday At Christmas",
        "artist": "Miller-Wells (Stevie Wonder)",
        "url": "https://www.quickchords.org/charts/unfiled/millerwells_stevie_wonder/someday_at_christmas?source=ireal"
      },
      {
        "title": "Summer Soft (p1)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/summer_soft_p1?source=ireal"
      },
      {
        "title": "Summer Soft (p2)",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/summer_soft_p2?source=ireal"
      },
      {
        "title": "Superstition",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superstition?source=ireal"
      },
      {
        "title": "Superwoman (Where Were You When I Needed You) p1",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superwoman_where_were_you_when_i_needed_you_p1?source=ireal"
      },
      {
        "title": "Superwoman (Where Were You When I Needed You) p2",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superwoman_where_were_you_when_i_needed_you_p2?source=ireal"
      },
      {
        "title": "That Girl",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/that_girl?source=ireal"
      },
      {
        "title": "Uptight",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/uptight?source=ireal"
      },
      {
        "title": "Visions",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/visions?source=ireal"
      },
      {
        "title": "You Are The Sunshine Of My Life",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_are_the_sunshine_of_my_life?source=ireal"
      },
      {
        "title": "Bird Of Beauty",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/bird_of_beauty?source=ireal"
      },
      {
        "title": "Black Man",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/black_man?source=ireal"
      },
      {
        "title": "You Will Know",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_will_know?source=ireal"
      },
      {
        "title": "Dark 'n' Lovely",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/dark_n_lovely?source=ireal"
      },
      {
        "title": "Crying Through The Night",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/crying_through_the_night?source=ireal"
      },
      {
        "title": "My Eyes Don't Cry",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/my_eyes_dont_cry?source=ireal"
      },
      {
        "title": "One Of A Kind",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/one_of_a_kind?source=ireal"
      },
      {
        "title": "Ebony And Ivory",
        "artist": "Wonder McCartney-Stevie Paul",
        "url": "https://www.quickchords.org/charts/unfiled/wonder_mccartneystevie_paul/ebony_and_ivory?source=ireal"
      },
      {
        "title": "Creepin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/creepin?source=ireal"
      },
      {
        "title": "I Just Called To Say I Love You",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_just_called_to_say_i_love_you?source=ireal"
      },
      {
        "title": "Betcha Wouldn't Hurt Me",
        "artist": "Austin Wonder/Patti Stevie",
        "url": "https://www.quickchords.org/charts/unfiled/austin_wonderpatti_stevie/betcha_wouldnt_hurt_me?source=ireal"
      },
      {
        "title": "Pastime Paradise",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/pastime_paradise?source=ireal"
      },
      {
        "title": "Superwoman (Where Were You When I Needed You) p1",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superwoman_where_were_you_when_i_needed_you_p1?source=ireal"
      },
      {
        "title": "Superwoman (Where Were You When I Needed You) p2",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/superwoman_where_were_you_when_i_needed_you_p2?source=ireal"
      },
      {
        "title": "Signed, Sealed, Delivered 1",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/signed_sealed_delivered_1?source=ireal"
      },
      {
        "title": "You Haven't Done Nothin'",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/you_havent_done_nothin?source=ireal"
      },
      {
        "title": "Smile Please",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/smile_please?source=ireal"
      },
      {
        "title": "Boogie On Reggae Woman",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/boogie_on_reggae_woman?source=ireal"
      },
      {
        "title": "That Girl",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/that_girl?source=ireal"
      },
      {
        "title": "As",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as?source=ireal"
      },
      {
        "title": "Sir Duke",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/sir_duke?source=ireal"
      },
      {
        "title": "I Ain't Gonna Stand For It",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/i_aint_gonna_stand_for_it?source=ireal"
      },
      {
        "title": "As If You Read My Mind",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/as_if_you_read_my_mind?source=ireal"
      },
      {
        "title": "Ngiculela - Es Una Historia - I Am Singing",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/ngiculela__es_una_historia__i_am_singing?source=ireal"
      },
      {
        "title": "Do Like You",
        "artist": "Stevie Wonder",
        "url": "https://www.quickchords.org/charts/unfiled/stevie_wonder/do_like_you?source=ireal"
      }
    ]
  }
]